import { useEffect as tC } from "react";
/*!
 * Microsoft Dynamic Proto Utility, 1.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var xf, Pf = "undefined", mc = "constructor", Et = "prototype", xc = "function", Pc = "_dynInstFuncs", mv = "_isDynProxy", za = "_dynClass", iC = "_dynCls$", xv = "_dynInstChk", So = xv, Bp = "_dfOpts", Jg = "_unknown_", kp = "__proto__", Of = "_dyn" + kp, Qg = "__dynProto$Gbl", Yl = "_dynInstProto", fc = "useBaseInst", Pv = "setInstFuncs", ls = Object, No = ls.getPrototypeOf, jg = ls.getOwnPropertyNames;
function aC() {
  var e;
  return typeof globalThis !== Pf && (e = globalThis), !e && typeof self !== Pf && (e = self), !e && typeof window !== Pf && (e = window), !e && typeof global !== Pf && (e = global), e || {};
}
var n0 = aC(), Ov = n0[Qg] || (n0[Qg] = {
  o: (xf = {}, xf[Pv] = !0, xf[fc] = !0, xf),
  n: 1e3
  // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
function Tt(e, t) {
  return e && ls[Et].hasOwnProperty.call(e, t);
}
function Gp(e) {
  return e && (e === ls[Et] || e === Array[Et]);
}
function H_(e) {
  return Gp(e) || e === Function[Et];
}
function Ji(e) {
  var t;
  if (e) {
    if (No)
      return No(e);
    var i = e[kp] || e[Et] || (e[mc] ? e[mc][Et] : null);
    t = e[Of] || i, Tt(e, Of) || (delete e[Yl], t = e[Of] = e[Yl] || e[Of], e[Yl] = i);
  }
  return t;
}
function Oc(e, t) {
  var i = [];
  if (jg)
    i = jg(e);
  else
    for (var u in e)
      typeof u == "string" && Tt(e, u) && i.push(u);
  if (i && i.length > 0)
    for (var o = 0; o < i.length; o++)
      t(i[o]);
}
function B_(e, t, i) {
  return t !== mc && typeof e[t] === xc && (i || Tt(e, t));
}
function Lc(e) {
  throw new TypeError("DynamicProto: " + e);
}
function uC(e) {
  var t = {};
  return Oc(e, function(i) {
    !t[i] && B_(e, i, !1) && (t[i] = e[i]);
  }), t;
}
function k_(e, t) {
  for (var i = e.length - 1; i >= 0; i--)
    if (e[i] === t)
      return !0;
  return !1;
}
function oC(e, t, i, u) {
  function o(d, p, h) {
    var S = p[h];
    if (S[mv] && u) {
      var I = d[Pc] || {};
      I[So] !== !1 && (S = (I[p[za]] || {})[h] || S);
    }
    return function() {
      return S.apply(d, arguments);
    };
  }
  var c = {};
  Oc(i, function(d) {
    c[d] = o(t, i, d);
  });
  for (var s = Ji(e), v = []; s && !H_(s) && !k_(v, s); )
    Oc(s, function(d) {
      !c[d] && B_(s, d, !No) && (c[d] = o(t, s, d));
    }), v.push(s), s = Ji(s);
  return c;
}
function fC(e, t, i, u) {
  var o = null;
  if (e && Tt(i, za)) {
    var c = e[Pc] || {};
    if (o = (c[i[za]] || {})[t], o || Lc("Missing [" + t + "] " + xc), !o[xv] && c[So] !== !1) {
      for (var s = !Tt(e, t), v = Ji(e), d = []; s && v && !H_(v) && !k_(d, v); ) {
        var p = v[t];
        if (p) {
          s = p === u;
          break;
        }
        d.push(v), v = Ji(v);
      }
      try {
        s && (e[t] = o), o[xv] = 1;
      } catch {
        c[So] = !1;
      }
    }
  }
  return o;
}
function cC(e, t, i) {
  var u = t[e];
  return u === i && (u = Ji(t)[e]), typeof u !== xc && Lc("[" + e + "] is not a " + xc), u;
}
function sC(e, t, i, u, o) {
  function c(d, p) {
    var h = function() {
      var S = fC(this, p, d, h) || cC(p, d, h);
      return S.apply(this, arguments);
    };
    return h[mv] = 1, h;
  }
  if (!Gp(e)) {
    var s = i[Pc] = i[Pc] || {}, v = s[t] = s[t] || {};
    s[So] !== !1 && (s[So] = !!o), Oc(i, function(d) {
      B_(i, d, !1) && i[d] !== u[d] && (v[d] = i[d], delete i[d], (!Tt(e, d) || e[d] && !e[d][mv]) && (e[d] = c(e, d)));
    });
  }
}
function lC(e, t) {
  if (No) {
    for (var i = [], u = Ji(t); u && !H_(u) && !k_(i, u); ) {
      if (u === e)
        return !0;
      i.push(u), u = Ji(u);
    }
    return !1;
  }
  return !0;
}
function Ul(e, t) {
  return Tt(e, Et) ? e.name || t || Jg : ((e || {})[mc] || {}).name || t || Jg;
}
function nr(e, t, i, u) {
  Tt(e, Et) || Lc("theClass is an invalid class definition.");
  var o = e[Et];
  lC(o, t) || Lc("[" + Ul(e) + "] not in hierarchy of [" + Ul(t) + "]");
  var c = null;
  Tt(o, za) ? c = o[za] : (c = iC + Ul(e, "_") + "$" + Ov.n, Ov.n++, o[za] = c);
  var s = nr[Bp], v = !!s[fc];
  v && u && u[fc] !== void 0 && (v = !!u[fc]);
  var d = uC(t), p = oC(o, t, d, v);
  i(t, p);
  var h = !!No && !!s[Pv];
  h && u && (h = !!u[Pv]), sC(o, c, t, d, h !== !1);
}
nr[Bp] = Ov.o;
var vu = "function", Nt = "object", qt = "undefined", qr = "prototype", G_ = "hasOwnProperty", Dt = Object, W_ = Dt[qr], Lv = Dt.assign, vC = Dt.create, Wp = Dt.defineProperty, Qi = W_[G_], r0 = null;
function _u(e) {
  e === void 0 && (e = !0);
  var t = e === !1 ? null : r0;
  return t || (typeof globalThis !== qt && (t = globalThis), !t && typeof self !== qt && (t = self), !t && typeof window !== qt && (t = window), !t && typeof global !== qt && (t = global), r0 = t), t;
}
function z_(e) {
  throw new TypeError(e);
}
function zp(e) {
  var t = vC;
  if (t)
    return t(e);
  if (e == null)
    return {};
  var i = typeof e;
  i !== Nt && i !== vu && z_("Object prototype may only be an Object:" + e);
  function u() {
  }
  return u[qr] = e, new u();
}
(_u() || {}).Symbol;
(_u() || {}).Reflect;
var _C = function(e) {
  for (var t, i = 1, u = arguments.length; i < u; i++) {
    t = arguments[i];
    for (var o in t)
      W_[G_].call(t, o) && (e[o] = t[o]);
  }
  return e;
}, Wr = Lv || _C, bv = function(e, t) {
  return bv = Dt.setPrototypeOf || // tslint:disable-next-line: only-arrow-functions
  { __proto__: [] } instanceof Array && function(i, u) {
    i.__proto__ = u;
  } || // tslint:disable-next-line: only-arrow-functions
  function(i, u) {
    for (var o in u)
      u[G_](o) && (i[o] = u[o]);
  }, bv(e, t);
};
function It(e, t) {
  typeof t !== vu && t !== null && z_("Class extends value " + String(t) + " is not a constructor or null"), bv(e, t);
  function i() {
    this.constructor = e;
  }
  e[qr] = t === null ? zp(t) : (i[qr] = t[qr], new i());
}
function e0(e, t) {
  for (var i = 0, u = t.length, o = e.length; i < u; i++, o++)
    e[o] = t[i];
  return e;
}
var ji = "initialize", ui = "name", Mv = "getNotifyMgr", Jt = "identifier", Kn = "push", _t = "isInitialized", na = "config", Fl = "instrumentationKey", jr = "logger", Pn = "length", uo = "time", vr = "processNext", qp = "getProcessTelContext", oo = "addNotificationListener", fo = "removeNotificationListener", t0 = "stopPollingInternalLogs", Vu = "onComplete", vs = "getPlugin", bc = "flush", Lf = "_extensions", eu = "splice", st = "teardown", Mc = "messageId", qa = "message", tu = "isAsync", Yv = "_doTeardown", Do = "update", qe = "getNext", ra = "diagLog", Io = "setNextPlugin", iu = "createNew", Uv = "cookieCfg", bo = "indexOf", Yc = "substring", Uc = "userAgent", Ao = "split", Kp = "setEnabled", ba = "substr", Hl = "nodeType", au = "apply", Qt = "replace", i0 = "enableDebugExceptions", Xp = "logInternalMessage", Fv = "toLowerCase", Kr = "call", ht = "type", q_ = "handler", Aa = "listeners", Hv = "isChildEvt", Ka = "getCtx", ze = "setCtx", Bv = "complete", kv = "traceId", a0 = "spanId", Gv = "traceFlags", $p = "version", bn = "", u0 = "channels", Tr = "core", o0 = "createPerfMgr", Wv = "disabled", K_ = "extensionConfig", dC = "extensions", Xe = "processTelemetry", jt = "priority", cc = "eventsSent", co = "eventsDiscarded", sc = "eventsSendRequest", Ba = "perfEvent", Bl = "errorToConsole", lc = "warnToConsole", Fc = "getPerfMgr", Vp = "toISOString", Zp = "endsWith", f0 = "indexOf", c0 = "map", s0 = "reduce", zv = "trim", Jp = "toString", hC = "__proto__", vc = "constructor", l0 = Wp, qv = Dt.freeze, v0 = Dt.keys, Qp = String[qr], gC = Qp[zv], pC = Qp[Zp], EC = Date[qr], TC = EC[Vp], SC = Array.isArray, jp = W_[Jp], nE = Qi[Jp], NC = nE[
  Kr
  /* @min:%2ecall */
](Dt), DC = /-([a-z])/g, IC = /([^\w\d_$])/g, AC = /^(\d+[\w\d_$])/, Hc = Object.getPrototypeOf;
function rE(e) {
  if (e) {
    if (Hc)
      return Hc(e);
    var t = e[hC] || e[qr] || e[vc];
    if (t)
      return t;
  }
  return null;
}
function xr(e) {
  return e === void 0 || typeof e === qt;
}
function Q(e) {
  return e === null || xr(e);
}
function RC(e) {
  return !Q(e);
}
function eE(e, t) {
  return !!(e && Qi[
    Kr
    /* @min:%2ecall */
  ](e, t));
}
function Me(e) {
  return !!(e && typeof e === Nt);
}
function Cn(e) {
  return !!(e && typeof e === vu);
}
function Bc(e) {
  var t = e;
  return t && En(t) && (t = t[
    Qt
    /* @min:%2ereplace */
  ](DC, function(i, u) {
    return u.toUpperCase();
  }), t = t[
    Qt
    /* @min:%2ereplace */
  ](IC, "_"), t = t[
    Qt
    /* @min:%2ereplace */
  ](AC, function(i, u) {
    return "_" + u;
  })), t;
}
function ir(e, t) {
  if (e)
    for (var i in e)
      Qi[
        Kr
        /* @min:%2ecall */
      ](e, i) && t[
        Kr
        /* @min:%2ecall */
      ](e, i, e[i]);
}
function CC(e, t) {
  var i = !1;
  return e && t && !(i = e === t) && (i = pC ? e[Zp](t) : wC(e, t)), i;
}
function wC(e, t) {
  var i = !1, u = t ? t[
    Pn
    /* @min:%2elength */
  ] : 0, o = e ? e[
    Pn
    /* @min:%2elength */
  ] : 0;
  if (u && o && o >= u && !(i = e === t)) {
    for (var c = o - 1, s = u - 1; s >= 0; s--) {
      if (e[c] != t[s])
        return !1;
      c--;
    }
    i = !0;
  }
  return i;
}
function Ur(e, t) {
  return e && t ? e[
    bo
    /* @min:%2eindexOf */
  ](t) !== -1 : !1;
}
var Xn = SC || yC;
function yC(e) {
  return !!(e && jp[
    Kr
    /* @min:%2ecall */
  ](e) === "[object Array]");
}
function X_(e) {
  return !!(e && jp[
    Kr
    /* @min:%2ecall */
  ](e) === "[object Error]");
}
function En(e) {
  return typeof e == "string";
}
function tE(e) {
  return typeof e == "number";
}
function mC(e) {
  return typeof e == "boolean";
}
function _0(e) {
  var t = !1;
  if (e && typeof e == "object") {
    var i = Hc ? Hc(e) : rE(e);
    i ? (i[vc] && Qi[
      Kr
      /* @min:%2ecall */
    ](i, vc) && (i = i[vc]), t = typeof i === vu && nE[
      Kr
      /* @min:%2ecall */
    ](i) === NC) : t = !0;
  }
  return t;
}
function uu(e) {
  if (e)
    return TC ? e[Vp]() : xC(e);
}
function xC(e) {
  if (e && e.getUTCFullYear) {
    var t = function(i) {
      var u = String(i);
      return u[
        Pn
        /* @min:%2elength */
      ] === 1 && (u = "0" + u), u;
    };
    return e.getUTCFullYear() + "-" + t(e.getUTCMonth() + 1) + "-" + t(e.getUTCDate()) + "T" + t(e.getUTCHours()) + ":" + t(e.getUTCMinutes()) + ":" + t(e.getUTCSeconds()) + "." + String((e.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
  }
}
function hn(e, t, i) {
  var u = e[
    Pn
    /* @min:%2elength */
  ];
  try {
    for (var o = 0; o < u && !(o in e && t[
      Kr
      /* @min:%2ecall */
    ](i || e, e[o], o, e) === -1); o++)
      ;
  } catch {
  }
}
function be(e, t, i) {
  if (e) {
    if (e[f0])
      return e[f0](t, i);
    var u = e[
      Pn
      /* @min:%2elength */
    ], o = i || 0;
    try {
      for (var c = Math.max(o >= 0 ? o : u - Math.abs(o), 0); c < u; c++)
        if (c in e && e[c] === t)
          return c;
    } catch {
    }
  }
  return -1;
}
function so(e, t, i) {
  var u;
  if (e) {
    if (e[c0])
      return e[c0](t, i);
    var o = e[
      Pn
      /* @min:%2elength */
    ], c = i || e;
    u = new Array(o);
    try {
      for (var s = 0; s < o; s++)
        s in e && (u[s] = t[
          Kr
          /* @min:%2ecall */
        ](c, e[s], e));
    } catch {
    }
  }
  return u;
}
function PC(e, t, i) {
  var u;
  if (e) {
    if (e[s0])
      return e[s0](t, i);
    var o = e[
      Pn
      /* @min:%2elength */
    ], c = 0;
    if (arguments[
      Pn
      /* @min:%2elength */
    ] >= 3)
      u = arguments[2];
    else {
      for (; c < o && !(c in e); )
        c++;
      u = e[c++];
    }
    for (; c < o; )
      c in e && (u = t(u, e[c], c, e)), c++;
  }
  return u;
}
function zr(e) {
  return e && (e = gC && e[zv] ? e[zv]() : e[
    Qt
    /* @min:%2ereplace */
  ] ? e[
    Qt
    /* @min:%2ereplace */
  ](/^\s+|(?=\s)\s+$/g, bn) : e), e;
}
var d0 = !{ toString: null }.propertyIsEnumerable("toString"), kl = [
  "toString",
  "toLocaleString",
  "valueOf",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "constructor"
];
function ea(e) {
  var t = typeof e;
  if (t !== vu && (t !== Nt || e === null) && z_("objKeys called on non-object"), !d0 && v0)
    return v0(e);
  var i = [];
  for (var u in e)
    e && Qi[
      Kr
      /* @min:%2ecall */
    ](e, u) && i[
      Kn
      /* @min:%2epush */
    ](u);
  if (d0)
    for (var o = kl[
      Pn
      /* @min:%2elength */
    ], c = 0; c < o; c++)
      e && Qi[
        Kr
        /* @min:%2ecall */
      ](e, kl[c]) && i[
        Kn
        /* @min:%2epush */
      ](kl[c]);
  return i;
}
function Kt(e, t, i, u) {
  if (l0)
    try {
      var o = {
        enumerable: !0,
        configurable: !0
      };
      return i && (o.get = i), u && (o.set = u), l0(e, t, o), !0;
    } catch {
    }
  return !1;
}
function OC(e) {
  return e;
}
function $_(e) {
  return qv && ir(e, function(t, i) {
    (Xn(i) || Me(i)) && qv(i);
  }), Xa(e);
}
var Xa = qv || OC;
function $e() {
  var e = Date;
  return e.now ? e.now() : new e().getTime();
}
function Fn(e) {
  return X_(e) ? e[
    ui
    /* @min:%2ename */
  ] : bn;
}
function Gn(e, t, i, u, o) {
  var c = i;
  return e && (c = e[t], c !== i && (!o || o(c)) && (!u || u(i)) && (c = i, e[t] = c)), c;
}
function Rr(e, t, i) {
  var u;
  return e ? (u = e[t], !u && Q(u) && (u = xr(i) ? {} : i, e[t] = u)) : u = xr(i) ? {} : i, u;
}
function Oe(e, t) {
  return Q(e) ? t : e;
}
function Kv(e) {
  return !!e;
}
function Gr(e) {
  throw new Error(e);
}
function iE(e, t) {
  var i = null, u = null;
  return Cn(e) ? i = e : u = e, function() {
    var o = arguments;
    if (i && (u = i()), u)
      return u[t][
        au
        /* @min:%2eapply */
      ](u, o);
  };
}
function LC(e, t, i) {
  if (e && t && Me(e) && Me(t)) {
    var u = function(c) {
      if (En(c)) {
        var s = t[c];
        Cn(s) ? (!i || i(c, !0, t, e)) && (e[c] = iE(t, c)) : (!i || i(c, !1, t, e)) && (eE(e, c) && delete e[c], Kt(e, c, function() {
          return t[c];
        }, function(v) {
          t[c] = v;
        }) || (e[c] = s));
      }
    };
    for (var o in t)
      u(o);
  }
  return e;
}
function V_(e, t, i, u, o) {
  e && t && i && (o !== !1 || xr(e[t])) && (e[t] = iE(i, u));
}
function Zu(e, t, i, u) {
  return e && t && Me(e) && Xn(i) && hn(i, function(o) {
    En(o) && V_(e, o, t, o, u);
  }), e;
}
function bC(e) {
  return (
    /** @class */
    function() {
      function t() {
        var i = this;
        e && ir(e, function(u, o) {
          i[u] = o;
        });
      }
      return t;
    }()
  );
}
function aE(e) {
  return e && Lv && (e = Dt(Lv({}, e))), e;
}
function Z_(e, t, i, u, o, c) {
  var s = arguments, v = s[0] || {}, d = s[
    Pn
    /* @min:%2elength */
  ], p = !1, h = 1;
  for (d > 0 && mC(v) && (p = v, v = s[h] || {}, h++), Me(v) || (v = {}); h < d; h++) {
    var S = s[h], I = Xn(S), T = Me(S);
    for (var R in S) {
      var x = I && R in S || T && Qi[
        Kr
        /* @min:%2ecall */
      ](S, R);
      if (x) {
        var E = S[R], b = void 0;
        if (p && E && ((b = Xn(E)) || _0(E))) {
          var m = v[R];
          b ? Xn(m) || (m = []) : _0(m) || (m = {}), E = Z_(p, m, E);
        }
        E !== void 0 && (v[R] = E);
      }
    }
  }
  return v;
}
function J_(e) {
  var t = {};
  return ir(e, function(i, u) {
    t[i] = u, t[u] = i;
  }), $_(t);
}
function MC(e) {
  var t = {};
  return ir(e, function(i, u) {
    t[i] = u[1], t[u[0]] = u[1];
  }), $_(t);
}
var uE = "window", YC = "document", UC = "documentMode", FC = "navigator", HC = "history", BC = "location", kC = "console", GC = "performance", oE = "JSON", WC = "crypto", zC = "msCrypto", qC = "ReactNative", Xv = "msie", $v = "trident/", fE = "XMLHttpRequest", Gl = null, Wl = null, KC = !1, Ra = null, zl = null;
function cE(e, t) {
  var i = !1;
  if (e) {
    try {
      if (i = t in e, !i) {
        var u = e[qr];
        u && (i = t in u);
      }
    } catch {
    }
    if (!i)
      try {
        var o = new e();
        i = !xr(o[t]);
      } catch {
      }
  }
  return i;
}
function Nr(e) {
  var t = _u();
  return t && t[e] ? t[e] : e === uE && Mo() ? window : null;
}
function Mo() {
  return !!(typeof window === Nt && window);
}
function ni() {
  return Mo() ? window : Nr(uE);
}
function sE() {
  return !!(typeof document === Nt && document);
}
function le() {
  return sE() ? document : Nr(YC);
}
function lE() {
  return !!(typeof navigator === Nt && navigator);
}
function At() {
  return lE() ? navigator : Nr(FC);
}
function vE() {
  return !!(typeof history === Nt && history);
}
function XC() {
  return vE() ? history : Nr(HC);
}
function Xt(e) {
  if (e && KC) {
    var t = Nr("__mockLocation");
    if (t)
      return t;
  }
  return typeof location === Nt && location ? location : Nr(BC);
}
function $C() {
  return typeof console !== qt ? console : Nr(kC);
}
function oi() {
  return Nr(GC);
}
function du() {
  return !!(typeof JSON === Nt && JSON || Nr(oE) !== null);
}
function Ye() {
  return du() ? JSON || Nr(oE) : null;
}
function VC() {
  return Nr(WC);
}
function ZC() {
  return Nr(zC);
}
function JC() {
  var e = At();
  return e && e.product ? e.product === qC : !1;
}
function Vv() {
  var e = At();
  if (e && (e[
    Uc
    /* @min:%2euserAgent */
  ] !== Wl || Gl === null)) {
    Wl = e[
      Uc
      /* @min:%2euserAgent */
    ];
    var t = (Wl || bn)[
      Fv
      /* @min:%2etoLowerCase */
    ]();
    Gl = Ur(t, Xv) || Ur(t, $v);
  }
  return Gl;
}
function _E(e) {
  if (e === void 0 && (e = null), !e) {
    var t = At() || {};
    e = t ? (t[
      Uc
      /* @min:%2euserAgent */
    ] || bn)[
      Fv
      /* @min:%2etoLowerCase */
    ]() : bn;
  }
  var i = (e || bn)[
    Fv
    /* @min:%2etoLowerCase */
  ]();
  if (Ur(i, Xv)) {
    var u = le() || {};
    return Math.max(parseInt(i[
      Ao
      /* @min:%2esplit */
    ](Xv)[1]), u[UC] || 0);
  } else if (Ur(i, $v)) {
    var o = parseInt(i[
      Ao
      /* @min:%2esplit */
    ]($v)[1]);
    if (o)
      return o + 4;
  }
  return null;
}
function dn(e) {
  var t = Object[qr].toString[
    Kr
    /* @min:%2ecall */
  ](e), i = bn;
  return t === "[object Error]" ? i = "{ stack: '" + e.stack + "', message: '" + e.message + "', name: '" + e[
    ui
    /* @min:%2ename */
  ] + "'" : du() && (i = Ye().stringify(e)), t + i;
}
function bf() {
  return zl === null && (zl = lE() && !!At().sendBeacon), zl;
}
function h0(e) {
  var t = !1;
  try {
    t = !!Nr("fetch");
    var i = Nr("Request");
    t && e && i && (t = cE(i, "keepalive"));
  } catch {
  }
  return t;
}
function g0() {
  return Ra === null && (Ra = typeof XDomainRequest !== qt, Ra && kc() && (Ra = Ra && !cE(Nr(fE), "withCredentials"))), Ra;
}
function kc() {
  var e = !1;
  try {
    var t = Nr(fE);
    e = !!t;
  } catch {
  }
  return e;
}
var ql = ["eventsSent", "eventsDiscarded", "eventsSendRequest", "perfEvent"], Gc = null, Mf;
function QC(e, t) {
  return function() {
    var i = arguments, u = dE(t);
    if (u) {
      var o = u.listener;
      o && o[e] && o[e][
        au
        /* @min:%2eapply */
      ](o, i);
    }
  };
}
function jC() {
  var e = Nr("Microsoft");
  return e && (Gc = e.ApplicationInsights), Gc;
}
function dE(e) {
  var t = Gc;
  return !t && e.disableDbgExt !== !0 && (t = Gc || jC()), t ? t.ChromeDbgExt : null;
}
function nw(e) {
  if (!Mf) {
    Mf = {};
    for (var t = 0; t < ql[
      Pn
      /* @min:%2elength */
    ]; t++)
      Mf[ql[t]] = QC(ql[t], e);
  }
  return Mf;
}
var rw = "AI (Internal): ", ew = "AI: ", tw = "AITR_";
function p0(e) {
  return e ? '"' + e[
    Qt
    /* @min:%2ereplace */
  ](/\"/g, bn) + '"' : bn;
}
function E0(e, t) {
  var i = $C();
  if (i) {
    var u = "log";
    i[e] && (u = e), Cn(i[u]) && i[u](t);
  }
}
var Ro = (
  /** @class */
  function() {
    function e(t, i, u, o) {
      u === void 0 && (u = !1);
      var c = this;
      c[
        Mc
        /* @min:%2emessageId */
      ] = t, c[
        qa
        /* @min:%2emessage */
      ] = (u ? ew : rw) + t;
      var s = bn;
      du() && (s = Ye().stringify(o));
      var v = (i ? " message:" + p0(i) : bn) + (o ? " props:" + p0(s) : bn);
      c[
        qa
        /* @min:%2emessage */
      ] += v;
    }
    return e.dataType = "MessageData", e;
  }()
);
function Yo(e, t) {
  return (e || {})[
    jr
    /* @min:%2elogger */
  ] || new _s(t);
}
var _s = (
  /** @class */
  function() {
    function e(t) {
      this.identifier = "DiagnosticLogger", this.queue = [];
      var i = 0, u = {}, o, c, s, v;
      nr(e, this, function(d) {
        h(t || {}), d.consoleLoggingLevel = function() {
          return o;
        }, d.telemetryLoggingLevel = function() {
          return c;
        }, d.maxInternalMessageLimit = function() {
          return s;
        }, d[
          i0
          /* @min:%2eenableDebugExceptions */
        ] = function() {
          return v;
        }, d.throwInternal = function(T, R, x, E, b) {
          b === void 0 && (b = !1);
          var m = new Ro(R, x, b, E);
          if (v)
            throw dn(m);
          var F = T === 1 ? Bl : lc;
          if (xr(m[
            qa
            /* @min:%2emessage */
          ]))
            I("throw" + (T === 1 ? "Critical" : "Warning"), m);
          else {
            if (b) {
              var y = +m[
                Mc
                /* @min:%2emessageId */
              ];
              !u[y] && o >= T && (d[F](m[
                qa
                /* @min:%2emessage */
              ]), u[y] = !0);
            } else
              o >= T && d[F](m[
                qa
                /* @min:%2emessage */
              ]);
            p(T, m);
          }
        }, d[
          lc
          /* @min:%2ewarnToConsole */
        ] = function(T) {
          E0("warn", T), I("warning", T);
        }, d[
          Bl
          /* @min:%2eerrorToConsole */
        ] = function(T) {
          E0("error", T), I("error", T);
        }, d.resetInternalMessageCount = function() {
          i = 0, u = {};
        }, d[
          Xp
          /* @min:%2elogInternalMessage */
        ] = p;
        function p(T, R) {
          if (!S()) {
            var x = !0, E = tw + R[
              Mc
              /* @min:%2emessageId */
            ];
            if (u[E] ? x = !1 : u[E] = !0, x && (T <= c && (d.queue[
              Kn
              /* @min:%2epush */
            ](R), i++, I(T === 1 ? "error" : "warn", R)), i === s)) {
              var b = "Internal events throttle limit per PageView reached for this app.", m = new Ro(23, b, !1);
              d.queue[
                Kn
                /* @min:%2epush */
              ](m), T === 1 ? d[
                Bl
                /* @min:%2eerrorToConsole */
              ](b) : d[
                lc
                /* @min:%2ewarnToConsole */
              ](b);
            }
          }
        }
        function h(T) {
          o = Oe(T.loggingLevelConsole, 0), c = Oe(T.loggingLevelTelemetry, 1), s = Oe(T.maxMessageLimit, 25), v = Oe(T.enableDebug, Oe(T[
            i0
            /* @min:%2eenableDebugExceptions */
          ], !1));
        }
        function S() {
          return i >= s;
        }
        function I(T, R) {
          var x = dE(t || {});
          x && x[
            ra
            /* @min:%2ediagLog */
          ] && x[
            ra
            /* @min:%2ediagLog */
          ](T, R);
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
);
function Q_(e) {
  return e || new _s();
}
function en(e, t, i, u, o, c) {
  c === void 0 && (c = !1), Q_(e).throwInternal(t, i, u, o, c);
}
function ki(e, t) {
  Q_(e)[
    lc
    /* @min:%2ewarnToConsole */
  ](t);
}
function iw(e, t, i) {
  Q_(e)[
    Xp
    /* @min:%2elogInternalMessage */
  ](t, i);
}
var $a = "ctx", Zv = "ParentContextKey", lo = "ChildrenContextKey", aw = null, _c = (
  /** @class */
  function() {
    function e(t, i, u) {
      var o = this, c = !1;
      if (o.start = $e(), o[
        ui
        /* @min:%2ename */
      ] = t, o[
        tu
        /* @min:%2eisAsync */
      ] = u, o[
        Hv
        /* @min:%2eisChildEvt */
      ] = function() {
        return !1;
      }, Cn(i)) {
        var s;
        c = Kt(o, "payload", function() {
          return !s && Cn(i) && (s = i(), i = null), s;
        });
      }
      o[
        Ka
        /* @min:%2egetCtx */
      ] = function(v) {
        return v ? v === e[Zv] || v === e[lo] ? o[v] : (o[$a] || {})[v] : null;
      }, o[
        ze
        /* @min:%2esetCtx */
      ] = function(v, d) {
        if (v)
          if (v === e[Zv])
            o[v] || (o[
              Hv
              /* @min:%2eisChildEvt */
            ] = function() {
              return !0;
            }), o[v] = d;
          else if (v === e[lo])
            o[v] = d;
          else {
            var p = o[$a] = o[$a] || {};
            p[v] = d;
          }
      }, o[
        Bv
        /* @min:%2ecomplete */
      ] = function() {
        var v = 0, d = o[
          Ka
          /* @min:%2egetCtx */
        ](e[lo]);
        if (Xn(d))
          for (var p = 0; p < d[
            Pn
            /* @min:%2elength */
          ]; p++) {
            var h = d[p];
            h && (v += h[
              uo
              /* @min:%2etime */
            ]);
          }
        o[
          uo
          /* @min:%2etime */
        ] = $e() - o.start, o.exTime = o[
          uo
          /* @min:%2etime */
        ] - v, o[
          Bv
          /* @min:%2ecomplete */
        ] = function() {
        }, !c && Cn(i) && (o.payload = i());
      };
    }
    return e.ParentContextKey = "parent", e.ChildrenContextKey = "childEvts", e;
  }()
), uw = (
  /** @class */
  function() {
    function e(t) {
      this.ctx = {}, nr(e, this, function(i) {
        i.create = function(u, o, c) {
          return new _c(u, o, c);
        }, i.fire = function(u) {
          u && (u[
            Bv
            /* @min:%2ecomplete */
          ](), t && Cn(t[
            Ba
            /* @min:%2eperfEvent */
          ]) && t[
            Ba
            /* @min:%2eperfEvent */
          ](u));
        }, i[
          ze
          /* @min:%2esetCtx */
        ] = function(u, o) {
          if (u) {
            var c = i[$a] = i[$a] || {};
            c[u] = o;
          }
        }, i[
          Ka
          /* @min:%2egetCtx */
        ] = function(u) {
          return (i[$a] || {})[u];
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), Kl = "CoreUtils.doPerf";
function Wc(e, t, i, u, o) {
  if (e) {
    var c = e;
    if (c[Fc] && (c = c[Fc]()), c) {
      var s = void 0, v = c[
        Ka
        /* @min:%2egetCtx */
      ](Kl);
      try {
        if (s = c.create(t(), u, o), s) {
          if (v && s[
            ze
            /* @min:%2esetCtx */
          ] && (s[
            ze
            /* @min:%2esetCtx */
          ](_c[Zv], v), v[
            Ka
            /* @min:%2egetCtx */
          ] && v[
            ze
            /* @min:%2esetCtx */
          ])) {
            var d = v[
              Ka
              /* @min:%2egetCtx */
            ](_c[lo]);
            d || (d = [], v[
              ze
              /* @min:%2esetCtx */
            ](_c[lo], d)), d[
              Kn
              /* @min:%2epush */
            ](s);
          }
          return c[
            ze
            /* @min:%2esetCtx */
          ](Kl, s), i(s);
        }
      } catch (p) {
        s && s[
          ze
          /* @min:%2esetCtx */
        ] && s[
          ze
          /* @min:%2esetCtx */
        ]("exception", p);
      } finally {
        s && c.fire(s), c[
          ze
          /* @min:%2esetCtx */
        ](Kl, v);
      }
    }
  }
  return i();
}
function ow() {
  return aw;
}
var hE = 4294967296, Ki = 4294967295, gE = !1, Ju = 123456789, Qu = 987654321;
function fw(e) {
  e < 0 && (e >>>= 0), Ju = 123456789 + e & Ki, Qu = 987654321 - e & Ki, gE = !0;
}
function cw() {
  try {
    var e = $e() & 2147483647;
    fw((Math.random() * hE ^ e) + e);
  } catch {
  }
}
function zc(e) {
  var t = 0, i = VC() || ZC();
  return i && i.getRandomValues && (t = i.getRandomValues(new Uint32Array(1))[0] & Ki), t === 0 && Vv() && (gE || cw(), t = sw() & Ki), t === 0 && (t = Math.floor(hE * Math.random() | 0)), e || (t >>>= 0), t;
}
function sw(e) {
  Qu = 36969 * (Qu & 65535) + (Qu >> 16) & Ki, Ju = 18e3 * (Ju & 65535) + (Ju >> 16) & Ki;
  var t = (Qu << 16) + (Ju & 65535) >>> 0 & Ki | 0;
  return e || (t >>>= 0), t;
}
function j_(e) {
  e === void 0 && (e = 22);
  for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = zc() >>> 0, u = 0, o = bn; o[
    Pn
    /* @min:%2elength */
  ] < e; )
    u++, o += t.charAt(i & 63), i >>>= 6, u === 5 && (i = (zc() << 2 & 4294967295 | i & 3) >>> 0, u = 0);
  return o;
}
var T0 = Wp, pE = "2.8.16", lw = "." + j_(6), vw = 0;
function _w(e, t, i) {
  if (T0)
    try {
      return T0(e, t, {
        value: i,
        enumerable: !1,
        configurable: !0
      }), !0;
    } catch {
    }
  return !1;
}
function EE(e) {
  return e[
    Hl
    /* @min:%2enodeType */
  ] === 1 || e[
    Hl
    /* @min:%2enodeType */
  ] === 9 || !+e[
    Hl
    /* @min:%2enodeType */
  ];
}
function dw(e, t) {
  var i = t[e.id];
  if (!i) {
    i = {};
    try {
      EE(t) && (_w(t, e.id, i) || (t[e.id] = i));
    } catch {
    }
  }
  return i;
}
function Ve(e, t) {
  return t === void 0 && (t = !1), Bc(e + vw++ + (t ? "." + pE : bn) + lw);
}
function TE(e) {
  var t = {
    id: Ve("_aiData-" + (e || bn) + "." + pE),
    accept: function(i) {
      return EE(i);
    },
    get: function(i, u, o, c) {
      var s = i[t.id];
      return s ? s[Bc(u)] : (c && (s = dw(t, i), s[Bc(u)] = o), o);
    },
    kill: function(i, u) {
      if (i && i[u])
        try {
          delete i[u];
        } catch {
        }
    }
  };
  return t;
}
var S0 = "toGMTString", N0 = "toUTCString", nd = "cookie", Xl = "expires", Jv = "enabled", D0 = "isCookieUseDisabled", I0 = "disableCookiesUsage", $t = "_ckMgr", Yf = null, $l = null, A0 = null, Co = le(), R0 = {}, qc = {};
function hw(e, t) {
  var i = vo[$t] || qc[$t];
  return i || (i = vo[$t] = vo(e, t), qc[$t] = i), i;
}
function Uf(e) {
  return e ? e.isEnabled() : !0;
}
function gw(e) {
  var t = e[
    Uv
    /* @min:%2ecookieCfg */
  ] = e[
    Uv
    /* @min:%2ecookieCfg */
  ] || {};
  if (Gn(t, "domain", e.cookieDomain, RC, Q), Gn(t, "path", e.cookiePath || "/", null, Q), Q(t[Jv])) {
    var i = void 0;
    xr(e[D0]) || (i = !e[D0]), xr(e[I0]) || (i = !e[I0]), t[Jv] = i;
  }
  return t;
}
function SE(e, t) {
  return t && e && Xn(e.ignoreCookies) ? e.ignoreCookies[
    bo
    /* @min:%2eindexOf */
  ](t) !== -1 : !1;
}
function pw(e, t) {
  return t && e && Xn(e.blockedCookies) && e.blockedCookies[
    bo
    /* @min:%2eindexOf */
  ](t) !== -1 ? !0 : SE(e, t);
}
function rd(e, t) {
  var i;
  if (e)
    i = e.getCookieMgr();
  else if (t) {
    var u = t[
      Uv
      /* @min:%2ecookieCfg */
    ];
    u[$t] ? i = u[$t] : i = vo(t);
  }
  return i || (i = hw(t, (e || {})[
    jr
    /* @min:%2elogger */
  ])), i;
}
function vo(e, t) {
  var i, u = gw(e || qc), o = u.path || "/", c = u.domain, s = u[Jv] !== !1, v = (i = {
    isEnabled: function() {
      var d = s && C0(t), p = qc[$t];
      return d && p && v !== p && (d = Uf(p)), d;
    }
  }, i[
    Kp
    /* @min:setEnabled */
  ] = function(d) {
    s = d !== !1;
  }, i.set = function(d, p, h, S, I) {
    var T = !1;
    if (Uf(v) && !pw(u, d)) {
      var R = {}, x = zr(p || bn), E = x[
        bo
        /* @min:%2eindexOf */
      ](";");
      if (E !== -1 && (x = zr(p[
        Yc
        /* @min:%2esubstring */
      ](0, E)), R = NE(p[
        Yc
        /* @min:%2esubstring */
      ](E + 1))), Gn(R, "domain", S || c, Kv, xr), !Q(h)) {
        var b = Vv();
        if (xr(R[Xl])) {
          var m = $e(), F = m + h * 1e3;
          if (F > 0) {
            var y = /* @__PURE__ */ new Date();
            y.setTime(F), Gn(R, Xl, w0(y, b ? S0 : N0) || w0(y, b ? S0 : N0) || bn, Kv);
          }
        }
        b || Gn(R, "max-age", bn + h, null, xr);
      }
      var j = Xt();
      j && j.protocol === "https:" && (Gn(R, "secure", null, null, xr), $l === null && ($l = !Tw((At() || {})[
        Uc
        /* @min:%2euserAgent */
      ])), $l && Gn(R, "SameSite", "None", null, xr)), Gn(R, "path", I || o, null, xr);
      var un = u.setCookie || m0;
      un(d, y0(x, R)), T = !0;
    }
    return T;
  }, i.get = function(d) {
    var p = bn;
    return Uf(v) && !SE(u, d) && (p = (u.getCookie || Ew)(d)), p;
  }, i.del = function(d, p) {
    var h = !1;
    return Uf(v) && (h = v.purge(d, p)), h;
  }, i.purge = function(d, p) {
    var h, S = !1;
    if (C0(t)) {
      var I = (h = {}, h.path = p || "/", h[Xl] = "Thu, 01 Jan 1970 00:00:01 GMT", h);
      Vv() || (I["max-age"] = "0");
      var T = u.delCookie || m0;
      T(d, y0(bn, I)), S = !0;
    }
    return S;
  }, i);
  return v[$t] = v, v;
}
function C0(e) {
  if (Yf === null) {
    Yf = !1;
    try {
      var t = Co || {};
      Yf = t[nd] !== void 0;
    } catch (i) {
      en(e, 2, 68, "Cannot access document.cookie - " + Fn(i), { exception: dn(i) });
    }
  }
  return Yf;
}
function NE(e) {
  var t = {};
  if (e && e[
    Pn
    /* @min:%2elength */
  ]) {
    var i = zr(e)[
      Ao
      /* @min:%2esplit */
    ](";");
    hn(i, function(u) {
      if (u = zr(u || bn), u) {
        var o = u[
          bo
          /* @min:%2eindexOf */
        ]("=");
        o === -1 ? t[u] = null : t[zr(u[
          Yc
          /* @min:%2esubstring */
        ](0, o))] = zr(u[
          Yc
          /* @min:%2esubstring */
        ](o + 1));
      }
    });
  }
  return t;
}
function w0(e, t) {
  return Cn(e[t]) ? e[t]() : null;
}
function y0(e, t) {
  var i = e || bn;
  return ir(t, function(u, o) {
    i += "; " + u + (Q(o) ? bn : "=" + o);
  }), i;
}
function Ew(e) {
  var t = bn;
  if (Co) {
    var i = Co[nd] || bn;
    A0 !== i && (R0 = NE(i), A0 = i), t = zr(R0[e] || bn);
  }
  return t;
}
function m0(e, t) {
  Co && (Co[nd] = e + "=" + t);
}
function Tw(e) {
  return En(e) ? !!(Ur(e, "CPU iPhone OS 12") || Ur(e, "iPad; CPU OS 12") || Ur(e, "Macintosh; Intel Mac OS X 10_14") && Ur(e, "Version/") && Ur(e, "Safari") || Ur(e, "Macintosh; Intel Mac OS X 10_14") && CC(e, "AppleWebKit/605.1.15 (KHTML, like Gecko)") || Ur(e, "Chrome/5") || Ur(e, "Chrome/6") || Ur(e, "UnrealEngine") && !Ur(e, "Chrome") || Ur(e, "UCBrowser/12") || Ur(e, "UCBrowser/11")) : !1;
}
var DE = "on", x0 = "attachEvent", P0 = "addEventListener", O0 = "detachEvent", L0 = "removeEventListener", Qv = "events", jv = "visibilitychange", ds = "pagehide", IE = "unload", AE = "beforeunload", RE = Ve("aiEvtPageHide");
Ve("aiEvtPageShow");
var Sw = /\.[\.]+/g, Nw = /[\.]+$/, Dw = 1, Kc = TE("events"), Iw = /^([^.]*)(?:\.(.+)|)/;
function b0(e) {
  return e && e[
    Qt
    /* @min:%2ereplace */
  ] ? e[
    Qt
    /* @min:%2ereplace */
  ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, bn) : e;
}
function ed(e, t) {
  var i;
  if (t) {
    var u = bn;
    Xn(t) ? (u = bn, hn(t, function(c) {
      c = b0(c), c && (c[0] !== "." && (c = "." + c), u += c);
    })) : u = b0(t), u && (u[0] !== "." && (u = "." + u), e = (e || bn) + u);
  }
  var o = Iw.exec(e || bn) || [];
  return i = {}, i[
    ht
    /* @min:type */
  ] = o[1], i.ns = (o[2] || bn).replace(Sw, ".").replace(Nw, bn)[
    Ao
    /* @min:%2esplit */
  ](".").sort().join("."), i;
}
function CE(e, t, i) {
  i === void 0 && (i = !0);
  var u = Kc.get(e, Qv, {}, i), o = u[t];
  return o || (o = u[t] = []), o;
}
function wE(e, t, i, u) {
  e && t && t[
    ht
    /* @min:%2etype */
  ] && (e[L0] ? e[L0](t[
    ht
    /* @min:%2etype */
  ], i, u) : e[O0] && e[O0](DE + t[
    ht
    /* @min:%2etype */
  ], i));
}
function Aw(e, t, i, u) {
  var o = !1;
  return e && t && t[
    ht
    /* @min:%2etype */
  ] && i && (e[P0] ? (e[P0](t[
    ht
    /* @min:%2etype */
  ], i, u), o = !0) : e[x0] && (e[x0](DE + t[
    ht
    /* @min:%2etype */
  ], i), o = !0)), o;
}
function M0(e, t, i, u) {
  for (var o = t[
    Pn
    /* @min:%2elength */
  ]; o--; ) {
    var c = t[o];
    c && (!i.ns || i.ns === c.evtName.ns) && (!u || u(c)) && (wE(e, c.evtName, c[
      q_
      /* @min:%2ehandler */
    ], c.capture), t[
      eu
      /* @min:%2esplice */
    ](o, 1));
  }
}
function Rw(e, t, i) {
  if (t[
    ht
    /* @min:%2etype */
  ])
    M0(e, CE(e, t[
      ht
      /* @min:%2etype */
    ]), t, i);
  else {
    var u = Kc.get(e, Qv, {});
    ir(u, function(o, c) {
      M0(e, c, t, i);
    }), ea(u)[
      Pn
      /* @min:%2elength */
    ] === 0 && Kc.kill(e, Qv);
  }
}
function ta(e, t) {
  var i;
  return t ? (Xn(t) ? i = [e].concat(t) : i = [e, t], i = ed("xx", i).ns[
    Ao
    /* @min:%2esplit */
  ](".")) : i = e, i;
}
function ri(e, t, i, u, o) {
  var c;
  o === void 0 && (o = !1);
  var s = !1;
  if (e)
    try {
      var v = ed(t, u);
      if (s = Aw(e, v, i, o), s && Kc.accept(e)) {
        var d = (c = {
          guid: Dw++,
          evtName: v
        }, c[
          q_
          /* @min:handler */
        ] = i, c.capture = o, c);
        CE(e, v.type)[
          Kn
          /* @min:%2epush */
        ](d);
      }
    } catch {
    }
  return s;
}
function _o(e, t, i, u, o) {
  if (o === void 0 && (o = !1), e)
    try {
      var c = ed(t, u), s = !1;
      Rw(e, c, function(v) {
        return c.ns && !i || v[
          q_
          /* @min:%2ehandler */
        ] === i ? (s = !0, !0) : !1;
      }), s || wE(e, c, i, o);
    } catch {
    }
}
function Cw(e, t, i) {
  var u = !1, o = ni();
  o && (u = ri(o, e, t, i), u = ri(o.body, e, t, i) || u);
  var c = le();
  return c && (u = ri(c, e, t, i) || u), u;
}
function ww(e, t, i) {
  var u = ni();
  u && (_o(u, e, t, i), _o(u.body, e, t, i));
  var o = le();
  o && _o(o, e, t, i);
}
function Xc(e, t, i, u) {
  var o = !1;
  return t && e && e[
    Pn
    /* @min:%2elength */
  ] > 0 && hn(e, function(c) {
    c && (!i || be(i, c) === -1) && (o = Cw(c, t, u) || o);
  }), o;
}
function yw(e, t, i, u) {
  var o = !1;
  return t && e && Xn(e) && (o = Xc(e, t, i, u), !o && i && i[
    Pn
    /* @min:%2elength */
  ] > 0 && (o = Xc(e, t, null, u))), o;
}
function n_(e, t, i) {
  e && Xn(e) && hn(e, function(u) {
    u && ww(u, t, i);
  });
}
function mw(e, t, i) {
  return yw([AE, IE, ds], e, t, i);
}
function xw(e, t) {
  n_([AE, IE, ds], e, t);
}
function r_(e, t, i) {
  function u(s) {
    var v = le();
    e && v && v.visibilityState === "hidden" && e(s);
  }
  var o = ta(RE, i), c = Xc([ds], e, t, o);
  return (!t || be(t, jv) === -1) && (c = Xc([jv], u, t, o) || c), !c && t && (c = r_(e, null, i)), c;
}
function Pw(e, t) {
  var i = ta(RE, t);
  n_([ds], e, i), n_([jv], null, i);
}
function Vt() {
  for (var e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"], t = bn, i, u = 0; u < 4; u++)
    i = zc(), t += e[i & 15] + e[i >> 4 & 15] + e[i >> 8 & 15] + e[i >> 12 & 15] + e[i >> 16 & 15] + e[i >> 20 & 15] + e[i >> 24 & 15] + e[i >> 28 & 15];
  var o = e[8 + (zc() & 3) | 0];
  return t[
    ba
    /* @min:%2esubstr */
  ](0, 8) + t[
    ba
    /* @min:%2esubstr */
  ](9, 4) + "4" + t[
    ba
    /* @min:%2esubstr */
  ](13, 3) + o + t[
    ba
    /* @min:%2esubstr */
  ](16, 3) + t[
    ba
    /* @min:%2esubstr */
  ](19, 12);
}
var e_ = "00", Ow = "ff", yE = "00000000000000000000000000000000", mE = "0000000000000000";
function Uo(e, t, i) {
  return e && e[
    Pn
    /* @min:%2elength */
  ] === t && e !== i ? !!e.match(/^[\da-f]*$/i) : !1;
}
function Y0(e, t, i) {
  return Uo(e, t) ? e : i;
}
function Lw(e) {
  (isNaN(e) || e < 0 || e > 255) && (e = 1);
  for (var t = e.toString(16); t[
    Pn
    /* @min:%2elength */
  ] < 2; )
    t = "0" + t;
  return t;
}
function U0(e, t, i, u) {
  var o;
  return o = {}, o[
    $p
    /* @min:version */
  ] = Uo(u, 2, Ow) ? u : e_, o[
    kv
    /* @min:traceId */
  ] = td(e) ? e : Vt(), o.spanId = id(t) ? t : Vt()[
    ba
    /* @min:%2esubstr */
  ](0, 16), o.traceFlags = i >= 0 && i <= 255 ? i : 1, o;
}
function td(e) {
  return Uo(e, 32, yE);
}
function id(e) {
  return Uo(e, 16, mE);
}
function F0(e) {
  if (e) {
    var t = Lw(e[
      Gv
      /* @min:%2etraceFlags */
    ]);
    Uo(t, 2) || (t = "01");
    var i = e[
      $p
      /* @min:%2eversion */
    ] || e_;
    return i !== "00" && i !== "ff" && (i = e_), "".concat(i.toLowerCase(), "-").concat(Y0(e.traceId, 32, yE).toLowerCase(), "-").concat(Y0(e.spanId, 16, mE).toLowerCase(), "-").concat(t.toLowerCase());
  }
  return "";
}
var bw = TE("plugin");
function Xi(e) {
  return bw.get(e, "state", {}, !0);
}
function xE(e, t) {
  for (var i = [], u = null, o = e[
    qe
    /* @min:%2egetNext */
  ](), c; o; ) {
    var s = o[
      vs
      /* @min:%2egetPlugin */
    ]();
    if (s) {
      u && Cn(u[
        Io
        /* @min:%2esetNextPlugin */
      ]) && Cn(s[
        Xe
        /* @min:%2eprocessTelemetry */
      ]) && u[
        Io
        /* @min:%2esetNextPlugin */
      ](s);
      var v = !1;
      Cn(s[
        _t
        /* @min:%2eisInitialized */
      ]) ? v = s[
        _t
        /* @min:%2eisInitialized */
      ]() : (c = Xi(s), v = c[
        _t
        /* @min:%2eisInitialized */
      ]), v || i[
        Kn
        /* @min:%2epush */
      ](s), u = s, o = o[
        qe
        /* @min:%2egetNext */
      ]();
    }
  }
  hn(i, function(d) {
    var p = e[Tr]();
    d[
      ji
      /* @min:%2einitialize */
    ](e.getCfg(), p, t, e[
      qe
      /* @min:%2egetNext */
    ]()), c = Xi(d), !d[Tr] && !c[Tr] && (c[Tr] = p), c[
      _t
      /* @min:%2eisInitialized */
    ] = !0, delete c[
      st
      /* @min:%2eteardown */
    ];
  });
}
function Vl(e) {
  return e.sort(function(t, i) {
    var u = 0;
    if (i) {
      var o = Cn(i[Xe]);
      Cn(t[Xe]) ? u = o ? t[jt] - i[jt] : 1 : o && (u = -1);
    } else
      u = t ? 1 : -1;
    return u;
  });
}
function Mw(e) {
  var t = {};
  return {
    getName: function() {
      return t[
        ui
        /* @min:%2ename */
      ];
    },
    setName: function(i) {
      e && e.setName(i), t[
        ui
        /* @min:%2ename */
      ] = i;
    },
    getTraceId: function() {
      return t[
        kv
        /* @min:%2etraceId */
      ];
    },
    setTraceId: function(i) {
      e && e.setTraceId(i), td(i) && (t[
        kv
        /* @min:%2etraceId */
      ] = i);
    },
    getSpanId: function() {
      return t[
        a0
        /* @min:%2espanId */
      ];
    },
    setSpanId: function(i) {
      e && e.setSpanId(i), id(i) && (t[
        a0
        /* @min:%2espanId */
      ] = i);
    },
    getTraceFlags: function() {
      return t[
        Gv
        /* @min:%2etraceFlags */
      ];
    },
    setTraceFlags: function(i) {
      e && e.setTraceFlags(i), t[
        Gv
        /* @min:%2etraceFlags */
      ] = i;
    }
  };
}
var Yw = "TelemetryPluginChain", H0 = "_hasRun", B0 = "_getTelCtx", k0 = 0;
function Uw(e, t, i) {
  for (; e; ) {
    if (e[
      vs
      /* @min:%2egetPlugin */
    ]() === i)
      return e;
    e = e[
      qe
      /* @min:%2egetNext */
    ]();
  }
  return fi([i], t[
    na
    /* @min:%2econfig */
  ] || {}, t);
}
function ad(e, t, i, u) {
  var o = null, c = [];
  u !== null && (o = u ? Uw(e, i, u) : e);
  var s = {
    _next: d,
    ctx: {
      core: function() {
        return i;
      },
      diagLog: function() {
        return Yo(i, t);
      },
      getCfg: function() {
        return t;
      },
      getExtCfg: p,
      getConfig: h,
      hasNext: function() {
        return !!o;
      },
      getNext: function() {
        return o;
      },
      setNext: function(I) {
        o = I;
      },
      iterate: S,
      onComplete: v
    }
  };
  function v(I, T) {
    for (var R = [], x = 2; x < arguments.length; x++)
      R[x - 2] = arguments[x];
    I && c[
      Kn
      /* @min:%2epush */
    ]({
      func: I,
      self: xr(T) ? s.ctx : T,
      args: R
    });
  }
  function d() {
    var I = o;
    if (o = I ? I[
      qe
      /* @min:%2egetNext */
    ]() : null, !I) {
      var T = c;
      T && T[
        Pn
        /* @min:%2elength */
      ] > 0 && (hn(T, function(R) {
        try {
          R.func[
            Kr
            /* @min:%2ecall */
          ](R.self, R.args);
        } catch (x) {
          en(i[
            jr
            /* @min:%2elogger */
          ], 2, 73, "Unexpected Exception during onComplete - " + dn(x));
        }
      }), c = []);
    }
    return I;
  }
  function p(I, T, R) {
    T === void 0 && (T = {}), R === void 0 && (R = 0);
    var x;
    if (t) {
      var E = t[
        K_
        /* @min:%2eextensionConfig */
      ];
      E && I && (x = E[I]);
    }
    if (!x)
      x = T;
    else if (Me(T) && R !== 0) {
      var b = Z_(!0, T, x);
      t && R === 2 && ir(T, function(m) {
        if (Q(b[m])) {
          var F = t[m];
          Q(F) || (b[m] = F);
        }
      }), x = b;
    }
    return x;
  }
  function h(I, T, R) {
    R === void 0 && (R = !1);
    var x, E = p(I, null);
    return E && !Q(E[T]) ? x = E[T] : t && !Q(t[T]) && (x = t[T]), Q(x) ? R : x;
  }
  function S(I) {
    for (var T; T = s._next(); ) {
      var R = T[
        vs
        /* @min:%2egetPlugin */
      ]();
      R && I(R);
    }
  }
  return s;
}
function Ze(e, t, i, u) {
  var o = ad(e, t, i, u), c = o.ctx;
  function s(d) {
    var p = o._next();
    return p && p[
      Xe
      /* @min:%2eprocessTelemetry */
    ](d, c), !p;
  }
  function v(d, p) {
    return d === void 0 && (d = null), Xn(d) && (d = fi(d, t, i, p)), Ze(d || c[
      qe
      /* @min:%2egetNext */
    ](), t, i, p);
  }
  return c[
    vr
    /* @min:%2eprocessNext */
  ] = s, c[
    iu
    /* @min:%2ecreateNew */
  ] = v, c;
}
function $c(e, t, i) {
  var u = t[
    na
    /* @min:%2econfig */
  ] || {}, o = ad(e, u, t, i), c = o.ctx;
  function s(d) {
    var p = o._next();
    return p && p.unload(c, d), !p;
  }
  function v(d, p) {
    return d === void 0 && (d = null), Xn(d) && (d = fi(d, u, t, p)), $c(d || c[
      qe
      /* @min:%2egetNext */
    ](), t, p);
  }
  return c[
    vr
    /* @min:%2eprocessNext */
  ] = s, c[
    iu
    /* @min:%2ecreateNew */
  ] = v, c;
}
function ud(e, t, i) {
  var u = t[
    na
    /* @min:%2econfig */
  ] || {}, o = ad(e, u, t, i), c = o.ctx;
  function s(d) {
    return c.iterate(function(p) {
      Cn(p[
        Do
        /* @min:%2eupdate */
      ]) && p[
        Do
        /* @min:%2eupdate */
      ](c, d);
    });
  }
  function v(d, p) {
    return d === void 0 && (d = null), Xn(d) && (d = fi(d, u, t, p)), ud(d || c[
      qe
      /* @min:%2egetNext */
    ](), t, p);
  }
  return c[
    vr
    /* @min:%2eprocessNext */
  ] = s, c[
    iu
    /* @min:%2ecreateNew */
  ] = v, c;
}
function fi(e, t, i, u) {
  var o = null, c = !u;
  if (Xn(e) && e[
    Pn
    /* @min:%2elength */
  ] > 0) {
    var s = null;
    hn(e, function(v) {
      if (!c && u === v && (c = !0), c && v && Cn(v[
        Xe
        /* @min:%2eprocessTelemetry */
      ])) {
        var d = Fw(v, t, i);
        o || (o = d), s && s._setNext(d), s = d;
      }
    });
  }
  return u && !o ? fi([u], t, i) : o;
}
function Fw(e, t, i) {
  var u = null, o = Cn(e[
    Xe
    /* @min:%2eprocessTelemetry */
  ]), c = Cn(e[
    Io
    /* @min:%2esetNextPlugin */
  ]), s;
  e ? s = e[
    Jt
    /* @min:%2eidentifier */
  ] + "-" + e[
    jt
    /* @min:%2epriority */
  ] + "-" + k0++ : s = "Unknown-0-" + k0++;
  var v = {
    getPlugin: function() {
      return e;
    },
    getNext: function() {
      return u;
    },
    processTelemetry: h,
    unload: S,
    update: I,
    _id: s,
    _setNext: function(T) {
      u = T;
    }
  };
  function d() {
    var T;
    return e && Cn(e[B0]) && (T = e[B0]()), T || (T = Ze(v, t, i)), T;
  }
  function p(T, R, x, E, b) {
    var m = !1, F = e ? e[
      Jt
      /* @min:%2eidentifier */
    ] : Yw, y = T[H0];
    return y || (y = T[H0] = {}), T.setNext(u), e && Wc(T[
      Tr
      /* @min:%2ecore */
    ](), function() {
      return F + ":" + x;
    }, function() {
      y[s] = !0;
      try {
        var j = u ? u._id : bn;
        j && (y[j] = !1), m = R(T);
      } catch (k) {
        var un = u ? y[u._id] : !0;
        un && (m = !0), (!u || !un) && en(T[
          ra
          /* @min:%2ediagLog */
        ](), 1, 73, "Plugin [" + F + "] failed during " + x + " - " + dn(k) + ", run flags: " + dn(y));
      }
    }, E, b), m;
  }
  function h(T, R) {
    R = R || d();
    function x(E) {
      if (!e || !o)
        return !1;
      var b = Xi(e);
      return b[
        st
        /* @min:%2eteardown */
      ] || b[Wv] ? !1 : (c && e[
        Io
        /* @min:%2esetNextPlugin */
      ](u), e[
        Xe
        /* @min:%2eprocessTelemetry */
      ](T, E), !0);
    }
    p(R, x, "processTelemetry", function() {
      return { item: T };
    }, !T.sync) || R[
      vr
      /* @min:%2eprocessNext */
    ](T);
  }
  function S(T, R) {
    function x() {
      var E = !1;
      if (e) {
        var b = Xi(e), m = e[Tr] || b[
          Tr
          /* @min:%2ecore */
        ];
        e && (!m || m === T.core()) && !b[
          st
          /* @min:%2eteardown */
        ] && (b[
          Tr
          /* @min:%2ecore */
        ] = null, b[
          st
          /* @min:%2eteardown */
        ] = !0, b[
          _t
          /* @min:%2eisInitialized */
        ] = !1, e[
          st
          /* @min:%2eteardown */
        ] && e[
          st
          /* @min:%2eteardown */
        ](T, R) === !0 && (E = !0));
      }
      return E;
    }
    p(T, x, "unload", function() {
    }, R[
      tu
      /* @min:%2eisAsync */
    ]) || T[
      vr
      /* @min:%2eprocessNext */
    ](R);
  }
  function I(T, R) {
    function x() {
      var E = !1;
      if (e) {
        var b = Xi(e), m = e[Tr] || b[
          Tr
          /* @min:%2ecore */
        ];
        e && (!m || m === T.core()) && !b[
          st
          /* @min:%2eteardown */
        ] && e[
          Do
          /* @min:%2eupdate */
        ] && e[
          Do
          /* @min:%2eupdate */
        ](T, R) === !0 && (E = !0);
      }
      return E;
    }
    p(T, x, "update", function() {
    }, !1) || T[
      vr
      /* @min:%2eprocessNext */
    ](R);
  }
  return Xa(v);
}
var hs = 500, Hw = "Channel has invalid priority - ";
function G0(e, t, i) {
  t && Xn(t) && t[
    Pn
    /* @min:%2elength */
  ] > 0 && (t = t.sort(function(u, o) {
    return u[
      jt
      /* @min:%2epriority */
    ] - o[
      jt
      /* @min:%2epriority */
    ];
  }), hn(t, function(u) {
    u[
      jt
      /* @min:%2epriority */
    ] < hs && Gr(Hw + u[
      Jt
      /* @min:%2eidentifier */
    ]);
  }), e[
    Kn
    /* @min:%2epush */
  ]({
    queue: Xa(t),
    chain: fi(t, i[
      na
      /* @min:%2econfig */
    ], i)
  }));
}
function Bw(e, t) {
  function i() {
    return Ze(null, t[
      na
      /* @min:%2econfig */
    ], t, null);
  }
  function u(p, h, S, I) {
    var T = p ? p[
      Pn
      /* @min:%2elength */
    ] + 1 : 1;
    function R() {
      T--, T === 0 && (I && I(), I = null);
    }
    T > 0 && hn(p, function(x) {
      if (x && x.queue[
        Pn
        /* @min:%2elength */
      ] > 0) {
        var E = x.chain, b = h[
          iu
          /* @min:%2ecreateNew */
        ](E);
        b[
          Vu
          /* @min:%2eonComplete */
        ](R), S(b);
      } else
        T--;
    }), R();
  }
  function o(p, h) {
    var S = h || {
      reason: 0
      /* TelemetryUpdateReason.Unknown */
    };
    return u(e, p, function(I) {
      I[
        vr
        /* @min:%2eprocessNext */
      ](S);
    }, function() {
      p[
        vr
        /* @min:%2eprocessNext */
      ](S);
    }), !0;
  }
  function c(p, h) {
    var S = h || {
      reason: 0,
      isAsync: !1
    };
    return u(e, p, function(I) {
      I[
        vr
        /* @min:%2eprocessNext */
      ](S);
    }, function() {
      p[
        vr
        /* @min:%2eprocessNext */
      ](S), v = !1;
    }), !0;
  }
  function s(p) {
    var h = null;
    return e && e[
      Pn
      /* @min:%2elength */
    ] > 0 && hn(e, function(S) {
      if (S && S.queue[
        Pn
        /* @min:%2elength */
      ] > 0 && (hn(S.queue, function(I) {
        if (I[
          Jt
          /* @min:%2eidentifier */
        ] === p)
          return h = I, -1;
      }), h))
        return -1;
    }), h;
  }
  var v = !1, d = {
    identifier: "ChannelControllerPlugin",
    priority: hs,
    initialize: function(p, h, S, I) {
      v = !0, hn(e, function(T) {
        T && T.queue[
          Pn
          /* @min:%2elength */
        ] > 0 && xE(Ze(T.chain, p, h), S);
      });
    },
    isInitialized: function() {
      return v;
    },
    processTelemetry: function(p, h) {
      u(e, h || i(), function(S) {
        S[
          vr
          /* @min:%2eprocessNext */
        ](p);
      }, function() {
        h[
          vr
          /* @min:%2eprocessNext */
        ](p);
      });
    },
    update: o,
    pause: function() {
      u(e, i(), function(p) {
        p.iterate(function(h) {
          h.pause && h.pause();
        });
      }, null);
    },
    resume: function() {
      u(e, i(), function(p) {
        p.iterate(function(h) {
          h.resume && h.resume();
        });
      }, null);
    },
    teardown: c,
    getChannel: s,
    flush: function(p, h, S, I) {
      var T = 1, R = !1, x = null;
      I = I || 5e3;
      function E() {
        T--, R && T === 0 && (x && (clearTimeout(x), x = null), h && h(R), h = null);
      }
      return u(e, i(), function(b) {
        b.iterate(function(m) {
          if (m[
            bc
            /* @min:%2eflush */
          ]) {
            T++;
            var F = !1;
            m[
              bc
              /* @min:%2eflush */
            ](p, function() {
              F = !0, E();
            }, S) || F || (p && x == null ? x = setTimeout(function() {
              x = null, E();
            }, I) : E());
          }
        });
      }, function() {
        R = !0, E();
      }), !0;
    },
    _setQueue: function(p) {
      e = p;
    }
  };
  return d;
}
function kw(e, t, i) {
  var u = [];
  if (e && hn(e, function(c) {
    return G0(u, c, i);
  }), t) {
    var o = [];
    hn(t, function(c) {
      c[
        jt
        /* @min:%2epriority */
      ] > hs && o[
        Kn
        /* @min:%2epush */
      ](c);
    }), G0(u, o, i);
  }
  return u;
}
function PE() {
  var e = [];
  function t(u) {
    u && e[
      Kn
      /* @min:%2epush */
    ](u);
  }
  function i(u, o) {
    hn(e, function(c) {
      try {
        c(u, o);
      } catch (s) {
        en(u[
          ra
          /* @min:%2ediagLog */
        ](), 2, 73, "Unexpected error calling unload handler - " + dn(s));
      }
    }), e = [];
  }
  return {
    add: t,
    run: i
  };
}
var bt = "getPlugin", Fo = (
  /** @class */
  function() {
    function e() {
      var t = this, i, u, o, c, s;
      p(), nr(e, t, function(h) {
        h[
          ji
          /* @min:%2einitialize */
        ] = function(S, I, T, R) {
          d(S, I, R), i = !0;
        }, h[
          st
          /* @min:%2eteardown */
        ] = function(S, I) {
          var T, R = h[
            Tr
            /* @min:%2ecore */
          ];
          if (!R || S && R !== S[
            Tr
            /* @min:%2ecore */
          ]())
            return;
          var x, E = !1, b = S || $c(null, R, o && o[bt] ? o[bt]() : o), m = I || (T = {
            reason: 0
            /* TelemetryUnloadReason.ManualTeardown */
          }, T[
            tu
            /* @min:isAsync */
          ] = !1, T);
          function F() {
            if (!E) {
              E = !0, c.run(b, I);
              var y = s;
              s = [], hn(y, function(j) {
                j.rm();
              }), x === !0 && b[
                vr
                /* @min:%2eprocessNext */
              ](m), p();
            }
          }
          return !h[
            Yv
            /* @min:%2e_doTeardown */
          ] || h[
            Yv
            /* @min:%2e_doTeardown */
          ](b, m, F) !== !0 ? F() : x = !0, x;
        }, h[
          Do
          /* @min:%2eupdate */
        ] = function(S, I) {
          var T = h[
            Tr
            /* @min:%2ecore */
          ];
          if (!T || S && T !== S[
            Tr
            /* @min:%2ecore */
          ]())
            return;
          var R, x = !1, E = S || ud(null, T, o && o[bt] ? o[bt]() : o), b = I || {
            reason: 0
            /* TelemetryUpdateReason.Unknown */
          };
          function m() {
            x || (x = !0, d(E.getCfg(), E.core(), E[
              qe
              /* @min:%2egetNext */
            ]()));
          }
          return !h._doUpdate || h._doUpdate(E, b, m) !== !0 ? m() : R = !0, R;
        }, h._addHook = function(S) {
          S && (Xn(S) ? s = s.concat(S) : s[
            Kn
            /* @min:%2epush */
          ](S));
        }, V_(h, "_addUnloadCb", function() {
          return c;
        }, "add");
      }), t[
        ra
        /* @min:%2ediagLog */
      ] = function(h) {
        return v(h)[
          ra
          /* @min:%2ediagLog */
        ]();
      }, t[
        _t
        /* @min:%2eisInitialized */
      ] = function() {
        return i;
      }, t.setInitialized = function(h) {
        i = h;
      }, t[
        Io
        /* @min:%2esetNextPlugin */
      ] = function(h) {
        o = h;
      }, t[
        vr
        /* @min:%2eprocessNext */
      ] = function(h, S) {
        S ? S[
          vr
          /* @min:%2eprocessNext */
        ](h) : o && Cn(o[
          Xe
          /* @min:%2eprocessTelemetry */
        ]) && o[
          Xe
          /* @min:%2eprocessTelemetry */
        ](h, null);
      }, t._getTelCtx = v;
      function v(h) {
        h === void 0 && (h = null);
        var S = h;
        if (!S) {
          var I = u || Ze(null, {}, t[
            Tr
            /* @min:%2ecore */
          ]);
          o && o[bt] ? S = I[
            iu
            /* @min:%2ecreateNew */
          ](null, o[bt]) : S = I[
            iu
            /* @min:%2ecreateNew */
          ](null, o);
        }
        return S;
      }
      function d(h, S, I) {
        h && Gn(h, K_, [], null, Q), !I && S && (I = S[
          qp
          /* @min:%2egetProcessTelContext */
        ]()[
          qe
          /* @min:%2egetNext */
        ]());
        var T = o;
        o && o[bt] && (T = o[bt]()), t[
          Tr
          /* @min:%2ecore */
        ] = S, u = Ze(I, h, S, T);
      }
      function p() {
        i = !1, t[
          Tr
          /* @min:%2ecore */
        ] = null, u = null, o = null, s = [], c = PE();
      }
    }
    return e.__ieDyn = 1, e;
  }()
), Gw = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      var i = e.call(this) || this;
      i.identifier = "TelemetryInitializerPlugin", i.priority = 199;
      var u, o;
      c(), nr(t, i, function(s, v) {
        s.addTelemetryInitializer = function(d) {
          var p = {
            id: u++,
            fn: d
          };
          o[
            Kn
            /* @min:%2epush */
          ](p);
          var h = {
            remove: function() {
              hn(o, function(S, I) {
                if (S.id === p.id)
                  return o[
                    eu
                    /* @min:%2esplice */
                  ](I, 1), -1;
              });
            }
          };
          return h;
        }, s[
          Xe
          /* @min:%2eprocessTelemetry */
        ] = function(d, p) {
          for (var h = !1, S = o[
            Pn
            /* @min:%2elength */
          ], I = 0; I < S; ++I) {
            var T = o[I];
            if (T)
              try {
                if (T.fn[
                  au
                  /* @min:%2eapply */
                ](null, [d]) === !1) {
                  h = !0;
                  break;
                }
              } catch (R) {
                en(p[
                  ra
                  /* @min:%2ediagLog */
                ](), 1, 64, "One of telemetry initializers failed, telemetry item will not be sent: " + Fn(R), { exception: dn(R) }, !0);
              }
          }
          h || s[
            vr
            /* @min:%2eprocessNext */
          ](d, p);
        }, s[
          Yv
          /* @min:%2e_doTeardown */
        ] = function() {
          c();
        };
      });
      function c() {
        u = 0, o = [];
      }
      return i;
    }
    return t.__ieDyn = 1, t;
  }(Fo)
), OE = "Plugins must provide initialize method", W0 = "_notificationManager", z0 = "SDK is still unloading...", Ww = "SDK is not initialized", zw = {
  // Have the Diagnostic Logger default to log critical errors to the console
  loggingLevelConsole: 1
  /* eLoggingSeverity.CRITICAL */
};
function qw(e, t) {
  return new uw(t);
}
function Kw(e, t, i) {
  var u, o = [], c = {};
  return hn(i, function(s) {
    (Q(s) || Q(s[
      ji
      /* @min:%2einitialize */
    ])) && Gr(OE);
    var v = s[
      jt
      /* @min:%2epriority */
    ], d = s[
      Jt
      /* @min:%2eidentifier */
    ];
    s && v && (Q(c[v]) ? c[v] = d : ki(e, "Two extensions have same priority #" + v + " - " + c[v] + ", " + d)), (!v || v < t) && o[
      Kn
      /* @min:%2epush */
    ](s);
  }), u = {
    all: i
  }, u[
    Tr
    /* @min:core */
  ] = o, u;
}
function q0(e, t) {
  var i = !1;
  return hn(t, function(u) {
    if (u === e)
      return i = !0, -1;
  }), i;
}
function Xw() {
  var e;
  return zp((e = {}, e[
    oo
    /* @min:addNotificationListener */
  ] = function(t) {
  }, e[
    fo
    /* @min:removeNotificationListener */
  ] = function(t) {
  }, e[
    cc
    /* @min:eventsSent */
  ] = function(t) {
  }, e[
    co
    /* @min:eventsDiscarded */
  ] = function(t, i) {
  }, e[
    sc
    /* @min:eventsSendRequest */
  ] = function(t, i) {
  }, e));
}
var $w = (
  /** @class */
  function() {
    function e() {
      var t, i, u, o, c, s, v, d, p, h, S, I, T, R, x, E, b, m, F, y, j = 0, un = !1;
      nr(e, this, function(k) {
        Zn(), k[
          _t
          /* @min:%2eisInitialized */
        ] = function() {
          return i;
        }, k[
          ji
          /* @min:%2einitialize */
        ] = function(P, X, rn, D) {
          R && Gr(z0), k[
            _t
            /* @min:%2eisInitialized */
          ]() && Gr("Core should not be initialized more than once"), t = P || {}, k[
            na
            /* @min:%2econfig */
          ] = t, Q(P[
            Fl
            /* @min:%2einstrumentationKey */
          ]) && Gr("Please provide instrumentation key"), o = D, k[W0] = D, Mn(), rr(), M(), rn && (k[
            jr
            /* @min:%2elogger */
          ] = rn);
          var Y = Rr(t, dC, []);
          p = [], p[
            Kn
            /* @min:%2epush */
          ].apply(p, e0(e0([], X, !1), Y)), I = Rr(t, u0, []), on(null), (!T || T[
            Pn
            /* @min:%2elength */
          ] === 0) && Gr("No " + u0 + " available"), i = !0, k.releaseQueue();
        }, k.getTransmissionControls = function() {
          var P = [];
          return T && hn(T, function(X) {
            P[
              Kn
              /* @min:%2epush */
            ](X.queue);
          }), Xa(P);
        }, k.track = function(P) {
          P.iKey = P.iKey || t[
            Fl
            /* @min:%2einstrumentationKey */
          ], P[
            uo
            /* @min:%2etime */
          ] = P[
            uo
            /* @min:%2etime */
          ] || uu(/* @__PURE__ */ new Date()), P.ver = P.ver || "4.0", !R && k[
            _t
            /* @min:%2eisInitialized */
          ]() ? or()[
            vr
            /* @min:%2eprocessNext */
          ](P) : u[
            Kn
            /* @min:%2epush */
          ](P);
        }, k[
          qp
          /* @min:%2egetProcessTelContext */
        ] = or, k[
          Mv
          /* @min:%2egetNotifyMgr */
        ] = function() {
          return o || (o = Xw(), k[W0] = o), o;
        }, k[
          oo
          /* @min:%2eaddNotificationListener */
        ] = function(P) {
          o && o[
            oo
            /* @min:%2eaddNotificationListener */
          ](P);
        }, k[
          fo
          /* @min:%2eremoveNotificationListener */
        ] = function(P) {
          o && o[
            fo
            /* @min:%2eremoveNotificationListener */
          ](P);
        }, k.getCookieMgr = function() {
          return v || (v = vo(t, k[
            jr
            /* @min:%2elogger */
          ])), v;
        }, k.setCookieMgr = function(P) {
          v = P;
        }, k[
          Fc
          /* @min:%2egetPerfMgr */
        ] = function() {
          if (!c && !s && Oe(t.enablePerfMgr)) {
            var P = Oe(t[
              o0
              /* @min:%2ecreatePerfMgr */
            ]);
            Cn(P) && (s = P(k, k[
              Mv
              /* @min:%2egetNotifyMgr */
            ]()));
          }
          return c || s || ow();
        }, k.setPerfMgr = function(P) {
          c = P;
        }, k.eventCnt = function() {
          return u[
            Pn
            /* @min:%2elength */
          ];
        }, k.releaseQueue = function() {
          if (i && u[
            Pn
            /* @min:%2elength */
          ] > 0) {
            var P = u;
            u = [], hn(P, function(X) {
              or()[
                vr
                /* @min:%2eprocessNext */
              ](X);
            });
          }
        }, k.pollInternalLogs = function(P) {
          return E = P || null, un = !1, j && (clearInterval(j), j = null), On(!0);
        };
        function On(P) {
          if (!j && !un) {
            var X = P || k[
              jr
              /* @min:%2elogger */
            ] && k[
              jr
              /* @min:%2elogger */
            ].queue[
              Pn
              /* @min:%2elength */
            ] > 0;
            if (X) {
              var rn = Oe(t.diagnosticLogInterval);
              (!rn || !(rn > 0)) && (rn = 1e4), j = setInterval(function() {
                clearInterval(j), j = 0, Lr();
              }, rn);
            }
          }
          return j;
        }
        k[
          t0
          /* @min:%2estopPollingInternalLogs */
        ] = function() {
          un = !0, j && (clearInterval(j), j = 0, Lr());
        }, Zu(k, function() {
          return x;
        }, ["addTelemetryInitializer"]), k.unload = function(P, X, rn) {
          var D;
          P === void 0 && (P = !0), i || Gr(Ww), R && Gr(z0);
          var Y = (D = {
            reason: 50
            /* TelemetryUnloadReason.SdkUnload */
          }, D[
            tu
            /* @min:isAsync */
          ] = P, D.flushComplete = !1, D), W = $c(Ir(), k);
          W[
            Vu
            /* @min:%2eonComplete */
          ](function() {
            Zn(), X && X(Y);
          }, k);
          function J(cn) {
            Y.flushComplete = cn, R = !0, m.run(W, Y), k[
              t0
              /* @min:%2estopPollingInternalLogs */
            ](), W[
              vr
              /* @min:%2eprocessNext */
            ](Y);
          }
          Lr(), Xr(P, J, 6, rn) || J(!1);
        }, k[
          vs
          /* @min:%2egetPlugin */
        ] = Dr, k.addPlugin = function(P, X, rn, D) {
          if (!P) {
            D && D(!1), Z(OE);
            return;
          }
          var Y = Dr(P[
            Jt
            /* @min:%2eidentifier */
          ]);
          if (Y && !X) {
            D && D(!1), Z("Plugin [" + P[
              Jt
              /* @min:%2eidentifier */
            ] + "] is already loaded!");
            return;
          }
          var W = {
            reason: 16
            /* TelemetryUpdateReason.PluginAdded */
          };
          function J(gn) {
            p[
              Kn
              /* @min:%2epush */
            ](P), W.added = [P], on(W), D && D(!0);
          }
          if (Y) {
            var cn = [Y.plugin], pn = {
              reason: 2,
              isAsync: !!rn
            };
            Or(cn, pn, function(gn) {
              gn ? (W.removed = cn, W.reason |= 32, J()) : D && D(!1);
            });
          } else
            J();
        }, k.evtNamespace = function() {
          return b;
        }, k[
          bc
          /* @min:%2eflush */
        ] = Xr, k.getTraceCtx = function(P) {
          return y || (y = Mw()), y;
        }, k.setTraceCtx = function(P) {
          y = P || null;
        }, V_(k, "addUnloadCb", function() {
          return m;
        }, "add");
        function Zn() {
          i = !1, t = Z_(!0, {}, zw), k[
            na
            /* @min:%2econfig */
          ] = t, k[
            jr
            /* @min:%2elogger */
          ] = new _s(t), k[
            Lf
            /* @min:%2e_extensions */
          ] = [], x = new Gw(), u = [], o = null, c = null, s = null, v = null, d = null, h = null, p = [], S = null, I = null, T = null, R = !1, E = null, b = Ve("AIBaseCore", !0), m = PE(), y = null;
        }
        function or() {
          var P = Ze(Ir(), t, k);
          return P[
            Vu
            /* @min:%2eonComplete */
          ](On), P;
        }
        function on(P) {
          var X = Kw(k[
            jr
            /* @min:%2elogger */
          ], hs, p);
          h = X[
            Tr
            /* @min:%2ecore */
          ], d = null;
          var rn = X.all;
          if (T = Xa(kw(I, rn, k)), S) {
            var D = be(rn, S);
            D !== -1 && rn[
              eu
              /* @min:%2esplice */
            ](D, 1), D = be(h, S), D !== -1 && h[
              eu
              /* @min:%2esplice */
            ](D, 1), S._setQueue(T);
          } else
            S = Bw(T, k);
          rn[
            Kn
            /* @min:%2epush */
          ](S), h[
            Kn
            /* @min:%2epush */
          ](S), k[
            Lf
            /* @min:%2e_extensions */
          ] = Vl(rn), S[
            ji
            /* @min:%2einitialize */
          ](t, k, rn);
          var Y = or();
          xE(Y, rn), k[
            Lf
            /* @min:%2e_extensions */
          ] = Xa(Vl(h || [])).slice(), P && q(P);
        }
        function Dr(P) {
          var X, rn = null, D = null;
          return hn(k[
            Lf
            /* @min:%2e_extensions */
          ], function(Y) {
            if (Y[
              Jt
              /* @min:%2eidentifier */
            ] === P && Y !== S && Y !== x)
              return D = Y, -1;
          }), !D && S && (D = S.getChannel(P)), D && (rn = (X = {
            plugin: D
          }, X[
            Kp
            /* @min:setEnabled */
          ] = function(Y) {
            Xi(D)[Wv] = !Y;
          }, X.isEnabled = function() {
            var Y = Xi(D);
            return !Y[
              st
              /* @min:%2eteardown */
            ] && !Y[Wv];
          }, X.remove = function(Y, W) {
            var J;
            Y === void 0 && (Y = !0);
            var cn = [D], pn = (J = {
              reason: 1
              /* TelemetryUnloadReason.PluginUnload */
            }, J[
              tu
              /* @min:isAsync */
            ] = Y, J);
            Or(cn, pn, function(gn) {
              gn && on({
                reason: 32,
                removed: cn
              }), W && W(gn);
            });
          }, X)), rn;
        }
        function Ir() {
          if (!d) {
            var P = (h || []).slice();
            be(P, x) === -1 && P[
              Kn
              /* @min:%2epush */
            ](x), d = fi(Vl(P), t, k);
          }
          return d;
        }
        function Or(P, X, rn) {
          if (P && P[
            Pn
            /* @min:%2elength */
          ] > 0) {
            var D = fi(P, t, k), Y = $c(D, k);
            Y[
              Vu
              /* @min:%2eonComplete */
            ](function() {
              var W = !1, J = [];
              hn(p, function(pn, gn) {
                q0(pn, P) ? W = !0 : J[
                  Kn
                  /* @min:%2epush */
                ](pn);
              }), p = J;
              var cn = [];
              I && (hn(I, function(pn, gn) {
                var zn = [];
                hn(pn, function(cr) {
                  q0(cr, P) ? W = !0 : zn[
                    Kn
                    /* @min:%2epush */
                  ](cr);
                }), cn[
                  Kn
                  /* @min:%2epush */
                ](zn);
              }), I = cn), rn && rn(W), On();
            }), Y[
              vr
              /* @min:%2eprocessNext */
            ](X);
          } else
            rn(!1);
        }
        function Lr() {
          if (k[
            jr
            /* @min:%2elogger */
          ] && k[
            jr
            /* @min:%2elogger */
          ].queue) {
            var P = k[
              jr
              /* @min:%2elogger */
            ].queue.slice(0);
            k[
              jr
              /* @min:%2elogger */
            ].queue[
              Pn
              /* @min:%2elength */
            ] = 0, hn(P, function(X) {
              var rn, D = (rn = {}, rn[
                ui
                /* @min:name */
              ] = E || "InternalMessageId: " + X[
                Mc
                /* @min:%2emessageId */
              ], rn.iKey = Oe(t[
                Fl
                /* @min:%2einstrumentationKey */
              ]), rn.time = uu(/* @__PURE__ */ new Date()), rn.baseType = Ro.dataType, rn.baseData = { message: X[
                qa
                /* @min:%2emessage */
              ] }, rn);
              k.track(D);
            });
          }
        }
        function Xr(P, X, rn, D) {
          return S ? S[
            bc
            /* @min:%2eflush */
          ](P, X, rn || 6, D) : (X && X(!1), !0);
        }
        function Mn() {
          var P = Oe(t.disableDbgExt);
          P === !0 && F && (o[
            fo
            /* @min:%2eremoveNotificationListener */
          ](F), F = null), o && !F && P !== !0 && (F = nw(t), o[
            oo
            /* @min:%2eaddNotificationListener */
          ](F));
        }
        function rr() {
          var P = Oe(t.enablePerfMgr);
          !P && s && (s = null), P && Rr(t, o0, qw);
        }
        function M() {
          var P = Rr(t, K_, {});
          P.NotificationManager = o;
        }
        function q(P) {
          var X = ud(Ir(), k);
          X[
            Vu
            /* @min:%2eonComplete */
          ](On), (!k._updateHook || k._updateHook(X, P) !== !0) && X[
            vr
            /* @min:%2eprocessNext */
          ](P);
        }
        function Z(P) {
          var X = k[
            jr
            /* @min:%2elogger */
          ];
          X ? (en(X, 2, 73, P), On()) : Gr(P);
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
);
function Ff(e, t, i, u) {
  hn(e, function(o) {
    if (o && o[t])
      if (i)
        setTimeout(function() {
          return u(o);
        }, 0);
      else
        try {
          u(o);
        } catch {
        }
  });
}
var Vw = (
  /** @class */
  function() {
    function e(t) {
      this.listeners = [];
      var i = !!(t || {}).perfEvtsSendAll;
      nr(e, this, function(u) {
        u[
          oo
          /* @min:%2eaddNotificationListener */
        ] = function(o) {
          u.listeners[
            Kn
            /* @min:%2epush */
          ](o);
        }, u[
          fo
          /* @min:%2eremoveNotificationListener */
        ] = function(o) {
          for (var c = be(u[
            Aa
            /* @min:%2elisteners */
          ], o); c > -1; )
            u.listeners[
              eu
              /* @min:%2esplice */
            ](c, 1), c = be(u[
              Aa
              /* @min:%2elisteners */
            ], o);
        }, u[
          cc
          /* @min:%2eeventsSent */
        ] = function(o) {
          Ff(u[
            Aa
            /* @min:%2elisteners */
          ], cc, !0, function(c) {
            c[
              cc
              /* @min:%2eeventsSent */
            ](o);
          });
        }, u[
          co
          /* @min:%2eeventsDiscarded */
        ] = function(o, c) {
          Ff(u[
            Aa
            /* @min:%2elisteners */
          ], co, !0, function(s) {
            s[
              co
              /* @min:%2eeventsDiscarded */
            ](o, c);
          });
        }, u[
          sc
          /* @min:%2eeventsSendRequest */
        ] = function(o, c) {
          Ff(u[
            Aa
            /* @min:%2elisteners */
          ], sc, c, function(s) {
            s[
              sc
              /* @min:%2eeventsSendRequest */
            ](o, c);
          });
        }, u[
          Ba
          /* @min:%2eperfEvent */
        ] = function(o) {
          o && (i || !o[
            Hv
            /* @min:%2eisChildEvt */
          ]()) && Ff(u[
            Aa
            /* @min:%2elisteners */
          ], Ba, !1, function(c) {
            o[
              tu
              /* @min:%2eisAsync */
            ] ? setTimeout(function() {
              return c[
                Ba
                /* @min:%2eperfEvent */
              ](o);
            }, 0) : c[
              Ba
              /* @min:%2eperfEvent */
            ](o);
          });
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), Zw = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      var i = e.call(this) || this;
      return nr(t, i, function(u, o) {
        u[
          ji
          /* @min:%2einitialize */
        ] = function(v, d, p, h) {
          o[
            ji
            /* @min:%2einitialize */
          ](v, d, p || new _s(v), h || new Vw(v));
        }, u.track = function(v) {
          Wc(u[
            Fc
            /* @min:%2egetPerfMgr */
          ](), function() {
            return "AppInsightsCore:track";
          }, function() {
            v === null && (s(v), Gr("Invalid telemetry item")), c(v), o.track(v);
          }, function() {
            return { item: v };
          }, !v.sync);
        };
        function c(v) {
          Q(v[
            ui
            /* @min:%2ename */
          ]) && (s(v), Gr("telemetry name required"));
        }
        function s(v) {
          var d = u[
            Mv
            /* @min:%2egetNotifyMgr */
          ]();
          d && d[
            co
            /* @min:%2eeventsDiscarded */
          ](
            [v],
            2
            /* eEventsDiscardedReason.InvalidEvent */
          );
        }
      }), i;
    }
    return t.__ieDyn = 1, t;
  }($w)
), K0 = "_aiHooks", X0 = [
  "req",
  "rsp",
  "hkErr",
  "fnErr"
];
function od(e, t) {
  if (e)
    for (var i = 0; i < e[
      Pn
      /* @min:%2elength */
    ] && !t(e[i], i); i++)
      ;
}
function Zl(e, t, i, u, o) {
  o >= 0 && o <= 2 && od(e, function(c, s) {
    var v = c.cbks, d = v[X0[o]];
    if (d) {
      t.ctx = function() {
        var S = u[s] = u[s] || {};
        return S;
      };
      try {
        d[
          au
          /* @min:%2eapply */
        ](t.inst, i);
      } catch (S) {
        var p = t.err;
        try {
          var h = v[X0[
            2
            /* CallbackType.HookError */
          ]];
          h && (t.err = S, h[
            au
            /* @min:%2eapply */
          ](t.inst, i));
        } catch {
        } finally {
          t.err = p;
        }
      }
    }
  });
}
function Jw(e) {
  return function() {
    var t, i = this, u = arguments, o = e.h, c = (t = {}, t[
      ui
      /* @min:name */
    ] = e.n, t.inst = i, t.ctx = null, t.set = p, t), s = [], v = d([c], u);
    c.evt = Nr("event");
    function d(S, I) {
      return od(I, function(T) {
        S[
          Kn
          /* @min:%2epush */
        ](T);
      }), S;
    }
    function p(S, I) {
      u = d([], u), u[S] = I, v = d([c], u);
    }
    Zl(
      o,
      c,
      v,
      s,
      0
      /* CallbackType.Request */
    );
    var h = e.f;
    if (h)
      try {
        c.rslt = h[
          au
          /* @min:%2eapply */
        ](i, u);
      } catch (S) {
        throw c.err = S, Zl(
          o,
          c,
          v,
          s,
          3
          /* CallbackType.FunctionError */
        ), S;
      }
    return Zl(
      o,
      c,
      v,
      s,
      1
      /* CallbackType.Response */
    ), c.rslt;
  };
}
function fd(e, t, i, u) {
  var o = null;
  return e && (eE(e, t) ? o = e : i && (o = fd(rE(e), t, u, !1))), o;
}
function Qw(e, t, i) {
  return e ? t_(e[qr], t, i, !1) : null;
}
function LE(e, t, i, u) {
  var o = i && i[K0];
  if (!o) {
    o = {
      i: 0,
      n: t,
      f: i,
      h: []
    };
    var c = Jw(o);
    c[K0] = o, e[t] = c;
  }
  var s = {
    // tslint:disable:object-literal-shorthand
    id: o.i,
    cbks: u,
    rm: function() {
      var v = this.id;
      od(o.h, function(d, p) {
        if (d.id === v)
          return o.h[
            eu
            /* @min:%2esplice */
          ](p, 1), 1;
      });
    }
    // tslint:enable:object-literal-shorthand
  };
  return o.i++, o.h[
    Kn
    /* @min:%2epush */
  ](s), s;
}
function t_(e, t, i, u, o) {
  if (u === void 0 && (u = !0), e && t && i) {
    var c = fd(e, t, u, o);
    if (c) {
      var s = c[t];
      if (typeof s === vu)
        return LE(c, t, s, i);
    }
  }
  return null;
}
function Hf(e, t, i, u, o) {
  if (e && t && i) {
    var c = fd(e, t, u, o) || e;
    if (c)
      return LE(c, t, c[t], i);
  }
  return null;
}
var Gi = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation", bE = "sampleRate", Jl = "ProcessLegacy", $0 = "http.method", cd = "https://dc.services.visualstudio.com", ho = "/v2/track", Je = "not_specified", Ql = "iKey";
function Ou(e) {
  var t = null;
  if (Cn(Event))
    t = new Event(e);
  else {
    var i = le();
    i && i.createEvent && (t = i.createEvent("Event"), t.initEvent(e, !0, !0));
  }
  return t;
}
var ou = "split", An = "length", fu = "toLowerCase", Bf = "ingestionendpoint", ci = "toString", sd = "removeItem", Ue = "name", Wi = "message", jw = "count", i_ = "stringify", jl = "pathname", V0 = "correlationHeaderExcludePatterns", Vc = "indexOf", Ca = "exceptions", me = "parsedStack", gt = "properties", pt = "measurements", Va = "sizeInBytes", ct = "typeName", ju = "severityLevel", nv = "problemGroup", rv = "isManual", ME = "CreateFromInterface", ka = "assembly", Ui = "fileName", dc = "hasFullStack", kf = "level", wa = "method", Lu = "line", Zc = "duration", Z0 = "receivedResponse", hu = "substring", ny = "sanitizeKeyAndAddUniqueness", ry = "sanitizeException", ey = "sanitizeProperties", ty = "sanitizeMeasurements", bu = "";
function Ge(e, t) {
  return t === void 0 && (t = !1), e == null ? t : e.toString()[
    fu
    /* @min:%2etoLowerCase */
  ]() === "true";
}
function Gt(e) {
  (isNaN(e) || e < 0) && (e = 0), e = Math.round(e);
  var t = bu + e % 1e3, i = bu + Math.floor(e / 1e3) % 60, u = bu + Math.floor(e / (1e3 * 60)) % 60, o = bu + Math.floor(e / (1e3 * 60 * 60)) % 24, c = Math.floor(e / (1e3 * 60 * 60 * 24));
  return t = t[
    An
    /* @min:%2elength */
  ] === 1 ? "00" + t : t[
    An
    /* @min:%2elength */
  ] === 2 ? "0" + t : t, i = i[
    An
    /* @min:%2elength */
  ] < 2 ? "0" + i : i, u = u[
    An
    /* @min:%2elength */
  ] < 2 ? "0" + u : u, o = o[
    An
    /* @min:%2elength */
  ] < 2 ? "0" + o : o, (c > 0 ? c + "." : bu) + o + ":" + u + ":" + i + "." + t;
}
function iy(e, t, i, u, o) {
  return !o && En(e) && (e === "Script error." || e === "Script error");
}
var kn = MC({
  requestContextHeader: [0, "Request-Context"],
  requestContextTargetKey: [1, "appId"],
  requestContextAppIdFormat: [2, "appId=cid-v1:"],
  requestIdHeader: [3, "Request-Id"],
  traceParentHeader: [4, "traceparent"],
  traceStateHeader: [5, "tracestate"],
  sdkContextHeader: [6, "Sdk-Context"],
  sdkContextHeaderAppIdRequest: [7, "appId"],
  requestContextHeaderLowerCase: [8, "request-context"]
}), Ho = J_({
  LocalStorage: 0,
  SessionStorage: 1
  /* eStorageType.SessionStorage */
});
J_({
  AI: 0,
  AI_AND_W3C: 1,
  W3C: 2
  /* eDistributedTracingModes.W3C */
});
var ei = void 0, ti = void 0, YE = "";
function ld() {
  return dd() ? gs(Ho.LocalStorage) : null;
}
function gs(e) {
  try {
    if (Q(_u()))
      return null;
    var t = (/* @__PURE__ */ new Date())[
      ci
      /* @min:%2etoString */
    ](), i = Nr(e === Ho.LocalStorage ? "localStorage" : "sessionStorage"), u = YE + t;
    i.setItem(u, t);
    var o = i.getItem(u) !== t;
    if (i[
      sd
      /* @min:%2eremoveItem */
    ](u), !o)
      return i;
  } catch {
  }
  return null;
}
function vd() {
  return wo() ? gs(Ho.SessionStorage) : null;
}
function ay() {
  ei = !1, ti = !1;
}
function _d(e) {
  YE = e || "";
}
function uy() {
  ei = dd(!0), ti = wo(!0);
}
function dd(e) {
  return (e || ei === void 0) && (ei = !!gs(Ho.LocalStorage)), ei;
}
function oy(e, t) {
  var i = ld();
  if (i !== null)
    try {
      return i.getItem(t);
    } catch (u) {
      ei = !1, en(e, 2, 1, "Browser failed read of local storage. " + Fn(u), { exception: dn(u) });
    }
  return null;
}
function fy(e, t, i) {
  var u = ld();
  if (u !== null)
    try {
      return u.setItem(t, i), !0;
    } catch (o) {
      ei = !1, en(e, 2, 3, "Browser failed write to local storage. " + Fn(o), { exception: dn(o) });
    }
  return !1;
}
function cy(e, t) {
  var i = ld();
  if (i !== null)
    try {
      return i[
        sd
        /* @min:%2eremoveItem */
      ](t), !0;
    } catch (u) {
      ei = !1, en(e, 2, 5, "Browser failed removal of local storage item. " + Fn(u), { exception: dn(u) });
    }
  return !1;
}
function wo(e) {
  return (e || ti === void 0) && (ti = !!gs(Ho.SessionStorage)), ti;
}
function a_(e, t) {
  var i = vd();
  if (i !== null)
    try {
      return i.getItem(t);
    } catch (u) {
      ti = !1, en(e, 2, 2, "Browser failed read of session storage. " + Fn(u), { exception: dn(u) });
    }
  return null;
}
function UE(e, t, i) {
  var u = vd();
  if (u !== null)
    try {
      return u.setItem(t, i), !0;
    } catch (o) {
      ti = !1, en(e, 2, 4, "Browser failed write to session storage. " + Fn(o), { exception: dn(o) });
    }
  return !1;
}
function sy(e, t) {
  var i = vd();
  if (i !== null)
    try {
      return i[
        sd
        /* @min:%2eremoveItem */
      ](t), !0;
    } catch (u) {
      ti = !1, en(e, 2, 6, "Browser failed removal of session storage item. " + Fn(u), { exception: dn(u) });
    }
  return !1;
}
var Qr;
function hd(e, t, i) {
  var u = t[
    An
    /* @min:%2elength */
  ], o = FE(e, t);
  if (o[
    An
    /* @min:%2elength */
  ] !== u) {
    for (var c = 0, s = o; i[s] !== void 0; )
      c++, s = o[
        hu
        /* @min:%2esubstring */
      ](0, 150 - 3) + kE(c);
    o = s;
  }
  return o;
}
function FE(e, t) {
  var i;
  return t && (t = zr(t[
    ci
    /* @min:%2etoString */
  ]()), t[
    An
    /* @min:%2elength */
  ] > 150 && (i = t[
    hu
    /* @min:%2esubstring */
  ](
    0,
    150
    /* DataSanitizerValues.MAX_NAME_LENGTH */
  ), en(e, 2, 57, "name is too long.  It has been truncated to 150 characters.", { name: t }, !0))), i || t;
}
function _r(e, t, i) {
  i === void 0 && (i = 1024);
  var u;
  return t && (i = i || 1024, t = zr(t), t.toString()[
    An
    /* @min:%2elength */
  ] > i && (u = t[
    ci
    /* @min:%2etoString */
  ]()[
    hu
    /* @min:%2esubstring */
  ](0, i), en(e, 2, 61, "string value is too long. It has been truncated to " + i + " characters.", { value: t }, !0))), u || t;
}
function Bo(e, t) {
  return pd(
    e,
    t,
    2048,
    66
    /* _eInternalMessageId.UrlTooLong */
  );
}
function gd(e, t) {
  var i;
  return t && t[
    An
    /* @min:%2elength */
  ] > 32768 && (i = t[
    hu
    /* @min:%2esubstring */
  ](
    0,
    32768
    /* DataSanitizerValues.MAX_MESSAGE_LENGTH */
  ), en(e, 2, 56, "message is too long, it has been truncated to 32768 characters.", { message: t }, !0)), i || t;
}
function HE(e, t) {
  var i;
  if (t) {
    var u = "" + t;
    u[
      An
      /* @min:%2elength */
    ] > 32768 && (i = u[
      hu
      /* @min:%2esubstring */
    ](
      0,
      32768
      /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */
    ), en(e, 2, 52, "exception is too long, it has been truncated to 32768 characters.", { exception: t }, !0));
  }
  return i || t;
}
function li(e, t) {
  if (t) {
    var i = {};
    ir(t, function(u, o) {
      if (Me(o) && du())
        try {
          o = Ye()[
            i_
            /* @min:%2estringify */
          ](o);
        } catch (c) {
          en(e, 2, 49, "custom property is not valid", { exception: c }, !0);
        }
      o = _r(
        e,
        o,
        8192
        /* DataSanitizerValues.MAX_PROPERTY_LENGTH */
      ), u = hd(e, u, i), i[u] = o;
    }), t = i;
  }
  return t;
}
function vi(e, t) {
  if (t) {
    var i = {};
    ir(t, function(u, o) {
      u = hd(e, u, i), i[u] = o;
    }), t = i;
  }
  return t;
}
function BE(e, t) {
  return t && pd(
    e,
    t,
    128,
    69
    /* _eInternalMessageId.IdTooLong */
  )[
    ci
    /* @min:%2etoString */
  ]();
}
function pd(e, t, i, u) {
  var o;
  return t && (t = zr(t), t[
    An
    /* @min:%2elength */
  ] > i && (o = t[
    hu
    /* @min:%2esubstring */
  ](0, i), en(e, 2, u, "input is too long, it has been truncated to " + i + " characters.", { data: t }, !0))), o || t;
}
function kE(e) {
  var t = "00" + e;
  return t.substr(t[
    An
    /* @min:%2elength */
  ] - 3);
}
Qr = {
  MAX_NAME_LENGTH: 150,
  MAX_ID_LENGTH: 128,
  MAX_PROPERTY_LENGTH: 8192,
  MAX_STRING_LENGTH: 1024,
  MAX_URL_LENGTH: 2048,
  MAX_MESSAGE_LENGTH: 32768,
  MAX_EXCEPTION_LENGTH: 32768
  /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */
}, Qr[
  ny
  /* @min:sanitizeKeyAndAddUniqueness */
] = hd, Qr.sanitizeKey = FE, Qr.sanitizeString = _r, Qr.sanitizeUrl = Bo, Qr.sanitizeMessage = gd, Qr[
  ry
  /* @min:sanitizeException */
] = HE, Qr[
  ey
  /* @min:sanitizeProperties */
] = li, Qr[
  ty
  /* @min:sanitizeMeasurements */
] = vi, Qr.sanitizeId = BE, Qr.sanitizeInput = pd, Qr.padNumber = kE, Qr.trim = zr;
var J0 = le() || {}, Q0 = 0, ly = [null, null, null, null, null];
function Ed(e) {
  var t = Q0, i = ly, u = i[t];
  return J0.createElement ? i[t] || (u = i[t] = J0.createElement("a")) : u = { host: dy(e, !0) }, u.href = e, t++, t >= i[
    An
    /* @min:%2elength */
  ] && (t = 0), Q0 = t, u;
}
function vy(e) {
  var t, i = Ed(e);
  return i && (t = i.href), t;
}
function _y(e, t) {
  return e ? e.toUpperCase() + " " + t : t;
}
function dy(e, t) {
  var i = GE(e, t) || "";
  if (i) {
    var u = i.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
    if (u != null && u[
      An
      /* @min:%2elength */
    ] > 3 && En(u[2]) && u[2][
      An
      /* @min:%2elength */
    ] > 0)
      return u[2] + (u[3] || "");
  }
  return i;
}
function GE(e, t) {
  var i = null;
  if (e) {
    var u = e.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
    if (u != null && u[
      An
      /* @min:%2elength */
    ] > 2 && En(u[2]) && u[2][
      An
      /* @min:%2elength */
    ] > 0 && (i = u[2] || "", t && u[
      An
      /* @min:%2elength */
    ] > 2)) {
      var o = (u[1] || "")[
        fu
        /* @min:%2etoLowerCase */
      ](), c = u[3] || "";
      (o === "http" && c === ":80" || o === "https" && c === ":443") && (c = ""), i += c;
    }
  }
  return i;
}
var hy = [
  cd + ho,
  "https://breeze.aimon.applicationinsights.io" + ho,
  "https://dc-int.services.visualstudio.com" + ho
];
function hc(e) {
  return be(hy, e[
    fu
    /* @min:%2etoLowerCase */
  ]()) !== -1;
}
var Ga = {
  correlationIdPrefix: "cid-v1:",
  /**
   * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
   * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
   * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
   * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
   * manually supply domains to include correlation headers on. Else, no headers will be included at all.
   */
  canIncludeCorrelationHeader: function(e, t, i) {
    if (!t || e && e.disableCorrelationHeaders)
      return !1;
    if (e && e[
      V0
      /* @min:%2ecorrelationHeaderExcludePatterns */
    ]) {
      for (var u = 0; u < e.correlationHeaderExcludePatterns[
        An
        /* @min:%2elength */
      ]; u++)
        if (e[
          V0
          /* @min:%2ecorrelationHeaderExcludePatterns */
        ][u].test(t))
          return !1;
    }
    var o = Ed(t).host[
      fu
      /* @min:%2etoLowerCase */
    ]();
    if (o && (o[
      Vc
      /* @min:%2eindexOf */
    ](":443") !== -1 || o[
      Vc
      /* @min:%2eindexOf */
    ](":80") !== -1) && (o = (GE(t, !0) || "")[
      fu
      /* @min:%2etoLowerCase */
    ]()), (!e || !e.enableCorsCorrelation) && o && o !== i)
      return !1;
    var c = e && e.correlationHeaderDomains;
    if (c) {
      var s;
      if (hn(c, function(p) {
        var h = new RegExp(p.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        s = s || h.test(o);
      }), !s)
        return !1;
    }
    var v = e && e.correlationHeaderExcludedDomains;
    if (!v || v[
      An
      /* @min:%2elength */
    ] === 0)
      return !0;
    for (var u = 0; u < v[
      An
      /* @min:%2elength */
    ]; u++) {
      var d = new RegExp(v[u].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
      if (d.test(o))
        return !1;
    }
    return o && o[
      An
      /* @min:%2elength */
    ] > 0;
  },
  /**
   * Combines target appId and target role name from response header.
   */
  getCorrelationContext: function(e) {
    if (e) {
      var t = Ga.getCorrelationContextValue(e, kn[
        1
        /* eRequestHeaders.requestContextTargetKey */
      ]);
      if (t && t !== Ga.correlationIdPrefix)
        return t;
    }
  },
  /**
   * Gets key from correlation response header
   */
  getCorrelationContextValue: function(e, t) {
    if (e)
      for (var i = e[
        ou
        /* @min:%2esplit */
      ](","), u = 0; u < i[
        An
        /* @min:%2elength */
      ]; ++u) {
        var o = i[u][
          ou
          /* @min:%2esplit */
        ]("=");
        if (o[
          An
          /* @min:%2elength */
        ] === 2 && o[0] === t)
          return o[1];
      }
  }
};
function gy(e, t, i, u) {
  var o, c = u, s = u;
  if (t && t[
    An
    /* @min:%2elength */
  ] > 0) {
    var v = Ed(t);
    if (o = v.host, !c)
      if (v[
        jl
        /* @min:%2epathname */
      ] != null) {
        var d = v.pathname[
          An
          /* @min:%2elength */
        ] === 0 ? "/" : v[
          jl
          /* @min:%2epathname */
        ];
        d.charAt(0) !== "/" && (d = "/" + d), s = v[
          jl
          /* @min:%2epathname */
        ], c = _r(e, i ? i + " " + d : d);
      } else
        c = _r(e, t);
  } else
    o = u, c = u;
  return {
    target: o,
    name: c,
    data: s
  };
}
function Gf() {
  var e = oi();
  if (e && e.now && e.timing) {
    var t = e.now() + e.timing.navigationStart;
    if (t > 0)
      return t;
  }
  return $e();
}
function ne(e, t) {
  var i = null;
  return e !== 0 && t !== 0 && !Q(e) && !Q(t) && (i = t - e), i;
}
function Td(e, t) {
  var i = e || {};
  return {
    getName: function() {
      return i[
        Ue
        /* @min:%2ename */
      ];
    },
    setName: function(u) {
      t && t.setName(u), i[
        Ue
        /* @min:%2ename */
      ] = u;
    },
    getTraceId: function() {
      return i.traceID;
    },
    setTraceId: function(u) {
      t && t.setTraceId(u), td(u) && (i.traceID = u);
    },
    getSpanId: function() {
      return i.parentID;
    },
    setSpanId: function(u) {
      t && t.setSpanId(u), id(u) && (i.parentID = u);
    },
    getTraceFlags: function() {
      return i.traceFlags;
    },
    setTraceFlags: function(u) {
      t && t.setTraceFlags(u), i.traceFlags = u;
    }
  };
}
var py = ";", Ey = "=";
function Ty(e) {
  if (!e)
    return {};
  var t = e[
    ou
    /* @min:%2esplit */
  ](py), i = PC(t, function(o, c) {
    var s = c[
      ou
      /* @min:%2esplit */
    ](Ey);
    if (s[
      An
      /* @min:%2elength */
    ] === 2) {
      var v = s[0][
        fu
        /* @min:%2etoLowerCase */
      ](), d = s[1];
      o[v] = d;
    }
    return o;
  }, {});
  if (ea(i)[
    An
    /* @min:%2elength */
  ] > 0) {
    if (i.endpointsuffix) {
      var u = i.location ? i.location + "." : "";
      i[
        Bf
        /* @min:%2eingestionendpoint */
      ] = i[
        Bf
        /* @min:%2eingestionendpoint */
      ] || "https://" + u + "dc." + i.endpointsuffix;
    }
    i[
      Bf
      /* @min:%2eingestionendpoint */
    ] = i[
      Bf
      /* @min:%2eingestionendpoint */
    ] || cd;
  }
  return i;
}
var Sy = (
  /** @class */
  function() {
    function e(t, i, u) {
      var o = this, c = this;
      c.ver = 1, c.sampleRate = 100, c.tags = {}, c[
        Ue
        /* @min:%2ename */
      ] = _r(t, u) || Je, c.data = i, c.time = uu(/* @__PURE__ */ new Date()), c.aiDataContract = {
        time: 1,
        iKey: 1,
        name: 1,
        sampleRate: function() {
          return o.sampleRate === 100 ? 4 : 1;
        },
        tags: 1,
        data: 1
        /* FieldType.Required */
      };
    }
    return e;
  }()
), Wt = (
  /** @class */
  function() {
    function e(t, i, u, o) {
      this.aiDataContract = {
        ver: 1,
        name: 1,
        properties: 0,
        measurements: 0
        /* FieldType.Default */
      };
      var c = this;
      c.ver = 2, c[
        Ue
        /* @min:%2ename */
      ] = _r(t, i) || Je, c[
        gt
        /* @min:%2eproperties */
      ] = li(t, u), c[
        pt
        /* @min:%2emeasurements */
      ] = vi(t, o);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Event", e.dataType = "EventData", e;
  }()
), Ny = "<no_method>", Za = "error", re = "stack", u_ = "stackDetails", j0 = "errorSrc", o_ = "message", WE = "description";
function f_(e, t) {
  var i = e;
  return i && !En(i) && (JSON && JSON[
    i_
    /* @min:%2estringify */
  ] ? (i = JSON[
    i_
    /* @min:%2estringify */
  ](e), t && (!i || i === "{}") && (Cn(e[
    ci
    /* @min:%2etoString */
  ]) ? i = e[
    ci
    /* @min:%2etoString */
  ]() : i = "" + e)) : i = "" + e + " - (Missing JSON.stringify)"), i || "";
}
function zE(e, t) {
  var i = e;
  return e && (i && !En(i) && (i = e[o_] || e[WE] || i), i && !En(i) && (i = f_(i, !0)), e.filename && (i = i + " @" + (e.filename || "") + ":" + (e.lineno || "?") + ":" + (e.colno || "?"))), t && t !== "String" && t !== "Object" && t !== "Error" && (i || "")[
    Vc
    /* @min:%2eindexOf */
  ](t) === -1 && (i = t + ": " + i), i || "";
}
function Dy(e) {
  try {
    if (Me(e))
      return "hasFullStack" in e && "typeName" in e;
  } catch {
  }
  return !1;
}
function Iy(e) {
  try {
    if (Me(e))
      return "ver" in e && "exceptions" in e && "properties" in e;
  } catch {
  }
  return !1;
}
function np(e) {
  return e && e.src && En(e.src) && e.obj && Xn(e.obj);
}
function Ai(e) {
  var t = e || "";
  En(t) || (En(t[re]) ? t = t[re] : t = "" + t);
  var i = t[
    ou
    /* @min:%2esplit */
  ](`
`);
  return {
    src: t,
    obj: i
  };
}
function Ay(e) {
  for (var t = [], i = e[
    ou
    /* @min:%2esplit */
  ](`
`), u = 0; u < i[
    An
    /* @min:%2elength */
  ]; u++) {
    var o = i[u];
    i[u + 1] && (o += "@" + i[u + 1], u++), t.push(o);
  }
  return {
    src: e,
    obj: t
  };
}
function qE(e) {
  var t = null;
  if (e)
    try {
      if (e[re])
        t = Ai(e[re]);
      else if (e[Za] && e[Za][re])
        t = Ai(e[Za][re]);
      else if (e.exception && e.exception[re])
        t = Ai(e.exception[re]);
      else if (np(e))
        t = e;
      else if (np(e[u_]))
        t = e[u_];
      else if (window && window.opera && e[o_])
        t = Ay(e[
          Wi
          /* @min:%2emessage */
        ]);
      else if (e.reason && e.reason[re])
        t = Ai(e.reason[re]);
      else if (En(e))
        t = Ai(e);
      else {
        var i = e[o_] || e[WE] || "";
        En(e[j0]) && (i && (i += `
`), i += " from " + e[j0]), i && (t = Ai(i));
      }
    } catch (u) {
      t = Ai(u);
    }
  return t || {
    src: "",
    obj: null
  };
}
function Ry(e) {
  var t = "";
  return e && (e.obj ? hn(e.obj, function(i) {
    t += i + `
`;
  }) : t = e.src || ""), t;
}
function Cy(e) {
  var t, i = e.obj;
  if (i && i[
    An
    /* @min:%2elength */
  ] > 0) {
    t = [];
    var u = 0, o = 0;
    hn(i, function(R) {
      var x = R[
        ci
        /* @min:%2etoString */
      ]();
      if (c_.regex.test(x)) {
        var E = new c_(x, u++);
        o += E[
          Va
          /* @min:%2esizeInBytes */
        ], t.push(E);
      }
    });
    var c = 32 * 1024;
    if (o > c)
      for (var s = 0, v = t[
        An
        /* @min:%2elength */
      ] - 1, d = 0, p = s, h = v; s < v; ) {
        var S = t[s][
          Va
          /* @min:%2esizeInBytes */
        ], I = t[v][
          Va
          /* @min:%2esizeInBytes */
        ];
        if (d += S + I, d > c) {
          var T = h - p + 1;
          t.splice(p, T);
          break;
        }
        p = s, h = v, s++, v--;
      }
  }
  return t;
}
function Jc(e) {
  var t = "";
  if (e && (t = e.typeName || e[
    Ue
    /* @min:%2ename */
  ] || "", !t))
    try {
      var i = /function (.{1,200})\(/, u = i.exec(e.constructor[
        ci
        /* @min:%2etoString */
      ]());
      t = u && u[
        An
        /* @min:%2elength */
      ] > 1 ? u[1] : "";
    } catch {
    }
  return t;
}
function ev(e) {
  if (e)
    try {
      if (!En(e)) {
        var t = Jc(e), i = f_(e, !1);
        return (!i || i === "{}") && (e[Za] && (e = e[Za], t = Jc(e)), i = f_(e, !0)), i[
          Vc
          /* @min:%2eindexOf */
        ](t) !== 0 && t !== "String" ? t + ":" + i : i;
      }
    } catch {
    }
  return "" + (e || "");
}
var Ne = (
  /** @class */
  function() {
    function e(t, i, u, o, c, s) {
      this.aiDataContract = {
        ver: 1,
        exceptions: 1,
        severityLevel: 0,
        properties: 0,
        measurements: 0
        /* FieldType.Default */
      };
      var v = this;
      v.ver = 2, Iy(i) ? (v[
        Ca
        /* @min:%2eexceptions */
      ] = i[
        Ca
        /* @min:%2eexceptions */
      ] || [], v[
        gt
        /* @min:%2eproperties */
      ] = i[
        gt
        /* @min:%2eproperties */
      ], v[
        pt
        /* @min:%2emeasurements */
      ] = i[
        pt
        /* @min:%2emeasurements */
      ], i[
        ju
        /* @min:%2eseverityLevel */
      ] && (v[
        ju
        /* @min:%2eseverityLevel */
      ] = i[
        ju
        /* @min:%2eseverityLevel */
      ]), i.id && (v.id = i.id), i[
        nv
        /* @min:%2eproblemGroup */
      ] && (v[
        nv
        /* @min:%2eproblemGroup */
      ] = i[
        nv
        /* @min:%2eproblemGroup */
      ]), Q(i[
        rv
        /* @min:%2eisManual */
      ]) || (v[
        rv
        /* @min:%2eisManual */
      ] = i[
        rv
        /* @min:%2eisManual */
      ])) : (u || (u = {}), v[
        Ca
        /* @min:%2eexceptions */
      ] = [new rp(t, i, u)], v[
        gt
        /* @min:%2eproperties */
      ] = li(t, u), v[
        pt
        /* @min:%2emeasurements */
      ] = vi(t, o), c && (v[
        ju
        /* @min:%2eseverityLevel */
      ] = c), s && (v.id = s));
    }
    return e.CreateAutoException = function(t, i, u, o, c, s, v, d) {
      var p, h = Jc(c || s || t);
      return p = {}, p[
        Wi
        /* @min:message */
      ] = zE(t, h), p.url = i, p.lineNumber = u, p.columnNumber = o, p.error = ev(c || s || t), p.evt = ev(s || t), p[
        ct
        /* @min:typeName */
      ] = h, p.stackDetails = qE(v || c || s), p.errorSrc = d, p;
    }, e.CreateFromInterface = function(t, i, u, o) {
      var c = i[
        Ca
        /* @min:%2eexceptions */
      ] && so(i[
        Ca
        /* @min:%2eexceptions */
      ], function(v) {
        return rp[
          ME
          /* @min:%2eCreateFromInterface */
        ](t, v);
      }), s = new e(t, Wr(Wr({}, i), { exceptions: c }), u, o);
      return s;
    }, e.prototype.toInterface = function() {
      var t, i = this, u = i.exceptions, o = i.properties, c = i.measurements, s = i.severityLevel, v = i.problemGroup, d = i.id, p = i.isManual, h = u instanceof Array && so(u, function(S) {
        return S.toInterface();
      }) || void 0;
      return t = {
        ver: "4.0"
      }, t[
        Ca
        /* @min:exceptions */
      ] = h, t.severityLevel = s, t.properties = o, t.measurements = c, t.problemGroup = v, t.id = d, t.isManual = p, t;
    }, e.CreateSimpleException = function(t, i, u, o, c, s) {
      var v;
      return {
        exceptions: [
          (v = {}, v[
            dc
            /* @min:hasFullStack */
          ] = !0, v.message = t, v.stack = c, v.typeName = i, v)
        ]
      };
    }, e.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception", e.dataType = "ExceptionData", e.formatError = ev, e;
  }()
), rp = (
  /** @class */
  function() {
    function e(t, i, u) {
      this.aiDataContract = {
        id: 0,
        outerId: 0,
        typeName: 1,
        message: 1,
        hasFullStack: 0,
        stack: 0,
        parsedStack: 2
        /* FieldType.Array */
      };
      var o = this;
      if (Dy(i))
        o[
          ct
          /* @min:%2etypeName */
        ] = i[
          ct
          /* @min:%2etypeName */
        ], o[
          Wi
          /* @min:%2emessage */
        ] = i[
          Wi
          /* @min:%2emessage */
        ], o[re] = i[re], o[
          me
          /* @min:%2eparsedStack */
        ] = i[
          me
          /* @min:%2eparsedStack */
        ] || [], o[
          dc
          /* @min:%2ehasFullStack */
        ] = i[
          dc
          /* @min:%2ehasFullStack */
        ];
      else {
        var c = i, s = c && c.evt;
        X_(c) || (c = c[Za] || s || c), o[
          ct
          /* @min:%2etypeName */
        ] = _r(t, Jc(c)) || Je, o[
          Wi
          /* @min:%2emessage */
        ] = gd(t, zE(i || c, o[
          ct
          /* @min:%2etypeName */
        ])) || Je;
        var v = i[u_] || qE(i);
        o[
          me
          /* @min:%2eparsedStack */
        ] = Cy(v), Xn(o[
          me
          /* @min:%2eparsedStack */
        ]) && so(o[
          me
          /* @min:%2eparsedStack */
        ], function(d) {
          d[
            ka
            /* @min:%2eassembly */
          ] = _r(t, d[
            ka
            /* @min:%2eassembly */
          ]), d[
            Ui
            /* @min:%2efileName */
          ] = _r(t, d[
            Ui
            /* @min:%2efileName */
          ]);
        }), o[re] = HE(t, Ry(v)), o.hasFullStack = Xn(o.parsedStack) && o.parsedStack[
          An
          /* @min:%2elength */
        ] > 0, u && (u[
          ct
          /* @min:%2etypeName */
        ] = u[
          ct
          /* @min:%2etypeName */
        ] || o[
          ct
          /* @min:%2etypeName */
        ]);
      }
    }
    return e.prototype.toInterface = function() {
      var t, i = this, u = i[
        me
        /* @min:%2eparsedStack */
      ] instanceof Array && so(i[
        me
        /* @min:%2eparsedStack */
      ], function(c) {
        return c.toInterface();
      }), o = (t = {
        id: i.id,
        outerId: i.outerId,
        typeName: i[
          ct
          /* @min:%2etypeName */
        ],
        message: i[
          Wi
          /* @min:%2emessage */
        ],
        hasFullStack: i[
          dc
          /* @min:%2ehasFullStack */
        ],
        stack: i[re]
      }, t[
        me
        /* @min:parsedStack */
      ] = u || void 0, t);
      return o;
    }, e.CreateFromInterface = function(t, i) {
      var u = i[
        me
        /* @min:%2eparsedStack */
      ] instanceof Array && so(i[
        me
        /* @min:%2eparsedStack */
      ], function(c) {
        return c_[
          ME
          /* @min:%2eCreateFromInterface */
        ](c);
      }) || i[
        me
        /* @min:%2eparsedStack */
      ], o = new e(t, Wr(Wr({}, i), { parsedStack: u }));
      return o;
    }, e;
  }()
), c_ = (
  /** @class */
  function() {
    function e(t, i) {
      this.aiDataContract = {
        level: 1,
        method: 1,
        assembly: 0,
        fileName: 0,
        line: 0
        /* FieldType.Default */
      };
      var u = this;
      if (u[
        Va
        /* @min:%2esizeInBytes */
      ] = 0, typeof t == "string") {
        var o = t;
        u[
          kf
          /* @min:%2elevel */
        ] = i, u[
          wa
          /* @min:%2emethod */
        ] = Ny, u[
          ka
          /* @min:%2eassembly */
        ] = zr(o), u[
          Ui
          /* @min:%2efileName */
        ] = "", u[
          Lu
          /* @min:%2eline */
        ] = 0;
        var c = o.match(e.regex);
        c && c[
          An
          /* @min:%2elength */
        ] >= 5 && (u[
          wa
          /* @min:%2emethod */
        ] = zr(c[2]) || u[
          wa
          /* @min:%2emethod */
        ], u[
          Ui
          /* @min:%2efileName */
        ] = zr(c[4]), u[
          Lu
          /* @min:%2eline */
        ] = parseInt(c[5]) || 0);
      } else
        u[
          kf
          /* @min:%2elevel */
        ] = t[
          kf
          /* @min:%2elevel */
        ], u[
          wa
          /* @min:%2emethod */
        ] = t[
          wa
          /* @min:%2emethod */
        ], u[
          ka
          /* @min:%2eassembly */
        ] = t[
          ka
          /* @min:%2eassembly */
        ], u[
          Ui
          /* @min:%2efileName */
        ] = t[
          Ui
          /* @min:%2efileName */
        ], u[
          Lu
          /* @min:%2eline */
        ] = t[
          Lu
          /* @min:%2eline */
        ], u[
          Va
          /* @min:%2esizeInBytes */
        ] = 0;
      u.sizeInBytes += u.method[
        An
        /* @min:%2elength */
      ], u.sizeInBytes += u.fileName[
        An
        /* @min:%2elength */
      ], u.sizeInBytes += u.assembly[
        An
        /* @min:%2elength */
      ], u[
        Va
        /* @min:%2esizeInBytes */
      ] += e.baseSize, u.sizeInBytes += u.level.toString()[
        An
        /* @min:%2elength */
      ], u.sizeInBytes += u.line.toString()[
        An
        /* @min:%2elength */
      ];
    }
    return e.CreateFromInterface = function(t) {
      return new e(
        t,
        null
        /* level is available in frame interface */
      );
    }, e.prototype.toInterface = function() {
      var t = this;
      return {
        level: t[
          kf
          /* @min:%2elevel */
        ],
        method: t[
          wa
          /* @min:%2emethod */
        ],
        assembly: t[
          ka
          /* @min:%2eassembly */
        ],
        fileName: t[
          Ui
          /* @min:%2efileName */
        ],
        line: t[
          Lu
          /* @min:%2eline */
        ]
      };
    }, e.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/, e.baseSize = 58, e;
  }()
), wy = (
  /** @class */
  function() {
    function e() {
      this.aiDataContract = {
        name: 1,
        kind: 0,
        value: 1,
        count: 0,
        min: 0,
        max: 0,
        stdDev: 0
        /* FieldType.Default */
      }, this.kind = 0;
    }
    return e;
  }()
), $i = (
  /** @class */
  function() {
    function e(t, i, u, o, c, s, v, d, p) {
      this.aiDataContract = {
        ver: 1,
        metrics: 1,
        properties: 0
        /* FieldType.Default */
      };
      var h = this;
      h.ver = 2;
      var S = new wy();
      S[
        jw
        /* @min:%2ecount */
      ] = o > 0 ? o : void 0, S.max = isNaN(s) || s === null ? void 0 : s, S.min = isNaN(c) || c === null ? void 0 : c, S[
        Ue
        /* @min:%2ename */
      ] = _r(t, i) || Je, S.value = u, S.stdDev = isNaN(v) || v === null ? void 0 : v, h.metrics = [S], h[
        gt
        /* @min:%2eproperties */
      ] = li(t, d), h[
        pt
        /* @min:%2emeasurements */
      ] = vi(t, p);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric", e.dataType = "MetricData", e;
  }()
), ii = (
  /** @class */
  function() {
    function e(t, i, u, o, c, s, v) {
      this.aiDataContract = {
        ver: 1,
        name: 0,
        url: 0,
        duration: 0,
        properties: 0,
        measurements: 0,
        id: 0
        /* FieldType.Default */
      };
      var d = this;
      d.ver = 2, d.id = BE(t, v), d.url = Bo(t, u), d[
        Ue
        /* @min:%2ename */
      ] = _r(t, i) || Je, isNaN(o) || (d[
        Zc
        /* @min:%2eduration */
      ] = Gt(o)), d[
        gt
        /* @min:%2eproperties */
      ] = li(t, c), d[
        pt
        /* @min:%2emeasurements */
      ] = vi(t, s);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview", e.dataType = "PageviewData", e;
  }()
), Vi = (
  /** @class */
  function() {
    function e(t, i, u, o, c, s, v, d, p, h, S, I) {
      p === void 0 && (p = "Ajax"), this.aiDataContract = {
        id: 1,
        ver: 1,
        name: 0,
        resultCode: 0,
        duration: 0,
        success: 0,
        data: 0,
        target: 0,
        type: 0,
        properties: 0,
        measurements: 0,
        kind: 0,
        value: 0,
        count: 0,
        min: 0,
        max: 0,
        stdDev: 0,
        dependencyKind: 0,
        dependencySource: 0,
        commandName: 0,
        dependencyTypeName: 0
        /* FieldType.Default */
      };
      var T = this;
      T.ver = 2, T.id = i, T[
        Zc
        /* @min:%2eduration */
      ] = Gt(c), T.success = s, T.resultCode = v + "", T.type = _r(t, p);
      var R = gy(t, u, d, o);
      T.data = Bo(t, o) || R.data, T.target = _r(t, R.target), h && (T.target = "".concat(T.target, " | ").concat(h)), T[
        Ue
        /* @min:%2ename */
      ] = _r(t, R[
        Ue
        /* @min:%2ename */
      ]), T[
        gt
        /* @min:%2eproperties */
      ] = li(t, S), T[
        pt
        /* @min:%2emeasurements */
      ] = vi(t, I);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency", e.dataType = "RemoteDependencyData", e;
  }()
), Ja = (
  /** @class */
  function() {
    function e(t, i, u, o, c) {
      this.aiDataContract = {
        ver: 1,
        message: 1,
        severityLevel: 0,
        properties: 0
        /* FieldType.Default */
      };
      var s = this;
      s.ver = 2, i = i || Je, s[
        Wi
        /* @min:%2emessage */
      ] = gd(t, i), s[
        gt
        /* @min:%2eproperties */
      ] = li(t, o), s[
        pt
        /* @min:%2emeasurements */
      ] = vi(t, c), u && (s[
        ju
        /* @min:%2eseverityLevel */
      ] = u);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Message", e.dataType = "MessageData", e;
  }()
), Qa = (
  /** @class */
  function() {
    function e(t, i, u, o, c, s, v) {
      this.aiDataContract = {
        ver: 1,
        name: 0,
        url: 0,
        duration: 0,
        perfTotal: 0,
        networkConnect: 0,
        sentRequest: 0,
        receivedResponse: 0,
        domProcessing: 0,
        properties: 0,
        measurements: 0
        /* FieldType.Default */
      };
      var d = this;
      d.ver = 2, d.url = Bo(t, u), d[
        Ue
        /* @min:%2ename */
      ] = _r(t, i) || Je, d[
        gt
        /* @min:%2eproperties */
      ] = li(t, c), d[
        pt
        /* @min:%2emeasurements */
      ] = vi(t, s), v && (d.domProcessing = v.domProcessing, d[
        Zc
        /* @min:%2eduration */
      ] = v[
        Zc
        /* @min:%2eduration */
      ], d.networkConnect = v.networkConnect, d.perfTotal = v.perfTotal, d[
        Z0
        /* @min:%2ereceivedResponse */
      ] = v[
        Z0
        /* @min:%2ereceivedResponse */
      ], d.sentRequest = v.sentRequest);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance", e.dataType = "PageviewPerformanceData", e;
  }()
), ia = (
  /** @class */
  function() {
    function e(t, i) {
      this.aiDataContract = {
        baseType: 1,
        baseData: 1
        /* FieldType.Required */
      }, this.baseType = t, this.baseData = i;
    }
    return e;
  }()
), ep = J_({
  Verbose: 0,
  Information: 1,
  Warning: 2,
  Error: 3,
  Critical: 4
  /* eSeverityLevel.Critical */
});
function _i(e) {
  var t = "ai." + e + ".";
  return function(i) {
    return t + i;
  };
}
var Mu = _i("application"), Er = _i("device"), Wf = _i("location"), ya = _i("operation"), tv = _i("session"), Mt = _i("user"), Ri = _i("cloud"), Yu = _i("internal"), KE = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e.call(this) || this;
    }
    return t;
  }(bC({
    applicationVersion: Mu("ver"),
    applicationBuild: Mu("build"),
    applicationTypeId: Mu("typeId"),
    applicationId: Mu("applicationId"),
    applicationLayer: Mu("layer"),
    deviceId: Er("id"),
    deviceIp: Er("ip"),
    deviceLanguage: Er("language"),
    deviceLocale: Er("locale"),
    deviceModel: Er("model"),
    deviceFriendlyName: Er("friendlyName"),
    deviceNetwork: Er("network"),
    deviceNetworkName: Er("networkName"),
    deviceOEMName: Er("oemName"),
    deviceOS: Er("os"),
    deviceOSVersion: Er("osVersion"),
    deviceRoleInstance: Er("roleInstance"),
    deviceRoleName: Er("roleName"),
    deviceScreenResolution: Er("screenResolution"),
    deviceType: Er("type"),
    deviceMachineName: Er("machineName"),
    deviceVMName: Er("vmName"),
    deviceBrowser: Er("browser"),
    deviceBrowserVersion: Er("browserVersion"),
    locationIp: Wf("ip"),
    locationCountry: Wf("country"),
    locationProvince: Wf("province"),
    locationCity: Wf("city"),
    operationId: ya("id"),
    operationName: ya("name"),
    operationParentId: ya("parentId"),
    operationRootId: ya("rootId"),
    operationSyntheticSource: ya("syntheticSource"),
    operationCorrelationVector: ya("correlationVector"),
    sessionId: tv("id"),
    sessionIsFirst: tv("isFirst"),
    sessionIsNew: tv("isNew"),
    userAccountAcquisitionDate: Mt("accountAcquisitionDate"),
    userAccountId: Mt("accountId"),
    userAgent: Mt("userAgent"),
    userId: Mt("id"),
    userStoreRegion: Mt("storeRegion"),
    userAuthUserId: Mt("authUserId"),
    userAnonymousUserAcquisitionDate: Mt("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: Mt("authUserAcquisitionDate"),
    cloudName: Ri("name"),
    cloudRole: Ri("role"),
    cloudRoleVer: Ri("roleVer"),
    cloudRoleInstance: Ri("roleInstance"),
    cloudEnvironment: Ri("environment"),
    cloudLocation: Ri("location"),
    cloudDeploymentUnit: Ri("deploymentUnit"),
    internalNodeName: Yu("nodeName"),
    internalSdkVersion: Yu("sdkVersion"),
    internalAgentVersion: Yu("agentVersion"),
    internalSnippet: Yu("snippet"),
    internalSdkSrc: Yu("sdkSrc")
  }))
);
function Ft(e, t, i, u, o, c) {
  var s;
  i = _r(u, i) || Je, (Q(e) || Q(t) || Q(i)) && Gr("Input doesn't contain all required fields");
  var v = "";
  e[Ql] && (v = e[Ql], delete e[Ql]);
  var d = (s = {}, s[
    Ue
    /* @min:name */
  ] = i, s.time = uu(/* @__PURE__ */ new Date()), s.iKey = v, s.ext = c || {}, s.tags = [], s.data = {}, s.baseType = t, s.baseData = e, s);
  return Q(o) || ir(o, function(p, h) {
    d.data[p] = h;
  }), d;
}
var ce = {
  UserExt: "user",
  DeviceExt: "device",
  TraceExt: "trace",
  WebExt: "web",
  AppExt: "app",
  OSExt: "os",
  SessionExt: "ses",
  SDKExt: "sdk"
}, jn = new KE(), ps = "AppInsightsPropertiesPlugin", XE = "AppInsightsChannelPlugin", yy = "ApplicationInsightsAnalytics", Qc = "toString", s_ = "disableExceptionTracking", jc = "autoTrackPageVisitTime", l_ = "overridePageViewDuration", v_ = "enableUnhandledPromiseRejectionTracking", zf = "samplingPercentage", ns = "isStorageUseDisabled", rs = "isBrowserLinkTrackingEnabled", __ = "enableAutoRouteTracking", d_ = "namePrefix", iv = "disableFlushOnBeforeUnload", mr = "core", Yt = "dataType", Ci = "envelopeType", fe = "diagLog", wi = "track", gc = "trackPageView", h_ = "trackPreviousPageVisit", Fi = "sendPageViewInternal", g_ = "sendPageViewPerformanceInternal", Sd = "populatePageViewPerformanceEvent", Ma = "href", tp = "sendExceptionInternal", av = "exception", Uu = "error", uv = "_onerror", ov = "errorSrc", fv = "lineNumber", cv = "columnNumber", ip = "message", sv = "CreateAutoException", qf = "addTelemetryInitializer", Bt = "duration", yo = "length", $E = "isPerformanceTimingSupported", VE = "getPerformanceTiming", es = "navigationStart", p_ = "shouldCollectDuration", ZE = "isPerformanceTimingDataReady", my = "getEntriesByType", no = "responseStart", xy = "requestStart", pc = "loadEventEnd", E_ = "responseEnd", Ec = "connectEnd", JE = "pageVisitStartTime", Kf = null;
function Py() {
  if (Kf == null)
    try {
      Kf = !!(self && self instanceof WorkerGlobalScope);
    } catch {
      Kf = !1;
    }
  return Kf;
}
var Oy = (
  /** @class */
  function() {
    function e(t, i, u, o) {
      nr(e, this, function(c) {
        var s = null, v = [], d = !1, p;
        u && (p = u.logger);
        function h(T) {
          u && u.flush(T);
        }
        function S() {
          s || (s = setTimeout(function() {
            s = null;
            var T = v.slice(0), R = !1;
            v = [], hn(T, function(x) {
              x() ? R = !0 : v.push(x);
            }), v[
              yo
              /* @min:%2elength */
            ] > 0 && S(), R && h(!0);
          }, 100));
        }
        function I(T) {
          v.push(T), S();
        }
        c[
          gc
          /* @min:%2etrackPageView */
        ] = function(T, R) {
          var x = T.name;
          if (Q(x) || typeof x != "string") {
            var E = le();
            x = T.name = E && E.title || "";
          }
          var b = T.uri;
          if (Q(b) || typeof b != "string") {
            var m = Xt();
            b = T.uri = m && m[
              Ma
              /* @min:%2ehref */
            ] || "";
          }
          if (!o[
            $E
            /* @min:%2eisPerformanceTimingSupported */
          ]()) {
            t[
              Fi
              /* @min:%2esendPageViewInternal */
            ](T, R), h(!0), Py() || en(p, 2, 25, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
            return;
          }
          var F = !1, y, j = o[
            VE
            /* @min:%2egetPerformanceTiming */
          ]()[
            es
            /* @min:%2enavigationStart */
          ];
          j > 0 && (y = ne(j, +/* @__PURE__ */ new Date()), o[
            p_
            /* @min:%2eshouldCollectDuration */
          ](y) || (y = void 0));
          var un;
          !Q(R) && !Q(R[
            Bt
            /* @min:%2eduration */
          ]) && (un = R[
            Bt
            /* @min:%2eduration */
          ]), (i || !isNaN(un)) && (isNaN(un) && (R || (R = {}), R[
            Bt
            /* @min:%2eduration */
          ] = y), t[
            Fi
            /* @min:%2esendPageViewInternal */
          ](T, R), h(!0), F = !0);
          var k = 6e4;
          R || (R = {}), I(function() {
            var On = !1;
            try {
              if (o[
                ZE
                /* @min:%2eisPerformanceTimingDataReady */
              ]()) {
                On = !0;
                var Zn = {
                  name: x,
                  uri: b
                };
                o[
                  Sd
                  /* @min:%2epopulatePageViewPerformanceEvent */
                ](Zn), !Zn.isValid && !F ? (R[
                  Bt
                  /* @min:%2eduration */
                ] = y, t[
                  Fi
                  /* @min:%2esendPageViewInternal */
                ](T, R)) : (F || (R[
                  Bt
                  /* @min:%2eduration */
                ] = Zn.durationMs, t[
                  Fi
                  /* @min:%2esendPageViewInternal */
                ](T, R)), d || (t[
                  g_
                  /* @min:%2esendPageViewPerformanceInternal */
                ](Zn, R), d = !0));
              } else
                j > 0 && ne(j, +/* @__PURE__ */ new Date()) > k && (On = !0, F || (R[
                  Bt
                  /* @min:%2eduration */
                ] = k, t[
                  Fi
                  /* @min:%2esendPageViewInternal */
                ](T, R)));
            } catch (or) {
              en(p, 1, 38, "trackPageView failed on page load calculation: " + Fn(or), { exception: dn(or) });
            }
            return On;
          });
        }, c.teardown = function(T, R) {
          if (s) {
            clearTimeout(s), s = null;
            var x = v.slice(0);
            v = [], hn(x, function(E) {
              E();
            });
          }
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), Ly = 36e5, ap = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function QE() {
  var e = oi();
  return e && !!e.timing;
}
function by() {
  var e = oi();
  return e && e.getEntriesByType && e.getEntriesByType("navigation")[
    yo
    /* @min:%2elength */
  ] > 0;
}
function My() {
  var e = oi(), t = e ? e.timing : 0;
  return t && t.domainLookupStart > 0 && t[
    es
    /* @min:%2enavigationStart */
  ] > 0 && t[
    no
    /* @min:%2eresponseStart */
  ] > 0 && t[
    xy
    /* @min:%2erequestStart */
  ] > 0 && t[
    pc
    /* @min:%2eloadEventEnd */
  ] > 0 && t[
    E_
    /* @min:%2eresponseEnd */
  ] > 0 && t[
    Ec
    /* @min:%2econnectEnd */
  ] > 0 && t.domLoading > 0;
}
function up() {
  return QE() ? oi().timing : null;
}
function Yy() {
  return by() ? oi()[
    my
    /* @min:%2egetEntriesByType */
  ]("navigation")[0] : null;
}
function Uy() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var i = At() || {}, u = i.userAgent, o = !1;
  if (u)
    for (var c = 0; c < ap[
      yo
      /* @min:%2elength */
    ]; c++)
      o = o || u.toLowerCase().indexOf(ap[c]) !== -1;
  if (o)
    return !1;
  for (var c = 0; c < e[
    yo
    /* @min:%2elength */
  ]; c++)
    if (e[c] < 0 || e[c] >= Ly)
      return !1;
  return !0;
}
var Fy = (
  /** @class */
  function() {
    function e(t) {
      var i = Yo(t);
      nr(e, this, function(u) {
        u[
          Sd
          /* @min:%2epopulatePageViewPerformanceEvent */
        ] = function(o) {
          o.isValid = !1;
          var c = Yy(), s = up(), v = 0, d = 0, p = 0, h = 0, S = 0;
          (c || s) && (c ? (v = c[
            Bt
            /* @min:%2eduration */
          ], d = c.startTime === 0 ? c[
            Ec
            /* @min:%2econnectEnd */
          ] : ne(c.startTime, c[
            Ec
            /* @min:%2econnectEnd */
          ]), p = ne(c.requestStart, c[
            no
            /* @min:%2eresponseStart */
          ]), h = ne(c[
            no
            /* @min:%2eresponseStart */
          ], c[
            E_
            /* @min:%2eresponseEnd */
          ]), S = ne(c.responseEnd, c[
            pc
            /* @min:%2eloadEventEnd */
          ])) : (v = ne(s[
            es
            /* @min:%2enavigationStart */
          ], s[
            pc
            /* @min:%2eloadEventEnd */
          ]), d = ne(s[
            es
            /* @min:%2enavigationStart */
          ], s[
            Ec
            /* @min:%2econnectEnd */
          ]), p = ne(s.requestStart, s[
            no
            /* @min:%2eresponseStart */
          ]), h = ne(s[
            no
            /* @min:%2eresponseStart */
          ], s[
            E_
            /* @min:%2eresponseEnd */
          ]), S = ne(s.responseEnd, s[
            pc
            /* @min:%2eloadEventEnd */
          ])), v === 0 ? en(i, 2, 10, "error calculating page view performance.", { total: v, network: d, request: p, response: h, dom: S }) : u[
            p_
            /* @min:%2eshouldCollectDuration */
          ](v, d, p, h, S) ? v < Math.floor(d) + Math.floor(p) + Math.floor(h) + Math.floor(S) ? en(i, 2, 8, "client performance math error.", { total: v, network: d, request: p, response: h, dom: S }) : (o.durationMs = v, o.perfTotal = o[
            Bt
            /* @min:%2eduration */
          ] = Gt(v), o.networkConnect = Gt(d), o.sentRequest = Gt(p), o.receivedResponse = Gt(h), o.domProcessing = Gt(S), o.isValid = !0) : en(i, 2, 45, "Invalid page load duration value. Browser perf data won't be sent.", { total: v, network: d, request: p, response: h, dom: S }));
        }, u[
          VE
          /* @min:%2egetPerformanceTiming */
        ] = up, u[
          $E
          /* @min:%2eisPerformanceTimingSupported */
        ] = QE, u[
          ZE
          /* @min:%2eisPerformanceTimingDataReady */
        ] = My, u[
          p_
          /* @min:%2eshouldCollectDuration */
        ] = Uy;
      });
    }
    return e.__ieDyn = 1, e;
  }()
), Hy = (
  /** @class */
  function() {
    function e(t, i) {
      var u = "prevPageVisitData";
      nr(e, this, function(o) {
        o[
          h_
          /* @min:%2etrackPreviousPageVisit */
        ] = function(d, p) {
          try {
            var h = c(d, p);
            h && i(h.pageName, h.pageUrl, h.pageVisitTime);
          } catch (S) {
            ki(t, "Auto track page visit time failed, metric will not be collected: " + dn(S));
          }
        };
        function c(d, p) {
          var h = null;
          try {
            h = v(), s(d, p);
          } catch (S) {
            ki(t, "Call to restart failed: " + dn(S)), h = null;
          }
          return h;
        }
        function s(d, p) {
          try {
            if (wo()) {
              a_(t, u) != null && Gr("Cannot call startPageVisit consecutively without first calling stopPageVisit");
              var h = new By(d, p), S = Ye().stringify(h);
              UE(t, u, S);
            }
          } catch (I) {
            ki(t, "Call to start failed: " + dn(I));
          }
        }
        function v() {
          var d = null;
          try {
            if (wo()) {
              var p = $e(), h = a_(t, u);
              h && du() && (d = Ye().parse(h), d.pageVisitTime = p - d[
                JE
                /* @min:%2epageVisitStartTime */
              ], sy(t, u));
            }
          } catch (S) {
            ki(t, "Stop page visit timer failed: " + dn(S)), d = null;
          }
          return d;
        }
        Kt(o, "_logger", function() {
          return t;
        }), Kt(o, "pageVisitTimeTrackingHandler", function() {
          return i;
        });
      });
    }
    return e.__ieDyn = 1, e;
  }()
), By = (
  /** @class */
  function() {
    function e(t, i) {
      this[
        JE
        /* @min:%2epageVisitStartTime */
      ] = $e(), this.pageName = t, this.pageUrl = i;
    }
    return e;
  }()
), op = (
  /** @class */
  function() {
    function e(t, i) {
      var u = this, o = {};
      u.start = function(c) {
        typeof o[c] < "u" && en(t, 2, 62, "start was called more than once for this event without calling stop.", { name: c, key: c }, !0), o[c] = +/* @__PURE__ */ new Date();
      }, u.stop = function(c, s, v, d) {
        var p = o[c];
        if (isNaN(p))
          en(t, 2, 63, "stop was called without a corresponding start.", { name: c, key: c }, !0);
        else {
          var h = +/* @__PURE__ */ new Date(), S = ne(p, h);
          u.action(c, s, S, v, d);
        }
        delete o[c], o[c] = void 0;
      };
    }
    return e;
  }()
), ky = "event";
function Fu(e, t) {
  e && e.dispatchEvent && t && e.dispatchEvent(t);
}
function Gy(e) {
  if (e && e.reason) {
    var t = e.reason;
    return !En(t) && Cn(t[
      Qc
      /* @min:%2etoString */
    ]) ? t[
      Qc
      /* @min:%2etoString */
    ]() : dn(t);
  }
  return e || "";
}
var fp = 6e4;
function cp(e, t) {
  return e = e || t, e < fp && (e = fp), e;
}
function sp(e) {
  return e || (e = {}), e.sessionRenewalMs = cp(e.sessionRenewalMs, 30 * 60 * 1e3), e.sessionExpirationMs = cp(e.sessionExpirationMs, 24 * 60 * 60 * 1e3), e[
    s_
    /* @min:%2edisableExceptionTracking */
  ] = Ge(e[
    s_
    /* @min:%2edisableExceptionTracking */
  ]), e[
    jc
    /* @min:%2eautoTrackPageVisitTime */
  ] = Ge(e[
    jc
    /* @min:%2eautoTrackPageVisitTime */
  ]), e[
    l_
    /* @min:%2eoverridePageViewDuration */
  ] = Ge(e[
    l_
    /* @min:%2eoverridePageViewDuration */
  ]), e[
    v_
    /* @min:%2eenableUnhandledPromiseRejectionTracking */
  ] = Ge(e[
    v_
    /* @min:%2eenableUnhandledPromiseRejectionTracking */
  ]), (isNaN(e[
    zf
    /* @min:%2esamplingPercentage */
  ]) || e[
    zf
    /* @min:%2esamplingPercentage */
  ] <= 0 || e[
    zf
    /* @min:%2esamplingPercentage */
  ] >= 100) && (e[
    zf
    /* @min:%2esamplingPercentage */
  ] = 100), e[
    ns
    /* @min:%2eisStorageUseDisabled */
  ] = Ge(e[
    ns
    /* @min:%2eisStorageUseDisabled */
  ]), e[
    rs
    /* @min:%2eisBrowserLinkTrackingEnabled */
  ] = Ge(e[
    rs
    /* @min:%2eisBrowserLinkTrackingEnabled */
  ]), e[
    __
    /* @min:%2eenableAutoRouteTracking */
  ] = Ge(e[
    __
    /* @min:%2eenableAutoRouteTracking */
  ]), e[
    d_
    /* @min:%2enamePrefix */
  ] = e[
    d_
    /* @min:%2enamePrefix */
  ] || "", e.enableDebug = Ge(e.enableDebug), e[
    iv
    /* @min:%2edisableFlushOnBeforeUnload */
  ] = Ge(e[
    iv
    /* @min:%2edisableFlushOnBeforeUnload */
  ]), e.disableFlushOnUnload = Ge(e.disableFlushOnUnload, e[
    iv
    /* @min:%2edisableFlushOnBeforeUnload */
  ]), e;
}
function Wy(e) {
  xr(e[
    ns
    /* @min:%2eisStorageUseDisabled */
  ]) || (e[
    ns
    /* @min:%2eisStorageUseDisabled */
  ] ? ay() : uy());
}
var zy = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      var i = e.call(this) || this;
      i.identifier = yy, i.priority = 180, i.autoRoutePVDelay = 500;
      var u, o, c, s, v, d, p, h, S, I, T, R, x, E, b, m, F;
      return nr(t, i, function(y, j) {
        var un = j._addHook;
        rr(), y.getCookieMgr = function() {
          return rd(y[
            mr
            /* @min:%2ecore */
          ]);
        }, y.processTelemetry = function(M, q) {
          y.processNext(M, q);
        }, y.trackEvent = function(M, q) {
          try {
            var Z = Ft(M, Wt[
              Yt
              /* @min:%2edataType */
            ], Wt[
              Ci
              /* @min:%2eenvelopeType */
            ], y[
              fe
              /* @min:%2ediagLog */
            ](), q);
            y[
              mr
              /* @min:%2ecore */
            ][
              wi
              /* @min:%2etrack */
            ](Z);
          } catch (P) {
            Mn(2, 39, "trackTrace failed, trace will not be collected: " + Fn(P), { exception: dn(P) });
          }
        }, y.startTrackEvent = function(M) {
          try {
            u.start(M);
          } catch (q) {
            Mn(1, 29, "startTrackEvent failed, event will not be collected: " + Fn(q), { exception: dn(q) });
          }
        }, y.stopTrackEvent = function(M, q, Z) {
          try {
            u.stop(M, void 0, q, Z);
          } catch (P) {
            Mn(1, 30, "stopTrackEvent failed, event will not be collected: " + Fn(P), { exception: dn(P) });
          }
        }, y.trackTrace = function(M, q) {
          try {
            var Z = Ft(M, Ja[
              Yt
              /* @min:%2edataType */
            ], Ja[
              Ci
              /* @min:%2eenvelopeType */
            ], y[
              fe
              /* @min:%2ediagLog */
            ](), q);
            y[
              mr
              /* @min:%2ecore */
            ][
              wi
              /* @min:%2etrack */
            ](Z);
          } catch (P) {
            Mn(2, 39, "trackTrace failed, trace will not be collected: " + Fn(P), { exception: dn(P) });
          }
        }, y.trackMetric = function(M, q) {
          try {
            var Z = Ft(M, $i[
              Yt
              /* @min:%2edataType */
            ], $i[
              Ci
              /* @min:%2eenvelopeType */
            ], y[
              fe
              /* @min:%2ediagLog */
            ](), q);
            y[
              mr
              /* @min:%2ecore */
            ][
              wi
              /* @min:%2etrack */
            ](Z);
          } catch (P) {
            Mn(1, 36, "trackMetric failed, metric will not be collected: " + Fn(P), { exception: dn(P) });
          }
        }, y[
          gc
          /* @min:%2etrackPageView */
        ] = function(M, q) {
          try {
            var Z = M || {};
            c[
              gc
              /* @min:%2etrackPageView */
            ](Z, Wr(Wr(Wr({}, Z.properties), Z.measurements), q)), y.config[
              jc
              /* @min:%2eautoTrackPageVisitTime */
            ] && v[
              h_
              /* @min:%2etrackPreviousPageVisit */
            ](Z.name, Z.uri);
          } catch (P) {
            Mn(1, 37, "trackPageView failed, page view will not be collected: " + Fn(P), { exception: dn(P) });
          }
        }, y[
          Fi
          /* @min:%2esendPageViewInternal */
        ] = function(M, q, Z) {
          var P = le();
          P && (M.refUri = M.refUri === void 0 ? P.referrer : M.refUri);
          var X = Ft(M, ii[
            Yt
            /* @min:%2edataType */
          ], ii[
            Ci
            /* @min:%2eenvelopeType */
          ], y[
            fe
            /* @min:%2ediagLog */
          ](), q, Z);
          y[
            mr
            /* @min:%2ecore */
          ][
            wi
            /* @min:%2etrack */
          ](X);
        }, y[
          g_
          /* @min:%2esendPageViewPerformanceInternal */
        ] = function(M, q, Z) {
          var P = Ft(M, Qa[
            Yt
            /* @min:%2edataType */
          ], Qa[
            Ci
            /* @min:%2eenvelopeType */
          ], y[
            fe
            /* @min:%2ediagLog */
          ](), q, Z);
          y[
            mr
            /* @min:%2ecore */
          ][
            wi
            /* @min:%2etrack */
          ](P);
        }, y.trackPageViewPerformance = function(M, q) {
          var Z = M || {};
          try {
            s[
              Sd
              /* @min:%2epopulatePageViewPerformanceEvent */
            ](Z), y[
              g_
              /* @min:%2esendPageViewPerformanceInternal */
            ](Z, q);
          } catch (P) {
            Mn(1, 37, "trackPageViewPerformance failed, page view will not be collected: " + Fn(P), { exception: dn(P) });
          }
        }, y.startTrackPage = function(M) {
          try {
            if (typeof M != "string") {
              var q = le();
              M = q && q.title || "";
            }
            o.start(M);
          } catch (Z) {
            Mn(1, 31, "startTrackPage failed, page view may not be collected: " + Fn(Z), { exception: dn(Z) });
          }
        }, y.stopTrackPage = function(M, q, Z, P) {
          try {
            if (typeof M != "string") {
              var X = le();
              M = X && X.title || "";
            }
            if (typeof q != "string") {
              var rn = Xt();
              q = rn && rn[
                Ma
                /* @min:%2ehref */
              ] || "";
            }
            o.stop(M, q, Z, P), y.config[
              jc
              /* @min:%2eautoTrackPageVisitTime */
            ] && v[
              h_
              /* @min:%2etrackPreviousPageVisit */
            ](M, q);
          } catch (D) {
            Mn(1, 32, "stopTrackPage failed, page view will not be collected: " + Fn(D), { exception: dn(D) });
          }
        }, y[
          tp
          /* @min:%2esendExceptionInternal */
        ] = function(M, q, Z) {
          var P = M && (M[
            av
            /* @min:%2eexception */
          ] || M[
            Uu
            /* @min:%2eerror */
          ]) || // - Handle someone calling trackException based of v1 API where the exception was the Error
          X_(M) && M || // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
          //   is preserved and does not list ApplicationInsights code as the source
          { name: M && typeof M, message: M || Je };
          M = M || {};
          var X = new Ne(y[
            fe
            /* @min:%2ediagLog */
          ](), P, M.properties || q, M.measurements, M.severityLevel, M.id).toInterface(), rn = Ft(X, Ne[
            Yt
            /* @min:%2edataType */
          ], Ne[
            Ci
            /* @min:%2eenvelopeType */
          ], y[
            fe
            /* @min:%2ediagLog */
          ](), q, Z);
          y[
            mr
            /* @min:%2ecore */
          ][
            wi
            /* @min:%2etrack */
          ](rn);
        }, y.trackException = function(M, q) {
          M && !M[
            av
            /* @min:%2eexception */
          ] && M[
            Uu
            /* @min:%2eerror */
          ] && (M[
            av
            /* @min:%2eexception */
          ] = M[
            Uu
            /* @min:%2eerror */
          ]);
          try {
            y[
              tp
              /* @min:%2esendExceptionInternal */
            ](M, q);
          } catch (Z) {
            Mn(1, 35, "trackException failed, exception will not be collected: " + Fn(Z), { exception: dn(Z) });
          }
        }, y[
          uv
          /* @min:%2e_onerror */
        ] = function(M) {
          var q = M && M[
            Uu
            /* @min:%2eerror */
          ], Z = M && M.evt;
          try {
            if (!Z) {
              var P = ni();
              P && (Z = P[ky]);
            }
            var X = M && M.url || (le() || {}).URL, rn = M[
              ov
              /* @min:%2eerrorSrc */
            ] || "window.onerror@" + X + ":" + (M[
              fv
              /* @min:%2elineNumber */
            ] || 0) + ":" + (M[
              cv
              /* @min:%2ecolumnNumber */
            ] || 0), D = {
              errorSrc: rn,
              url: X,
              lineNumber: M[
                fv
                /* @min:%2elineNumber */
              ] || 0,
              columnNumber: M[
                cv
                /* @min:%2ecolumnNumber */
              ] || 0,
              message: M[
                ip
                /* @min:%2emessage */
              ]
            };
            iy(M.message, M.url, M.lineNumber, M.columnNumber, M[
              Uu
              /* @min:%2eerror */
            ]) ? on(Ne[
              sv
              /* @min:%2eCreateAutoException */
            ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", X, M[
              fv
              /* @min:%2elineNumber */
            ] || 0, M[
              cv
              /* @min:%2ecolumnNumber */
            ] || 0, q, Z, null, rn), D) : (M[
              ov
              /* @min:%2eerrorSrc */
            ] || (M[
              ov
              /* @min:%2eerrorSrc */
            ] = rn), y.trackException({
              exception: M,
              severityLevel: 3
              /* eSeverityLevel.Error */
            }, D));
          } catch (W) {
            var Y = q ? q.name + ", " + q[
              ip
              /* @min:%2emessage */
            ] : "null";
            Mn(1, 11, "_onError threw exception while logging error, error will not be collected: " + Fn(W), { exception: dn(W), errorString: Y });
          }
        }, y[
          qf
          /* @min:%2eaddTelemetryInitializer */
        ] = function(M) {
          if (y[
            mr
            /* @min:%2ecore */
          ])
            return y[
              mr
              /* @min:%2ecore */
            ][
              qf
              /* @min:%2eaddTelemetryInitializer */
            ](M);
          d || (d = []), d.push(M);
        }, y.initialize = function(M, q, Z, P) {
          if (!y.isInitialized()) {
            Q(q) && Gr("Error initializing"), j.initialize(M, q, Z, P), M.storagePrefix && _d(M.storagePrefix);
            try {
              F = ta(Ve(y.identifier), q.evtNamespace && q.evtNamespace()), d && (hn(d, function(rn) {
                q[
                  qf
                  /* @min:%2eaddTelemetryInitializer */
                ](rn);
              }), d = null);
              var X = k(M);
              Wy(X), s = new Fy(y[
                mr
                /* @min:%2ecore */
              ]), c = new Oy(y, X[
                l_
                /* @min:%2eoverridePageViewDuration */
              ], y[
                mr
                /* @min:%2ecore */
              ], s), v = new Hy(y[
                fe
                /* @min:%2ediagLog */
              ](), function(rn, D, Y) {
                return Zn(rn, D, Y);
              }), On(X, M), u = new op(y[
                fe
                /* @min:%2ediagLog */
              ](), "trackEvent"), u.action = function(rn, D, Y, W, J) {
                W || (W = {}), J || (J = {}), W.duration = Y[
                  Qc
                  /* @min:%2etoString */
                ](), y.trackEvent({ name: rn, properties: W, measurements: J });
              }, o = new op(y[
                fe
                /* @min:%2ediagLog */
              ](), "trackPageView"), o.action = function(rn, D, Y, W, J) {
                Q(W) && (W = {}), W.duration = Y[
                  Qc
                  /* @min:%2etoString */
                ]();
                var cn = {
                  name: rn,
                  uri: D,
                  properties: W,
                  measurements: J
                };
                y[
                  Fi
                  /* @min:%2esendPageViewInternal */
                ](cn, W);
              }, Mo() && (Dr(X), Ir(X));
            } catch (rn) {
              throw y.setInitialized(!1), rn;
            }
          }
        }, y._doTeardown = function(M, q) {
          c && c.teardown(M, q), _o(window, null, null, F), rr();
        };
        function k(M) {
          var q = Ze(null, M, y[
            mr
            /* @min:%2ecore */
          ]), Z = y.identifier, P = sp(M), X = y.config = q.getExtCfg(Z);
          return P !== void 0 && ir(P, function(rn, D) {
            X[rn] = q.getConfig(Z, rn, D), X[rn] === void 0 && (X = D);
          }), X;
        }
        function On(M, q) {
          p = M[
            rs
            /* @min:%2eisBrowserLinkTrackingEnabled */
          ] || q[
            rs
            /* @min:%2eisBrowserLinkTrackingEnabled */
          ], or();
        }
        function Zn(M, q, Z) {
          var P = { PageName: M, PageUrl: q };
          y.trackMetric({
            name: "PageVisitTime",
            average: Z,
            max: Z,
            min: Z,
            sampleCount: 1
          }, P);
        }
        function or() {
          if (!h && p) {
            var M = ["/browserLinkSignalR/", "/__browserLink/"], q = function(Z) {
              if (p && Z.baseType === Vi[
                Yt
                /* @min:%2edataType */
              ]) {
                var P = Z.baseData;
                if (P) {
                  for (var X = 0; X < M[
                    yo
                    /* @min:%2elength */
                  ]; X++)
                    if (P.target && P.target.indexOf(M[X]) >= 0)
                      return !1;
                }
              }
              return !0;
            };
            y[
              qf
              /* @min:%2eaddTelemetryInitializer */
            ](q), h = !0;
          }
        }
        function on(M, q) {
          var Z = Ft(M, Ne[
            Yt
            /* @min:%2edataType */
          ], Ne[
            Ci
            /* @min:%2eenvelopeType */
          ], y[
            fe
            /* @min:%2ediagLog */
          ](), q);
          y[
            mr
            /* @min:%2ecore */
          ][
            wi
            /* @min:%2etrack */
          ](Z);
        }
        function Dr(M) {
          var q = ni(), Z = Xt(!0);
          T = M[
            s_
            /* @min:%2edisableExceptionTracking */
          ], !T && !R && !M.autoExceptionInstrumented && (un(Hf(q, "onerror", {
            ns: F,
            rsp: function(P, X, rn, D, Y, W) {
              !T && P.rslt !== !0 && y[
                uv
                /* @min:%2e_onerror */
              ](Ne[
                sv
                /* @min:%2eCreateAutoException */
              ](X, rn, D, Y, W, P.evt));
            }
          }, !1)), R = !0), Xr(M, q, Z);
        }
        function Ir(M) {
          var q = ni(), Z = Xt(!0);
          if (S = M[
            __
            /* @min:%2eenableAutoRouteTracking */
          ] === !0, q && S && vE()) {
            var P = XC();
            Cn(P.pushState) && Cn(P.replaceState) && typeof Event !== qt && Lr(M, q, P, Z);
          }
        }
        function Or() {
          var M = null;
          if (y[
            mr
            /* @min:%2ecore */
          ] && y[
            mr
            /* @min:%2ecore */
          ].getTraceCtx && (M = y[
            mr
            /* @min:%2ecore */
          ].getTraceCtx(!1)), !M) {
            var q = y[
              mr
              /* @min:%2ecore */
            ].getPlugin(ps);
            if (q) {
              var Z = q.plugin.context;
              Z && (M = Td(Z.telemetryTrace));
            }
          }
          return M;
        }
        function Lr(M, q, Z, P) {
          var X = M[
            d_
            /* @min:%2enamePrefix */
          ] || "";
          function rn() {
            S && Fu(q, Ou(X + "locationchange"));
          }
          function D() {
            if (m && (b = m), m = P && P[
              Ma
              /* @min:%2ehref */
            ] || "", S) {
              var Y = Or();
              if (Y) {
                Y.setTraceId(Vt());
                var W = "_unknown_";
                P && P.pathname && (W = P.pathname + (P.hash || "")), Y.setName(_r(y[
                  fe
                  /* @min:%2ediagLog */
                ](), W));
              }
              setTimeout((function(J) {
                y[
                  gc
                  /* @min:%2etrackPageView */
                ]({ refUri: J, properties: { duration: 0 } });
              }).bind(y, b), y.autoRoutePVDelay);
            }
          }
          I || (un(Hf(Z, "pushState", {
            ns: F,
            rsp: function() {
              S && (Fu(q, Ou(X + "pushState")), Fu(q, Ou(X + "locationchange")));
            }
          }, !0)), un(Hf(Z, "replaceState", {
            ns: F,
            rsp: function() {
              S && (Fu(q, Ou(X + "replaceState")), Fu(q, Ou(X + "locationchange")));
            }
          }, !0)), ri(q, X + "popstate", rn, F), ri(q, X + "locationchange", D, F), I = !0);
        }
        function Xr(M, q, Z) {
          x = M[
            v_
            /* @min:%2eenableUnhandledPromiseRejectionTracking */
          ] === !0, x && !E && (un(Hf(q, "onunhandledrejection", {
            ns: F,
            rsp: function(P, X) {
              x && P.rslt !== !0 && y[
                uv
                /* @min:%2e_onerror */
              ](Ne[
                sv
                /* @min:%2eCreateAutoException */
              ](Gy(X), Z ? Z[
                Ma
                /* @min:%2ehref */
              ] : "", 0, 0, X, P.evt));
            }
          }, !1)), E = !0, M.autoUnhandledPromiseInstrumented = E);
        }
        function Mn(M, q, Z, P, X) {
          y[
            fe
            /* @min:%2ediagLog */
          ]().throwInternal(M, q, Z, P, X);
        }
        function rr() {
          u = null, o = null, c = null, s = null, v = null, d = null, p = !1, h = !1, S = !1, I = !1, T = !1, R = !1, x = !1, E = !1;
          var M = Xt(!0);
          b = M && M[
            Ma
            /* @min:%2ehref */
          ] || "", m = null, F = null;
        }
        Kt(y, "_pageViewManager", function() {
          return c;
        }), Kt(y, "_pageViewPerformanceManager", function() {
          return s;
        }), Kt(y, "_pageVisitTimeManager", function() {
          return v;
        }), Kt(y, "_evtNamespace", function() {
          return "." + F;
        });
      }), i;
    }
    return t.Version = "2.8.16", t.getDefaultConfig = sp, t;
  }(Fo)
), bi = "duration", Pr = "tags", lv = "deviceType", se = "data", St = "name", mo = "traceID", xn = "length", xo = "stringify", aa = "measurements", Ke = "dataType", ua = "envelopeType", Mi = "toString", Xf = "onLine", T_ = "isOnline", Po = "enqueue", ja = "count", nu = "push", S_ = "emitLineDelimitedJson", cu = "clear", ro = "batchPayloads", Wa = "markAsSent", go = "clearSent", Nd = "bufferOverride", Hu = "BUFFER_KEY", yi = "SENT_BUFFER_KEY", Bu = "MAX_BUFFER_SIZE", Yi = "namePrefix", N_ = "maxBatchSizeInBytes", ma = "triggerSend", kr = "diagLog", jE = "onunloadDisableBeacon", D_ = "isBeaconApiDisabled", ku = "_sender", Qn = "_senderConfig", nT = "enableSessionStorageBuffer", mi = "_buffer", rT = "samplingPercentage", Tc = "instrumentationKey", xi = "endpointUrl", eT = "customHeaders", eo = "disableXhr", tT = "onunloadDisableFetch", I_ = "disableTelemetry", vv = "baseType", ts = "sampleRate", iT = "convertUndefined", qy = "_xhrReadyStateChange", xe = "_onError", _v = "_onPartialSuccess", $f = "_onSuccess", Vf = "itemsAccepted", Ky = "itemsReceived", to = "isRetryDisabled", dv = "setRequestHeader", aT = "maxBatchInterval", lp = "eventsSendRequest", vp = "disableInstrumentationKeyValidation", uT = "getSamplingScore", Xy = "getHashCodeScore", hv = "baseType", tr = "baseData", Cr = "properties", _p = "true";
function dr(e, t, i) {
  return Gn(e, t, i, Kv);
}
function $y(e, t, i) {
  var u = i[
    Pr
    /* @min:%2etags */
  ] = i[
    Pr
    /* @min:%2etags */
  ] || {}, o = t.ext = t.ext || {}, c = t[
    Pr
    /* @min:%2etags */
  ] = t[
    Pr
    /* @min:%2etags */
  ] || [], s = o.user;
  s && (dr(u, jn.userAuthUserId, s.authId), dr(u, jn.userId, s.id || s.localId));
  var v = o.app;
  v && dr(u, jn.sessionId, v.sesId);
  var d = o.device;
  d && (dr(u, jn.deviceId, d.id || d.localId), dr(u, jn[
    lv
    /* @min:%2edeviceType */
  ], d.deviceClass), dr(u, jn.deviceIp, d.ip), dr(u, jn.deviceModel, d.model), dr(u, jn[
    lv
    /* @min:%2edeviceType */
  ], d[
    lv
    /* @min:%2edeviceType */
  ]));
  var p = t.ext.web;
  if (p) {
    dr(u, jn.deviceLanguage, p.browserLang), dr(u, jn.deviceBrowserVersion, p.browserVer), dr(u, jn.deviceBrowser, p.browser);
    var h = i[
      se
      /* @min:%2edata */
    ] = i[
      se
      /* @min:%2edata */
    ] || {}, S = h[tr] = h[tr] || {}, I = S[Cr] = S[Cr] || {};
    dr(I, "domain", p.domain), dr(I, "isManual", p.isManual ? _p : null), dr(I, "screenRes", p.screenRes), dr(I, "userConsent", p.userConsent ? _p : null);
  }
  var T = o.os;
  T && dr(u, jn.deviceOS, T[
    St
    /* @min:%2ename */
  ]);
  var R = o.trace;
  R && (dr(u, jn.operationParentId, R.parentID), dr(u, jn.operationName, _r(e, R[
    St
    /* @min:%2ename */
  ])), dr(u, jn.operationId, R[
    mo
    /* @min:%2etraceID */
  ]));
  for (var x = {}, E = c[
    xn
    /* @min:%2elength */
  ] - 1; E >= 0; E--) {
    var b = c[E];
    ir(b, function(F, y) {
      x[F] = y;
    }), c.splice(E, 1);
  }
  ir(c, function(F, y) {
    x[F] = y;
  });
  var m = Wr(Wr({}, u), x);
  m[jn.internalSdkVersion] || (m[jn.internalSdkVersion] = _r(e, "javascript:".concat(Vy.Version), 64)), i[
    Pr
    /* @min:%2etags */
  ] = aE(m);
}
function si(e, t, i) {
  Q(e) || ir(e, function(u, o) {
    tE(o) ? i[u] = o : En(o) ? t[u] = o : du() && (t[u] = Ye()[
      xo
      /* @min:%2estringify */
    ](o));
  });
}
function oa(e, t) {
  Q(e) || ir(e, function(i, u) {
    e[i] = u || t;
  });
}
function fa(e, t, i, u) {
  var o = new Sy(e, u, t);
  dr(o, "sampleRate", i[bE]), (i[tr] || {}).startTime && (o.time = uu(i[tr].startTime)), o.iKey = i.iKey;
  var c = i.iKey.replace(/-/g, "");
  return o[
    St
    /* @min:%2ename */
  ] = o[
    St
    /* @min:%2ename */
  ].replace("{0}", c), $y(e, i, o), i[
    Pr
    /* @min:%2etags */
  ] = i[
    Pr
    /* @min:%2etags */
  ] || [], aE(o);
}
function ca(e, t) {
  Q(t[tr]) && en(e, 1, 46, "telemetryItem.baseData cannot be null.");
}
var Vy = {
  Version: "2.8.16"
};
function Zy(e, t, i) {
  ca(e, t);
  var u = t[tr][
    aa
    /* @min:%2emeasurements */
  ] || {}, o = t[tr][Cr] || {};
  si(t[
    se
    /* @min:%2edata */
  ], o, u), Q(i) || oa(o, i);
  var c = t[tr];
  if (Q(c))
    return ki(e, "Invalid input for dependency data"), null;
  var s = c[Cr] && c[Cr][$0] ? c[Cr][$0] : "GET", v = new Vi(e, c.id, c.target, c[
    St
    /* @min:%2ename */
  ], c[
    bi
    /* @min:%2eduration */
  ], c.success, c.responseCode, s, c.type, c.correlationContext, o, u), d = new ia(Vi[
    Ke
    /* @min:%2edataType */
  ], v);
  return fa(e, Vi[
    ua
    /* @min:%2eenvelopeType */
  ], t, d);
}
function oT(e, t, i) {
  ca(e, t);
  var u = {}, o = {};
  t[hv] !== Wt[
    Ke
    /* @min:%2edataType */
  ] && (u.baseTypeSource = t[hv]), t[hv] === Wt[
    Ke
    /* @min:%2edataType */
  ] ? (u = t[tr][Cr] || {}, o = t[tr][
    aa
    /* @min:%2emeasurements */
  ] || {}) : t[tr] && si(t[tr], u, o), si(t[
    se
    /* @min:%2edata */
  ], u, o), Q(i) || oa(u, i);
  var c = t[tr][
    St
    /* @min:%2ename */
  ], s = new Wt(e, c, u, o), v = new ia(Wt[
    Ke
    /* @min:%2edataType */
  ], s);
  return fa(e, Wt[
    ua
    /* @min:%2eenvelopeType */
  ], t, v);
}
function Jy(e, t, i) {
  ca(e, t);
  var u = t[tr][
    aa
    /* @min:%2emeasurements */
  ] || {}, o = t[tr][Cr] || {};
  si(t[
    se
    /* @min:%2edata */
  ], o, u), Q(i) || oa(o, i);
  var c = t[tr], s = Ne.CreateFromInterface(e, c, o, u), v = new ia(Ne[
    Ke
    /* @min:%2edataType */
  ], s);
  return fa(e, Ne[
    ua
    /* @min:%2eenvelopeType */
  ], t, v);
}
function Qy(e, t, i) {
  ca(e, t);
  var u = t[tr], o = u[Cr] || {}, c = u[
    aa
    /* @min:%2emeasurements */
  ] || {};
  si(t[
    se
    /* @min:%2edata */
  ], o, c), Q(i) || oa(o, i);
  var s = new $i(e, u[
    St
    /* @min:%2ename */
  ], u.average, u.sampleCount, u.min, u.max, u.stdDev, o, c), v = new ia($i[
    Ke
    /* @min:%2edataType */
  ], s);
  return fa(e, $i[
    ua
    /* @min:%2eenvelopeType */
  ], t, v);
}
function jy(e, t, i) {
  ca(e, t);
  var u, o = t[tr];
  !Q(o) && !Q(o[Cr]) && !Q(o[Cr][bi]) ? (u = o[Cr][bi], delete o[Cr][bi]) : !Q(t[
    se
    /* @min:%2edata */
  ]) && !Q(t[
    se
    /* @min:%2edata */
  ][bi]) && (u = t[
    se
    /* @min:%2edata */
  ][bi], delete t[
    se
    /* @min:%2edata */
  ][bi]);
  var c = t[tr], s;
  ((t.ext || {}).trace || {})[
    mo
    /* @min:%2etraceID */
  ] && (s = t.ext.trace[
    mo
    /* @min:%2etraceID */
  ]);
  var v = c.id || s, d = c[
    St
    /* @min:%2ename */
  ], p = c.uri, h = c[Cr] || {}, S = c[
    aa
    /* @min:%2emeasurements */
  ] || {};
  if (Q(c.refUri) || (h.refUri = c.refUri), Q(c.pageType) || (h.pageType = c.pageType), Q(c.isLoggedIn) || (h.isLoggedIn = c.isLoggedIn[
    Mi
    /* @min:%2etoString */
  ]()), !Q(c[Cr])) {
    var I = c[Cr];
    ir(I, function(x, E) {
      h[x] = E;
    });
  }
  si(t[
    se
    /* @min:%2edata */
  ], h, S), Q(i) || oa(h, i);
  var T = new ii(e, d, p, u, h, S, v), R = new ia(ii[
    Ke
    /* @min:%2edataType */
  ], T);
  return fa(e, ii[
    ua
    /* @min:%2eenvelopeType */
  ], t, R);
}
function nm(e, t, i) {
  ca(e, t);
  var u = t[tr], o = u[
    St
    /* @min:%2ename */
  ], c = u.uri || u.url, s = u[Cr] || {}, v = u[
    aa
    /* @min:%2emeasurements */
  ] || {};
  si(t[
    se
    /* @min:%2edata */
  ], s, v), Q(i) || oa(s, i);
  var d = new Qa(e, o, c, void 0, s, v, u), p = new ia(Qa[
    Ke
    /* @min:%2edataType */
  ], d);
  return fa(e, Qa[
    ua
    /* @min:%2eenvelopeType */
  ], t, p);
}
function rm(e, t, i) {
  ca(e, t);
  var u = t[tr].message, o = t[tr].severityLevel, c = t[tr][Cr] || {}, s = t[tr][
    aa
    /* @min:%2emeasurements */
  ] || {};
  si(t[
    se
    /* @min:%2edata */
  ], c, s), Q(i) || oa(c, i);
  var v = new Ja(e, u, o, c, s), d = new ia(Ja[
    Ke
    /* @min:%2edataType */
  ], v);
  return fa(e, Ja[
    ua
    /* @min:%2eenvelopeType */
  ], t, d);
}
function dp(e, t) {
  _o(e, null, null, t);
}
function em(e) {
  var t, i = le(), u = At(), o = !1, c = !0, s = ta(Ve("OfflineListener"), e);
  try {
    if (d(ni()) && (o = !0), i) {
      var v = i.body || i;
      v.ononline && d(v) && (o = !0);
    }
    o && u && !Q(u[
      Xf
      /* @min:%2eonLine */
    ]) && (c = u[
      Xf
      /* @min:%2eonLine */
    ]);
  } catch {
    o = !1;
  }
  function d(T) {
    var R = !1;
    return T && (R = ri(T, "online", p, s), R && ri(T, "offline", h, s)), R;
  }
  function p() {
    c = !0;
  }
  function h() {
    c = !1;
  }
  function S() {
    var T = !0;
    return o ? T = c : u && !Q(u[
      Xf
      /* @min:%2eonLine */
    ]) && (T = u[
      Xf
      /* @min:%2eonLine */
    ]), T;
  }
  function I() {
    var T = ni();
    if (T && o) {
      if (dp(T, s), i) {
        var R = i.body || i;
        xr(R.ononline) || dp(R, s);
      }
      o = !1;
    }
  }
  return t = {}, t[
    T_
    /* @min:isOnline */
  ] = S, t.isListening = function() {
    return o;
  }, t.unload = I, t;
}
var fT = (
  /** @class */
  function() {
    function e(t, i) {
      var u = [], o = !1;
      this._get = function() {
        return u;
      }, this._set = function(c) {
        return u = c, u;
      }, nr(e, this, function(c) {
        c[
          Po
          /* @min:%2eenqueue */
        ] = function(s) {
          if (c[
            ja
            /* @min:%2ecount */
          ]() >= i.eventsLimitInMem()) {
            o || (en(t, 2, 105, "Maximum in-memory buffer size reached: " + c[
              ja
              /* @min:%2ecount */
            ](), !0), o = !0);
            return;
          }
          u[
            nu
            /* @min:%2epush */
          ](s);
        }, c[
          ja
          /* @min:%2ecount */
        ] = function() {
          return u[
            xn
            /* @min:%2elength */
          ];
        }, c.size = function() {
          for (var s = u[
            xn
            /* @min:%2elength */
          ], v = 0; v < u[
            xn
            /* @min:%2elength */
          ]; v++)
            s += u[v][
              xn
              /* @min:%2elength */
            ];
          return i[
            S_
            /* @min:%2eemitLineDelimitedJson */
          ]() || (s += 2), s;
        }, c[
          cu
          /* @min:%2eclear */
        ] = function() {
          u = [], o = !1;
        }, c.getItems = function() {
          return u.slice(0);
        }, c[
          ro
          /* @min:%2ebatchPayloads */
        ] = function(s) {
          if (s && s[
            xn
            /* @min:%2elength */
          ] > 0) {
            var v = i[
              S_
              /* @min:%2eemitLineDelimitedJson */
            ]() ? s.join(`
`) : "[" + s.join(",") + "]";
            return v;
          }
          return null;
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), tm = (
  /** @class */
  function(e) {
    It(t, e);
    function t(i, u) {
      var o = e.call(this, i, u) || this;
      return nr(t, o, function(c, s) {
        c[
          Wa
          /* @min:%2emarkAsSent */
        ] = function(v) {
          s[
            cu
            /* @min:%2eclear */
          ]();
        }, c[
          go
          /* @min:%2eclearSent */
        ] = function(v) {
        };
      }), o;
    }
    return t.__ieDyn = 1, t;
  }(fT)
), im = (
  /** @class */
  function(e) {
    It(t, e);
    function t(i, u) {
      var o = e.call(this, i, u) || this, c = !1, s = u[
        Nd
        /* @min:%2ebufferOverride */
      ]() || { getItem: a_, setItem: UE }, v = s.getItem, d = s.setItem;
      return nr(t, o, function(p, h) {
        var S = x(t[
          Hu
          /* @min:%2eBUFFER_KEY */
        ]), I = x(t[
          yi
          /* @min:%2eSENT_BUFFER_KEY */
        ]), T = p._set(S.concat(I));
        T[
          xn
          /* @min:%2elength */
        ] > t[
          Bu
          /* @min:%2eMAX_BUFFER_SIZE */
        ] && (T[
          xn
          /* @min:%2elength */
        ] = t[
          Bu
          /* @min:%2eMAX_BUFFER_SIZE */
        ]), E(t[
          yi
          /* @min:%2eSENT_BUFFER_KEY */
        ], []), E(t[
          Hu
          /* @min:%2eBUFFER_KEY */
        ], T), p[
          Po
          /* @min:%2eenqueue */
        ] = function(b) {
          if (p[
            ja
            /* @min:%2ecount */
          ]() >= t[
            Bu
            /* @min:%2eMAX_BUFFER_SIZE */
          ]) {
            c || (en(i, 2, 67, "Maximum buffer size reached: " + p[
              ja
              /* @min:%2ecount */
            ](), !0), c = !0);
            return;
          }
          h[
            Po
            /* @min:%2eenqueue */
          ](b), E(t[
            Hu
            /* @min:%2eBUFFER_KEY */
          ], p._get());
        }, p[
          cu
          /* @min:%2eclear */
        ] = function() {
          h[
            cu
            /* @min:%2eclear */
          ](), E(t[
            Hu
            /* @min:%2eBUFFER_KEY */
          ], p._get()), E(t[
            yi
            /* @min:%2eSENT_BUFFER_KEY */
          ], []), c = !1;
        }, p[
          Wa
          /* @min:%2emarkAsSent */
        ] = function(b) {
          E(t[
            Hu
            /* @min:%2eBUFFER_KEY */
          ], p._set(R(b, p._get())));
          var m = x(t[
            yi
            /* @min:%2eSENT_BUFFER_KEY */
          ]);
          m instanceof Array && b instanceof Array && (m = m.concat(b), m[
            xn
            /* @min:%2elength */
          ] > t[
            Bu
            /* @min:%2eMAX_BUFFER_SIZE */
          ] && (en(i, 1, 67, "Sent buffer reached its maximum size: " + m[
            xn
            /* @min:%2elength */
          ], !0), m[
            xn
            /* @min:%2elength */
          ] = t[
            Bu
            /* @min:%2eMAX_BUFFER_SIZE */
          ]), E(t[
            yi
            /* @min:%2eSENT_BUFFER_KEY */
          ], m));
        }, p[
          go
          /* @min:%2eclearSent */
        ] = function(b) {
          var m = x(t[
            yi
            /* @min:%2eSENT_BUFFER_KEY */
          ]);
          m = R(b, m), E(t[
            yi
            /* @min:%2eSENT_BUFFER_KEY */
          ], m);
        };
        function R(b, m) {
          var F = [];
          return hn(m, function(y) {
            !Cn(y) && be(b, y) === -1 && F[
              nu
              /* @min:%2epush */
            ](y);
          }), F;
        }
        function x(b) {
          var m = b;
          try {
            m = u[
              Yi
              /* @min:%2enamePrefix */
            ] && u[
              Yi
              /* @min:%2enamePrefix */
            ]() ? u[
              Yi
              /* @min:%2enamePrefix */
            ]() + "_" + m : m;
            var F = v(i, m);
            if (F) {
              var y = Ye().parse(F);
              if (En(y) && (y = Ye().parse(y)), y && Xn(y))
                return y;
            }
          } catch (j) {
            en(i, 1, 42, " storage key: " + m + ", " + Fn(j), { exception: dn(j) });
          }
          return [];
        }
        function E(b, m) {
          var F = b;
          try {
            F = u[
              Yi
              /* @min:%2enamePrefix */
            ] && u[
              Yi
              /* @min:%2enamePrefix */
            ]() ? u[
              Yi
              /* @min:%2enamePrefix */
            ]() + "_" + F : F;
            var y = JSON[
              xo
              /* @min:%2estringify */
            ](m);
            d(i, F, y);
          } catch (j) {
            d(i, F, JSON[
              xo
              /* @min:%2estringify */
            ]([])), en(i, 2, 41, " storage key: " + F + ", " + Fn(j) + ". Buffer cleared", { exception: dn(j) });
          }
        }
      }), o;
    }
    return t.BUFFER_KEY = "AI_buffer", t.SENT_BUFFER_KEY = "AI_sentBuffer", t.MAX_BUFFER_SIZE = 2e3, t;
  }(fT)
), am = (
  /** @class */
  function() {
    function e(t) {
      nr(e, this, function(i) {
        i.serialize = function(s) {
          var v = u(s, "root");
          try {
            return Ye()[
              xo
              /* @min:%2estringify */
            ](v);
          } catch (d) {
            en(t, 1, 48, d && Cn(d[
              Mi
              /* @min:%2etoString */
            ]) ? d[
              Mi
              /* @min:%2etoString */
            ]() : "Error serializing object", null, !0);
          }
        };
        function u(s, v) {
          var d = "__aiCircularRefCheck", p = {};
          if (!s)
            return en(t, 1, 48, "cannot serialize object because it is null or undefined", { name: v }, !0), p;
          if (s[d])
            return en(t, 2, 50, "Circular reference detected while serializing object", { name: v }, !0), p;
          if (!s.aiDataContract) {
            if (v === "measurements")
              p = c(s, "number", v);
            else if (v === "properties")
              p = c(s, "string", v);
            else if (v === "tags")
              p = c(s, "string", v);
            else if (Xn(s))
              p = o(s, v);
            else {
              en(t, 2, 49, "Attempting to serialize an object which does not implement ISerializable", { name: v }, !0);
              try {
                Ye()[
                  xo
                  /* @min:%2estringify */
                ](s), p = s;
              } catch (h) {
                en(t, 1, 48, h && Cn(h[
                  Mi
                  /* @min:%2etoString */
                ]) ? h[
                  Mi
                  /* @min:%2etoString */
                ]() : "Error serializing object", null, !0);
              }
            }
            return p;
          }
          return s[d] = !0, ir(s.aiDataContract, function(h, S) {
            var I = Cn(S) ? S() & 1 : S & 1, T = Cn(S) ? S() & 4 : S & 4, R = S & 2, x = s[h] !== void 0, E = Me(s[h]) && s[h] !== null;
            if (I && !x && !R)
              en(t, 1, 24, "Missing required field specification. The field is required but not present on source", { field: h, name: v });
            else if (!T) {
              var b = void 0;
              E ? R ? b = o(s[h], h) : b = u(s[h], h) : b = s[h], b !== void 0 && (p[h] = b);
            }
          }), delete s[d], p;
        }
        function o(s, v) {
          var d;
          if (s)
            if (!Xn(s))
              en(t, 1, 54, `This field was specified as an array in the contract but the item is not an array.\r
`, { name: v }, !0);
            else {
              d = [];
              for (var p = 0; p < s[
                xn
                /* @min:%2elength */
              ]; p++) {
                var h = s[p], S = u(h, v + "[" + p + "]");
                d[
                  nu
                  /* @min:%2epush */
                ](S);
              }
            }
          return d;
        }
        function c(s, v, d) {
          var p;
          return s && (p = {}, ir(s, function(h, S) {
            if (v === "string")
              S === void 0 ? p[h] = "undefined" : S === null ? p[h] = "null" : S[
                Mi
                /* @min:%2etoString */
              ] ? p[h] = S[
                Mi
                /* @min:%2etoString */
              ]() : p[h] = "invalid field: toString() is not defined.";
            else if (v === "number")
              if (S === void 0)
                p[h] = "undefined";
              else if (S === null)
                p[h] = "null";
              else {
                var I = parseFloat(S);
                isNaN(I) ? p[h] = "NaN" : p[h] = I;
              }
            else
              p[h] = "invalid field: " + d + " is of unknown type.", en(t, 1, p[h], null, !0);
          })), p;
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
), um = 8, om = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getHashCodeScore = function(t) {
      var i = this.getHashCode(t) / e.INT_MAX_VALUE;
      return i * 100;
    }, e.prototype.getHashCode = function(t) {
      if (t === "")
        return 0;
      for (; t[
        xn
        /* @min:%2elength */
      ] < um; )
        t = t.concat(t);
      for (var i = 5381, u = 0; u < t[
        xn
        /* @min:%2elength */
      ]; ++u)
        i = (i << 5) + i + t.charCodeAt(u), i = i & i;
      return Math.abs(i);
    }, e.INT_MAX_VALUE = 2147483647, e;
  }()
), fm = (
  /** @class */
  function() {
    function e() {
      var t = this, i = new om(), u = new KE();
      t[
        uT
        /* @min:%2egetSamplingScore */
      ] = function(o) {
        var c = 0;
        return o[
          Pr
          /* @min:%2etags */
        ] && o[
          Pr
          /* @min:%2etags */
        ][u.userId] ? c = i.getHashCodeScore(o[
          Pr
          /* @min:%2etags */
        ][u.userId]) : o.ext && o.ext.user && o.ext.user.id ? c = i[
          Xy
          /* @min:%2egetHashCodeScore */
        ](o.ext.user.id) : o[
          Pr
          /* @min:%2etags */
        ] && o[
          Pr
          /* @min:%2etags */
        ][u.operationId] ? c = i.getHashCodeScore(o[
          Pr
          /* @min:%2etags */
        ][u.operationId]) : o.ext && o.ext.telemetryTrace && o.ext.telemetryTrace[
          mo
          /* @min:%2etraceID */
        ] ? c = i.getHashCodeScore(o.ext.telemetryTrace[
          mo
          /* @min:%2etraceID */
        ]) : c = Math.random() * 100, c;
      };
    }
    return e;
  }()
), cm = (
  /** @class */
  function() {
    function e(t, i) {
      this.INT_MAX_VALUE = 2147483647;
      var u = i || Yo(null);
      (t > 100 || t < 0) && (u.throwInternal(2, 58, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: t }, !0), t = 100), this[
        ts
        /* @min:%2esampleRate */
      ] = t, this.samplingScoreGenerator = new fm();
    }
    return e.prototype.isSampledIn = function(t) {
      var i = this[
        ts
        /* @min:%2esampleRate */
      ], u = !1;
      return i == null || i >= 100 || t.baseType === $i[
        Ke
        /* @min:%2edataType */
      ] ? !0 : (u = this.samplingScoreGenerator[
        uT
        /* @min:%2egetSamplingScore */
      ](t) < i, u);
    }, e;
  }()
), ot, sm = 65e3;
function Zf(e) {
  try {
    return e.responseText;
  } catch {
  }
  return null;
}
function hp() {
  var e, t, i;
  return e = {
    endpointUrl: function() {
      return cd + ho;
    }
  }, e[
    S_
    /* @min:emitLineDelimitedJson */
  ] = function() {
    return !1;
  }, e[
    aT
    /* @min:maxBatchInterval */
  ] = function() {
    return 15e3;
  }, e[
    N_
    /* @min:maxBatchSizeInBytes */
  ] = function() {
    return 102400;
  }, e[
    I_
    /* @min:disableTelemetry */
  ] = function() {
    return !1;
  }, e[
    nT
    /* @min:enableSessionStorageBuffer */
  ] = function() {
    return !0;
  }, e[
    Nd
    /* @min:bufferOverride */
  ] = function() {
    return !1;
  }, e[
    to
    /* @min:isRetryDisabled */
  ] = function() {
    return !1;
  }, e[
    D_
    /* @min:isBeaconApiDisabled */
  ] = function() {
    return !0;
  }, e[
    eo
    /* @min:disableXhr */
  ] = function() {
    return !1;
  }, e[
    tT
    /* @min:onunloadDisableFetch */
  ] = function() {
    return !1;
  }, e[
    jE
    /* @min:onunloadDisableBeacon */
  ] = function() {
    return !1;
  }, e[
    Tc
    /* @min:instrumentationKey */
  ] = function() {
    return t;
  }, e[
    Yi
    /* @min:namePrefix */
  ] = function() {
    return t;
  }, e[
    rT
    /* @min:samplingPercentage */
  ] = function() {
    return 100;
  }, e[
    eT
    /* @min:customHeaders */
  ] = function() {
    return i;
  }, e[
    iT
    /* @min:convertUndefined */
  ] = function() {
    return t;
  }, e.eventsLimitInMem = function() {
    return 1e4;
  }, e;
}
var lm = (ot = {}, ot[Wt.dataType] = oT, ot[Ja.dataType] = rm, ot[ii.dataType] = jy, ot[Qa.dataType] = nm, ot[Ne.dataType] = Jy, ot[$i.dataType] = Qy, ot[Vi.dataType] = Zy, ot), vm = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      var i = e.call(this) || this;
      i.priority = 1001, i.identifier = XE, i._senderConfig = hp();
      var u, o, c, s, v, d, p, h, S = 0, I, T, R, x;
      return nr(t, i, function(E, b) {
        rn(), E.pause = function() {
          Xr(), s = !0;
        }, E.resume = function() {
          s && (s = !1, o = null, E._buffer.size() > E._senderConfig[
            N_
            /* @min:%2emaxBatchSizeInBytes */
          ]() && E[
            ma
            /* @min:%2etriggerSend */
          ](
            !0,
            null,
            10
            /* SendRequestReason.MaxBatchSize */
          ), Lr());
        }, E.flush = function(D, Y, W) {
          if (D === void 0 && (D = !0), !s) {
            Xr();
            try {
              E[
                ma
                /* @min:%2etriggerSend */
              ](
                D,
                null,
                W || 1
                /* SendRequestReason.ManualFlush */
              );
            } catch (J) {
              en(E[
                kr
                /* @min:%2ediagLog */
              ](), 1, 22, "flush failed, telemetry will not be collected: " + Fn(J), { exception: dn(J) });
            }
          }
        }, E.onunloadFlush = function() {
          if (!s)
            if ((E._senderConfig[
              jE
              /* @min:%2eonunloadDisableBeacon */
            ]() === !1 || E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              D_
              /* @min:%2eisBeaconApiDisabled */
            ]() === !1) && bf())
              try {
                E[
                  ma
                  /* @min:%2etriggerSend */
                ](
                  !0,
                  j,
                  2
                  /* SendRequestReason.Unload */
                );
              } catch (D) {
                en(E[
                  kr
                  /* @min:%2ediagLog */
                ](), 1, 20, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + Fn(D), { exception: dn(D) });
              }
            else
              E.flush();
        }, E.addHeader = function(D, Y) {
          h[D] = Y;
        }, E.initialize = function(D, Y, W, J) {
          E.isInitialized() && en(E[
            kr
            /* @min:%2ediagLog */
          ](), 1, 28, "Sender is already initialized"), b.initialize(D, Y, W, J);
          var cn = E._getTelCtx(), pn = E.identifier;
          d = new am(Y.logger), u = 0, o = null, c = 0, E[
            ku
            /* @min:%2e_sender */
          ] = null, p = 0;
          var gn = E[
            kr
            /* @min:%2ediagLog */
          ]();
          x = ta(Ve("Sender"), Y.evtNamespace && Y.evtNamespace()), R = em(x);
          var zn = hp();
          ir(zn, function(O, H) {
            E[
              Qn
              /* @min:%2e_senderConfig */
            ][O] = function() {
              var $ = cn.getConfig(pn, O, H());
              return !$ && O === "endpointUrl" && ($ = H()), $;
            };
          }), D.storagePrefix && _d(D.storagePrefix);
          var cr = E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            nT
            /* @min:%2eenableSessionStorageBuffer */
          ]() && !!(E._senderConfig[
            Nd
            /* @min:%2ebufferOverride */
          ]() || wo());
          E[
            mi
            /* @min:%2e_buffer */
          ] = cr ? new im(gn, E[
            Qn
            /* @min:%2e_senderConfig */
          ]) : new tm(gn, E[
            Qn
            /* @min:%2e_senderConfig */
          ]), E._sample = new cm(E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            rT
            /* @min:%2esamplingPercentage */
          ](), gn), X(D) || en(gn, 1, 100, "Invalid Instrumentation key " + D[
            Tc
            /* @min:%2einstrumentationKey */
          ]), !hc(E._senderConfig.endpointUrl()) && E._senderConfig.customHeaders() && E._senderConfig.customHeaders()[
            xn
            /* @min:%2elength */
          ] > 0 && hn(E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            eT
            /* @min:%2ecustomHeaders */
          ](), function(O) {
            i.addHeader(O.header, O.value);
          });
          var Hn = E[
            Qn
            /* @min:%2e_senderConfig */
          ], $n = null;
          !Hn[
            eo
            /* @min:%2edisableXhr */
          ]() && g0() ? $n = M : !Hn[
            eo
            /* @min:%2edisableXhr */
          ]() && kc() && ($n = On), !$n && h0() && ($n = or), I = $n || On, !Hn[
            D_
            /* @min:%2eisBeaconApiDisabled */
          ]() && bf() && ($n = k), E[
            ku
            /* @min:%2e_sender */
          ] = $n || On, !Hn[
            tT
            /* @min:%2eonunloadDisableFetch */
          ]() && h0(!0) ? T = Zn : bf() ? T = k : !Hn[
            eo
            /* @min:%2edisableXhr */
          ]() && g0() ? T = M : !Hn[
            eo
            /* @min:%2edisableXhr */
          ]() && kc() ? T = On : T = I;
        }, E.processTelemetry = function(D, Y) {
          Y = E._getTelCtx(Y);
          var W = Y[
            kr
            /* @min:%2ediagLog */
          ]();
          try {
            if (E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              I_
              /* @min:%2edisableTelemetry */
            ]())
              return;
            if (!D) {
              en(W, 1, 7, "Cannot send empty telemetry");
              return;
            }
            if (D.baseData && !D[
              vv
              /* @min:%2ebaseType */
            ]) {
              en(W, 1, 70, "Cannot send telemetry without baseData and baseType");
              return;
            }
            if (D[
              vv
              /* @min:%2ebaseType */
            ] || (D[
              vv
              /* @min:%2ebaseType */
            ] = "EventData"), !E[
              ku
              /* @min:%2e_sender */
            ]) {
              en(W, 1, 28, "Sender was not initialized");
              return;
            }
            if (m(D))
              D[bE] = E._sample[
                ts
                /* @min:%2esampleRate */
              ];
            else {
              en(W, 2, 33, "Telemetry item was sampled out and not sent", { SampleRate: E._sample[
                ts
                /* @min:%2esampleRate */
              ] });
              return;
            }
            var J = E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              iT
              /* @min:%2econvertUndefined */
            ]() || void 0, cn = D.iKey || E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              Tc
              /* @min:%2einstrumentationKey */
            ](), pn = t.constructEnvelope(D, cn, W, J);
            if (!pn) {
              en(W, 1, 47, "Unable to create an AppInsights envelope");
              return;
            }
            var gn = !1;
            if (D[
              Pr
              /* @min:%2etags */
            ] && D[
              Pr
              /* @min:%2etags */
            ][Jl] && (hn(D[
              Pr
              /* @min:%2etags */
            ][Jl], function($n) {
              try {
                $n && $n(pn) === !1 && (gn = !0, ki(W, "Telemetry processor check returns false"));
              } catch (O) {
                en(W, 1, 64, "One of telemetry initializers failed, telemetry item will not be sent: " + Fn(O), { exception: dn(O) }, !0);
              }
            }), delete D[
              Pr
              /* @min:%2etags */
            ][Jl]), gn)
              return;
            var zn = d.serialize(pn), cr = E[
              mi
              /* @min:%2e_buffer */
            ], Hn = cr.size();
            Hn + zn[
              xn
              /* @min:%2elength */
            ] > E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              N_
              /* @min:%2emaxBatchSizeInBytes */
            ]() && (!R || R[
              T_
              /* @min:%2eisOnline */
            ]()) && E[
              ma
              /* @min:%2etriggerSend */
            ](
              !0,
              null,
              10
              /* SendRequestReason.MaxBatchSize */
            ), cr[
              Po
              /* @min:%2eenqueue */
            ](zn), Lr();
          } catch ($n) {
            en(W, 2, 12, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + Fn($n), { exception: dn($n) });
          }
          E.processNext(D, Y);
        }, E[
          qy
          /* @min:%2e_xhrReadyStateChange */
        ] = function(D, Y, W) {
          D.readyState === 4 && F(D.status, Y, D.responseURL, W, rr(D), Zf(D) || D.response);
        }, E[
          ma
          /* @min:%2etriggerSend */
        ] = function(D, Y, W) {
          if (D === void 0 && (D = !0), !s)
            try {
              var J = E[
                mi
                /* @min:%2e_buffer */
              ];
              if (E[
                Qn
                /* @min:%2e_senderConfig */
              ][
                I_
                /* @min:%2edisableTelemetry */
              ]())
                J[
                  cu
                  /* @min:%2eclear */
                ]();
              else {
                if (J[
                  ja
                  /* @min:%2ecount */
                ]() > 0) {
                  var cn = J.getItems();
                  P(W || 0, D), Y ? Y.call(E, cn, D) : E[
                    ku
                    /* @min:%2e_sender */
                  ](cn, D);
                }
                c = +/* @__PURE__ */ new Date();
              }
              Xr();
            } catch (gn) {
              var pn = _E();
              (!pn || pn > 9) && en(E[
                kr
                /* @min:%2ediagLog */
              ](), 1, 40, "Telemetry transmission failed, some telemetry will be lost: " + Fn(gn), { exception: dn(gn) });
            }
        }, E._doTeardown = function(D, Y) {
          E.onunloadFlush(), R.unload(), rn();
        }, E[
          xe
          /* @min:%2e_onError */
        ] = function(D, Y, W) {
          en(E[
            kr
            /* @min:%2ediagLog */
          ](), 2, 26, "Failed to send telemetry.", { message: Y }), E._buffer && E._buffer[
            go
            /* @min:%2eclearSent */
          ](D);
        }, E[
          _v
          /* @min:%2e_onPartialSuccess */
        ] = function(D, Y) {
          for (var W = [], J = [], cn = Y.errors.reverse(), pn = 0, gn = cn; pn < gn.length; pn++) {
            var zn = gn[pn], cr = D.splice(zn.index, 1)[0];
            Mn(zn.statusCode) ? J[
              nu
              /* @min:%2epush */
            ](cr) : W[
              nu
              /* @min:%2epush */
            ](cr);
          }
          D[
            xn
            /* @min:%2elength */
          ] > 0 && E[
            $f
            /* @min:%2e_onSuccess */
          ](D, Y[
            Vf
            /* @min:%2eitemsAccepted */
          ]), W[
            xn
            /* @min:%2elength */
          ] > 0 && E[
            xe
            /* @min:%2e_onError */
          ](W, rr(null, ["partial success", Y[
            Vf
            /* @min:%2eitemsAccepted */
          ], "of", Y.itemsReceived].join(" "))), J[
            xn
            /* @min:%2elength */
          ] > 0 && (Ir(J), en(E[
            kr
            /* @min:%2ediagLog */
          ](), 2, 40, "Partial success. Delivered: " + D[
            xn
            /* @min:%2elength */
          ] + ", Failed: " + W[
            xn
            /* @min:%2elength */
          ] + ". Will retry to send " + J[
            xn
            /* @min:%2elength */
          ] + " our of " + Y[
            Ky
            /* @min:%2eitemsReceived */
          ] + " items"));
        }, E[
          $f
          /* @min:%2e_onSuccess */
        ] = function(D, Y) {
          E._buffer && E._buffer[
            go
            /* @min:%2eclearSent */
          ](D);
        }, E._xdrOnLoad = function(D, Y) {
          var W = Zf(D);
          if (D && (W + "" == "200" || W === ""))
            u = 0, E[
              $f
              /* @min:%2e_onSuccess */
            ](Y, 0);
          else {
            var J = Dr(W);
            J && J.itemsReceived && J.itemsReceived > J[
              Vf
              /* @min:%2eitemsAccepted */
            ] && !E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              to
              /* @min:%2eisRetryDisabled */
            ]() ? E[
              _v
              /* @min:%2e_onPartialSuccess */
            ](Y, J) : E[
              xe
              /* @min:%2e_onError */
            ](Y, q(D));
          }
        };
        function m(D) {
          return E._sample.isSampledIn(D);
        }
        function F(D, Y, W, J, cn, pn) {
          var gn = null;
          if (E._appId || (gn = Dr(pn), gn && gn.appId && (E._appId = gn.appId)), (D < 200 || D >= 300) && D !== 0) {
            if ((D === 301 || D === 307 || D === 308) && !y(W)) {
              E[
                xe
                /* @min:%2e_onError */
              ](Y, cn);
              return;
            }
            !E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              to
              /* @min:%2eisRetryDisabled */
            ]() && Mn(D) ? (Ir(Y), en(E[
              kr
              /* @min:%2ediagLog */
            ](), 2, 40, ". Response code " + D + ". Will retry to send " + Y[
              xn
              /* @min:%2elength */
            ] + " items.")) : E[
              xe
              /* @min:%2e_onError */
            ](Y, cn);
          } else if (R && !R[
            T_
            /* @min:%2eisOnline */
          ]()) {
            if (!E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              to
              /* @min:%2eisRetryDisabled */
            ]()) {
              var zn = 10;
              Ir(Y, zn), en(E[
                kr
                /* @min:%2ediagLog */
              ](), 2, 40, ". Offline - Response Code: ".concat(D, ". Offline status: ").concat(!R.isOnline(), ". Will retry to send ").concat(Y.length, " items."));
            }
          } else
            y(W), D === 206 ? (gn || (gn = Dr(pn)), gn && !E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              to
              /* @min:%2eisRetryDisabled */
            ]() ? E[
              _v
              /* @min:%2e_onPartialSuccess */
            ](Y, gn) : E[
              xe
              /* @min:%2e_onError */
            ](Y, cn)) : (u = 0, E[
              $f
              /* @min:%2e_onSuccess */
            ](Y, J));
        }
        function y(D) {
          return p >= 10 ? !1 : !Q(D) && D !== "" && D !== E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            xi
            /* @min:%2eendpointUrl */
          ]() ? (E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            xi
            /* @min:%2eendpointUrl */
          ] = function() {
            return D;
          }, ++p, !0) : !1;
        }
        function j(D, Y) {
          T ? T(D, !1) : k(D);
        }
        function un(D) {
          var Y = At(), W = E[
            mi
            /* @min:%2e_buffer */
          ], J = E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            xi
            /* @min:%2eendpointUrl */
          ](), cn = E._buffer[
            ro
            /* @min:%2ebatchPayloads */
          ](D), pn = new Blob([cn], { type: "text/plain;charset=UTF-8" }), gn = Y.sendBeacon(J, pn);
          return gn && (W[
            Wa
            /* @min:%2emarkAsSent */
          ](D), E._onSuccess(D, D[
            xn
            /* @min:%2elength */
          ])), gn;
        }
        function k(D, Y) {
          if (Xn(D) && D[
            xn
            /* @min:%2elength */
          ] > 0 && !un(D)) {
            for (var W = [], J = 0; J < D[
              xn
              /* @min:%2elength */
            ]; J++) {
              var cn = D[J];
              un([cn]) || W[
                nu
                /* @min:%2epush */
              ](cn);
            }
            W[
              xn
              /* @min:%2elength */
            ] > 0 && (I && I(W, !0), en(E[
              kr
              /* @min:%2ediagLog */
            ](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender."));
          }
        }
        function On(D, Y) {
          var W = new XMLHttpRequest(), J = E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            xi
            /* @min:%2eendpointUrl */
          ]();
          try {
            W[Gi] = !0;
          } catch {
          }
          W.open("POST", J, Y), W[
            dv
            /* @min:%2esetRequestHeader */
          ]("Content-type", "application/json"), hc(J) && W[
            dv
            /* @min:%2esetRequestHeader */
          ](kn[
            6
            /* eRequestHeaders.sdkContextHeader */
          ], kn[
            7
            /* eRequestHeaders.sdkContextHeaderAppIdRequest */
          ]), hn(ea(h), function(pn) {
            W[
              dv
              /* @min:%2esetRequestHeader */
            ](pn, h[pn]);
          }), W.onreadystatechange = function() {
            return E._xhrReadyStateChange(W, D, D[
              xn
              /* @min:%2elength */
            ]);
          }, W.onerror = function(pn) {
            return E[
              xe
              /* @min:%2e_onError */
            ](D, rr(W), pn);
          };
          var cn = E._buffer[
            ro
            /* @min:%2ebatchPayloads */
          ](D);
          W.send(cn), E._buffer[
            Wa
            /* @min:%2emarkAsSent */
          ](D);
        }
        function Zn(D, Y) {
          if (Xn(D)) {
            for (var W = D[
              xn
              /* @min:%2elength */
            ], J = 0; J < D[
              xn
              /* @min:%2elength */
            ]; J++)
              W += D[J][
                xn
                /* @min:%2elength */
              ];
            S + W <= sm ? on(D, !1) : bf() ? k(D) : (I && I(D, !0), en(E[
              kr
              /* @min:%2ediagLog */
            ](), 2, 40, ". Failed to send telemetry with Beacon API, retried with xhrSender."));
          }
        }
        function or(D, Y) {
          on(D, !0);
        }
        function on(D, Y) {
          var W, J = E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            xi
            /* @min:%2eendpointUrl */
          ](), cn = E._buffer[
            ro
            /* @min:%2ebatchPayloads */
          ](D), pn = new Blob([cn], { type: "application/json" }), gn = new Headers(), zn = cn[
            xn
            /* @min:%2elength */
          ], cr = !1, Hn = !1;
          hc(J) && gn.append(kn[
            6
            /* eRequestHeaders.sdkContextHeader */
          ], kn[
            7
            /* eRequestHeaders.sdkContextHeaderAppIdRequest */
          ]), hn(ea(h), function(H) {
            gn.append(H, h[H]);
          });
          var $n = (W = {
            method: "POST",
            headers: gn,
            body: pn
          }, W[Gi] = !0, W);
          Y || ($n.keepalive = !0, cr = !0, S += zn);
          var O = new Request(J, $n);
          try {
            O[Gi] = !0;
          } catch {
          }
          E._buffer[
            Wa
            /* @min:%2emarkAsSent */
          ](D);
          try {
            fetch(O).then(function(H) {
              Y || (S -= zn, zn = 0), Hn || (Hn = !0, H.ok ? H.text().then(function($) {
                F(H.status, D, H.url, D[
                  xn
                  /* @min:%2elength */
                ], H.statusText, $);
              }) : E[
                xe
                /* @min:%2e_onError */
              ](D, H.statusText));
            }).catch(function(H) {
              Y || (S -= zn, zn = 0), Hn || (Hn = !0, E[
                xe
                /* @min:%2e_onError */
              ](D, H.message));
            });
          } catch (H) {
            Hn || E[
              xe
              /* @min:%2e_onError */
            ](D, dn(H));
          }
          cr && !Hn && (Hn = !0, E._onSuccess(D, D[
            xn
            /* @min:%2elength */
          ]));
        }
        function Dr(D) {
          try {
            if (D && D !== "") {
              var Y = Ye().parse(D);
              if (Y && Y.itemsReceived && Y.itemsReceived >= Y[
                Vf
                /* @min:%2eitemsAccepted */
              ] && Y.itemsReceived - Y.itemsAccepted === Y.errors[
                xn
                /* @min:%2elength */
              ])
                return Y;
            }
          } catch (W) {
            en(E[
              kr
              /* @min:%2ediagLog */
            ](), 1, 43, "Cannot parse the response. " + Fn(W), {
              response: D
            });
          }
          return null;
        }
        function Ir(D, Y) {
          if (Y === void 0 && (Y = 1), !(!D || D[
            xn
            /* @min:%2elength */
          ] === 0)) {
            var W = E[
              mi
              /* @min:%2e_buffer */
            ];
            W[
              go
              /* @min:%2eclearSent */
            ](D), u++;
            for (var J = 0, cn = D; J < cn.length; J++) {
              var pn = cn[J];
              W[
                Po
                /* @min:%2eenqueue */
              ](pn);
            }
            Or(Y), Lr();
          }
        }
        function Or(D) {
          var Y = 10, W;
          if (u <= 1)
            W = Y;
          else {
            var J = (Math.pow(2, u) - 1) / 2, cn = Math.floor(Math.random() * J * Y) + 1;
            cn = D * cn, W = Math.max(Math.min(cn, 3600), Y);
          }
          var pn = $e() + W * 1e3;
          o = pn;
        }
        function Lr() {
          if (!v && !s) {
            var D = o ? Math.max(0, o - $e()) : 0, Y = Math.max(E[
              Qn
              /* @min:%2e_senderConfig */
            ][
              aT
              /* @min:%2emaxBatchInterval */
            ](), D);
            v = setTimeout(function() {
              v = null, E[
                ma
                /* @min:%2etriggerSend */
              ](
                !0,
                null,
                1
                /* SendRequestReason.NormalSchedule */
              );
            }, Y);
          }
        }
        function Xr() {
          clearTimeout(v), v = null, o = null;
        }
        function Mn(D) {
          return D === 401 || D === 403 || D === 408 || D === 429 || D === 500 || D === 502 || D === 503 || D === 504;
        }
        function rr(D, Y) {
          return D ? "XMLHttpRequest,Status:" + D.status + ",Response:" + Zf(D) || D.response || "" : Y;
        }
        function M(D, Y) {
          var W = E[
            mi
            /* @min:%2e_buffer */
          ], J = ni(), cn = new XDomainRequest();
          cn.onload = function() {
            return E._xdrOnLoad(cn, D);
          }, cn.onerror = function(cr) {
            return E[
              xe
              /* @min:%2e_onError */
            ](D, q(cn), cr);
          };
          var pn = J && J.location && J.location.protocol || "";
          if (E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            xi
            /* @min:%2eendpointUrl */
          ]().lastIndexOf(pn, 0) !== 0) {
            en(E[
              kr
              /* @min:%2ediagLog */
            ](), 2, 40, ". Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol."), W[
              cu
              /* @min:%2eclear */
            ]();
            return;
          }
          var gn = E[
            Qn
            /* @min:%2e_senderConfig */
          ][
            xi
            /* @min:%2eendpointUrl */
          ]().replace(/^(https?:)/, "");
          cn.open("POST", gn);
          var zn = W[
            ro
            /* @min:%2ebatchPayloads */
          ](D);
          cn.send(zn), W[
            Wa
            /* @min:%2emarkAsSent */
          ](D);
        }
        function q(D, Y) {
          return D ? "XDomainRequest,Response:" + Zf(D) || "" : Y;
        }
        function Z() {
          var D = "getNotifyMgr";
          return E.core[D] ? E.core[D]() : E.core._notificationManager;
        }
        function P(D, Y) {
          var W = Z();
          if (W && W[
            lp
            /* @min:%2eeventsSendRequest */
          ])
            try {
              W[
                lp
                /* @min:%2eeventsSendRequest */
              ](D, Y);
            } catch (J) {
              en(E[
                kr
                /* @min:%2ediagLog */
              ](), 1, 74, "send request notification failed: " + Fn(J), { exception: dn(J) });
            }
        }
        function X(D) {
          var Y = Q(D[
            vp
            /* @min:%2edisableInstrumentationKeyValidation */
          ]) ? !1 : D[
            vp
            /* @min:%2edisableInstrumentationKeyValidation */
          ];
          if (Y)
            return !0;
          var W = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$", J = new RegExp(W);
          return J.test(D[
            Tc
            /* @min:%2einstrumentationKey */
          ]);
        }
        function rn() {
          E[
            ku
            /* @min:%2e_sender */
          ] = null, E[
            mi
            /* @min:%2e_buffer */
          ] = null, E._appId = null, E._sample = null, h = {}, R = null, u = 0, o = null, c = null, s = !1, v = null, d = null, p = 0, S = 0, I = null, T = null, x = null;
        }
      }), i;
    }
    return t.constructEnvelope = function(i, u, o, c) {
      var s;
      u !== i.iKey && !Q(u) ? s = Wr(Wr({}, i), { iKey: u }) : s = i;
      var v = lm[s.baseType] || oT;
      return v(o, s, c);
    }, t;
  }(Fo)
), gp = "duration", su = "properties", De = "requestUrl", io = "inst", lt = "length", dt = "traceID", Zt = "spanID", Ie = "traceFlags", po = "context", ru = "aborted", Sc = "traceId", Nc = "spanId", We = "core", gv = "includeCorrelationHeaders", pp = "canIncludeCorrelationHeader", A_ = "getAbsoluteUrl", Pi = "headers", Se = "requestHeaders", Jf = "appId", pv = "setRequestHeader", Ep = "trackDependencyDataInternal", Ev = "distributedTracingMode", zi = "startTime", xa = "toLowerCase", _m = "enableRequestHeaderTracking", dm = "enableAjaxErrorStatusText", hm = "enableAjaxPerfTracking", gm = "maxAjaxCallsPerView", pm = "enableResponseHeaderTracking", Em = "excludeRequestFromAutoTrackingPatterns", Tm = "addRequestContext", Sm = "disableAjaxTracking", Nm = "disableFetchTracking", Le = "status", Hi = "statusText", is = "headerMap", R_ = "openDone", C_ = "sendDone", qi = "requestSentTime", w_ = "abortDone", y_ = "getTraceId", m_ = "getTraceFlags", zt = "method", x_ = "errorStatusText", cT = "stateChangeAttached", Dm = "responseText", ao = "responseFinishedTime", P_ = "CreateTrackItem", sT = "response", Tp = "getAllResponseHeaders", O_ = "getPartAProps", Sp = "getCorrelationContext", as = "perfMark", Im = "ajaxPerfLookupDelay", Ya = "name", L_ = "perfTiming", Am = "correlationContext", Tv = "ajaxTotalDuration", Sv = "eventTraceCtx";
function lT(e, t, i) {
  var u = 0, o = e[t], c = e[i];
  return o && c && (u = ne(o, c)), u;
}
function Oi(e, t, i, u, o) {
  var c = 0, s = lT(i, u, o);
  return s && (c = Ht(e, t, Gt(s))), c;
}
function Ht(e, t, i) {
  var u = "ajaxPerf", o = 0;
  if (e && t && i) {
    var c = e[u] = e[u] || {};
    c[t] = i, o = 1;
  }
  return o;
}
function Rm(e, t) {
  var i = e[
    L_
    /* @min:%2eperfTiming */
  ], u = t[
    su
    /* @min:%2eproperties */
  ] || {}, o = 0, c = "name", s = "Start", v = "End", d = "domainLookup", p = "connect", h = "redirect", S = "request", I = "response", T = "startTime", R = d + s, x = d + v, E = p + s, b = p + v, m = S + s, F = S + v, y = I + s, j = I + v, un = h + s, k = h = v, On = "transferSize", Zn = "encodedBodySize", or = "decodedBodySize", on = "serverTiming";
  if (i) {
    o |= Oi(u, h, i, un, k), o |= Oi(u, d, i, R, x), o |= Oi(u, p, i, E, b), o |= Oi(u, S, i, m, F), o |= Oi(u, I, i, y, j), o |= Oi(u, "networkConnect", i, T, b), o |= Oi(u, "sentRequest", i, m, j);
    var Dr = i[
      gp
      /* @min:%2eduration */
    ];
    Dr || (Dr = lT(i, T, j) || 0), o |= Ht(u, gp, Dr), o |= Ht(u, "perfTotal", Dr);
    var Ir = i[on];
    if (Ir) {
      var Or = {};
      hn(Ir, function(Lr, Xr) {
        var Mn = Bc(Lr[c] || "" + Xr), rr = Or[Mn] || {};
        ir(Lr, function(M, q) {
          (M !== c && En(q) || tE(q)) && (rr[M] && (q = rr[M] + ";" + q), (q || !En(q)) && (rr[M] = q));
        }), Or[Mn] = rr;
      }), o |= Ht(u, on, Or);
    }
    o |= Ht(u, On, i[On]), o |= Ht(u, Zn, i[Zn]), o |= Ht(u, or, i[or]);
  } else
    e[
      as
      /* @min:%2eperfMark */
    ] && (o |= Ht(u, "missing", e.perfAttempts));
  o && (t[
    su
    /* @min:%2eproperties */
  ] = u);
}
var Cm = (
  /** @class */
  function() {
    function e() {
      var t = this;
      t[
        R_
        /* @min:%2eopenDone */
      ] = !1, t.setRequestHeaderDone = !1, t[
        C_
        /* @min:%2esendDone */
      ] = !1, t[
        w_
        /* @min:%2eabortDone */
      ] = !1, t[
        cT
        /* @min:%2estateChangeAttached */
      ] = !1;
    }
    return e;
  }()
), Np = (
  /** @class */
  function() {
    function e(t, i, u, o) {
      var c, s = this, v = u, d = "responseText";
      s[
        as
        /* @min:%2eperfMark */
      ] = null, s.completed = !1, s.requestHeadersSize = null, s[
        Se
        /* @min:%2erequestHeaders */
      ] = null, s.responseReceivingDuration = null, s.callbackDuration = null, s[
        Tv
        /* @min:%2eajaxTotalDuration */
      ] = null, s[
        ru
        /* @min:%2eaborted */
      ] = 0, s.pageUrl = null, s[
        De
        /* @min:%2erequestUrl */
      ] = null, s.requestSize = 0, s[
        zt
        /* @min:%2emethod */
      ] = null, s[
        Le
        /* @min:%2estatus */
      ] = null, s[
        qi
        /* @min:%2erequestSentTime */
      ] = null, s.responseStartedTime = null, s[
        ao
        /* @min:%2eresponseFinishedTime */
      ] = null, s.callbackFinishedTime = null, s.endTime = null, s.xhrMonitoringState = new Cm(), s.clientFailure = 0, s[
        dt
        /* @min:%2etraceID */
      ] = t, s[
        Zt
        /* @min:%2espanID */
      ] = i, s[
        Ie
        /* @min:%2etraceFlags */
      ] = o == null ? void 0 : o.getTraceFlags(), o ? s[
        Sv
        /* @min:%2eeventTraceCtx */
      ] = (c = {}, c[
        Sc
        /* @min:traceId */
      ] = o[
        y_
        /* @min:%2egetTraceId */
      ](), c[
        Nc
        /* @min:spanId */
      ] = o.getSpanId(), c[
        Ie
        /* @min:traceFlags */
      ] = o[
        m_
        /* @min:%2egetTraceFlags */
      ](), c) : s[
        Sv
        /* @min:%2eeventTraceCtx */
      ] = null, nr(e, s, function(p) {
        p.getAbsoluteUrl = function() {
          return p[
            De
            /* @min:%2erequestUrl */
          ] ? vy(p[
            De
            /* @min:%2erequestUrl */
          ]) : null;
        }, p.getPathName = function() {
          return p[
            De
            /* @min:%2erequestUrl */
          ] ? Bo(v, _y(p[
            zt
            /* @min:%2emethod */
          ], p[
            De
            /* @min:%2erequestUrl */
          ])) : null;
        }, p[
          P_
          /* @min:%2eCreateTrackItem */
        ] = function(h, S, I) {
          var T;
          if (p.ajaxTotalDuration = Math.round(ne(p.requestSentTime, p.responseFinishedTime) * 1e3) / 1e3, p[
            Tv
            /* @min:%2eajaxTotalDuration */
          ] < 0)
            return null;
          var R = (T = {
            id: "|" + p[
              dt
              /* @min:%2etraceID */
            ] + "." + p[
              Zt
              /* @min:%2espanID */
            ],
            target: p[
              A_
              /* @min:%2egetAbsoluteUrl */
            ]()
          }, T[
            Ya
            /* @min:name */
          ] = p.getPathName(), T.type = h, T[
            zi
            /* @min:startTime */
          ] = null, T.duration = p[
            Tv
            /* @min:%2eajaxTotalDuration */
          ], T.success = +p[
            Le
            /* @min:%2estatus */
          ] >= 200 && +p[
            Le
            /* @min:%2estatus */
          ] < 400, T.responseCode = +p[
            Le
            /* @min:%2estatus */
          ], T[su] = { HttpMethod: p[
            zt
            /* @min:%2emethod */
          ] }, T), x = R[su];
          if (p[
            ru
            /* @min:%2eaborted */
          ] && (x[
            ru
            /* @min:%2eaborted */
          ] = !0), p[
            qi
            /* @min:%2erequestSentTime */
          ] && (R[
            zi
            /* @min:%2estartTime */
          ] = /* @__PURE__ */ new Date(), R[
            zi
            /* @min:%2estartTime */
          ].setTime(p[
            qi
            /* @min:%2erequestSentTime */
          ])), Rm(p, R), S && ea(p.requestHeaders)[
            lt
            /* @min:%2elength */
          ] > 0 && (x[
            Se
            /* @min:%2erequestHeaders */
          ] = p[
            Se
            /* @min:%2erequestHeaders */
          ]), I) {
            var E = I();
            if (E) {
              var b = E[
                Am
                /* @min:%2ecorrelationContext */
              ];
              if (b && (R.correlationContext = /* dependency.target + " | " + */
              b), E[
                is
                /* @min:%2eheaderMap */
              ] && ea(E.headerMap)[
                lt
                /* @min:%2elength */
              ] > 0 && (x.responseHeaders = E[
                is
                /* @min:%2eheaderMap */
              ]), p[
                x_
                /* @min:%2eerrorStatusText */
              ])
                if (p[
                  Le
                  /* @min:%2estatus */
                ] >= 400) {
                  var m = E.type;
                  (m === "" || m === "text") && (x.responseText = E.responseText ? E[
                    Hi
                    /* @min:%2estatusText */
                  ] + " - " + E[d] : E[
                    Hi
                    /* @min:%2estatusText */
                  ]), m === "json" && (x.responseText = E.response ? E[
                    Hi
                    /* @min:%2estatusText */
                  ] + " - " + JSON.stringify(E[
                    sT
                    /* @min:%2eresponse */
                  ]) : E[
                    Hi
                    /* @min:%2estatusText */
                  ]);
                } else
                  p[
                    Le
                    /* @min:%2estatus */
                  ] === 0 && (x.responseText = E[
                    Hi
                    /* @min:%2estatusText */
                  ] || "");
            }
          }
          return R;
        }, p[
          O_
          /* @min:%2egetPartAProps */
        ] = function() {
          var h, S = null, I = p[
            Sv
            /* @min:%2eeventTraceCtx */
          ];
          if (I && (I[
            Sc
            /* @min:%2etraceId */
          ] || I[
            Nc
            /* @min:%2espanId */
          ])) {
            S = {};
            var T = S[ce.TraceExt] = (h = {}, h[
              dt
              /* @min:traceID */
            ] = I[
              Sc
              /* @min:%2etraceId */
            ], h.parentID = I[
              Nc
              /* @min:%2espanId */
            ], h);
            Q(I[
              Ie
              /* @min:%2etraceFlags */
            ]) || (T[
              Ie
              /* @min:%2etraceFlags */
            ] = I[
              Ie
              /* @min:%2etraceFlags */
            ]);
          }
          return S;
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), Dp = "ai.ajxmn.", Eo = "diagLog", ai = "_ajaxData", Bi = "fetch", Gu = "Failed to monitor XMLHttpRequest", vT = ", monitoring data for this ajax call ", Pa = vT + "may be incorrect.", Ip = vT + "won't be sent.", Ap = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.", Rp = "Failed to add custom defined request context as configured call back may missing a null check.", Cp = "Failed to calculate the duration of the ", wp = 0;
function wm() {
  var e = _u();
  return !e || Q(e.Request) || Q(e.Request[qr]) || Q(e[Bi]) ? null : e[Bi];
}
var Qf = null;
function ym() {
  if (Qf == null)
    try {
      Qf = !!(self && self instanceof WorkerGlobalScope);
    } catch {
      Qf = !1;
    }
  return Qf;
}
function mm(e, t) {
  var i, u = !1;
  if (kc()) {
    var o = XMLHttpRequest[qr];
    u = !Q(o) && !Q(o.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
    !Q(o.send) && !Q(o.abort);
  }
  var c = _E();
  if (c && c < 9 && (u = !1), u)
    try {
      var s = new XMLHttpRequest(), v = {
        xh: [],
        i: (i = {}, i[t] = {}, i)
      };
      s[ai] = v;
      var d = XMLHttpRequest[qr].open;
      XMLHttpRequest[qr].open = d;
    } catch (p) {
      u = !1, To(e, 15, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
        exception: dn(p)
      });
    }
  return u;
}
var Ua = function(e, t) {
  return e && t && e[ai] ? (e[ai].i || {})[t] : null;
}, xm = function(e, t, i) {
  if (e) {
    var u = (e[ai] || {}).xh;
    u && u.push({
      n: t,
      v: i
    });
  }
}, Nv = function(e, t) {
  var i = !1;
  if (e) {
    var u = (e[ai] || {}).xh;
    u && hn(u, function(o) {
      if (o.n === t)
        return i = !0, -1;
    });
  }
  return i;
};
function Dc(e, t) {
  var i = "";
  try {
    var u = Ua(e, t);
    u && u[
      De
      /* @min:%2erequestUrl */
    ] && (i += "(url: '" + u[
      De
      /* @min:%2erequestUrl */
    ] + "')");
  } catch {
  }
  return i;
}
function To(e, t, i, u, o) {
  en(e[Eo](), 1, t, i, u, o);
}
function ft(e, t, i, u, o) {
  en(e[Eo](), 2, t, i, u, o);
}
function Wu(e, t, i) {
  return function(u) {
    To(e, t, i, {
      ajaxDiagnosticsMessage: Dc(u[
        io
        /* @min:%2einst */
      ], e._ajaxDataId),
      exception: dn(u.err)
    });
  };
}
function Oa(e, t) {
  return e && t ? e.indexOf(t) : -1;
}
function yp(e, t, i) {
  var u = {
    id: t,
    fn: i
  };
  return e.push(u), {
    remove: function() {
      hn(e, function(o, c) {
        if (o.id === u.id)
          return e.splice(c, 1), -1;
      });
    }
  };
}
function _T(e, t, i, u) {
  var o = !0;
  return hn(t, function(c, s) {
    try {
      c.fn.call(null, i) === !1 && (o = !1);
    } catch (v) {
      en(e && e.logger, 1, 64, "Dependency " + u + " [#" + s + "] failed: " + Fn(v), { exception: dn(v) }, !0);
    }
  }), o;
}
function Pm(e, t, i, u, o, c) {
  var s = e[
    lt
    /* @min:%2elength */
  ];
  if (s > 0) {
    var v = {
      core: t,
      xhr: u,
      input: o,
      init: c,
      traceId: i[
        dt
        /* @min:%2etraceID */
      ],
      spanId: i[
        Zt
        /* @min:%2espanID */
      ],
      traceFlags: i[
        Ie
        /* @min:%2etraceFlags */
      ],
      context: i[
        po
        /* @min:%2econtext */
      ] || {},
      aborted: !!i[
        ru
        /* @min:%2eaborted */
      ]
    };
    _T(t, e, v, "listener"), i[
      dt
      /* @min:%2etraceID */
    ] = v[
      Sc
      /* @min:%2etraceId */
    ], i[
      Zt
      /* @min:%2espanID */
    ] = v[
      Nc
      /* @min:%2espanId */
    ], i[
      Ie
      /* @min:%2etraceFlags */
    ] = v[
      Ie
      /* @min:%2etraceFlags */
    ], i[
      po
      /* @min:%2econtext */
    ] = v[
      po
      /* @min:%2econtext */
    ];
  }
}
var jf = "*.blob.core.", Om = $_([
  jf + "windows.net",
  jf + "chinacloudapi.cn",
  jf + "cloudapi.de",
  jf + "usgovcloudapi.net"
]), Lm = [
  /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
function b_() {
  var e = {
    maxAjaxCallsPerView: 500,
    disableAjaxTracking: !1,
    disableFetchTracking: !1,
    excludeRequestFromAutoTrackingPatterns: void 0,
    disableCorrelationHeaders: !1,
    distributedTracingMode: 1,
    correlationHeaderExcludedDomains: Om,
    correlationHeaderDomains: void 0,
    correlationHeaderExcludePatterns: void 0,
    appId: void 0,
    enableCorsCorrelation: !1,
    enableRequestHeaderTracking: !1,
    enableResponseHeaderTracking: !1,
    enableAjaxErrorStatusText: !1,
    enableAjaxPerfTracking: !1,
    maxAjaxPerfLookupAttempts: 3,
    ajaxPerfLookupDelay: 25,
    ignoreHeaders: [
      "Authorization",
      "X-API-Key",
      "WWW-Authenticate"
    ],
    addRequestContext: void 0,
    addIntEndpoints: !0
  };
  return e;
}
function mp() {
  var e = b_();
  return ir(e, function(t) {
    e[t] = void 0;
  }), e;
}
var bm = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      var i = e.call(this) || this;
      i.identifier = t.identifier, i.priority = 120;
      var u, o, c, s, v, d, p, h, S, I, T, R, x, E, b, m, F, y, j, un, k, On, Zn, or;
      return nr(t, i, function(on, Dr) {
        var Ir = Dr._addHook;
        Or(), on.initialize = function(O, H, $, K) {
          on.isInitialized() || (Dr.initialize(O, H, $, K), un = ta(Ve("ajax"), H && H.evtNamespace && H.evtNamespace()), Lr(O), q(), rr(), Xr());
        }, on._doTeardown = function() {
          Or();
        }, on.trackDependencyData = function(O, H) {
          $n(or, on[
            We
            /* @min:%2ecore */
          ], null, O, H);
        }, on[
          gv
          /* @min:%2eincludeCorrelationHeaders */
        ] = function(O, H, $, K) {
          var V = on._currentWindowHost || c;
          if (Pm(Zn, on[
            We
            /* @min:%2ecore */
          ], O, K, H, $), H || H === "") {
            if (Ga[
              pp
              /* @min:%2ecanIncludeCorrelationHeader */
            ](s, O[
              A_
              /* @min:%2egetAbsoluteUrl */
            ](), V)) {
              $ || ($ = {});
              var an = new Headers($[
                Pi
                /* @min:%2eheaders */
              ] || (H instanceof Request ? H[
                Pi
                /* @min:%2eheaders */
              ] || {} : {}));
              if (I) {
                var sn = "|" + O[
                  dt
                  /* @min:%2etraceID */
                ] + "." + O[
                  Zt
                  /* @min:%2espanID */
                ];
                an.set(kn[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ], sn), v && (O[
                  Se
                  /* @min:%2erequestHeaders */
                ][kn[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ]] = sn);
              }
              var wn = s[
                Jf
                /* @min:%2eappId */
              ] || h && h[
                Jf
                /* @min:%2eappId */
              ]();
              if (wn && (an.set(kn[
                0
                /* eRequestHeaders.requestContextHeader */
              ], kn[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + wn), v && (O[
                Se
                /* @min:%2erequestHeaders */
              ][kn[
                0
                /* eRequestHeaders.requestContextHeader */
              ]] = kn[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + wn)), S) {
                var Sn = O[
                  Ie
                  /* @min:%2etraceFlags */
                ];
                Q(Sn) && (Sn = 1);
                var Yn = F0(U0(O[
                  dt
                  /* @min:%2etraceID */
                ], O[
                  Zt
                  /* @min:%2espanID */
                ], Sn));
                an.set(kn[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ], Yn), v && (O[
                  Se
                  /* @min:%2erequestHeaders */
                ][kn[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ]] = Yn);
              }
              $[
                Pi
                /* @min:%2eheaders */
              ] = an;
            }
            return $;
          } else if (K) {
            if (Ga[
              pp
              /* @min:%2ecanIncludeCorrelationHeader */
            ](s, O[
              A_
              /* @min:%2egetAbsoluteUrl */
            ](), V)) {
              if (I)
                if (Nv(K, kn[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ]))
                  ft(on, 71, "Unable to set [" + kn[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ] + "] as it has already been set by another instance");
                else {
                  var sn = "|" + O[
                    dt
                    /* @min:%2etraceID */
                  ] + "." + O[
                    Zt
                    /* @min:%2espanID */
                  ];
                  K[
                    pv
                    /* @min:%2esetRequestHeader */
                  ](kn[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ], sn), v && (O[
                    Se
                    /* @min:%2erequestHeaders */
                  ][kn[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ]] = sn);
                }
              var wn = s[
                Jf
                /* @min:%2eappId */
              ] || h && h[
                Jf
                /* @min:%2eappId */
              ]();
              if (wn && (Nv(K, kn[
                0
                /* eRequestHeaders.requestContextHeader */
              ]) ? ft(on, 71, "Unable to set [" + kn[
                0
                /* eRequestHeaders.requestContextHeader */
              ] + "] as it has already been set by another instance") : (K[
                pv
                /* @min:%2esetRequestHeader */
              ](kn[
                0
                /* eRequestHeaders.requestContextHeader */
              ], kn[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + wn), v && (O[
                Se
                /* @min:%2erequestHeaders */
              ][kn[
                0
                /* eRequestHeaders.requestContextHeader */
              ]] = kn[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + wn))), S) {
                var Sn = O[
                  Ie
                  /* @min:%2etraceFlags */
                ];
                if (Q(Sn) && (Sn = 1), Nv(K, kn[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ]))
                  ft(on, 71, "Unable to set [" + kn[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ] + "] as it has already been set by another instance");
                else {
                  var Yn = F0(U0(O[
                    dt
                    /* @min:%2etraceID */
                  ], O[
                    Zt
                    /* @min:%2espanID */
                  ], Sn));
                  K[
                    pv
                    /* @min:%2esetRequestHeader */
                  ](kn[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ], Yn), v && (O[
                    Se
                    /* @min:%2erequestHeaders */
                  ][kn[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ]] = Yn);
                }
              }
            }
            return K;
          }
        }, on[
          Ep
          /* @min:%2etrackDependencyDataInternal */
        ] = function(O, H, $) {
          if (x === -1 || p < x) {
            (s[
              Ev
              /* @min:%2edistributedTracingMode */
            ] === 2 || s[
              Ev
              /* @min:%2edistributedTracingMode */
            ] === 1) && typeof O.id == "string" && O.id[O.id[
              lt
              /* @min:%2elength */
            ] - 1] !== "." && (O.id += "."), Q(O[
              zi
              /* @min:%2estartTime */
            ]) && (O[
              zi
              /* @min:%2estartTime */
            ] = /* @__PURE__ */ new Date());
            var K = Ft(O, Vi.dataType, Vi.envelopeType, on[Eo](), H, $);
            on[
              We
              /* @min:%2ecore */
            ].track(K);
          } else
            p === x && To(on, 55, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", !0);
          ++p;
        }, on.addDependencyListener = function(O) {
          return yp(Zn, On++, O);
        }, on.addDependencyInitializer = function(O) {
          return yp(or, On++, O);
        };
        function Or() {
          var O = Xt();
          u = !1, o = !1, c = O && O.host && O.host[
            xa
            /* @min:%2etoLowerCase */
          ](), s = t.getEmptyConfig(), v = !1, d = !1, p = 0, h = null, S = !1, I = !1, T = null, R = !1, x = 0, E = !1, b = {}, m = !1, F = !1, y = null, j = null, un = null, On = 0, Zn = [], or = [], k = Ve("ajaxData"), on._ajaxDataId = k;
        }
        function Lr(O) {
          var H = Ze(null, O, on[
            We
            /* @min:%2ecore */
          ]);
          s = mp();
          var $ = b_();
          ir($, function(an, sn) {
            s[an] = H.getConfig(t.identifier, an, sn);
          });
          var K = s[
            Ev
            /* @min:%2edistributedTracingMode */
          ];
          if (v = s[
            _m
            /* @min:%2eenableRequestHeaderTracking */
          ], d = s[
            dm
            /* @min:%2eenableAjaxErrorStatusText */
          ], R = s[
            hm
            /* @min:%2eenableAjaxPerfTracking */
          ], x = s[
            gm
            /* @min:%2emaxAjaxCallsPerView */
          ], E = s[
            pm
            /* @min:%2eenableResponseHeaderTracking */
          ], y = [].concat(s[
            Em
            /* @min:%2eexcludeRequestFromAutoTrackingPatterns */
          ] || [], s.addIntEndpoints !== !1 ? Lm : []), j = s[
            Tm
            /* @min:%2eaddRequestContext */
          ], I = K === 0 || K === 1, S = K === 1 || K === 2, R) {
            var V = O.instrumentationKey || "unkwn";
            V[
              lt
              /* @min:%2elength */
            ] > 5 ? T = Dp + V.substring(V[
              lt
              /* @min:%2elength */
            ] - 5) + "." : T = Dp + V + ".";
          }
          m = !!s[
            Sm
            /* @min:%2edisableAjaxTracking */
          ], F = !!s[
            Nm
            /* @min:%2edisableFetchTracking */
          ];
        }
        function Xr() {
          var O = on[
            We
            /* @min:%2ecore */
          ].getPlugin(ps);
          O && (h = O.plugin[
            po
            /* @min:%2econtext */
          ]);
        }
        function Mn(O) {
          var H = !0;
          return (O || s.ignoreHeaders) && hn(s.ignoreHeaders, function($) {
            if ($[
              xa
              /* @min:%2etoLowerCase */
            ]() === O[
              xa
              /* @min:%2etoLowerCase */
            ]())
              return H = !1, -1;
          }), H;
        }
        function rr() {
          var O = wm();
          if (O) {
            var H = _u(), $ = O.polyfill;
            !F && !u ? (Ir(t_(H, Bi, {
              ns: un,
              // Add request hook
              req: function(K, V, an) {
                var sn;
                if (!F && u && !Z(null, V, an) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                !($ && o)) {
                  var wn = K.ctx();
                  sn = gn(V, an);
                  var Sn = on[
                    gv
                    /* @min:%2eincludeCorrelationHeaders */
                  ](sn, V, an);
                  Sn !== an && K.set(1, Sn), wn.data = sn;
                }
              },
              rsp: function(K, V) {
                if (!F) {
                  var an = K.ctx().data;
                  an && (K.rslt = K.rslt.then(function(sn) {
                    return cr(K, (sn || {})[
                      Le
                      /* @min:%2estatus */
                    ], V, sn, an, function() {
                      var wn = {
                        statusText: (sn || {})[
                          Hi
                          /* @min:%2estatusText */
                        ],
                        headerMap: null,
                        correlationContext: Hn(sn)
                      };
                      if (E && sn) {
                        var Sn = {};
                        sn.headers.forEach(function(Yn, ar) {
                          Mn(ar) && (Sn[ar] = Yn);
                        }), wn[
                          is
                          /* @min:%2eheaderMap */
                        ] = Sn;
                      }
                      return wn;
                    }), sn;
                  }).catch(function(sn) {
                    throw cr(K, 0, V, null, an, null, { error: sn.message || dn(sn) }), sn;
                  }));
                }
              },
              // Create an error callback to report any hook errors
              hkErr: Wu(on, 15, "Failed to monitor Window.fetch" + Pa)
            }, !0, ym())), u = !0) : $ && Ir(t_(H, Bi, {
              ns: un,
              req: function(K, V, an) {
                Z(null, V, an);
              }
            })), $ && (H[Bi].polyfill = $);
          }
        }
        function M(O, H, $) {
          Ir(Qw(O, H, $));
        }
        function q() {
          mm(on, k) && !m && !o && (M(XMLHttpRequest, "open", {
            ns: un,
            req: function(O, H, $, K) {
              if (!m) {
                var V = O[
                  io
                  /* @min:%2einst */
                ], an = Ua(V, k);
                !Z(V, $) && P(V, an, !0) && ((!an || !an.xhrMonitoringState[
                  R_
                  /* @min:%2eopenDone */
                ]) && (an = rn(V, H, $, K)), D(V, an));
              }
            },
            hkErr: Wu(on, 15, Gu + ".open" + Pa)
          }), M(XMLHttpRequest, "send", {
            ns: un,
            req: function(O, H) {
              if (!m) {
                var $ = O[
                  io
                  /* @min:%2einst */
                ], K = Ua($, k);
                P($, K) && !K.xhrMonitoringState[
                  C_
                  /* @min:%2esendDone */
                ] && (cn("xhr", K), K[
                  qi
                  /* @min:%2erequestSentTime */
                ] = Gf(), on[
                  gv
                  /* @min:%2eincludeCorrelationHeaders */
                ](K, void 0, void 0, $), K.xhrMonitoringState[
                  C_
                  /* @min:%2esendDone */
                ] = !0);
              }
            },
            hkErr: Wu(on, 17, Gu + Pa)
          }), M(XMLHttpRequest, "abort", {
            ns: un,
            req: function(O) {
              if (!m) {
                var H = O[
                  io
                  /* @min:%2einst */
                ], $ = Ua(H, k);
                P(H, $) && !$.xhrMonitoringState[
                  w_
                  /* @min:%2eabortDone */
                ] && ($[
                  ru
                  /* @min:%2eaborted */
                ] = 1, $.xhrMonitoringState[
                  w_
                  /* @min:%2eabortDone */
                ] = !0);
              }
            },
            hkErr: Wu(on, 13, Gu + ".abort" + Pa)
          }), M(XMLHttpRequest, "setRequestHeader", {
            ns: un,
            req: function(O, H, $) {
              if (!m) {
                var K = O[
                  io
                  /* @min:%2einst */
                ], V = Ua(K, k);
                V && P(K, V) && (xm(K, H, $), v && Mn(H) && V && (V[
                  Se
                  /* @min:%2erequestHeaders */
                ][H] = $));
              }
            },
            hkErr: Wu(on, 71, Gu + ".setRequestHeader" + Pa)
          }), o = !0);
        }
        function Z(O, H, $) {
          var K = !1, V = ((En(H) ? H : (H || {}).url || "") || "")[
            xa
            /* @min:%2etoLowerCase */
          ]();
          if (hn(y, function(wn) {
            var Sn = wn;
            En(wn) && (Sn = new RegExp(wn)), K || (K = Sn.test(V));
          }), K)
            return K;
          var an = Oa(V, "?"), sn = Oa(V, "#");
          return (an === -1 || sn !== -1 && sn < an) && (an = sn), an !== -1 && (V = V.substring(0, an)), Q(O) ? Q(H) || (K = (typeof H == "object" ? H[Gi] === !0 : !1) || ($ ? $[Gi] === !0 : !1)) : K = O[Gi] === !0 || V[Gi] === !0, !K && V && hc(V) && (K = !0), K ? b[V] || (b[V] = 1) : b[V] && (K = !0), K;
        }
        function P(O, H, $) {
          var K = !0, V = o;
          return Q(O) || (K = $ === !0 || !Q(H)), V && K;
        }
        function X() {
          var O = null;
          return on[
            We
            /* @min:%2ecore */
          ] && on[
            We
            /* @min:%2ecore */
          ].getTraceCtx && (O = on[
            We
            /* @min:%2ecore */
          ].getTraceCtx(!1)), !O && h && h.telemetryTrace && (O = Td(h.telemetryTrace)), O;
        }
        function rn(O, H, $, K) {
          var V, an = X(), sn = an && an[
            y_
            /* @min:%2egetTraceId */
          ]() || Vt(), wn = Vt().substr(0, 16), Sn = O[ai] = O[ai] || { xh: [], i: {} }, Yn = Sn.i = Sn.i || {}, ar = Yn[k] = Yn[k] || new Np(sn, wn, on[Eo](), (V = on.core) === null || V === void 0 ? void 0 : V.getTraceCtx());
          return ar[
            Ie
            /* @min:%2etraceFlags */
          ] = an && an[
            m_
            /* @min:%2egetTraceFlags */
          ](), ar[
            zt
            /* @min:%2emethod */
          ] = H, ar[
            De
            /* @min:%2erequestUrl */
          ] = $, ar.xhrMonitoringState[
            R_
            /* @min:%2eopenDone */
          ] = !0, ar[
            Se
            /* @min:%2erequestHeaders */
          ] = {}, ar.async = K, ar[
            x_
            /* @min:%2eerrorStatusText */
          ] = d, ar;
        }
        function D(O, H) {
          H.xhrMonitoringState[
            cT
            /* @min:%2estateChangeAttached */
          ] = ri(O, "readystatechange", function() {
            try {
              O && O.readyState === 4 && P(O, H) && W(O);
            } catch (K) {
              var $ = dn(K);
              (!$ || Oa($[
                xa
                /* @min:%2etoLowerCase */
              ](), "c00c023f") === -1) && To(on, 16, Gu + " 'readystatechange' event handler" + Pa, {
                ajaxDiagnosticsMessage: Dc(O, k),
                exception: $
              });
            }
          }, un);
        }
        function Y(O) {
          try {
            var H = O.responseType;
            if (H === "" || H === "text")
              return O[
                Dm
                /* @min:%2eresponseText */
              ];
          } catch {
          }
          return null;
        }
        function W(O) {
          var H = Ua(O, k);
          H[
            ao
            /* @min:%2eresponseFinishedTime */
          ] = Gf(), H[
            Le
            /* @min:%2estatus */
          ] = O[
            Le
            /* @min:%2estatus */
          ];
          function $(K, V) {
            var an = V || {};
            an.ajaxDiagnosticsMessage = Dc(O, k), K && (an.exception = dn(K)), ft(on, 14, Cp + "ajax call" + Ip, an);
          }
          pn("xmlhttprequest", H, function() {
            try {
              var K = H[
                P_
                /* @min:%2eCreateTrackItem */
              ]("Ajax", v, function() {
                var Sn = {
                  statusText: O[
                    Hi
                    /* @min:%2estatusText */
                  ],
                  headerMap: null,
                  correlationContext: J(O),
                  type: O.responseType,
                  responseText: Y(O),
                  response: O[
                    sT
                    /* @min:%2eresponse */
                  ]
                };
                if (E) {
                  var Yn = O[
                    Tp
                    /* @min:%2egetAllResponseHeaders */
                  ]();
                  if (Yn) {
                    var ar = zr(Yn).split(/[\r\n]+/), hr = {};
                    hn(ar, function(Ae) {
                      var Fe = Ae.split(": "), br = Fe.shift(), di = Fe.join(": ");
                      Mn(br) && (hr[br] = di);
                    }), Sn[
                      is
                      /* @min:%2eheaderMap */
                    ] = hr;
                  }
                }
                return Sn;
              }), V = void 0;
              try {
                j && (V = j({ status: O[
                  Le
                  /* @min:%2estatus */
                ], xhr: O }));
              } catch {
                ft(on, 104, Rp);
              }
              if (K) {
                V !== void 0 && (K[
                  su
                  /* @min:%2eproperties */
                ] = Wr(Wr({}, K.properties), V));
                var an = H[
                  O_
                  /* @min:%2egetPartAProps */
                ]();
                $n(or, on[
                  We
                  /* @min:%2ecore */
                ], H, K, null, an);
              } else
                $(null, {
                  requestSentTime: H[
                    qi
                    /* @min:%2erequestSentTime */
                  ],
                  responseFinishedTime: H[
                    ao
                    /* @min:%2eresponseFinishedTime */
                  ]
                });
            } finally {
              try {
                var sn = O[ai] || { i: {} }, wn = sn.i || {};
                wn[k] && (wn[k] = null);
              } catch {
              }
            }
          }, function(K) {
            $(K, null);
          });
        }
        function J(O) {
          try {
            var H = O[
              Tp
              /* @min:%2egetAllResponseHeaders */
            ]();
            if (H !== null) {
              var $ = Oa(H[
                xa
                /* @min:%2etoLowerCase */
              ](), kn[
                8
                /* eRequestHeaders.requestContextHeaderLowerCase */
              ]);
              if ($ !== -1) {
                var K = O.getResponseHeader(kn[
                  0
                  /* eRequestHeaders.requestContextHeader */
                ]);
                return Ga[
                  Sp
                  /* @min:%2egetCorrelationContext */
                ](K);
              }
            }
          } catch (V) {
            ft(on, 18, Ap, {
              ajaxDiagnosticsMessage: Dc(O, k),
              exception: dn(V)
            });
          }
        }
        function cn(O, H) {
          if (H[
            De
            /* @min:%2erequestUrl */
          ] && T && R) {
            var $ = oi();
            if ($ && Cn($.mark)) {
              wp++;
              var K = T + O + "#" + wp;
              $.mark(K);
              var V = $.getEntriesByName(K);
              V && V[
                lt
                /* @min:%2elength */
              ] === 1 && (H[
                as
                /* @min:%2eperfMark */
              ] = V[0]);
            }
          }
        }
        function pn(O, H, $, K) {
          var V = H[
            as
            /* @min:%2eperfMark */
          ], an = oi(), sn = s.maxAjaxPerfLookupAttempts, wn = s[
            Im
            /* @min:%2eajaxPerfLookupDelay */
          ], Sn = H[
            De
            /* @min:%2erequestUrl */
          ], Yn = 0;
          (function ar() {
            try {
              if (an && V) {
                Yn++;
                for (var hr = null, Ae = an.getEntries(), Fe = Ae[
                  lt
                  /* @min:%2elength */
                ] - 1; Fe >= 0; Fe--) {
                  var br = Ae[Fe];
                  if (br) {
                    if (br.entryType === "resource")
                      br.initiatorType === O && (Oa(br[
                        Ya
                        /* @min:%2ename */
                      ], Sn) !== -1 || Oa(Sn, br[
                        Ya
                        /* @min:%2ename */
                      ]) !== -1) && (hr = br);
                    else if (br.entryType === "mark" && br[
                      Ya
                      /* @min:%2ename */
                    ] === V[
                      Ya
                      /* @min:%2ename */
                    ]) {
                      H[
                        L_
                        /* @min:%2eperfTiming */
                      ] = hr;
                      break;
                    }
                    if (br[
                      zi
                      /* @min:%2estartTime */
                    ] < V[
                      zi
                      /* @min:%2estartTime */
                    ] - 1e3)
                      break;
                  }
                }
              }
              !V || // - we don't have a perfMark or
              H[
                L_
                /* @min:%2eperfTiming */
              ] || // - we have not found the perf entry or
              Yn >= sn || // - we have tried too many attempts or
              H.async === !1 ? (V && Cn(an.clearMarks) && an.clearMarks(V[
                Ya
                /* @min:%2ename */
              ]), H.perfAttempts = Yn, $()) : setTimeout(ar, wn);
            } catch (di) {
              K(di);
            }
          })();
        }
        function gn(O, H) {
          var $, K = X(), V = K && K[
            y_
            /* @min:%2egetTraceId */
          ]() || Vt(), an = Vt().substr(0, 16), sn = new Np(V, an, on[Eo](), ($ = on.core) === null || $ === void 0 ? void 0 : $.getTraceCtx());
          sn[
            Ie
            /* @min:%2etraceFlags */
          ] = K && K[
            m_
            /* @min:%2egetTraceFlags */
          ](), sn[
            qi
            /* @min:%2erequestSentTime */
          ] = Gf(), sn[
            x_
            /* @min:%2eerrorStatusText */
          ] = d, O instanceof Request ? sn[
            De
            /* @min:%2erequestUrl */
          ] = O ? O.url : "" : sn[
            De
            /* @min:%2erequestUrl */
          ] = O;
          var wn = "GET";
          H && H[
            zt
            /* @min:%2emethod */
          ] ? wn = H[
            zt
            /* @min:%2emethod */
          ] : O && O instanceof Request && (wn = O[
            zt
            /* @min:%2emethod */
          ]), sn[
            zt
            /* @min:%2emethod */
          ] = wn;
          var Sn = {};
          if (v) {
            var Yn = new Headers((H ? H[
              Pi
              /* @min:%2eheaders */
            ] : 0) || (O instanceof Request ? O[
              Pi
              /* @min:%2eheaders */
            ] || {} : {}));
            Yn.forEach(function(ar, hr) {
              Mn(hr) && (Sn[hr] = ar);
            });
          }
          return sn[
            Se
            /* @min:%2erequestHeaders */
          ] = Sn, cn(Bi, sn), sn;
        }
        function zn(O) {
          var H = "";
          try {
            Q(O) || (En(O) ? H += "(url: '".concat(O, "')") : H += "(url: '".concat(O.url, "')"));
          } catch ($) {
            To(on, 15, "Failed to grab failed fetch diagnostics message", { exception: dn($) });
          }
          return H;
        }
        function cr(O, H, $, K, V, an, sn) {
          if (!V)
            return;
          function wn(Sn, Yn, ar) {
            var hr = ar || {};
            hr.fetchDiagnosticsMessage = zn($), Yn && (hr.exception = dn(Yn)), ft(on, Sn, Cp + "fetch call" + Ip, hr);
          }
          V[
            ao
            /* @min:%2eresponseFinishedTime */
          ] = Gf(), V[
            Le
            /* @min:%2estatus */
          ] = H, pn(Bi, V, function() {
            var Sn = V[
              P_
              /* @min:%2eCreateTrackItem */
            ]("Fetch", v, an), Yn;
            try {
              j && (Yn = j({ status: H, request: $, response: K }));
            } catch {
              ft(on, 104, Rp);
            }
            if (Sn) {
              Yn !== void 0 && (Sn[
                su
                /* @min:%2eproperties */
              ] = Wr(Wr({}, Sn.properties), Yn));
              var ar = V[
                O_
                /* @min:%2egetPartAProps */
              ]();
              $n(or, on[
                We
                /* @min:%2ecore */
              ], V, Sn, null, ar);
            } else
              wn(14, null, {
                requestSentTime: V[
                  qi
                  /* @min:%2erequestSentTime */
                ],
                responseFinishedTime: V[
                  ao
                  /* @min:%2eresponseFinishedTime */
                ]
              });
          }, function(Sn) {
            wn(18, Sn, null);
          });
        }
        function Hn(O) {
          if (O && O[
            Pi
            /* @min:%2eheaders */
          ])
            try {
              var H = O[
                Pi
                /* @min:%2eheaders */
              ].get(kn[
                0
                /* eRequestHeaders.requestContextHeader */
              ]);
              return Ga[
                Sp
                /* @min:%2egetCorrelationContext */
              ](H);
            } catch ($) {
              ft(on, 18, Ap, {
                fetchDiagnosticsMessage: zn(O),
                exception: dn($)
              });
            }
        }
        function $n(O, H, $, K, V, an) {
          var sn = !0, wn = O[
            lt
            /* @min:%2elength */
          ];
          if (wn > 0) {
            var Sn = {
              item: K,
              properties: V,
              sysProperties: an,
              context: $ ? $[
                po
                /* @min:%2econtext */
              ] : null,
              aborted: $ ? !!$[
                ru
                /* @min:%2eaborted */
              ] : !1
            };
            sn = _T(H, O, Sn, "initializer");
          }
          sn && on[
            Ep
            /* @min:%2etrackDependencyDataInternal */
          ](K, V, an);
        }
      }), i;
    }
    return t.prototype.processTelemetry = function(i, u) {
      this.processNext(i, u);
    }, t.prototype.addDependencyInitializer = function(i) {
      return null;
    }, t.identifier = "AjaxDependencyPlugin", t.getDefaultConfig = b_, t.getEmptyConfig = mp, t;
  }(Fo)
), Mm = (
  /** @class */
  function() {
    function e() {
    }
    return e;
  }()
), Ym = (
  /** @class */
  function() {
    function e() {
      this.id = "browser", this.deviceClass = "Browser";
    }
    return e;
  }()
), us = "sessionManager", os = "update", Ic = "isUserCookieSet", fs = "isNewUser", Dv = "getTraceCtx", M_ = "telemetryTrace", dT = "applySessionContext", hT = "applyApplicationContext", gT = "applyDeviceContext", pT = "applyOperationContext", ET = "applyUserContext", TT = "applyOperatingSystemContxt", ST = "applyLocationContext", NT = "applyInternalContext", kt = "accountId", Ac = "sdkExtension", Rc = "getSessionId", Zi = "namePrefix", Cc = "sessionCookiePostfix", wc = "userCookiePostfix", Oo = "idLength", Lo = "getNewId", cs = "length", Fa = "automaticSession", Ha = "authenticatedId", zu = "sessionExpirationMs", nc = "sessionRenewalMs", vt = "config", qu = "acquisitionDate", rc = "renewalDate", Y_ = "cookieDomain", yc = "join", Ku = "cookieSeparator", Iv = "authUserCookieName", Um = "2.8.16", Fm = (
  /** @class */
  function() {
    function e(t) {
      this.sdkVersion = (t[
        Ac
        /* @min:%2esdkExtension */
      ] && t[
        Ac
        /* @min:%2esdkExtension */
      ]() ? t[
        Ac
        /* @min:%2esdkExtension */
      ]() + "_" : "") + "javascript:" + Um;
    }
    return e;
  }()
), Hm = (
  /** @class */
  function() {
    function e() {
    }
    return e;
  }()
), Bm = "ai_session", DT = (
  /** @class */
  function() {
    function e() {
    }
    return e;
  }()
), km = (
  /** @class */
  function() {
    function e(t, i) {
      var u = this, o, c, s = Yo(i), v = rd(i);
      nr(e, u, function(d) {
        t || (t = {}), Cn(t[
          zu
          /* @min:%2esessionExpirationMs */
        ]) || (t[
          zu
          /* @min:%2esessionExpirationMs */
        ] = function() {
          return e.acquisitionSpan;
        }), Cn(t[
          nc
          /* @min:%2esessionRenewalMs */
        ]) || (t[
          nc
          /* @min:%2esessionRenewalMs */
        ] = function() {
          return e.renewalSpan;
        }), d[
          vt
          /* @min:%2econfig */
        ] = t;
        var p = d.config[
          Cc
          /* @min:%2esessionCookiePostfix */
        ] && d[
          vt
          /* @min:%2econfig */
        ][
          Cc
          /* @min:%2esessionCookiePostfix */
        ]() ? d.config[
          Cc
          /* @min:%2esessionCookiePostfix */
        ]() : d.config[
          Zi
          /* @min:%2enamePrefix */
        ] && d[
          vt
          /* @min:%2econfig */
        ][
          Zi
          /* @min:%2enamePrefix */
        ]() ? d[
          vt
          /* @min:%2econfig */
        ][
          Zi
          /* @min:%2enamePrefix */
        ]() : "";
        o = function() {
          return Bm + p;
        }, d[
          Fa
          /* @min:%2eautomaticSession */
        ] = new DT(), d[
          os
          /* @min:%2eupdate */
        ] = function() {
          var x = $e(), E = !1, b = d[
            Fa
            /* @min:%2eautomaticSession */
          ];
          b.id || (E = !h(b));
          var m = d.config[
            zu
            /* @min:%2esessionExpirationMs */
          ]();
          if (!E && m > 0) {
            var F = d.config[
              nc
              /* @min:%2esessionRenewalMs */
            ](), y = x - b[
              qu
              /* @min:%2eacquisitionDate */
            ], j = x - b[
              rc
              /* @min:%2erenewalDate */
            ];
            E = y < 0 || j < 0, E = E || y > m, E = E || j > F;
          }
          E ? I(x) : (!c || x - c > e.cookieUpdateInterval) && T(b, x);
        }, d.backup = function() {
          var x = d[
            Fa
            /* @min:%2eautomaticSession */
          ];
          R(x.id, x[
            qu
            /* @min:%2eacquisitionDate */
          ], x[
            rc
            /* @min:%2erenewalDate */
          ]);
        };
        function h(x, E) {
          var b = !1, m = v.get(o());
          if (m && Cn(m.split))
            b = S(x, m);
          else {
            var F = oy(s, o());
            F && (b = S(x, F));
          }
          return b || !!x.id;
        }
        function S(x, E) {
          var b = !1, m = ", session will be reset", F = E.split("|");
          if (F[
            cs
            /* @min:%2elength */
          ] >= 2)
            try {
              var y = +F[1] || 0, j = +F[2] || 0;
              isNaN(y) || y <= 0 ? en(s, 2, 27, "AI session acquisition date is 0" + m) : isNaN(j) || j <= 0 ? en(s, 2, 27, "AI session renewal date is 0" + m) : F[0] && (x.id = F[0], x[
                qu
                /* @min:%2eacquisitionDate */
              ] = y, x[
                rc
                /* @min:%2erenewalDate */
              ] = j, b = !0);
            } catch (un) {
              en(s, 1, 9, "Error parsing ai_session value [" + (E || "") + "]" + m + " - " + Fn(un), { exception: dn(un) });
            }
          return b;
        }
        function I(x) {
          var E = d[
            vt
            /* @min:%2econfig */
          ] || {}, b = (E[
            Lo
            /* @min:%2egetNewId */
          ] ? E[
            Lo
            /* @min:%2egetNewId */
          ]() : null) || j_;
          d.automaticSession.id = b(E[
            Oo
            /* @min:%2eidLength */
          ] ? E[
            Oo
            /* @min:%2eidLength */
          ]() : 22), d[
            Fa
            /* @min:%2eautomaticSession */
          ][
            qu
            /* @min:%2eacquisitionDate */
          ] = x, T(d[
            Fa
            /* @min:%2eautomaticSession */
          ], x), dd() || en(s, 2, 0, "Browser does not support local storage. Session durations will be inaccurate.");
        }
        function T(x, E) {
          var b = x[
            qu
            /* @min:%2eacquisitionDate */
          ];
          x[
            rc
            /* @min:%2erenewalDate */
          ] = E;
          var m = d[
            vt
            /* @min:%2econfig */
          ], F = m[
            nc
            /* @min:%2esessionRenewalMs */
          ](), y = b + m[
            zu
            /* @min:%2esessionExpirationMs */
          ]() - E, j = [x.id, b, E], un = 0;
          y < F ? un = y / 1e3 : un = F / 1e3;
          var k = m[
            Y_
            /* @min:%2ecookieDomain */
          ] ? m[
            Y_
            /* @min:%2ecookieDomain */
          ]() : null;
          v.set(o(), j.join("|"), m[
            zu
            /* @min:%2esessionExpirationMs */
          ]() > 0 ? un : null, k), c = E;
        }
        function R(x, E, b) {
          fy(s, o(), [x, E, b][
            yc
            /* @min:%2ejoin */
          ]("|"));
        }
      });
    }
    return e.acquisitionSpan = 864e5, e.renewalSpan = 18e5, e.cookieUpdateInterval = 6e4, e;
  }()
), Gm = (
  /** @class */
  function() {
    function e(t, i, u, o) {
      var c = this;
      c.traceID = t || Vt(), c.parentID = i;
      var s = Xt();
      !u && s && s.pathname && (u = s.pathname), c.name = _r(o, u);
    }
    return e;
  }()
);
function xp(e) {
  return !(typeof e != "string" || !e || e.match(/,|;|=| |\|/));
}
var Wm = (
  /** @class */
  function() {
    function e(t, i) {
      this.isNewUser = !1, this.isUserCookieSet = !1;
      var u = Yo(i), o = rd(i), c;
      nr(e, this, function(s) {
        s[
          vt
          /* @min:%2econfig */
        ] = t;
        var v = s.config[
          wc
          /* @min:%2euserCookiePostfix */
        ] && s[
          vt
          /* @min:%2econfig */
        ][
          wc
          /* @min:%2euserCookiePostfix */
        ]() ? s[
          vt
          /* @min:%2econfig */
        ][
          wc
          /* @min:%2euserCookiePostfix */
        ]() : "";
        c = function() {
          return e.userCookieName + v;
        };
        var d = o.get(c());
        if (d) {
          s[
            fs
            /* @min:%2eisNewUser */
          ] = !1;
          var p = d.split(e[
            Ku
            /* @min:%2ecookieSeparator */
          ]);
          p[
            cs
            /* @min:%2elength */
          ] > 0 && (s.id = p[0], s[
            Ic
            /* @min:%2eisUserCookieSet */
          ] = !!s.id);
        }
        function h() {
          var b = t || {}, m = (b[
            Lo
            /* @min:%2egetNewId */
          ] ? b[
            Lo
            /* @min:%2egetNewId */
          ]() : null) || j_, F = m(b[
            Oo
            /* @min:%2eidLength */
          ] ? t[
            Oo
            /* @min:%2eidLength */
          ]() : 22);
          return F;
        }
        function S(b) {
          var m = uu(/* @__PURE__ */ new Date());
          s.accountAcquisitionDate = m, s[
            fs
            /* @min:%2eisNewUser */
          ] = !0;
          var F = [b, m];
          return F;
        }
        function I(b) {
          var m = 31536e3;
          s[
            Ic
            /* @min:%2eisUserCookieSet */
          ] = o.set(c(), b, m);
        }
        if (!s.id) {
          s.id = h();
          var T = S(s.id);
          I(T[
            yc
            /* @min:%2ejoin */
          ](e[
            Ku
            /* @min:%2ecookieSeparator */
          ]));
          var R = t[
            Zi
            /* @min:%2enamePrefix */
          ] && t[
            Zi
            /* @min:%2enamePrefix */
          ]() ? t[
            Zi
            /* @min:%2enamePrefix */
          ]() + "ai_session" : "ai_session";
          cy(u, R);
        }
        s[
          kt
          /* @min:%2eaccountId */
        ] = t[
          kt
          /* @min:%2eaccountId */
        ] ? t[
          kt
          /* @min:%2eaccountId */
        ]() : void 0;
        var x = o.get(e[
          Iv
          /* @min:%2eauthUserCookieName */
        ]);
        if (x) {
          x = decodeURI(x);
          var E = x.split(e[
            Ku
            /* @min:%2ecookieSeparator */
          ]);
          E[0] && (s[
            Ha
            /* @min:%2eauthenticatedId */
          ] = E[0]), E[
            cs
            /* @min:%2elength */
          ] > 1 && E[1] && (s[
            kt
            /* @min:%2eaccountId */
          ] = E[1]);
        }
        s.setAuthenticatedUserContext = function(b, m, F) {
          F === void 0 && (F = !1);
          var y = !xp(b) || m && !xp(m);
          if (y) {
            en(u, 2, 60, "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", !0);
            return;
          }
          s[
            Ha
            /* @min:%2eauthenticatedId */
          ] = b;
          var j = s[
            Ha
            /* @min:%2eauthenticatedId */
          ];
          m && (s[
            kt
            /* @min:%2eaccountId */
          ] = m, j = [s[
            Ha
            /* @min:%2eauthenticatedId */
          ], s.accountId][
            yc
            /* @min:%2ejoin */
          ](e[
            Ku
            /* @min:%2ecookieSeparator */
          ])), F && o.set(e[
            Iv
            /* @min:%2eauthUserCookieName */
          ], encodeURI(j));
        }, s.clearAuthenticatedUserContext = function() {
          s[
            Ha
            /* @min:%2eauthenticatedId */
          ] = null, s[
            kt
            /* @min:%2eaccountId */
          ] = null, o.del(e[
            Iv
            /* @min:%2eauthUserCookieName */
          ]);
        }, s[
          os
          /* @min:%2eupdate */
        ] = function(b) {
          if (s.id !== b || !s[
            Ic
            /* @min:%2eisUserCookieSet */
          ]) {
            var m = b || h(), F = S(m);
            I(F[
              yc
              /* @min:%2ejoin */
            ](e[
              Ku
              /* @min:%2ecookieSeparator */
            ]));
          }
        };
      });
    }
    return e.cookieSeparator = "|", e.userCookieName = "ai_user", e.authUserCookieName = "ai_authUser", e;
  }()
), ec = "ext", tc = "tags";
function La(e, t) {
  e && e[t] && ea(e[t])[
    cs
    /* @min:%2elength */
  ] === 0 && delete e[t];
}
var zm = (
  /** @class */
  function() {
    function e(t, i, u) {
      var o = this, c = t.logger;
      this.appId = function() {
        return null;
      }, this[
        Rc
        /* @min:%2egetSessionId */
      ] = function() {
        return null;
      }, nr(e, this, function(s) {
        if (s.application = new Mm(), s.internal = new Fm(i), Mo()) {
          s[
            us
            /* @min:%2esessionManager */
          ] = new km(i, t), s.device = new Ym(), s.location = new Hm(), s.user = new Wm(i, t);
          var v = void 0, d = void 0, p;
          u && (v = u.getTraceId(), d = u.getSpanId(), p = u.getName()), s[
            M_
            /* @min:%2etelemetryTrace */
          ] = new Gm(v, d, p, c), s.session = new DT();
        }
        s[
          Rc
          /* @min:%2egetSessionId */
        ] = function() {
          var h = s.session, S = null;
          if (h && En(h.id))
            S = h.id;
          else {
            var I = (s[
              us
              /* @min:%2esessionManager */
            ] || {})[
              Fa
              /* @min:%2eautomaticSession */
            ];
            S = I && En(I.id) ? I.id : null;
          }
          return S;
        }, s[
          dT
          /* @min:%2eapplySessionContext */
        ] = function(h, S) {
          Gn(Rr(h.ext, ce.AppExt), "sesId", s[
            Rc
            /* @min:%2egetSessionId */
          ](), En);
        }, s[
          TT
          /* @min:%2eapplyOperatingSystemContxt */
        ] = function(h, S) {
          Gn(h.ext, ce.OSExt, s.os);
        }, s[
          hT
          /* @min:%2eapplyApplicationContext */
        ] = function(h, S) {
          var I = s.application;
          if (I) {
            var T = Rr(h, tc);
            Gn(T, jn.applicationVersion, I.ver, En), Gn(T, jn.applicationBuild, I.build, En);
          }
        }, s[
          gT
          /* @min:%2eapplyDeviceContext */
        ] = function(h, S) {
          var I = s.device;
          if (I) {
            var T = Rr(Rr(h, ec), ce.DeviceExt);
            Gn(T, "localId", I.id, En), Gn(T, "ip", I.ip, En), Gn(T, "model", I.model, En), Gn(T, "deviceClass", I.deviceClass, En);
          }
        }, s[
          NT
          /* @min:%2eapplyInternalContext */
        ] = function(h, S) {
          var I = s.internal;
          if (I) {
            var T = Rr(h, tc);
            Gn(T, jn.internalAgentVersion, I.agentVersion, En), Gn(T, jn.internalSdkVersion, _r(c, I.sdkVersion, 64), En), (h.baseType === Ro.dataType || h.baseType === ii.dataType) && (Gn(T, jn.internalSnippet, I.snippetVer, En), Gn(T, jn.internalSdkSrc, I.sdkSrc, En));
          }
        }, s[
          ST
          /* @min:%2eapplyLocationContext */
        ] = function(h, S) {
          var I = o.location;
          I && Gn(Rr(h, tc, []), jn.locationIp, I.ip, En);
        }, s[
          pT
          /* @min:%2eapplyOperationContext */
        ] = function(h, S) {
          var I = s[
            M_
            /* @min:%2etelemetryTrace */
          ];
          if (I) {
            var T = Rr(Rr(h, ec), ce.TraceExt, { traceID: void 0, parentID: void 0 });
            Gn(T, "traceID", I.traceID, En, Q), Gn(T, "name", I.name, En, Q), Gn(T, "parentID", I.parentID, En, Q);
          }
        }, s.applyWebContext = function(h, S) {
          var I = o.web;
          I && Gn(Rr(h, ec), ce.WebExt, I);
        }, s[
          ET
          /* @min:%2eapplyUserContext */
        ] = function(h, S) {
          var I = s.user;
          if (I) {
            var T = Rr(h, tc, []);
            Gn(T, jn.userAccountId, I[
              kt
              /* @min:%2eaccountId */
            ], En);
            var R = Rr(Rr(h, ec), ce.UserExt);
            Gn(R, "id", I.id, En), Gn(R, "authId", I[
              Ha
              /* @min:%2eauthenticatedId */
            ], En);
          }
        }, s.cleanUp = function(h, S) {
          var I = h.ext;
          I && (La(I, ce.DeviceExt), La(I, ce.UserExt), La(I, ce.WebExt), La(I, ce.OSExt), La(I, ce.AppExt), La(I, ce.TraceExt));
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), qm = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      var i = e.call(this) || this;
      i.priority = 110, i.identifier = ps;
      var u, o, c;
      return nr(t, i, function(s, v) {
        d(), s.initialize = function(S, I, T, R) {
          v.initialize(S, I, T, R), p(S);
        }, s.processTelemetry = function(S, I) {
          if (!Q(S)) {
            I = s._getTelCtx(I), S.name === ii.envelopeType && I.diagLog().resetInternalMessageCount();
            var T = s.context || {};
            T.session && typeof s.context.session.id != "string" && T[
              us
              /* @min:%2esessionManager */
            ] && T[
              us
              /* @min:%2esessionManager */
            ][
              os
              /* @min:%2eupdate */
            ]();
            var R = T.user;
            if (R && !R[
              Ic
              /* @min:%2eisUserCookieSet */
            ] && R[
              os
              /* @min:%2eupdate */
            ](T.user.id), h(S, I), R && R[
              fs
              /* @min:%2eisNewUser */
            ]) {
              R[
                fs
                /* @min:%2eisNewUser */
              ] = !1;
              var x = new Ro(72, (At() || {}).userAgent || "");
              iw(I.diagLog(), 1, x);
            }
            s.processNext(S, I);
          }
        }, s._doTeardown = function(S, I) {
          var T = (S || {}).core();
          if (T && T[
            Dv
            /* @min:%2egetTraceCtx */
          ]) {
            var R = T[
              Dv
              /* @min:%2egetTraceCtx */
            ](!1);
            R === o && T.setTraceCtx(c);
          }
          d();
        };
        function d() {
          u = null, o = null, c = null;
        }
        function p(S) {
          var I = s.identifier, T = s.core, R = Ze(null, S, T), x = t.getDefaultConfig();
          u = u || {}, ir(x, function(E, b) {
            u[E] = function() {
              return R.getConfig(I, E, b());
            };
          }), S.storagePrefix && _d(S.storagePrefix), c = T[
            Dv
            /* @min:%2egetTraceCtx */
          ](!1), s.context = new zm(T, u, c), o = Td(s.context[
            M_
            /* @min:%2etelemetryTrace */
          ], c), T.setTraceCtx(o), s.context.appId = function() {
            var E = T.getPlugin(XE);
            return E ? E.plugin._appId : null;
          }, s._extConfig = u;
        }
        function h(S, I) {
          Rr(S, "tags", []), Rr(S, "ext", {});
          var T = s.context;
          T[
            dT
            /* @min:%2eapplySessionContext */
          ](S, I), T[
            hT
            /* @min:%2eapplyApplicationContext */
          ](S, I), T[
            gT
            /* @min:%2eapplyDeviceContext */
          ](S, I), T[
            pT
            /* @min:%2eapplyOperationContext */
          ](S, I), T[
            ET
            /* @min:%2eapplyUserContext */
          ](S, I), T[
            TT
            /* @min:%2eapplyOperatingSystemContxt */
          ](S, I), T.applyWebContext(S, I), T[
            ST
            /* @min:%2eapplyLocationContext */
          ](S, I), T[
            NT
            /* @min:%2eapplyInternalContext */
          ](S, I), T.cleanUp(S, I);
        }
      }), i;
    }
    return t.getDefaultConfig = function() {
      var i, u, o = null, c = (i = {
        instrumentationKey: function() {
          return u;
        }
      }, i[
        kt
        /* @min:accountId */
      ] = function() {
        return o;
      }, i.sessionRenewalMs = function() {
        return 30 * 60 * 1e3;
      }, i.samplingPercentage = function() {
        return 100;
      }, i.sessionExpirationMs = function() {
        return 24 * 60 * 60 * 1e3;
      }, i[
        Y_
        /* @min:cookieDomain */
      ] = function() {
        return o;
      }, i[
        Ac
        /* @min:sdkExtension */
      ] = function() {
        return o;
      }, i.isBrowserLinkTrackingEnabled = function() {
        return !1;
      }, i.appId = function() {
        return o;
      }, i[
        Rc
        /* @min:getSessionId */
      ] = function() {
        return o;
      }, i[
        Zi
        /* @min:namePrefix */
      ] = function() {
        return u;
      }, i[
        Cc
        /* @min:sessionCookiePostfix */
      ] = function() {
        return u;
      }, i[
        wc
        /* @min:userCookiePostfix */
      ] = function() {
        return u;
      }, i[
        Oo
        /* @min:idLength */
      ] = function() {
        return 22;
      }, i[
        Lo
        /* @min:getNewId */
      ] = function() {
        return o;
      }, i);
      return c;
    }, t;
  }(Fo)
);
const Km = qm;
var IT = "AuthenticatedUserContext", gu = "track", U_ = "snippet", Xm = "getCookieMgr", $m = "startTrackPage", Vm = "stopTrackPage", Av = "flush", Zm = "startTrackEvent", Jm = "stopTrackEvent", Qm = "addTelemetryInitializer", Pp = "pollInternalLogs", Rv = "getPlugin", Cv = "evtNamespace", jm = gu + "Event", nx = gu + "Trace", rx = gu + "Metric", ex = gu + "PageView", tx = gu + "Exception", ix = gu + "DependencyData", ax = "set" + IT, ux = "clear" + IT, ox = "updateSnippetDefinitions", fx = "loadAppInsights", Op = "endpointUrl", ic = "diagnosticLogInterval", cx = "disableFlushOnBeforeUnload", sx = "disableFlushOnUnload", Ut = "config", Pe = "context", ac = "push", wv = "version", Li = "queue", yv = "connectionString", Lp = "instrumentationKey", uc = "appInsights", bp = "disableIkeyDeprecationMessage", Mp = "getTransmissionControls", Xu = "onunloadFlush", Yp = "addHousekeepingBeforeUnload", oc = "indexOf", F_, Up = [
  U_,
  "dependencies",
  "properties",
  "_snippetVersion",
  "appInsightsNew",
  "getSKUDefaults"
], lx = (
  /** @class */
  function() {
    function e(t) {
      var i = this, u, o, c, s, v, d, p;
      nr(e, this, function(h) {
        b(), s = "" + (t.sv || t[
          wv
          /* @min:%2eversion */
        ] || ""), t[
          Li
          /* @min:%2equeue */
        ] = t[
          Li
          /* @min:%2equeue */
        ] || [], t[
          wv
          /* @min:%2eversion */
        ] = t[
          wv
          /* @min:%2eversion */
        ] || 2;
        var S = t[
          Ut
          /* @min:%2econfig */
        ] || {};
        if (S[
          yv
          /* @min:%2econnectionString */
        ]) {
          var I = Ty(S[
            yv
            /* @min:%2econnectionString */
          ]), T = I.ingestionendpoint;
          S[
            Op
            /* @min:%2eendpointUrl */
          ] = T ? T + ho : S[
            Op
            /* @min:%2eendpointUrl */
          ], S[
            Lp
            /* @min:%2einstrumentationKey */
          ] = I.instrumentationkey || S[
            Lp
            /* @min:%2einstrumentationKey */
          ];
        }
        h[
          uc
          /* @min:%2eappInsights */
        ] = new zy(), o = new Km(), u = new bm(), c = new vm(), p = new Zw(), h.core = p;
        var R = Q(S[
          bp
          /* @min:%2edisableIkeyDeprecationMessage */
        ]) ? !0 : S[
          bp
          /* @min:%2edisableIkeyDeprecationMessage */
        ];
        !S[
          yv
          /* @min:%2econnectionString */
        ] && !R && en(p.logger, 1, 106, "Instrumentation key support will end soon, see aka.ms/IkeyMigrate"), h[
          U_
          /* @min:%2esnippet */
        ] = t, h[
          Ut
          /* @min:%2econfig */
        ] = S, x(), h[
          Av
          /* @min:%2eflush */
        ] = function(m) {
          m === void 0 && (m = !0), Wc(p, function() {
            return "AISKU.flush";
          }, function() {
            hn(p[
              Mp
              /* @min:%2egetTransmissionControls */
            ](), function(F) {
              hn(F, function(y) {
                y[
                  Av
                  /* @min:%2eflush */
                ](m);
              });
            });
          }, null, m);
        }, h[
          Xu
          /* @min:%2eonunloadFlush */
        ] = function(m) {
          m === void 0 && (m = !0), hn(p[
            Mp
            /* @min:%2egetTransmissionControls */
          ](), function(F) {
            hn(F, function(y) {
              y[
                Xu
                /* @min:%2eonunloadFlush */
              ] ? y[
                Xu
                /* @min:%2eonunloadFlush */
              ]() : y[
                Av
                /* @min:%2eflush */
              ](m);
            });
          });
        }, h[
          fx
          /* @min:%2eloadAppInsights */
        ] = function(m, F, y) {
          m === void 0 && (m = !1);
          function j(un) {
            if (un) {
              var k = "";
              Q(s) || (k += s), m && (k += ".lg"), h[
                Pe
                /* @min:%2econtext */
              ] && h[
                Pe
                /* @min:%2econtext */
              ].internal && (h[
                Pe
                /* @min:%2econtext */
              ].internal.snippetVer = k || "-"), ir(h, function(On, Zn) {
                En(On) && !Cn(Zn) && On && On[0] !== "_" && // Don't copy "internal" values
                be(Up, On) === -1 && (un[On] = Zn);
              });
            }
          }
          return m && h[
            Ut
            /* @min:%2econfig */
          ].extensions && h[
            Ut
            /* @min:%2econfig */
          ].extensions.length > 0 && Gr("Extensions not allowed in legacy mode"), Wc(h.core, function() {
            return "AISKU.loadAppInsights";
          }, function() {
            var un = [];
            un[
              ac
              /* @min:%2epush */
            ](c), un[
              ac
              /* @min:%2epush */
            ](o), un[
              ac
              /* @min:%2epush */
            ](u), un[
              ac
              /* @min:%2epush */
            ](h[
              uc
              /* @min:%2eappInsights */
            ]), p.initialize(h[
              Ut
              /* @min:%2econfig */
            ], un, F, y), h[
              Pe
              /* @min:%2econtext */
            ] = o[
              Pe
              /* @min:%2econtext */
            ], F_ && h[
              Pe
              /* @min:%2econtext */
            ] && (h[
              Pe
              /* @min:%2econtext */
            ].internal.sdkSrc = F_), j(h[
              U_
              /* @min:%2esnippet */
            ]), h.emptyQueue(), h[
              Pp
              /* @min:%2epollInternalLogs */
            ](), h[
              Yp
              /* @min:%2eaddHousekeepingBeforeUnload */
            ](h);
          }), h;
        }, h[
          ox
          /* @min:%2eupdateSnippetDefinitions */
        ] = function(m) {
          LC(m, h, function(F) {
            return F && be(Up, F) === -1;
          });
        }, h.emptyQueue = function() {
          try {
            if (Xn(h.snippet[
              Li
              /* @min:%2equeue */
            ])) {
              for (var m = h.snippet[
                Li
                /* @min:%2equeue */
              ].length, F = 0; F < m; F++) {
                var y = h.snippet[
                  Li
                  /* @min:%2equeue */
                ][F];
                y();
              }
              h.snippet[
                Li
                /* @min:%2equeue */
              ] = void 0, delete h.snippet[
                Li
                /* @min:%2equeue */
              ];
            }
          } catch (un) {
            var j = {};
            un && Cn(un.toString) && (j.exception = un.toString());
          }
        }, h[
          Yp
          /* @min:%2eaddHousekeepingBeforeUnload */
        ] = function(m) {
          if (Mo() || sE()) {
            var F = function() {
              if (m[
                Xu
                /* @min:%2eonunloadFlush */
              ](!1), Cn(i.core[
                Rv
                /* @min:%2egetPlugin */
              ])) {
                var un = i.core[
                  Rv
                  /* @min:%2egetPlugin */
                ](ps);
                if (un) {
                  var k = un.plugin;
                  k && k[
                    Pe
                    /* @min:%2econtext */
                  ] && k[
                    Pe
                    /* @min:%2econtext */
                  ]._sessionManager && k[
                    Pe
                    /* @min:%2econtext */
                  ]._sessionManager.backup();
                }
              }
            }, y = !1, j = m.appInsights[
              Ut
              /* @min:%2econfig */
            ].disablePageUnloadEvents;
            d || (d = ta(v, p[
              Cv
              /* @min:%2eevtNamespace */
            ] && p[
              Cv
              /* @min:%2eevtNamespace */
            ]())), m.appInsights.config[
              cx
              /* @min:%2edisableFlushOnBeforeUnload */
            ] || (mw(F, j, d) && (y = !0), r_(F, j, d) && (y = !0), !y && !JC() && en(m[
              uc
              /* @min:%2eappInsights */
            ].core.logger, 1, 19, "Could not add handler for beforeunload and pagehide")), !y && !m.appInsights.config[
              sx
              /* @min:%2edisableFlushOnUnload */
            ] && r_(F, j, d);
          }
        }, h.getSender = function() {
          return c;
        }, h.unload = function(m, F, y) {
          h[
            Xu
            /* @min:%2eonunloadFlush */
          ](m), d && (xw(null, d), Pw(null, d)), p.unload && p.unload(m, F, y);
        }, Zu(h, h[
          uc
          /* @min:%2eappInsights */
        ], [
          Xm,
          jm,
          ex,
          "trackPageViewPerformance",
          tx,
          "_onerror",
          nx,
          rx,
          $m,
          Vm,
          Zm,
          Jm
        ]), Zu(h, E, [
          ix,
          "addDependencyListener",
          "addDependencyInitializer"
        ]), Zu(h, p, [
          Qm,
          Pp,
          "stopPollingInternalLogs",
          Rv,
          "addPlugin",
          Cv,
          "addUnloadCb",
          "getTraceCtx"
        ]), Zu(h, function() {
          var m = o[
            Pe
            /* @min:%2econtext */
          ];
          return m ? m.user : null;
        }, [
          ax,
          ux
        ]);
        function x() {
          h.config[
            ic
            /* @min:%2ediagnosticLogInterval */
          ] = h.config[
            ic
            /* @min:%2ediagnosticLogInterval */
          ] && h[
            Ut
            /* @min:%2econfig */
          ][
            ic
            /* @min:%2ediagnosticLogInterval */
          ] > 0 ? h[
            Ut
            /* @min:%2econfig */
          ][
            ic
            /* @min:%2ediagnosticLogInterval */
          ] : 1e4;
        }
        function E() {
          return u;
        }
        function b() {
          v = Ve("AISKU"), d = null, u = null, o = null, c = null, s = null;
        }
      });
    }
    return e.prototype.addDependencyInitializer = function(t) {
      return null;
    }, e;
  }()
);
(function() {
  var e = null, t = !1, i = [
    "://js.monitor.azure.com/",
    "://az416426.vo.msecnd.net/"
  ];
  try {
    var u = (document || {}).currentScript;
    u && (e = u.src);
  } catch {
  }
  if (e)
    try {
      var o = e.toLowerCase();
      if (o) {
        for (var c = "", s = 0; s < i.length; s++)
          if (o[
            oc
            /* @min:%2eindexOf */
          ](i[s]) !== -1) {
            c = "cdn" + (s + 1), o[
              oc
              /* @min:%2eindexOf */
            ]("/scripts/") === -1 && (o[
              oc
              /* @min:%2eindexOf */
            ]("/next/") !== -1 ? c += "-next" : o[
              oc
              /* @min:%2eindexOf */
            ]("/beta/") !== -1 && (c += "-beta")), F_ = c + (t ? ".mod" : "");
            break;
          }
      }
    } catch {
    }
})();
var $u = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ss = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
ss.exports;
(function(e, t) {
  (function() {
    var i, u = "4.17.21", o = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", v = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", p = 500, h = "__lodash_placeholder__", S = 1, I = 2, T = 4, R = 1, x = 2, E = 1, b = 2, m = 4, F = 8, y = 16, j = 32, un = 64, k = 128, On = 256, Zn = 512, or = 30, on = "...", Dr = 800, Ir = 16, Or = 1, Lr = 2, Xr = 3, Mn = 1 / 0, rr = 9007199254740991, M = 17976931348623157e292, q = 0 / 0, Z = 4294967295, P = Z - 1, X = Z >>> 1, rn = [
      ["ary", k],
      ["bind", E],
      ["bindKey", b],
      ["curry", F],
      ["curryRight", y],
      ["flip", Zn],
      ["partial", j],
      ["partialRight", un],
      ["rearg", On]
    ], D = "[object Arguments]", Y = "[object Array]", W = "[object AsyncFunction]", J = "[object Boolean]", cn = "[object Date]", pn = "[object DOMException]", gn = "[object Error]", zn = "[object Function]", cr = "[object GeneratorFunction]", Hn = "[object Map]", $n = "[object Number]", O = "[object Null]", H = "[object Object]", $ = "[object Promise]", K = "[object Proxy]", V = "[object RegExp]", an = "[object Set]", sn = "[object String]", wn = "[object Symbol]", Sn = "[object Undefined]", Yn = "[object WeakMap]", ar = "[object WeakSet]", hr = "[object ArrayBuffer]", Ae = "[object DataView]", Fe = "[object Float32Array]", br = "[object Float64Array]", di = "[object Int8Array]", Es = "[object Int16Array]", Ts = "[object Int32Array]", Ss = "[object Uint8Array]", Ns = "[object Uint8ClampedArray]", Ds = "[object Uint16Array]", Is = "[object Uint32Array]", AT = /\b__p \+= '';/g, RT = /\b(__p \+=) '' \+/g, CT = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Dd = /&(?:amp|lt|gt|quot|#39);/g, Id = /[&<>"']/g, wT = RegExp(Dd.source), yT = RegExp(Id.source), mT = /<%-([\s\S]+?)%>/g, xT = /<%([\s\S]+?)%>/g, Ad = /<%=([\s\S]+?)%>/g, PT = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, OT = /^\w*$/, LT = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, As = /[\\^$.*+?()[\]{}|]/g, bT = RegExp(As.source), Rs = /^\s+/, MT = /\s/, YT = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, UT = /\{\n\/\* \[wrapped with (.+)\] \*/, FT = /,? & /, HT = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, BT = /[()=,{}\[\]\/\s]/, kT = /\\(\\)?/g, GT = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Rd = /\w*$/, WT = /^[-+]0x[0-9a-f]+$/i, zT = /^0b[01]+$/i, qT = /^\[object .+?Constructor\]$/, KT = /^0o[0-7]+$/i, XT = /^(?:0|[1-9]\d*)$/, $T = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ko = /($^)/, VT = /['\n\r\u2028\u2029\\]/g, Go = "\\ud800-\\udfff", ZT = "\\u0300-\\u036f", JT = "\\ufe20-\\ufe2f", QT = "\\u20d0-\\u20ff", Cd = ZT + JT + QT, wd = "\\u2700-\\u27bf", yd = "a-z\\xdf-\\xf6\\xf8-\\xff", jT = "\\xac\\xb1\\xd7\\xf7", nS = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rS = "\\u2000-\\u206f", eS = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", md = "A-Z\\xc0-\\xd6\\xd8-\\xde", xd = "\\ufe0e\\ufe0f", Pd = jT + nS + rS + eS, Cs = "['’]", tS = "[" + Go + "]", Od = "[" + Pd + "]", Wo = "[" + Cd + "]", Ld = "\\d+", iS = "[" + wd + "]", bd = "[" + yd + "]", Md = "[^" + Go + Pd + Ld + wd + yd + md + "]", ws = "\\ud83c[\\udffb-\\udfff]", aS = "(?:" + Wo + "|" + ws + ")", Yd = "[^" + Go + "]", ys = "(?:\\ud83c[\\udde6-\\uddff]){2}", ms = "[\\ud800-\\udbff][\\udc00-\\udfff]", sa = "[" + md + "]", Ud = "\\u200d", Fd = "(?:" + bd + "|" + Md + ")", uS = "(?:" + sa + "|" + Md + ")", Hd = "(?:" + Cs + "(?:d|ll|m|re|s|t|ve))?", Bd = "(?:" + Cs + "(?:D|LL|M|RE|S|T|VE))?", kd = aS + "?", Gd = "[" + xd + "]?", oS = "(?:" + Ud + "(?:" + [Yd, ys, ms].join("|") + ")" + Gd + kd + ")*", fS = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", cS = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Wd = Gd + kd + oS, sS = "(?:" + [iS, ys, ms].join("|") + ")" + Wd, lS = "(?:" + [Yd + Wo + "?", Wo, ys, ms, tS].join("|") + ")", vS = RegExp(Cs, "g"), _S = RegExp(Wo, "g"), xs = RegExp(ws + "(?=" + ws + ")|" + lS + Wd, "g"), dS = RegExp([
      sa + "?" + bd + "+" + Hd + "(?=" + [Od, sa, "$"].join("|") + ")",
      uS + "+" + Bd + "(?=" + [Od, sa + Fd, "$"].join("|") + ")",
      sa + "?" + Fd + "+" + Hd,
      sa + "+" + Bd,
      cS,
      fS,
      Ld,
      sS
    ].join("|"), "g"), hS = RegExp("[" + Ud + Go + Cd + xd + "]"), gS = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, pS = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ES = -1, Jn = {};
    Jn[Fe] = Jn[br] = Jn[di] = Jn[Es] = Jn[Ts] = Jn[Ss] = Jn[Ns] = Jn[Ds] = Jn[Is] = !0, Jn[D] = Jn[Y] = Jn[hr] = Jn[J] = Jn[Ae] = Jn[cn] = Jn[gn] = Jn[zn] = Jn[Hn] = Jn[$n] = Jn[H] = Jn[V] = Jn[an] = Jn[sn] = Jn[Yn] = !1;
    var Vn = {};
    Vn[D] = Vn[Y] = Vn[hr] = Vn[Ae] = Vn[J] = Vn[cn] = Vn[Fe] = Vn[br] = Vn[di] = Vn[Es] = Vn[Ts] = Vn[Hn] = Vn[$n] = Vn[H] = Vn[V] = Vn[an] = Vn[sn] = Vn[wn] = Vn[Ss] = Vn[Ns] = Vn[Ds] = Vn[Is] = !0, Vn[gn] = Vn[zn] = Vn[Yn] = !1;
    var TS = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, SS = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, NS = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, DS = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, IS = parseFloat, AS = parseInt, zd = typeof $u == "object" && $u && $u.Object === Object && $u, RS = typeof self == "object" && self && self.Object === Object && self, wr = zd || RS || Function("return this")(), Ps = t && !t.nodeType && t, hi = Ps && !0 && e && !e.nodeType && e, qd = hi && hi.exports === Ps, Os = qd && zd.process, ve = function() {
      try {
        var C = hi && hi.require && hi.require("util").types;
        return C || Os && Os.binding && Os.binding("util");
      } catch {
      }
    }(), Kd = ve && ve.isArrayBuffer, Xd = ve && ve.isDate, $d = ve && ve.isMap, Vd = ve && ve.isRegExp, Zd = ve && ve.isSet, Jd = ve && ve.isTypedArray;
    function ee(C, U, L) {
      switch (L.length) {
        case 0:
          return C.call(U);
        case 1:
          return C.call(U, L[0]);
        case 2:
          return C.call(U, L[0], L[1]);
        case 3:
          return C.call(U, L[0], L[1], L[2]);
      }
      return C.apply(U, L);
    }
    function CS(C, U, L, tn) {
      for (var Tn = -1, Un = C == null ? 0 : C.length; ++Tn < Un; ) {
        var gr = C[Tn];
        U(tn, gr, L(gr), C);
      }
      return tn;
    }
    function _e(C, U) {
      for (var L = -1, tn = C == null ? 0 : C.length; ++L < tn && U(C[L], L, C) !== !1; )
        ;
      return C;
    }
    function wS(C, U) {
      for (var L = C == null ? 0 : C.length; L-- && U(C[L], L, C) !== !1; )
        ;
      return C;
    }
    function Qd(C, U) {
      for (var L = -1, tn = C == null ? 0 : C.length; ++L < tn; )
        if (!U(C[L], L, C))
          return !1;
      return !0;
    }
    function Rt(C, U) {
      for (var L = -1, tn = C == null ? 0 : C.length, Tn = 0, Un = []; ++L < tn; ) {
        var gr = C[L];
        U(gr, L, C) && (Un[Tn++] = gr);
      }
      return Un;
    }
    function zo(C, U) {
      var L = C == null ? 0 : C.length;
      return !!L && la(C, U, 0) > -1;
    }
    function Ls(C, U, L) {
      for (var tn = -1, Tn = C == null ? 0 : C.length; ++tn < Tn; )
        if (L(U, C[tn]))
          return !0;
      return !1;
    }
    function er(C, U) {
      for (var L = -1, tn = C == null ? 0 : C.length, Tn = Array(tn); ++L < tn; )
        Tn[L] = U(C[L], L, C);
      return Tn;
    }
    function Ct(C, U) {
      for (var L = -1, tn = U.length, Tn = C.length; ++L < tn; )
        C[Tn + L] = U[L];
      return C;
    }
    function bs(C, U, L, tn) {
      var Tn = -1, Un = C == null ? 0 : C.length;
      for (tn && Un && (L = C[++Tn]); ++Tn < Un; )
        L = U(L, C[Tn], Tn, C);
      return L;
    }
    function yS(C, U, L, tn) {
      var Tn = C == null ? 0 : C.length;
      for (tn && Tn && (L = C[--Tn]); Tn--; )
        L = U(L, C[Tn], Tn, C);
      return L;
    }
    function Ms(C, U) {
      for (var L = -1, tn = C == null ? 0 : C.length; ++L < tn; )
        if (U(C[L], L, C))
          return !0;
      return !1;
    }
    var mS = Ys("length");
    function xS(C) {
      return C.split("");
    }
    function PS(C) {
      return C.match(HT) || [];
    }
    function jd(C, U, L) {
      var tn;
      return L(C, function(Tn, Un, gr) {
        if (U(Tn, Un, gr))
          return tn = Un, !1;
      }), tn;
    }
    function qo(C, U, L, tn) {
      for (var Tn = C.length, Un = L + (tn ? 1 : -1); tn ? Un-- : ++Un < Tn; )
        if (U(C[Un], Un, C))
          return Un;
      return -1;
    }
    function la(C, U, L) {
      return U === U ? WS(C, U, L) : qo(C, nh, L);
    }
    function OS(C, U, L, tn) {
      for (var Tn = L - 1, Un = C.length; ++Tn < Un; )
        if (tn(C[Tn], U))
          return Tn;
      return -1;
    }
    function nh(C) {
      return C !== C;
    }
    function rh(C, U) {
      var L = C == null ? 0 : C.length;
      return L ? Fs(C, U) / L : q;
    }
    function Ys(C) {
      return function(U) {
        return U == null ? i : U[C];
      };
    }
    function Us(C) {
      return function(U) {
        return C == null ? i : C[U];
      };
    }
    function eh(C, U, L, tn, Tn) {
      return Tn(C, function(Un, gr, qn) {
        L = tn ? (tn = !1, Un) : U(L, Un, gr, qn);
      }), L;
    }
    function LS(C, U) {
      var L = C.length;
      for (C.sort(U); L--; )
        C[L] = C[L].value;
      return C;
    }
    function Fs(C, U) {
      for (var L, tn = -1, Tn = C.length; ++tn < Tn; ) {
        var Un = U(C[tn]);
        Un !== i && (L = L === i ? Un : L + Un);
      }
      return L;
    }
    function Hs(C, U) {
      for (var L = -1, tn = Array(C); ++L < C; )
        tn[L] = U(L);
      return tn;
    }
    function bS(C, U) {
      return er(U, function(L) {
        return [L, C[L]];
      });
    }
    function th(C) {
      return C && C.slice(0, oh(C) + 1).replace(Rs, "");
    }
    function te(C) {
      return function(U) {
        return C(U);
      };
    }
    function Bs(C, U) {
      return er(U, function(L) {
        return C[L];
      });
    }
    function pu(C, U) {
      return C.has(U);
    }
    function ih(C, U) {
      for (var L = -1, tn = C.length; ++L < tn && la(U, C[L], 0) > -1; )
        ;
      return L;
    }
    function ah(C, U) {
      for (var L = C.length; L-- && la(U, C[L], 0) > -1; )
        ;
      return L;
    }
    function MS(C, U) {
      for (var L = C.length, tn = 0; L--; )
        C[L] === U && ++tn;
      return tn;
    }
    var YS = Us(TS), US = Us(SS);
    function FS(C) {
      return "\\" + DS[C];
    }
    function HS(C, U) {
      return C == null ? i : C[U];
    }
    function va(C) {
      return hS.test(C);
    }
    function BS(C) {
      return gS.test(C);
    }
    function kS(C) {
      for (var U, L = []; !(U = C.next()).done; )
        L.push(U.value);
      return L;
    }
    function ks(C) {
      var U = -1, L = Array(C.size);
      return C.forEach(function(tn, Tn) {
        L[++U] = [Tn, tn];
      }), L;
    }
    function uh(C, U) {
      return function(L) {
        return C(U(L));
      };
    }
    function wt(C, U) {
      for (var L = -1, tn = C.length, Tn = 0, Un = []; ++L < tn; ) {
        var gr = C[L];
        (gr === U || gr === h) && (C[L] = h, Un[Tn++] = L);
      }
      return Un;
    }
    function Ko(C) {
      var U = -1, L = Array(C.size);
      return C.forEach(function(tn) {
        L[++U] = tn;
      }), L;
    }
    function GS(C) {
      var U = -1, L = Array(C.size);
      return C.forEach(function(tn) {
        L[++U] = [tn, tn];
      }), L;
    }
    function WS(C, U, L) {
      for (var tn = L - 1, Tn = C.length; ++tn < Tn; )
        if (C[tn] === U)
          return tn;
      return -1;
    }
    function zS(C, U, L) {
      for (var tn = L + 1; tn--; )
        if (C[tn] === U)
          return tn;
      return tn;
    }
    function _a(C) {
      return va(C) ? KS(C) : mS(C);
    }
    function Re(C) {
      return va(C) ? XS(C) : xS(C);
    }
    function oh(C) {
      for (var U = C.length; U-- && MT.test(C.charAt(U)); )
        ;
      return U;
    }
    var qS = Us(NS);
    function KS(C) {
      for (var U = xs.lastIndex = 0; xs.test(C); )
        ++U;
      return U;
    }
    function XS(C) {
      return C.match(xs) || [];
    }
    function $S(C) {
      return C.match(dS) || [];
    }
    var VS = function C(U) {
      U = U == null ? wr : da.defaults(wr.Object(), U, da.pick(wr, pS));
      var L = U.Array, tn = U.Date, Tn = U.Error, Un = U.Function, gr = U.Math, qn = U.Object, Gs = U.RegExp, ZS = U.String, de = U.TypeError, Xo = L.prototype, JS = Un.prototype, ha = qn.prototype, $o = U["__core-js_shared__"], Vo = JS.toString, Wn = ha.hasOwnProperty, QS = 0, fh = function() {
        var n = /[^.]+$/.exec($o && $o.keys && $o.keys.IE_PROTO || "");
        return n ? "Symbol(src)_1." + n : "";
      }(), Zo = ha.toString, jS = Vo.call(qn), n1 = wr._, r1 = Gs(
        "^" + Vo.call(Wn).replace(As, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Jo = qd ? U.Buffer : i, yt = U.Symbol, Qo = U.Uint8Array, ch = Jo ? Jo.allocUnsafe : i, jo = uh(qn.getPrototypeOf, qn), sh = qn.create, lh = ha.propertyIsEnumerable, nf = Xo.splice, vh = yt ? yt.isConcatSpreadable : i, Eu = yt ? yt.iterator : i, gi = yt ? yt.toStringTag : i, rf = function() {
        try {
          var n = Ni(qn, "defineProperty");
          return n({}, "", {}), n;
        } catch {
        }
      }(), e1 = U.clearTimeout !== wr.clearTimeout && U.clearTimeout, t1 = tn && tn.now !== wr.Date.now && tn.now, i1 = U.setTimeout !== wr.setTimeout && U.setTimeout, ef = gr.ceil, tf = gr.floor, Ws = qn.getOwnPropertySymbols, a1 = Jo ? Jo.isBuffer : i, _h = U.isFinite, u1 = Xo.join, o1 = uh(qn.keys, qn), pr = gr.max, Mr = gr.min, f1 = tn.now, c1 = U.parseInt, dh = gr.random, s1 = Xo.reverse, zs = Ni(U, "DataView"), Tu = Ni(U, "Map"), qs = Ni(U, "Promise"), ga = Ni(U, "Set"), Su = Ni(U, "WeakMap"), Nu = Ni(qn, "create"), af = Su && new Su(), pa = {}, l1 = Di(zs), v1 = Di(Tu), _1 = Di(qs), d1 = Di(ga), h1 = Di(Su), uf = yt ? yt.prototype : i, Du = uf ? uf.valueOf : i, hh = uf ? uf.toString : i;
      function _(n) {
        if (fr(n) && !Nn(n) && !(n instanceof mn)) {
          if (n instanceof he)
            return n;
          if (Wn.call(n, "__wrapped__"))
            return gg(n);
        }
        return new he(n);
      }
      var Ea = function() {
        function n() {
        }
        return function(r) {
          if (!ur(r))
            return {};
          if (sh)
            return sh(r);
          n.prototype = r;
          var a = new n();
          return n.prototype = i, a;
        };
      }();
      function of() {
      }
      function he(n, r) {
        this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = i;
      }
      _.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: mT,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: xT,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ad,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _
        }
      }, _.prototype = of.prototype, _.prototype.constructor = _, he.prototype = Ea(of.prototype), he.prototype.constructor = he;
      function mn(n) {
        this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Z, this.__views__ = [];
      }
      function g1() {
        var n = new mn(this.__wrapped__);
        return n.__actions__ = $r(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = $r(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = $r(this.__views__), n;
      }
      function p1() {
        if (this.__filtered__) {
          var n = new mn(this);
          n.__dir__ = -1, n.__filtered__ = !0;
        } else
          n = this.clone(), n.__dir__ *= -1;
        return n;
      }
      function E1() {
        var n = this.__wrapped__.value(), r = this.__dir__, a = Nn(n), f = r < 0, l = a ? n.length : 0, g = xN(0, l, this.__views__), N = g.start, A = g.end, w = A - N, B = f ? A : N - 1, G = this.__iteratees__, z = G.length, nn = 0, fn = Mr(w, this.__takeCount__);
        if (!a || !f && l == w && fn == w)
          return Hh(n, this.__actions__);
        var vn = [];
        n:
          for (; w-- && nn < fn; ) {
            B += r;
            for (var In = -1, _n = n[B]; ++In < z; ) {
              var yn = G[In], Ln = yn.iteratee, ue = yn.type, Br = Ln(_n);
              if (ue == Lr)
                _n = Br;
              else if (!Br) {
                if (ue == Or)
                  continue n;
                break n;
              }
            }
            vn[nn++] = _n;
          }
        return vn;
      }
      mn.prototype = Ea(of.prototype), mn.prototype.constructor = mn;
      function pi(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.clear(); ++r < a; ) {
          var f = n[r];
          this.set(f[0], f[1]);
        }
      }
      function T1() {
        this.__data__ = Nu ? Nu(null) : {}, this.size = 0;
      }
      function S1(n) {
        var r = this.has(n) && delete this.__data__[n];
        return this.size -= r ? 1 : 0, r;
      }
      function N1(n) {
        var r = this.__data__;
        if (Nu) {
          var a = r[n];
          return a === d ? i : a;
        }
        return Wn.call(r, n) ? r[n] : i;
      }
      function D1(n) {
        var r = this.__data__;
        return Nu ? r[n] !== i : Wn.call(r, n);
      }
      function I1(n, r) {
        var a = this.__data__;
        return this.size += this.has(n) ? 0 : 1, a[n] = Nu && r === i ? d : r, this;
      }
      pi.prototype.clear = T1, pi.prototype.delete = S1, pi.prototype.get = N1, pi.prototype.has = D1, pi.prototype.set = I1;
      function Qe(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.clear(); ++r < a; ) {
          var f = n[r];
          this.set(f[0], f[1]);
        }
      }
      function A1() {
        this.__data__ = [], this.size = 0;
      }
      function R1(n) {
        var r = this.__data__, a = ff(r, n);
        if (a < 0)
          return !1;
        var f = r.length - 1;
        return a == f ? r.pop() : nf.call(r, a, 1), --this.size, !0;
      }
      function C1(n) {
        var r = this.__data__, a = ff(r, n);
        return a < 0 ? i : r[a][1];
      }
      function w1(n) {
        return ff(this.__data__, n) > -1;
      }
      function y1(n, r) {
        var a = this.__data__, f = ff(a, n);
        return f < 0 ? (++this.size, a.push([n, r])) : a[f][1] = r, this;
      }
      Qe.prototype.clear = A1, Qe.prototype.delete = R1, Qe.prototype.get = C1, Qe.prototype.has = w1, Qe.prototype.set = y1;
      function je(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.clear(); ++r < a; ) {
          var f = n[r];
          this.set(f[0], f[1]);
        }
      }
      function m1() {
        this.size = 0, this.__data__ = {
          hash: new pi(),
          map: new (Tu || Qe)(),
          string: new pi()
        };
      }
      function x1(n) {
        var r = Sf(this, n).delete(n);
        return this.size -= r ? 1 : 0, r;
      }
      function P1(n) {
        return Sf(this, n).get(n);
      }
      function O1(n) {
        return Sf(this, n).has(n);
      }
      function L1(n, r) {
        var a = Sf(this, n), f = a.size;
        return a.set(n, r), this.size += a.size == f ? 0 : 1, this;
      }
      je.prototype.clear = m1, je.prototype.delete = x1, je.prototype.get = P1, je.prototype.has = O1, je.prototype.set = L1;
      function Ei(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.__data__ = new je(); ++r < a; )
          this.add(n[r]);
      }
      function b1(n) {
        return this.__data__.set(n, d), this;
      }
      function M1(n) {
        return this.__data__.has(n);
      }
      Ei.prototype.add = Ei.prototype.push = b1, Ei.prototype.has = M1;
      function Ce(n) {
        var r = this.__data__ = new Qe(n);
        this.size = r.size;
      }
      function Y1() {
        this.__data__ = new Qe(), this.size = 0;
      }
      function U1(n) {
        var r = this.__data__, a = r.delete(n);
        return this.size = r.size, a;
      }
      function F1(n) {
        return this.__data__.get(n);
      }
      function H1(n) {
        return this.__data__.has(n);
      }
      function B1(n, r) {
        var a = this.__data__;
        if (a instanceof Qe) {
          var f = a.__data__;
          if (!Tu || f.length < o - 1)
            return f.push([n, r]), this.size = ++a.size, this;
          a = this.__data__ = new je(f);
        }
        return a.set(n, r), this.size = a.size, this;
      }
      Ce.prototype.clear = Y1, Ce.prototype.delete = U1, Ce.prototype.get = F1, Ce.prototype.has = H1, Ce.prototype.set = B1;
      function gh(n, r) {
        var a = Nn(n), f = !a && Ii(n), l = !a && !f && Lt(n), g = !a && !f && !l && Da(n), N = a || f || l || g, A = N ? Hs(n.length, ZS) : [], w = A.length;
        for (var B in n)
          (r || Wn.call(n, B)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
          (B == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          l && (B == "offset" || B == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          g && (B == "buffer" || B == "byteLength" || B == "byteOffset") || // Skip index properties.
          tt(B, w))) && A.push(B);
        return A;
      }
      function ph(n) {
        var r = n.length;
        return r ? n[el(0, r - 1)] : i;
      }
      function k1(n, r) {
        return Nf($r(n), Ti(r, 0, n.length));
      }
      function G1(n) {
        return Nf($r(n));
      }
      function Ks(n, r, a) {
        (a !== i && !we(n[r], a) || a === i && !(r in n)) && nt(n, r, a);
      }
      function Iu(n, r, a) {
        var f = n[r];
        (!(Wn.call(n, r) && we(f, a)) || a === i && !(r in n)) && nt(n, r, a);
      }
      function ff(n, r) {
        for (var a = n.length; a--; )
          if (we(n[a][0], r))
            return a;
        return -1;
      }
      function W1(n, r, a, f) {
        return mt(n, function(l, g, N) {
          r(f, l, a(l), N);
        }), f;
      }
      function Eh(n, r) {
        return n && Be(r, Ar(r), n);
      }
      function z1(n, r) {
        return n && Be(r, Zr(r), n);
      }
      function nt(n, r, a) {
        r == "__proto__" && rf ? rf(n, r, {
          configurable: !0,
          enumerable: !0,
          value: a,
          writable: !0
        }) : n[r] = a;
      }
      function Xs(n, r) {
        for (var a = -1, f = r.length, l = L(f), g = n == null; ++a < f; )
          l[a] = g ? i : wl(n, r[a]);
        return l;
      }
      function Ti(n, r, a) {
        return n === n && (a !== i && (n = n <= a ? n : a), r !== i && (n = n >= r ? n : r)), n;
      }
      function ge(n, r, a, f, l, g) {
        var N, A = r & S, w = r & I, B = r & T;
        if (a && (N = l ? a(n, f, l, g) : a(n)), N !== i)
          return N;
        if (!ur(n))
          return n;
        var G = Nn(n);
        if (G) {
          if (N = ON(n), !A)
            return $r(n, N);
        } else {
          var z = Yr(n), nn = z == zn || z == cr;
          if (Lt(n))
            return Gh(n, A);
          if (z == H || z == D || nn && !l) {
            if (N = w || nn ? {} : og(n), !A)
              return w ? NN(n, z1(N, n)) : SN(n, Eh(N, n));
          } else {
            if (!Vn[z])
              return l ? n : {};
            N = LN(n, z, A);
          }
        }
        g || (g = new Ce());
        var fn = g.get(n);
        if (fn)
          return fn;
        g.set(n, N), Yg(n) ? n.forEach(function(_n) {
          N.add(ge(_n, r, a, _n, n, g));
        }) : bg(n) && n.forEach(function(_n, yn) {
          N.set(yn, ge(_n, r, a, yn, n, g));
        });
        var vn = B ? w ? _l : vl : w ? Zr : Ar, In = G ? i : vn(n);
        return _e(In || n, function(_n, yn) {
          In && (yn = _n, _n = n[yn]), Iu(N, yn, ge(_n, r, a, yn, n, g));
        }), N;
      }
      function q1(n) {
        var r = Ar(n);
        return function(a) {
          return Th(a, n, r);
        };
      }
      function Th(n, r, a) {
        var f = a.length;
        if (n == null)
          return !f;
        for (n = qn(n); f--; ) {
          var l = a[f], g = r[l], N = n[l];
          if (N === i && !(l in n) || !g(N))
            return !1;
        }
        return !0;
      }
      function Sh(n, r, a) {
        if (typeof n != "function")
          throw new de(s);
        return xu(function() {
          n.apply(i, a);
        }, r);
      }
      function Au(n, r, a, f) {
        var l = -1, g = zo, N = !0, A = n.length, w = [], B = r.length;
        if (!A)
          return w;
        a && (r = er(r, te(a))), f ? (g = Ls, N = !1) : r.length >= o && (g = pu, N = !1, r = new Ei(r));
        n:
          for (; ++l < A; ) {
            var G = n[l], z = a == null ? G : a(G);
            if (G = f || G !== 0 ? G : 0, N && z === z) {
              for (var nn = B; nn--; )
                if (r[nn] === z)
                  continue n;
              w.push(G);
            } else
              g(r, z, f) || w.push(G);
          }
        return w;
      }
      var mt = Xh(He), Nh = Xh(Vs, !0);
      function K1(n, r) {
        var a = !0;
        return mt(n, function(f, l, g) {
          return a = !!r(f, l, g), a;
        }), a;
      }
      function cf(n, r, a) {
        for (var f = -1, l = n.length; ++f < l; ) {
          var g = n[f], N = r(g);
          if (N != null && (A === i ? N === N && !ae(N) : a(N, A)))
            var A = N, w = g;
        }
        return w;
      }
      function X1(n, r, a, f) {
        var l = n.length;
        for (a = Dn(a), a < 0 && (a = -a > l ? 0 : l + a), f = f === i || f > l ? l : Dn(f), f < 0 && (f += l), f = a > f ? 0 : Fg(f); a < f; )
          n[a++] = r;
        return n;
      }
      function Dh(n, r) {
        var a = [];
        return mt(n, function(f, l, g) {
          r(f, l, g) && a.push(f);
        }), a;
      }
      function yr(n, r, a, f, l) {
        var g = -1, N = n.length;
        for (a || (a = MN), l || (l = []); ++g < N; ) {
          var A = n[g];
          r > 0 && a(A) ? r > 1 ? yr(A, r - 1, a, f, l) : Ct(l, A) : f || (l[l.length] = A);
        }
        return l;
      }
      var $s = $h(), Ih = $h(!0);
      function He(n, r) {
        return n && $s(n, r, Ar);
      }
      function Vs(n, r) {
        return n && Ih(n, r, Ar);
      }
      function sf(n, r) {
        return Rt(r, function(a) {
          return it(n[a]);
        });
      }
      function Si(n, r) {
        r = Pt(r, n);
        for (var a = 0, f = r.length; n != null && a < f; )
          n = n[ke(r[a++])];
        return a && a == f ? n : i;
      }
      function Ah(n, r, a) {
        var f = r(n);
        return Nn(n) ? f : Ct(f, a(n));
      }
      function Fr(n) {
        return n == null ? n === i ? Sn : O : gi && gi in qn(n) ? mN(n) : GN(n);
      }
      function Zs(n, r) {
        return n > r;
      }
      function $1(n, r) {
        return n != null && Wn.call(n, r);
      }
      function V1(n, r) {
        return n != null && r in qn(n);
      }
      function Z1(n, r, a) {
        return n >= Mr(r, a) && n < pr(r, a);
      }
      function Js(n, r, a) {
        for (var f = a ? Ls : zo, l = n[0].length, g = n.length, N = g, A = L(g), w = 1 / 0, B = []; N--; ) {
          var G = n[N];
          N && r && (G = er(G, te(r))), w = Mr(G.length, w), A[N] = !a && (r || l >= 120 && G.length >= 120) ? new Ei(N && G) : i;
        }
        G = n[0];
        var z = -1, nn = A[0];
        n:
          for (; ++z < l && B.length < w; ) {
            var fn = G[z], vn = r ? r(fn) : fn;
            if (fn = a || fn !== 0 ? fn : 0, !(nn ? pu(nn, vn) : f(B, vn, a))) {
              for (N = g; --N; ) {
                var In = A[N];
                if (!(In ? pu(In, vn) : f(n[N], vn, a)))
                  continue n;
              }
              nn && nn.push(vn), B.push(fn);
            }
          }
        return B;
      }
      function J1(n, r, a, f) {
        return He(n, function(l, g, N) {
          r(f, a(l), g, N);
        }), f;
      }
      function Ru(n, r, a) {
        r = Pt(r, n), n = lg(n, r);
        var f = n == null ? n : n[ke(Ee(r))];
        return f == null ? i : ee(f, n, a);
      }
      function Rh(n) {
        return fr(n) && Fr(n) == D;
      }
      function Q1(n) {
        return fr(n) && Fr(n) == hr;
      }
      function j1(n) {
        return fr(n) && Fr(n) == cn;
      }
      function Cu(n, r, a, f, l) {
        return n === r ? !0 : n == null || r == null || !fr(n) && !fr(r) ? n !== n && r !== r : nN(n, r, a, f, Cu, l);
      }
      function nN(n, r, a, f, l, g) {
        var N = Nn(n), A = Nn(r), w = N ? Y : Yr(n), B = A ? Y : Yr(r);
        w = w == D ? H : w, B = B == D ? H : B;
        var G = w == H, z = B == H, nn = w == B;
        if (nn && Lt(n)) {
          if (!Lt(r))
            return !1;
          N = !0, G = !1;
        }
        if (nn && !G)
          return g || (g = new Ce()), N || Da(n) ? ig(n, r, a, f, l, g) : wN(n, r, w, a, f, l, g);
        if (!(a & R)) {
          var fn = G && Wn.call(n, "__wrapped__"), vn = z && Wn.call(r, "__wrapped__");
          if (fn || vn) {
            var In = fn ? n.value() : n, _n = vn ? r.value() : r;
            return g || (g = new Ce()), l(In, _n, a, f, g);
          }
        }
        return nn ? (g || (g = new Ce()), yN(n, r, a, f, l, g)) : !1;
      }
      function rN(n) {
        return fr(n) && Yr(n) == Hn;
      }
      function Qs(n, r, a, f) {
        var l = a.length, g = l, N = !f;
        if (n == null)
          return !g;
        for (n = qn(n); l--; ) {
          var A = a[l];
          if (N && A[2] ? A[1] !== n[A[0]] : !(A[0] in n))
            return !1;
        }
        for (; ++l < g; ) {
          A = a[l];
          var w = A[0], B = n[w], G = A[1];
          if (N && A[2]) {
            if (B === i && !(w in n))
              return !1;
          } else {
            var z = new Ce();
            if (f)
              var nn = f(B, G, w, n, r, z);
            if (!(nn === i ? Cu(G, B, R | x, f, z) : nn))
              return !1;
          }
        }
        return !0;
      }
      function Ch(n) {
        if (!ur(n) || UN(n))
          return !1;
        var r = it(n) ? r1 : qT;
        return r.test(Di(n));
      }
      function eN(n) {
        return fr(n) && Fr(n) == V;
      }
      function tN(n) {
        return fr(n) && Yr(n) == an;
      }
      function iN(n) {
        return fr(n) && wf(n.length) && !!Jn[Fr(n)];
      }
      function wh(n) {
        return typeof n == "function" ? n : n == null ? Jr : typeof n == "object" ? Nn(n) ? xh(n[0], n[1]) : mh(n) : Vg(n);
      }
      function js(n) {
        if (!mu(n))
          return o1(n);
        var r = [];
        for (var a in qn(n))
          Wn.call(n, a) && a != "constructor" && r.push(a);
        return r;
      }
      function aN(n) {
        if (!ur(n))
          return kN(n);
        var r = mu(n), a = [];
        for (var f in n)
          f == "constructor" && (r || !Wn.call(n, f)) || a.push(f);
        return a;
      }
      function nl(n, r) {
        return n < r;
      }
      function yh(n, r) {
        var a = -1, f = Vr(n) ? L(n.length) : [];
        return mt(n, function(l, g, N) {
          f[++a] = r(l, g, N);
        }), f;
      }
      function mh(n) {
        var r = hl(n);
        return r.length == 1 && r[0][2] ? cg(r[0][0], r[0][1]) : function(a) {
          return a === n || Qs(a, n, r);
        };
      }
      function xh(n, r) {
        return pl(n) && fg(r) ? cg(ke(n), r) : function(a) {
          var f = wl(a, n);
          return f === i && f === r ? yl(a, n) : Cu(r, f, R | x);
        };
      }
      function lf(n, r, a, f, l) {
        n !== r && $s(r, function(g, N) {
          if (l || (l = new Ce()), ur(g))
            uN(n, r, N, a, lf, f, l);
          else {
            var A = f ? f(Tl(n, N), g, N + "", n, r, l) : i;
            A === i && (A = g), Ks(n, N, A);
          }
        }, Zr);
      }
      function uN(n, r, a, f, l, g, N) {
        var A = Tl(n, a), w = Tl(r, a), B = N.get(w);
        if (B) {
          Ks(n, a, B);
          return;
        }
        var G = g ? g(A, w, a + "", n, r, N) : i, z = G === i;
        if (z) {
          var nn = Nn(w), fn = !nn && Lt(w), vn = !nn && !fn && Da(w);
          G = w, nn || fn || vn ? Nn(A) ? G = A : sr(A) ? G = $r(A) : fn ? (z = !1, G = Gh(w, !0)) : vn ? (z = !1, G = Wh(w, !0)) : G = [] : Pu(w) || Ii(w) ? (G = A, Ii(A) ? G = Hg(A) : (!ur(A) || it(A)) && (G = og(w))) : z = !1;
        }
        z && (N.set(w, G), l(G, w, f, g, N), N.delete(w)), Ks(n, a, G);
      }
      function Ph(n, r) {
        var a = n.length;
        if (a)
          return r += r < 0 ? a : 0, tt(r, a) ? n[r] : i;
      }
      function Oh(n, r, a) {
        r.length ? r = er(r, function(g) {
          return Nn(g) ? function(N) {
            return Si(N, g.length === 1 ? g[0] : g);
          } : g;
        }) : r = [Jr];
        var f = -1;
        r = er(r, te(ln()));
        var l = yh(n, function(g, N, A) {
          var w = er(r, function(B) {
            return B(g);
          });
          return { criteria: w, index: ++f, value: g };
        });
        return LS(l, function(g, N) {
          return TN(g, N, a);
        });
      }
      function oN(n, r) {
        return Lh(n, r, function(a, f) {
          return yl(n, f);
        });
      }
      function Lh(n, r, a) {
        for (var f = -1, l = r.length, g = {}; ++f < l; ) {
          var N = r[f], A = Si(n, N);
          a(A, N) && wu(g, Pt(N, n), A);
        }
        return g;
      }
      function fN(n) {
        return function(r) {
          return Si(r, n);
        };
      }
      function rl(n, r, a, f) {
        var l = f ? OS : la, g = -1, N = r.length, A = n;
        for (n === r && (r = $r(r)), a && (A = er(n, te(a))); ++g < N; )
          for (var w = 0, B = r[g], G = a ? a(B) : B; (w = l(A, G, w, f)) > -1; )
            A !== n && nf.call(A, w, 1), nf.call(n, w, 1);
        return n;
      }
      function bh(n, r) {
        for (var a = n ? r.length : 0, f = a - 1; a--; ) {
          var l = r[a];
          if (a == f || l !== g) {
            var g = l;
            tt(l) ? nf.call(n, l, 1) : al(n, l);
          }
        }
        return n;
      }
      function el(n, r) {
        return n + tf(dh() * (r - n + 1));
      }
      function cN(n, r, a, f) {
        for (var l = -1, g = pr(ef((r - n) / (a || 1)), 0), N = L(g); g--; )
          N[f ? g : ++l] = n, n += a;
        return N;
      }
      function tl(n, r) {
        var a = "";
        if (!n || r < 1 || r > rr)
          return a;
        do
          r % 2 && (a += n), r = tf(r / 2), r && (n += n);
        while (r);
        return a;
      }
      function Rn(n, r) {
        return Sl(sg(n, r, Jr), n + "");
      }
      function sN(n) {
        return ph(Ia(n));
      }
      function lN(n, r) {
        var a = Ia(n);
        return Nf(a, Ti(r, 0, a.length));
      }
      function wu(n, r, a, f) {
        if (!ur(n))
          return n;
        r = Pt(r, n);
        for (var l = -1, g = r.length, N = g - 1, A = n; A != null && ++l < g; ) {
          var w = ke(r[l]), B = a;
          if (w === "__proto__" || w === "constructor" || w === "prototype")
            return n;
          if (l != N) {
            var G = A[w];
            B = f ? f(G, w, A) : i, B === i && (B = ur(G) ? G : tt(r[l + 1]) ? [] : {});
          }
          Iu(A, w, B), A = A[w];
        }
        return n;
      }
      var Mh = af ? function(n, r) {
        return af.set(n, r), n;
      } : Jr, vN = rf ? function(n, r) {
        return rf(n, "toString", {
          configurable: !0,
          enumerable: !1,
          value: xl(r),
          writable: !0
        });
      } : Jr;
      function _N(n) {
        return Nf(Ia(n));
      }
      function pe(n, r, a) {
        var f = -1, l = n.length;
        r < 0 && (r = -r > l ? 0 : l + r), a = a > l ? l : a, a < 0 && (a += l), l = r > a ? 0 : a - r >>> 0, r >>>= 0;
        for (var g = L(l); ++f < l; )
          g[f] = n[f + r];
        return g;
      }
      function dN(n, r) {
        var a;
        return mt(n, function(f, l, g) {
          return a = r(f, l, g), !a;
        }), !!a;
      }
      function vf(n, r, a) {
        var f = 0, l = n == null ? f : n.length;
        if (typeof r == "number" && r === r && l <= X) {
          for (; f < l; ) {
            var g = f + l >>> 1, N = n[g];
            N !== null && !ae(N) && (a ? N <= r : N < r) ? f = g + 1 : l = g;
          }
          return l;
        }
        return il(n, r, Jr, a);
      }
      function il(n, r, a, f) {
        var l = 0, g = n == null ? 0 : n.length;
        if (g === 0)
          return 0;
        r = a(r);
        for (var N = r !== r, A = r === null, w = ae(r), B = r === i; l < g; ) {
          var G = tf((l + g) / 2), z = a(n[G]), nn = z !== i, fn = z === null, vn = z === z, In = ae(z);
          if (N)
            var _n = f || vn;
          else
            B ? _n = vn && (f || nn) : A ? _n = vn && nn && (f || !fn) : w ? _n = vn && nn && !fn && (f || !In) : fn || In ? _n = !1 : _n = f ? z <= r : z < r;
          _n ? l = G + 1 : g = G;
        }
        return Mr(g, P);
      }
      function Yh(n, r) {
        for (var a = -1, f = n.length, l = 0, g = []; ++a < f; ) {
          var N = n[a], A = r ? r(N) : N;
          if (!a || !we(A, w)) {
            var w = A;
            g[l++] = N === 0 ? 0 : N;
          }
        }
        return g;
      }
      function Uh(n) {
        return typeof n == "number" ? n : ae(n) ? q : +n;
      }
      function ie(n) {
        if (typeof n == "string")
          return n;
        if (Nn(n))
          return er(n, ie) + "";
        if (ae(n))
          return hh ? hh.call(n) : "";
        var r = n + "";
        return r == "0" && 1 / n == -Mn ? "-0" : r;
      }
      function xt(n, r, a) {
        var f = -1, l = zo, g = n.length, N = !0, A = [], w = A;
        if (a)
          N = !1, l = Ls;
        else if (g >= o) {
          var B = r ? null : RN(n);
          if (B)
            return Ko(B);
          N = !1, l = pu, w = new Ei();
        } else
          w = r ? [] : A;
        n:
          for (; ++f < g; ) {
            var G = n[f], z = r ? r(G) : G;
            if (G = a || G !== 0 ? G : 0, N && z === z) {
              for (var nn = w.length; nn--; )
                if (w[nn] === z)
                  continue n;
              r && w.push(z), A.push(G);
            } else
              l(w, z, a) || (w !== A && w.push(z), A.push(G));
          }
        return A;
      }
      function al(n, r) {
        return r = Pt(r, n), n = lg(n, r), n == null || delete n[ke(Ee(r))];
      }
      function Fh(n, r, a, f) {
        return wu(n, r, a(Si(n, r)), f);
      }
      function _f(n, r, a, f) {
        for (var l = n.length, g = f ? l : -1; (f ? g-- : ++g < l) && r(n[g], g, n); )
          ;
        return a ? pe(n, f ? 0 : g, f ? g + 1 : l) : pe(n, f ? g + 1 : 0, f ? l : g);
      }
      function Hh(n, r) {
        var a = n;
        return a instanceof mn && (a = a.value()), bs(r, function(f, l) {
          return l.func.apply(l.thisArg, Ct([f], l.args));
        }, a);
      }
      function ul(n, r, a) {
        var f = n.length;
        if (f < 2)
          return f ? xt(n[0]) : [];
        for (var l = -1, g = L(f); ++l < f; )
          for (var N = n[l], A = -1; ++A < f; )
            A != l && (g[l] = Au(g[l] || N, n[A], r, a));
        return xt(yr(g, 1), r, a);
      }
      function Bh(n, r, a) {
        for (var f = -1, l = n.length, g = r.length, N = {}; ++f < l; ) {
          var A = f < g ? r[f] : i;
          a(N, n[f], A);
        }
        return N;
      }
      function ol(n) {
        return sr(n) ? n : [];
      }
      function fl(n) {
        return typeof n == "function" ? n : Jr;
      }
      function Pt(n, r) {
        return Nn(n) ? n : pl(n, r) ? [n] : hg(Bn(n));
      }
      var hN = Rn;
      function Ot(n, r, a) {
        var f = n.length;
        return a = a === i ? f : a, !r && a >= f ? n : pe(n, r, a);
      }
      var kh = e1 || function(n) {
        return wr.clearTimeout(n);
      };
      function Gh(n, r) {
        if (r)
          return n.slice();
        var a = n.length, f = ch ? ch(a) : new n.constructor(a);
        return n.copy(f), f;
      }
      function cl(n) {
        var r = new n.constructor(n.byteLength);
        return new Qo(r).set(new Qo(n)), r;
      }
      function gN(n, r) {
        var a = r ? cl(n.buffer) : n.buffer;
        return new n.constructor(a, n.byteOffset, n.byteLength);
      }
      function pN(n) {
        var r = new n.constructor(n.source, Rd.exec(n));
        return r.lastIndex = n.lastIndex, r;
      }
      function EN(n) {
        return Du ? qn(Du.call(n)) : {};
      }
      function Wh(n, r) {
        var a = r ? cl(n.buffer) : n.buffer;
        return new n.constructor(a, n.byteOffset, n.length);
      }
      function zh(n, r) {
        if (n !== r) {
          var a = n !== i, f = n === null, l = n === n, g = ae(n), N = r !== i, A = r === null, w = r === r, B = ae(r);
          if (!A && !B && !g && n > r || g && N && w && !A && !B || f && N && w || !a && w || !l)
            return 1;
          if (!f && !g && !B && n < r || B && a && l && !f && !g || A && a && l || !N && l || !w)
            return -1;
        }
        return 0;
      }
      function TN(n, r, a) {
        for (var f = -1, l = n.criteria, g = r.criteria, N = l.length, A = a.length; ++f < N; ) {
          var w = zh(l[f], g[f]);
          if (w) {
            if (f >= A)
              return w;
            var B = a[f];
            return w * (B == "desc" ? -1 : 1);
          }
        }
        return n.index - r.index;
      }
      function qh(n, r, a, f) {
        for (var l = -1, g = n.length, N = a.length, A = -1, w = r.length, B = pr(g - N, 0), G = L(w + B), z = !f; ++A < w; )
          G[A] = r[A];
        for (; ++l < N; )
          (z || l < g) && (G[a[l]] = n[l]);
        for (; B--; )
          G[A++] = n[l++];
        return G;
      }
      function Kh(n, r, a, f) {
        for (var l = -1, g = n.length, N = -1, A = a.length, w = -1, B = r.length, G = pr(g - A, 0), z = L(G + B), nn = !f; ++l < G; )
          z[l] = n[l];
        for (var fn = l; ++w < B; )
          z[fn + w] = r[w];
        for (; ++N < A; )
          (nn || l < g) && (z[fn + a[N]] = n[l++]);
        return z;
      }
      function $r(n, r) {
        var a = -1, f = n.length;
        for (r || (r = L(f)); ++a < f; )
          r[a] = n[a];
        return r;
      }
      function Be(n, r, a, f) {
        var l = !a;
        a || (a = {});
        for (var g = -1, N = r.length; ++g < N; ) {
          var A = r[g], w = f ? f(a[A], n[A], A, a, n) : i;
          w === i && (w = n[A]), l ? nt(a, A, w) : Iu(a, A, w);
        }
        return a;
      }
      function SN(n, r) {
        return Be(n, gl(n), r);
      }
      function NN(n, r) {
        return Be(n, ag(n), r);
      }
      function df(n, r) {
        return function(a, f) {
          var l = Nn(a) ? CS : W1, g = r ? r() : {};
          return l(a, n, ln(f, 2), g);
        };
      }
      function Ta(n) {
        return Rn(function(r, a) {
          var f = -1, l = a.length, g = l > 1 ? a[l - 1] : i, N = l > 2 ? a[2] : i;
          for (g = n.length > 3 && typeof g == "function" ? (l--, g) : i, N && Hr(a[0], a[1], N) && (g = l < 3 ? i : g, l = 1), r = qn(r); ++f < l; ) {
            var A = a[f];
            A && n(r, A, f, g);
          }
          return r;
        });
      }
      function Xh(n, r) {
        return function(a, f) {
          if (a == null)
            return a;
          if (!Vr(a))
            return n(a, f);
          for (var l = a.length, g = r ? l : -1, N = qn(a); (r ? g-- : ++g < l) && f(N[g], g, N) !== !1; )
            ;
          return a;
        };
      }
      function $h(n) {
        return function(r, a, f) {
          for (var l = -1, g = qn(r), N = f(r), A = N.length; A--; ) {
            var w = N[n ? A : ++l];
            if (a(g[w], w, g) === !1)
              break;
          }
          return r;
        };
      }
      function DN(n, r, a) {
        var f = r & E, l = yu(n);
        function g() {
          var N = this && this !== wr && this instanceof g ? l : n;
          return N.apply(f ? a : this, arguments);
        }
        return g;
      }
      function Vh(n) {
        return function(r) {
          r = Bn(r);
          var a = va(r) ? Re(r) : i, f = a ? a[0] : r.charAt(0), l = a ? Ot(a, 1).join("") : r.slice(1);
          return f[n]() + l;
        };
      }
      function Sa(n) {
        return function(r) {
          return bs(Xg(Kg(r).replace(vS, "")), n, "");
        };
      }
      function yu(n) {
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return new n();
            case 1:
              return new n(r[0]);
            case 2:
              return new n(r[0], r[1]);
            case 3:
              return new n(r[0], r[1], r[2]);
            case 4:
              return new n(r[0], r[1], r[2], r[3]);
            case 5:
              return new n(r[0], r[1], r[2], r[3], r[4]);
            case 6:
              return new n(r[0], r[1], r[2], r[3], r[4], r[5]);
            case 7:
              return new n(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
          }
          var a = Ea(n.prototype), f = n.apply(a, r);
          return ur(f) ? f : a;
        };
      }
      function IN(n, r, a) {
        var f = yu(n);
        function l() {
          for (var g = arguments.length, N = L(g), A = g, w = Na(l); A--; )
            N[A] = arguments[A];
          var B = g < 3 && N[0] !== w && N[g - 1] !== w ? [] : wt(N, w);
          if (g -= B.length, g < a)
            return ng(
              n,
              r,
              hf,
              l.placeholder,
              i,
              N,
              B,
              i,
              i,
              a - g
            );
          var G = this && this !== wr && this instanceof l ? f : n;
          return ee(G, this, N);
        }
        return l;
      }
      function Zh(n) {
        return function(r, a, f) {
          var l = qn(r);
          if (!Vr(r)) {
            var g = ln(a, 3);
            r = Ar(r), a = function(A) {
              return g(l[A], A, l);
            };
          }
          var N = n(r, a, f);
          return N > -1 ? l[g ? r[N] : N] : i;
        };
      }
      function Jh(n) {
        return et(function(r) {
          var a = r.length, f = a, l = he.prototype.thru;
          for (n && r.reverse(); f--; ) {
            var g = r[f];
            if (typeof g != "function")
              throw new de(s);
            if (l && !N && Tf(g) == "wrapper")
              var N = new he([], !0);
          }
          for (f = N ? f : a; ++f < a; ) {
            g = r[f];
            var A = Tf(g), w = A == "wrapper" ? dl(g) : i;
            w && El(w[0]) && w[1] == (k | F | j | On) && !w[4].length && w[9] == 1 ? N = N[Tf(w[0])].apply(N, w[3]) : N = g.length == 1 && El(g) ? N[A]() : N.thru(g);
          }
          return function() {
            var B = arguments, G = B[0];
            if (N && B.length == 1 && Nn(G))
              return N.plant(G).value();
            for (var z = 0, nn = a ? r[z].apply(this, B) : G; ++z < a; )
              nn = r[z].call(this, nn);
            return nn;
          };
        });
      }
      function hf(n, r, a, f, l, g, N, A, w, B) {
        var G = r & k, z = r & E, nn = r & b, fn = r & (F | y), vn = r & Zn, In = nn ? i : yu(n);
        function _n() {
          for (var yn = arguments.length, Ln = L(yn), ue = yn; ue--; )
            Ln[ue] = arguments[ue];
          if (fn)
            var Br = Na(_n), oe = MS(Ln, Br);
          if (f && (Ln = qh(Ln, f, l, fn)), g && (Ln = Kh(Ln, g, N, fn)), yn -= oe, fn && yn < B) {
            var lr = wt(Ln, Br);
            return ng(
              n,
              r,
              hf,
              _n.placeholder,
              a,
              Ln,
              lr,
              A,
              w,
              B - yn
            );
          }
          var ye = z ? a : this, ut = nn ? ye[n] : n;
          return yn = Ln.length, A ? Ln = WN(Ln, A) : vn && yn > 1 && Ln.reverse(), G && w < yn && (Ln.length = w), this && this !== wr && this instanceof _n && (ut = In || yu(ut)), ut.apply(ye, Ln);
        }
        return _n;
      }
      function Qh(n, r) {
        return function(a, f) {
          return J1(a, n, r(f), {});
        };
      }
      function gf(n, r) {
        return function(a, f) {
          var l;
          if (a === i && f === i)
            return r;
          if (a !== i && (l = a), f !== i) {
            if (l === i)
              return f;
            typeof a == "string" || typeof f == "string" ? (a = ie(a), f = ie(f)) : (a = Uh(a), f = Uh(f)), l = n(a, f);
          }
          return l;
        };
      }
      function sl(n) {
        return et(function(r) {
          return r = er(r, te(ln())), Rn(function(a) {
            var f = this;
            return n(r, function(l) {
              return ee(l, f, a);
            });
          });
        });
      }
      function pf(n, r) {
        r = r === i ? " " : ie(r);
        var a = r.length;
        if (a < 2)
          return a ? tl(r, n) : r;
        var f = tl(r, ef(n / _a(r)));
        return va(r) ? Ot(Re(f), 0, n).join("") : f.slice(0, n);
      }
      function AN(n, r, a, f) {
        var l = r & E, g = yu(n);
        function N() {
          for (var A = -1, w = arguments.length, B = -1, G = f.length, z = L(G + w), nn = this && this !== wr && this instanceof N ? g : n; ++B < G; )
            z[B] = f[B];
          for (; w--; )
            z[B++] = arguments[++A];
          return ee(nn, l ? a : this, z);
        }
        return N;
      }
      function jh(n) {
        return function(r, a, f) {
          return f && typeof f != "number" && Hr(r, a, f) && (a = f = i), r = at(r), a === i ? (a = r, r = 0) : a = at(a), f = f === i ? r < a ? 1 : -1 : at(f), cN(r, a, f, n);
        };
      }
      function Ef(n) {
        return function(r, a) {
          return typeof r == "string" && typeof a == "string" || (r = Te(r), a = Te(a)), n(r, a);
        };
      }
      function ng(n, r, a, f, l, g, N, A, w, B) {
        var G = r & F, z = G ? N : i, nn = G ? i : N, fn = G ? g : i, vn = G ? i : g;
        r |= G ? j : un, r &= ~(G ? un : j), r & m || (r &= ~(E | b));
        var In = [
          n,
          r,
          l,
          fn,
          z,
          vn,
          nn,
          A,
          w,
          B
        ], _n = a.apply(i, In);
        return El(n) && vg(_n, In), _n.placeholder = f, _g(_n, n, r);
      }
      function ll(n) {
        var r = gr[n];
        return function(a, f) {
          if (a = Te(a), f = f == null ? 0 : Mr(Dn(f), 292), f && _h(a)) {
            var l = (Bn(a) + "e").split("e"), g = r(l[0] + "e" + (+l[1] + f));
            return l = (Bn(g) + "e").split("e"), +(l[0] + "e" + (+l[1] - f));
          }
          return r(a);
        };
      }
      var RN = ga && 1 / Ko(new ga([, -0]))[1] == Mn ? function(n) {
        return new ga(n);
      } : Ll;
      function rg(n) {
        return function(r) {
          var a = Yr(r);
          return a == Hn ? ks(r) : a == an ? GS(r) : bS(r, n(r));
        };
      }
      function rt(n, r, a, f, l, g, N, A) {
        var w = r & b;
        if (!w && typeof n != "function")
          throw new de(s);
        var B = f ? f.length : 0;
        if (B || (r &= ~(j | un), f = l = i), N = N === i ? N : pr(Dn(N), 0), A = A === i ? A : Dn(A), B -= l ? l.length : 0, r & un) {
          var G = f, z = l;
          f = l = i;
        }
        var nn = w ? i : dl(n), fn = [
          n,
          r,
          a,
          f,
          l,
          G,
          z,
          g,
          N,
          A
        ];
        if (nn && BN(fn, nn), n = fn[0], r = fn[1], a = fn[2], f = fn[3], l = fn[4], A = fn[9] = fn[9] === i ? w ? 0 : n.length : pr(fn[9] - B, 0), !A && r & (F | y) && (r &= ~(F | y)), !r || r == E)
          var vn = DN(n, r, a);
        else
          r == F || r == y ? vn = IN(n, r, A) : (r == j || r == (E | j)) && !l.length ? vn = AN(n, r, a, f) : vn = hf.apply(i, fn);
        var In = nn ? Mh : vg;
        return _g(In(vn, fn), n, r);
      }
      function eg(n, r, a, f) {
        return n === i || we(n, ha[a]) && !Wn.call(f, a) ? r : n;
      }
      function tg(n, r, a, f, l, g) {
        return ur(n) && ur(r) && (g.set(r, n), lf(n, r, i, tg, g), g.delete(r)), n;
      }
      function CN(n) {
        return Pu(n) ? i : n;
      }
      function ig(n, r, a, f, l, g) {
        var N = a & R, A = n.length, w = r.length;
        if (A != w && !(N && w > A))
          return !1;
        var B = g.get(n), G = g.get(r);
        if (B && G)
          return B == r && G == n;
        var z = -1, nn = !0, fn = a & x ? new Ei() : i;
        for (g.set(n, r), g.set(r, n); ++z < A; ) {
          var vn = n[z], In = r[z];
          if (f)
            var _n = N ? f(In, vn, z, r, n, g) : f(vn, In, z, n, r, g);
          if (_n !== i) {
            if (_n)
              continue;
            nn = !1;
            break;
          }
          if (fn) {
            if (!Ms(r, function(yn, Ln) {
              if (!pu(fn, Ln) && (vn === yn || l(vn, yn, a, f, g)))
                return fn.push(Ln);
            })) {
              nn = !1;
              break;
            }
          } else if (!(vn === In || l(vn, In, a, f, g))) {
            nn = !1;
            break;
          }
        }
        return g.delete(n), g.delete(r), nn;
      }
      function wN(n, r, a, f, l, g, N) {
        switch (a) {
          case Ae:
            if (n.byteLength != r.byteLength || n.byteOffset != r.byteOffset)
              return !1;
            n = n.buffer, r = r.buffer;
          case hr:
            return !(n.byteLength != r.byteLength || !g(new Qo(n), new Qo(r)));
          case J:
          case cn:
          case $n:
            return we(+n, +r);
          case gn:
            return n.name == r.name && n.message == r.message;
          case V:
          case sn:
            return n == r + "";
          case Hn:
            var A = ks;
          case an:
            var w = f & R;
            if (A || (A = Ko), n.size != r.size && !w)
              return !1;
            var B = N.get(n);
            if (B)
              return B == r;
            f |= x, N.set(n, r);
            var G = ig(A(n), A(r), f, l, g, N);
            return N.delete(n), G;
          case wn:
            if (Du)
              return Du.call(n) == Du.call(r);
        }
        return !1;
      }
      function yN(n, r, a, f, l, g) {
        var N = a & R, A = vl(n), w = A.length, B = vl(r), G = B.length;
        if (w != G && !N)
          return !1;
        for (var z = w; z--; ) {
          var nn = A[z];
          if (!(N ? nn in r : Wn.call(r, nn)))
            return !1;
        }
        var fn = g.get(n), vn = g.get(r);
        if (fn && vn)
          return fn == r && vn == n;
        var In = !0;
        g.set(n, r), g.set(r, n);
        for (var _n = N; ++z < w; ) {
          nn = A[z];
          var yn = n[nn], Ln = r[nn];
          if (f)
            var ue = N ? f(Ln, yn, nn, r, n, g) : f(yn, Ln, nn, n, r, g);
          if (!(ue === i ? yn === Ln || l(yn, Ln, a, f, g) : ue)) {
            In = !1;
            break;
          }
          _n || (_n = nn == "constructor");
        }
        if (In && !_n) {
          var Br = n.constructor, oe = r.constructor;
          Br != oe && "constructor" in n && "constructor" in r && !(typeof Br == "function" && Br instanceof Br && typeof oe == "function" && oe instanceof oe) && (In = !1);
        }
        return g.delete(n), g.delete(r), In;
      }
      function et(n) {
        return Sl(sg(n, i, Tg), n + "");
      }
      function vl(n) {
        return Ah(n, Ar, gl);
      }
      function _l(n) {
        return Ah(n, Zr, ag);
      }
      var dl = af ? function(n) {
        return af.get(n);
      } : Ll;
      function Tf(n) {
        for (var r = n.name + "", a = pa[r], f = Wn.call(pa, r) ? a.length : 0; f--; ) {
          var l = a[f], g = l.func;
          if (g == null || g == n)
            return l.name;
        }
        return r;
      }
      function Na(n) {
        var r = Wn.call(_, "placeholder") ? _ : n;
        return r.placeholder;
      }
      function ln() {
        var n = _.iteratee || Pl;
        return n = n === Pl ? wh : n, arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function Sf(n, r) {
        var a = n.__data__;
        return YN(r) ? a[typeof r == "string" ? "string" : "hash"] : a.map;
      }
      function hl(n) {
        for (var r = Ar(n), a = r.length; a--; ) {
          var f = r[a], l = n[f];
          r[a] = [f, l, fg(l)];
        }
        return r;
      }
      function Ni(n, r) {
        var a = HS(n, r);
        return Ch(a) ? a : i;
      }
      function mN(n) {
        var r = Wn.call(n, gi), a = n[gi];
        try {
          n[gi] = i;
          var f = !0;
        } catch {
        }
        var l = Zo.call(n);
        return f && (r ? n[gi] = a : delete n[gi]), l;
      }
      var gl = Ws ? function(n) {
        return n == null ? [] : (n = qn(n), Rt(Ws(n), function(r) {
          return lh.call(n, r);
        }));
      } : bl, ag = Ws ? function(n) {
        for (var r = []; n; )
          Ct(r, gl(n)), n = jo(n);
        return r;
      } : bl, Yr = Fr;
      (zs && Yr(new zs(new ArrayBuffer(1))) != Ae || Tu && Yr(new Tu()) != Hn || qs && Yr(qs.resolve()) != $ || ga && Yr(new ga()) != an || Su && Yr(new Su()) != Yn) && (Yr = function(n) {
        var r = Fr(n), a = r == H ? n.constructor : i, f = a ? Di(a) : "";
        if (f)
          switch (f) {
            case l1:
              return Ae;
            case v1:
              return Hn;
            case _1:
              return $;
            case d1:
              return an;
            case h1:
              return Yn;
          }
        return r;
      });
      function xN(n, r, a) {
        for (var f = -1, l = a.length; ++f < l; ) {
          var g = a[f], N = g.size;
          switch (g.type) {
            case "drop":
              n += N;
              break;
            case "dropRight":
              r -= N;
              break;
            case "take":
              r = Mr(r, n + N);
              break;
            case "takeRight":
              n = pr(n, r - N);
              break;
          }
        }
        return { start: n, end: r };
      }
      function PN(n) {
        var r = n.match(UT);
        return r ? r[1].split(FT) : [];
      }
      function ug(n, r, a) {
        r = Pt(r, n);
        for (var f = -1, l = r.length, g = !1; ++f < l; ) {
          var N = ke(r[f]);
          if (!(g = n != null && a(n, N)))
            break;
          n = n[N];
        }
        return g || ++f != l ? g : (l = n == null ? 0 : n.length, !!l && wf(l) && tt(N, l) && (Nn(n) || Ii(n)));
      }
      function ON(n) {
        var r = n.length, a = new n.constructor(r);
        return r && typeof n[0] == "string" && Wn.call(n, "index") && (a.index = n.index, a.input = n.input), a;
      }
      function og(n) {
        return typeof n.constructor == "function" && !mu(n) ? Ea(jo(n)) : {};
      }
      function LN(n, r, a) {
        var f = n.constructor;
        switch (r) {
          case hr:
            return cl(n);
          case J:
          case cn:
            return new f(+n);
          case Ae:
            return gN(n, a);
          case Fe:
          case br:
          case di:
          case Es:
          case Ts:
          case Ss:
          case Ns:
          case Ds:
          case Is:
            return Wh(n, a);
          case Hn:
            return new f();
          case $n:
          case sn:
            return new f(n);
          case V:
            return pN(n);
          case an:
            return new f();
          case wn:
            return EN(n);
        }
      }
      function bN(n, r) {
        var a = r.length;
        if (!a)
          return n;
        var f = a - 1;
        return r[f] = (a > 1 ? "& " : "") + r[f], r = r.join(a > 2 ? ", " : " "), n.replace(YT, `{
/* [wrapped with ` + r + `] */
`);
      }
      function MN(n) {
        return Nn(n) || Ii(n) || !!(vh && n && n[vh]);
      }
      function tt(n, r) {
        var a = typeof n;
        return r = r ?? rr, !!r && (a == "number" || a != "symbol" && XT.test(n)) && n > -1 && n % 1 == 0 && n < r;
      }
      function Hr(n, r, a) {
        if (!ur(a))
          return !1;
        var f = typeof r;
        return (f == "number" ? Vr(a) && tt(r, a.length) : f == "string" && r in a) ? we(a[r], n) : !1;
      }
      function pl(n, r) {
        if (Nn(n))
          return !1;
        var a = typeof n;
        return a == "number" || a == "symbol" || a == "boolean" || n == null || ae(n) ? !0 : OT.test(n) || !PT.test(n) || r != null && n in qn(r);
      }
      function YN(n) {
        var r = typeof n;
        return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
      }
      function El(n) {
        var r = Tf(n), a = _[r];
        if (typeof a != "function" || !(r in mn.prototype))
          return !1;
        if (n === a)
          return !0;
        var f = dl(a);
        return !!f && n === f[0];
      }
      function UN(n) {
        return !!fh && fh in n;
      }
      var FN = $o ? it : Ml;
      function mu(n) {
        var r = n && n.constructor, a = typeof r == "function" && r.prototype || ha;
        return n === a;
      }
      function fg(n) {
        return n === n && !ur(n);
      }
      function cg(n, r) {
        return function(a) {
          return a == null ? !1 : a[n] === r && (r !== i || n in qn(a));
        };
      }
      function HN(n) {
        var r = Rf(n, function(f) {
          return a.size === p && a.clear(), f;
        }), a = r.cache;
        return r;
      }
      function BN(n, r) {
        var a = n[1], f = r[1], l = a | f, g = l < (E | b | k), N = f == k && a == F || f == k && a == On && n[7].length <= r[8] || f == (k | On) && r[7].length <= r[8] && a == F;
        if (!(g || N))
          return n;
        f & E && (n[2] = r[2], l |= a & E ? 0 : m);
        var A = r[3];
        if (A) {
          var w = n[3];
          n[3] = w ? qh(w, A, r[4]) : A, n[4] = w ? wt(n[3], h) : r[4];
        }
        return A = r[5], A && (w = n[5], n[5] = w ? Kh(w, A, r[6]) : A, n[6] = w ? wt(n[5], h) : r[6]), A = r[7], A && (n[7] = A), f & k && (n[8] = n[8] == null ? r[8] : Mr(n[8], r[8])), n[9] == null && (n[9] = r[9]), n[0] = r[0], n[1] = l, n;
      }
      function kN(n) {
        var r = [];
        if (n != null)
          for (var a in qn(n))
            r.push(a);
        return r;
      }
      function GN(n) {
        return Zo.call(n);
      }
      function sg(n, r, a) {
        return r = pr(r === i ? n.length - 1 : r, 0), function() {
          for (var f = arguments, l = -1, g = pr(f.length - r, 0), N = L(g); ++l < g; )
            N[l] = f[r + l];
          l = -1;
          for (var A = L(r + 1); ++l < r; )
            A[l] = f[l];
          return A[r] = a(N), ee(n, this, A);
        };
      }
      function lg(n, r) {
        return r.length < 2 ? n : Si(n, pe(r, 0, -1));
      }
      function WN(n, r) {
        for (var a = n.length, f = Mr(r.length, a), l = $r(n); f--; ) {
          var g = r[f];
          n[f] = tt(g, a) ? l[g] : i;
        }
        return n;
      }
      function Tl(n, r) {
        if (!(r === "constructor" && typeof n[r] == "function") && r != "__proto__")
          return n[r];
      }
      var vg = dg(Mh), xu = i1 || function(n, r) {
        return wr.setTimeout(n, r);
      }, Sl = dg(vN);
      function _g(n, r, a) {
        var f = r + "";
        return Sl(n, bN(f, zN(PN(f), a)));
      }
      function dg(n) {
        var r = 0, a = 0;
        return function() {
          var f = f1(), l = Ir - (f - a);
          if (a = f, l > 0) {
            if (++r >= Dr)
              return arguments[0];
          } else
            r = 0;
          return n.apply(i, arguments);
        };
      }
      function Nf(n, r) {
        var a = -1, f = n.length, l = f - 1;
        for (r = r === i ? f : r; ++a < r; ) {
          var g = el(a, l), N = n[g];
          n[g] = n[a], n[a] = N;
        }
        return n.length = r, n;
      }
      var hg = HN(function(n) {
        var r = [];
        return n.charCodeAt(0) === 46 && r.push(""), n.replace(LT, function(a, f, l, g) {
          r.push(l ? g.replace(kT, "$1") : f || a);
        }), r;
      });
      function ke(n) {
        if (typeof n == "string" || ae(n))
          return n;
        var r = n + "";
        return r == "0" && 1 / n == -Mn ? "-0" : r;
      }
      function Di(n) {
        if (n != null) {
          try {
            return Vo.call(n);
          } catch {
          }
          try {
            return n + "";
          } catch {
          }
        }
        return "";
      }
      function zN(n, r) {
        return _e(rn, function(a) {
          var f = "_." + a[0];
          r & a[1] && !zo(n, f) && n.push(f);
        }), n.sort();
      }
      function gg(n) {
        if (n instanceof mn)
          return n.clone();
        var r = new he(n.__wrapped__, n.__chain__);
        return r.__actions__ = $r(n.__actions__), r.__index__ = n.__index__, r.__values__ = n.__values__, r;
      }
      function qN(n, r, a) {
        (a ? Hr(n, r, a) : r === i) ? r = 1 : r = pr(Dn(r), 0);
        var f = n == null ? 0 : n.length;
        if (!f || r < 1)
          return [];
        for (var l = 0, g = 0, N = L(ef(f / r)); l < f; )
          N[g++] = pe(n, l, l += r);
        return N;
      }
      function KN(n) {
        for (var r = -1, a = n == null ? 0 : n.length, f = 0, l = []; ++r < a; ) {
          var g = n[r];
          g && (l[f++] = g);
        }
        return l;
      }
      function XN() {
        var n = arguments.length;
        if (!n)
          return [];
        for (var r = L(n - 1), a = arguments[0], f = n; f--; )
          r[f - 1] = arguments[f];
        return Ct(Nn(a) ? $r(a) : [a], yr(r, 1));
      }
      var $N = Rn(function(n, r) {
        return sr(n) ? Au(n, yr(r, 1, sr, !0)) : [];
      }), VN = Rn(function(n, r) {
        var a = Ee(r);
        return sr(a) && (a = i), sr(n) ? Au(n, yr(r, 1, sr, !0), ln(a, 2)) : [];
      }), ZN = Rn(function(n, r) {
        var a = Ee(r);
        return sr(a) && (a = i), sr(n) ? Au(n, yr(r, 1, sr, !0), i, a) : [];
      });
      function JN(n, r, a) {
        var f = n == null ? 0 : n.length;
        return f ? (r = a || r === i ? 1 : Dn(r), pe(n, r < 0 ? 0 : r, f)) : [];
      }
      function QN(n, r, a) {
        var f = n == null ? 0 : n.length;
        return f ? (r = a || r === i ? 1 : Dn(r), r = f - r, pe(n, 0, r < 0 ? 0 : r)) : [];
      }
      function jN(n, r) {
        return n && n.length ? _f(n, ln(r, 3), !0, !0) : [];
      }
      function nD(n, r) {
        return n && n.length ? _f(n, ln(r, 3), !0) : [];
      }
      function rD(n, r, a, f) {
        var l = n == null ? 0 : n.length;
        return l ? (a && typeof a != "number" && Hr(n, r, a) && (a = 0, f = l), X1(n, r, a, f)) : [];
      }
      function pg(n, r, a) {
        var f = n == null ? 0 : n.length;
        if (!f)
          return -1;
        var l = a == null ? 0 : Dn(a);
        return l < 0 && (l = pr(f + l, 0)), qo(n, ln(r, 3), l);
      }
      function Eg(n, r, a) {
        var f = n == null ? 0 : n.length;
        if (!f)
          return -1;
        var l = f - 1;
        return a !== i && (l = Dn(a), l = a < 0 ? pr(f + l, 0) : Mr(l, f - 1)), qo(n, ln(r, 3), l, !0);
      }
      function Tg(n) {
        var r = n == null ? 0 : n.length;
        return r ? yr(n, 1) : [];
      }
      function eD(n) {
        var r = n == null ? 0 : n.length;
        return r ? yr(n, Mn) : [];
      }
      function tD(n, r) {
        var a = n == null ? 0 : n.length;
        return a ? (r = r === i ? 1 : Dn(r), yr(n, r)) : [];
      }
      function iD(n) {
        for (var r = -1, a = n == null ? 0 : n.length, f = {}; ++r < a; ) {
          var l = n[r];
          f[l[0]] = l[1];
        }
        return f;
      }
      function Sg(n) {
        return n && n.length ? n[0] : i;
      }
      function aD(n, r, a) {
        var f = n == null ? 0 : n.length;
        if (!f)
          return -1;
        var l = a == null ? 0 : Dn(a);
        return l < 0 && (l = pr(f + l, 0)), la(n, r, l);
      }
      function uD(n) {
        var r = n == null ? 0 : n.length;
        return r ? pe(n, 0, -1) : [];
      }
      var oD = Rn(function(n) {
        var r = er(n, ol);
        return r.length && r[0] === n[0] ? Js(r) : [];
      }), fD = Rn(function(n) {
        var r = Ee(n), a = er(n, ol);
        return r === Ee(a) ? r = i : a.pop(), a.length && a[0] === n[0] ? Js(a, ln(r, 2)) : [];
      }), cD = Rn(function(n) {
        var r = Ee(n), a = er(n, ol);
        return r = typeof r == "function" ? r : i, r && a.pop(), a.length && a[0] === n[0] ? Js(a, i, r) : [];
      });
      function sD(n, r) {
        return n == null ? "" : u1.call(n, r);
      }
      function Ee(n) {
        var r = n == null ? 0 : n.length;
        return r ? n[r - 1] : i;
      }
      function lD(n, r, a) {
        var f = n == null ? 0 : n.length;
        if (!f)
          return -1;
        var l = f;
        return a !== i && (l = Dn(a), l = l < 0 ? pr(f + l, 0) : Mr(l, f - 1)), r === r ? zS(n, r, l) : qo(n, nh, l, !0);
      }
      function vD(n, r) {
        return n && n.length ? Ph(n, Dn(r)) : i;
      }
      var _D = Rn(Ng);
      function Ng(n, r) {
        return n && n.length && r && r.length ? rl(n, r) : n;
      }
      function dD(n, r, a) {
        return n && n.length && r && r.length ? rl(n, r, ln(a, 2)) : n;
      }
      function hD(n, r, a) {
        return n && n.length && r && r.length ? rl(n, r, i, a) : n;
      }
      var gD = et(function(n, r) {
        var a = n == null ? 0 : n.length, f = Xs(n, r);
        return bh(n, er(r, function(l) {
          return tt(l, a) ? +l : l;
        }).sort(zh)), f;
      });
      function pD(n, r) {
        var a = [];
        if (!(n && n.length))
          return a;
        var f = -1, l = [], g = n.length;
        for (r = ln(r, 3); ++f < g; ) {
          var N = n[f];
          r(N, f, n) && (a.push(N), l.push(f));
        }
        return bh(n, l), a;
      }
      function Nl(n) {
        return n == null ? n : s1.call(n);
      }
      function ED(n, r, a) {
        var f = n == null ? 0 : n.length;
        return f ? (a && typeof a != "number" && Hr(n, r, a) ? (r = 0, a = f) : (r = r == null ? 0 : Dn(r), a = a === i ? f : Dn(a)), pe(n, r, a)) : [];
      }
      function TD(n, r) {
        return vf(n, r);
      }
      function SD(n, r, a) {
        return il(n, r, ln(a, 2));
      }
      function ND(n, r) {
        var a = n == null ? 0 : n.length;
        if (a) {
          var f = vf(n, r);
          if (f < a && we(n[f], r))
            return f;
        }
        return -1;
      }
      function DD(n, r) {
        return vf(n, r, !0);
      }
      function ID(n, r, a) {
        return il(n, r, ln(a, 2), !0);
      }
      function AD(n, r) {
        var a = n == null ? 0 : n.length;
        if (a) {
          var f = vf(n, r, !0) - 1;
          if (we(n[f], r))
            return f;
        }
        return -1;
      }
      function RD(n) {
        return n && n.length ? Yh(n) : [];
      }
      function CD(n, r) {
        return n && n.length ? Yh(n, ln(r, 2)) : [];
      }
      function wD(n) {
        var r = n == null ? 0 : n.length;
        return r ? pe(n, 1, r) : [];
      }
      function yD(n, r, a) {
        return n && n.length ? (r = a || r === i ? 1 : Dn(r), pe(n, 0, r < 0 ? 0 : r)) : [];
      }
      function mD(n, r, a) {
        var f = n == null ? 0 : n.length;
        return f ? (r = a || r === i ? 1 : Dn(r), r = f - r, pe(n, r < 0 ? 0 : r, f)) : [];
      }
      function xD(n, r) {
        return n && n.length ? _f(n, ln(r, 3), !1, !0) : [];
      }
      function PD(n, r) {
        return n && n.length ? _f(n, ln(r, 3)) : [];
      }
      var OD = Rn(function(n) {
        return xt(yr(n, 1, sr, !0));
      }), LD = Rn(function(n) {
        var r = Ee(n);
        return sr(r) && (r = i), xt(yr(n, 1, sr, !0), ln(r, 2));
      }), bD = Rn(function(n) {
        var r = Ee(n);
        return r = typeof r == "function" ? r : i, xt(yr(n, 1, sr, !0), i, r);
      });
      function MD(n) {
        return n && n.length ? xt(n) : [];
      }
      function YD(n, r) {
        return n && n.length ? xt(n, ln(r, 2)) : [];
      }
      function UD(n, r) {
        return r = typeof r == "function" ? r : i, n && n.length ? xt(n, i, r) : [];
      }
      function Dl(n) {
        if (!(n && n.length))
          return [];
        var r = 0;
        return n = Rt(n, function(a) {
          if (sr(a))
            return r = pr(a.length, r), !0;
        }), Hs(r, function(a) {
          return er(n, Ys(a));
        });
      }
      function Dg(n, r) {
        if (!(n && n.length))
          return [];
        var a = Dl(n);
        return r == null ? a : er(a, function(f) {
          return ee(r, i, f);
        });
      }
      var FD = Rn(function(n, r) {
        return sr(n) ? Au(n, r) : [];
      }), HD = Rn(function(n) {
        return ul(Rt(n, sr));
      }), BD = Rn(function(n) {
        var r = Ee(n);
        return sr(r) && (r = i), ul(Rt(n, sr), ln(r, 2));
      }), kD = Rn(function(n) {
        var r = Ee(n);
        return r = typeof r == "function" ? r : i, ul(Rt(n, sr), i, r);
      }), GD = Rn(Dl);
      function WD(n, r) {
        return Bh(n || [], r || [], Iu);
      }
      function zD(n, r) {
        return Bh(n || [], r || [], wu);
      }
      var qD = Rn(function(n) {
        var r = n.length, a = r > 1 ? n[r - 1] : i;
        return a = typeof a == "function" ? (n.pop(), a) : i, Dg(n, a);
      });
      function Ig(n) {
        var r = _(n);
        return r.__chain__ = !0, r;
      }
      function KD(n, r) {
        return r(n), n;
      }
      function Df(n, r) {
        return r(n);
      }
      var XD = et(function(n) {
        var r = n.length, a = r ? n[0] : 0, f = this.__wrapped__, l = function(g) {
          return Xs(g, n);
        };
        return r > 1 || this.__actions__.length || !(f instanceof mn) || !tt(a) ? this.thru(l) : (f = f.slice(a, +a + (r ? 1 : 0)), f.__actions__.push({
          func: Df,
          args: [l],
          thisArg: i
        }), new he(f, this.__chain__).thru(function(g) {
          return r && !g.length && g.push(i), g;
        }));
      });
      function $D() {
        return Ig(this);
      }
      function VD() {
        return new he(this.value(), this.__chain__);
      }
      function ZD() {
        this.__values__ === i && (this.__values__ = Ug(this.value()));
        var n = this.__index__ >= this.__values__.length, r = n ? i : this.__values__[this.__index__++];
        return { done: n, value: r };
      }
      function JD() {
        return this;
      }
      function QD(n) {
        for (var r, a = this; a instanceof of; ) {
          var f = gg(a);
          f.__index__ = 0, f.__values__ = i, r ? l.__wrapped__ = f : r = f;
          var l = f;
          a = a.__wrapped__;
        }
        return l.__wrapped__ = n, r;
      }
      function jD() {
        var n = this.__wrapped__;
        if (n instanceof mn) {
          var r = n;
          return this.__actions__.length && (r = new mn(this)), r = r.reverse(), r.__actions__.push({
            func: Df,
            args: [Nl],
            thisArg: i
          }), new he(r, this.__chain__);
        }
        return this.thru(Nl);
      }
      function nI() {
        return Hh(this.__wrapped__, this.__actions__);
      }
      var rI = df(function(n, r, a) {
        Wn.call(n, a) ? ++n[a] : nt(n, a, 1);
      });
      function eI(n, r, a) {
        var f = Nn(n) ? Qd : K1;
        return a && Hr(n, r, a) && (r = i), f(n, ln(r, 3));
      }
      function tI(n, r) {
        var a = Nn(n) ? Rt : Dh;
        return a(n, ln(r, 3));
      }
      var iI = Zh(pg), aI = Zh(Eg);
      function uI(n, r) {
        return yr(If(n, r), 1);
      }
      function oI(n, r) {
        return yr(If(n, r), Mn);
      }
      function fI(n, r, a) {
        return a = a === i ? 1 : Dn(a), yr(If(n, r), a);
      }
      function Ag(n, r) {
        var a = Nn(n) ? _e : mt;
        return a(n, ln(r, 3));
      }
      function Rg(n, r) {
        var a = Nn(n) ? wS : Nh;
        return a(n, ln(r, 3));
      }
      var cI = df(function(n, r, a) {
        Wn.call(n, a) ? n[a].push(r) : nt(n, a, [r]);
      });
      function sI(n, r, a, f) {
        n = Vr(n) ? n : Ia(n), a = a && !f ? Dn(a) : 0;
        var l = n.length;
        return a < 0 && (a = pr(l + a, 0)), yf(n) ? a <= l && n.indexOf(r, a) > -1 : !!l && la(n, r, a) > -1;
      }
      var lI = Rn(function(n, r, a) {
        var f = -1, l = typeof r == "function", g = Vr(n) ? L(n.length) : [];
        return mt(n, function(N) {
          g[++f] = l ? ee(r, N, a) : Ru(N, r, a);
        }), g;
      }), vI = df(function(n, r, a) {
        nt(n, a, r);
      });
      function If(n, r) {
        var a = Nn(n) ? er : yh;
        return a(n, ln(r, 3));
      }
      function _I(n, r, a, f) {
        return n == null ? [] : (Nn(r) || (r = r == null ? [] : [r]), a = f ? i : a, Nn(a) || (a = a == null ? [] : [a]), Oh(n, r, a));
      }
      var dI = df(function(n, r, a) {
        n[a ? 0 : 1].push(r);
      }, function() {
        return [[], []];
      });
      function hI(n, r, a) {
        var f = Nn(n) ? bs : eh, l = arguments.length < 3;
        return f(n, ln(r, 4), a, l, mt);
      }
      function gI(n, r, a) {
        var f = Nn(n) ? yS : eh, l = arguments.length < 3;
        return f(n, ln(r, 4), a, l, Nh);
      }
      function pI(n, r) {
        var a = Nn(n) ? Rt : Dh;
        return a(n, Cf(ln(r, 3)));
      }
      function EI(n) {
        var r = Nn(n) ? ph : sN;
        return r(n);
      }
      function TI(n, r, a) {
        (a ? Hr(n, r, a) : r === i) ? r = 1 : r = Dn(r);
        var f = Nn(n) ? k1 : lN;
        return f(n, r);
      }
      function SI(n) {
        var r = Nn(n) ? G1 : _N;
        return r(n);
      }
      function NI(n) {
        if (n == null)
          return 0;
        if (Vr(n))
          return yf(n) ? _a(n) : n.length;
        var r = Yr(n);
        return r == Hn || r == an ? n.size : js(n).length;
      }
      function DI(n, r, a) {
        var f = Nn(n) ? Ms : dN;
        return a && Hr(n, r, a) && (r = i), f(n, ln(r, 3));
      }
      var II = Rn(function(n, r) {
        if (n == null)
          return [];
        var a = r.length;
        return a > 1 && Hr(n, r[0], r[1]) ? r = [] : a > 2 && Hr(r[0], r[1], r[2]) && (r = [r[0]]), Oh(n, yr(r, 1), []);
      }), Af = t1 || function() {
        return wr.Date.now();
      };
      function AI(n, r) {
        if (typeof r != "function")
          throw new de(s);
        return n = Dn(n), function() {
          if (--n < 1)
            return r.apply(this, arguments);
        };
      }
      function Cg(n, r, a) {
        return r = a ? i : r, r = n && r == null ? n.length : r, rt(n, k, i, i, i, i, r);
      }
      function wg(n, r) {
        var a;
        if (typeof r != "function")
          throw new de(s);
        return n = Dn(n), function() {
          return --n > 0 && (a = r.apply(this, arguments)), n <= 1 && (r = i), a;
        };
      }
      var Il = Rn(function(n, r, a) {
        var f = E;
        if (a.length) {
          var l = wt(a, Na(Il));
          f |= j;
        }
        return rt(n, f, r, a, l);
      }), yg = Rn(function(n, r, a) {
        var f = E | b;
        if (a.length) {
          var l = wt(a, Na(yg));
          f |= j;
        }
        return rt(r, f, n, a, l);
      });
      function mg(n, r, a) {
        r = a ? i : r;
        var f = rt(n, F, i, i, i, i, i, r);
        return f.placeholder = mg.placeholder, f;
      }
      function xg(n, r, a) {
        r = a ? i : r;
        var f = rt(n, y, i, i, i, i, i, r);
        return f.placeholder = xg.placeholder, f;
      }
      function Pg(n, r, a) {
        var f, l, g, N, A, w, B = 0, G = !1, z = !1, nn = !0;
        if (typeof n != "function")
          throw new de(s);
        r = Te(r) || 0, ur(a) && (G = !!a.leading, z = "maxWait" in a, g = z ? pr(Te(a.maxWait) || 0, r) : g, nn = "trailing" in a ? !!a.trailing : nn);
        function fn(lr) {
          var ye = f, ut = l;
          return f = l = i, B = lr, N = n.apply(ut, ye), N;
        }
        function vn(lr) {
          return B = lr, A = xu(yn, r), G ? fn(lr) : N;
        }
        function In(lr) {
          var ye = lr - w, ut = lr - B, Zg = r - ye;
          return z ? Mr(Zg, g - ut) : Zg;
        }
        function _n(lr) {
          var ye = lr - w, ut = lr - B;
          return w === i || ye >= r || ye < 0 || z && ut >= g;
        }
        function yn() {
          var lr = Af();
          if (_n(lr))
            return Ln(lr);
          A = xu(yn, In(lr));
        }
        function Ln(lr) {
          return A = i, nn && f ? fn(lr) : (f = l = i, N);
        }
        function ue() {
          A !== i && kh(A), B = 0, f = w = l = A = i;
        }
        function Br() {
          return A === i ? N : Ln(Af());
        }
        function oe() {
          var lr = Af(), ye = _n(lr);
          if (f = arguments, l = this, w = lr, ye) {
            if (A === i)
              return vn(w);
            if (z)
              return kh(A), A = xu(yn, r), fn(w);
          }
          return A === i && (A = xu(yn, r)), N;
        }
        return oe.cancel = ue, oe.flush = Br, oe;
      }
      var RI = Rn(function(n, r) {
        return Sh(n, 1, r);
      }), CI = Rn(function(n, r, a) {
        return Sh(n, Te(r) || 0, a);
      });
      function wI(n) {
        return rt(n, Zn);
      }
      function Rf(n, r) {
        if (typeof n != "function" || r != null && typeof r != "function")
          throw new de(s);
        var a = function() {
          var f = arguments, l = r ? r.apply(this, f) : f[0], g = a.cache;
          if (g.has(l))
            return g.get(l);
          var N = n.apply(this, f);
          return a.cache = g.set(l, N) || g, N;
        };
        return a.cache = new (Rf.Cache || je)(), a;
      }
      Rf.Cache = je;
      function Cf(n) {
        if (typeof n != "function")
          throw new de(s);
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, r[0]);
            case 2:
              return !n.call(this, r[0], r[1]);
            case 3:
              return !n.call(this, r[0], r[1], r[2]);
          }
          return !n.apply(this, r);
        };
      }
      function yI(n) {
        return wg(2, n);
      }
      var mI = hN(function(n, r) {
        r = r.length == 1 && Nn(r[0]) ? er(r[0], te(ln())) : er(yr(r, 1), te(ln()));
        var a = r.length;
        return Rn(function(f) {
          for (var l = -1, g = Mr(f.length, a); ++l < g; )
            f[l] = r[l].call(this, f[l]);
          return ee(n, this, f);
        });
      }), Al = Rn(function(n, r) {
        var a = wt(r, Na(Al));
        return rt(n, j, i, r, a);
      }), Og = Rn(function(n, r) {
        var a = wt(r, Na(Og));
        return rt(n, un, i, r, a);
      }), xI = et(function(n, r) {
        return rt(n, On, i, i, i, r);
      });
      function PI(n, r) {
        if (typeof n != "function")
          throw new de(s);
        return r = r === i ? r : Dn(r), Rn(n, r);
      }
      function OI(n, r) {
        if (typeof n != "function")
          throw new de(s);
        return r = r == null ? 0 : pr(Dn(r), 0), Rn(function(a) {
          var f = a[r], l = Ot(a, 0, r);
          return f && Ct(l, f), ee(n, this, l);
        });
      }
      function LI(n, r, a) {
        var f = !0, l = !0;
        if (typeof n != "function")
          throw new de(s);
        return ur(a) && (f = "leading" in a ? !!a.leading : f, l = "trailing" in a ? !!a.trailing : l), Pg(n, r, {
          leading: f,
          maxWait: r,
          trailing: l
        });
      }
      function bI(n) {
        return Cg(n, 1);
      }
      function MI(n, r) {
        return Al(fl(r), n);
      }
      function YI() {
        if (!arguments.length)
          return [];
        var n = arguments[0];
        return Nn(n) ? n : [n];
      }
      function UI(n) {
        return ge(n, T);
      }
      function FI(n, r) {
        return r = typeof r == "function" ? r : i, ge(n, T, r);
      }
      function HI(n) {
        return ge(n, S | T);
      }
      function BI(n, r) {
        return r = typeof r == "function" ? r : i, ge(n, S | T, r);
      }
      function kI(n, r) {
        return r == null || Th(n, r, Ar(r));
      }
      function we(n, r) {
        return n === r || n !== n && r !== r;
      }
      var GI = Ef(Zs), WI = Ef(function(n, r) {
        return n >= r;
      }), Ii = Rh(function() {
        return arguments;
      }()) ? Rh : function(n) {
        return fr(n) && Wn.call(n, "callee") && !lh.call(n, "callee");
      }, Nn = L.isArray, zI = Kd ? te(Kd) : Q1;
      function Vr(n) {
        return n != null && wf(n.length) && !it(n);
      }
      function sr(n) {
        return fr(n) && Vr(n);
      }
      function qI(n) {
        return n === !0 || n === !1 || fr(n) && Fr(n) == J;
      }
      var Lt = a1 || Ml, KI = Xd ? te(Xd) : j1;
      function XI(n) {
        return fr(n) && n.nodeType === 1 && !Pu(n);
      }
      function $I(n) {
        if (n == null)
          return !0;
        if (Vr(n) && (Nn(n) || typeof n == "string" || typeof n.splice == "function" || Lt(n) || Da(n) || Ii(n)))
          return !n.length;
        var r = Yr(n);
        if (r == Hn || r == an)
          return !n.size;
        if (mu(n))
          return !js(n).length;
        for (var a in n)
          if (Wn.call(n, a))
            return !1;
        return !0;
      }
      function VI(n, r) {
        return Cu(n, r);
      }
      function ZI(n, r, a) {
        a = typeof a == "function" ? a : i;
        var f = a ? a(n, r) : i;
        return f === i ? Cu(n, r, i, a) : !!f;
      }
      function Rl(n) {
        if (!fr(n))
          return !1;
        var r = Fr(n);
        return r == gn || r == pn || typeof n.message == "string" && typeof n.name == "string" && !Pu(n);
      }
      function JI(n) {
        return typeof n == "number" && _h(n);
      }
      function it(n) {
        if (!ur(n))
          return !1;
        var r = Fr(n);
        return r == zn || r == cr || r == W || r == K;
      }
      function Lg(n) {
        return typeof n == "number" && n == Dn(n);
      }
      function wf(n) {
        return typeof n == "number" && n > -1 && n % 1 == 0 && n <= rr;
      }
      function ur(n) {
        var r = typeof n;
        return n != null && (r == "object" || r == "function");
      }
      function fr(n) {
        return n != null && typeof n == "object";
      }
      var bg = $d ? te($d) : rN;
      function QI(n, r) {
        return n === r || Qs(n, r, hl(r));
      }
      function jI(n, r, a) {
        return a = typeof a == "function" ? a : i, Qs(n, r, hl(r), a);
      }
      function nA(n) {
        return Mg(n) && n != +n;
      }
      function rA(n) {
        if (FN(n))
          throw new Tn(c);
        return Ch(n);
      }
      function eA(n) {
        return n === null;
      }
      function tA(n) {
        return n == null;
      }
      function Mg(n) {
        return typeof n == "number" || fr(n) && Fr(n) == $n;
      }
      function Pu(n) {
        if (!fr(n) || Fr(n) != H)
          return !1;
        var r = jo(n);
        if (r === null)
          return !0;
        var a = Wn.call(r, "constructor") && r.constructor;
        return typeof a == "function" && a instanceof a && Vo.call(a) == jS;
      }
      var Cl = Vd ? te(Vd) : eN;
      function iA(n) {
        return Lg(n) && n >= -rr && n <= rr;
      }
      var Yg = Zd ? te(Zd) : tN;
      function yf(n) {
        return typeof n == "string" || !Nn(n) && fr(n) && Fr(n) == sn;
      }
      function ae(n) {
        return typeof n == "symbol" || fr(n) && Fr(n) == wn;
      }
      var Da = Jd ? te(Jd) : iN;
      function aA(n) {
        return n === i;
      }
      function uA(n) {
        return fr(n) && Yr(n) == Yn;
      }
      function oA(n) {
        return fr(n) && Fr(n) == ar;
      }
      var fA = Ef(nl), cA = Ef(function(n, r) {
        return n <= r;
      });
      function Ug(n) {
        if (!n)
          return [];
        if (Vr(n))
          return yf(n) ? Re(n) : $r(n);
        if (Eu && n[Eu])
          return kS(n[Eu]());
        var r = Yr(n), a = r == Hn ? ks : r == an ? Ko : Ia;
        return a(n);
      }
      function at(n) {
        if (!n)
          return n === 0 ? n : 0;
        if (n = Te(n), n === Mn || n === -Mn) {
          var r = n < 0 ? -1 : 1;
          return r * M;
        }
        return n === n ? n : 0;
      }
      function Dn(n) {
        var r = at(n), a = r % 1;
        return r === r ? a ? r - a : r : 0;
      }
      function Fg(n) {
        return n ? Ti(Dn(n), 0, Z) : 0;
      }
      function Te(n) {
        if (typeof n == "number")
          return n;
        if (ae(n))
          return q;
        if (ur(n)) {
          var r = typeof n.valueOf == "function" ? n.valueOf() : n;
          n = ur(r) ? r + "" : r;
        }
        if (typeof n != "string")
          return n === 0 ? n : +n;
        n = th(n);
        var a = zT.test(n);
        return a || KT.test(n) ? AS(n.slice(2), a ? 2 : 8) : WT.test(n) ? q : +n;
      }
      function Hg(n) {
        return Be(n, Zr(n));
      }
      function sA(n) {
        return n ? Ti(Dn(n), -rr, rr) : n === 0 ? n : 0;
      }
      function Bn(n) {
        return n == null ? "" : ie(n);
      }
      var lA = Ta(function(n, r) {
        if (mu(r) || Vr(r)) {
          Be(r, Ar(r), n);
          return;
        }
        for (var a in r)
          Wn.call(r, a) && Iu(n, a, r[a]);
      }), Bg = Ta(function(n, r) {
        Be(r, Zr(r), n);
      }), mf = Ta(function(n, r, a, f) {
        Be(r, Zr(r), n, f);
      }), vA = Ta(function(n, r, a, f) {
        Be(r, Ar(r), n, f);
      }), _A = et(Xs);
      function dA(n, r) {
        var a = Ea(n);
        return r == null ? a : Eh(a, r);
      }
      var hA = Rn(function(n, r) {
        n = qn(n);
        var a = -1, f = r.length, l = f > 2 ? r[2] : i;
        for (l && Hr(r[0], r[1], l) && (f = 1); ++a < f; )
          for (var g = r[a], N = Zr(g), A = -1, w = N.length; ++A < w; ) {
            var B = N[A], G = n[B];
            (G === i || we(G, ha[B]) && !Wn.call(n, B)) && (n[B] = g[B]);
          }
        return n;
      }), gA = Rn(function(n) {
        return n.push(i, tg), ee(kg, i, n);
      });
      function pA(n, r) {
        return jd(n, ln(r, 3), He);
      }
      function EA(n, r) {
        return jd(n, ln(r, 3), Vs);
      }
      function TA(n, r) {
        return n == null ? n : $s(n, ln(r, 3), Zr);
      }
      function SA(n, r) {
        return n == null ? n : Ih(n, ln(r, 3), Zr);
      }
      function NA(n, r) {
        return n && He(n, ln(r, 3));
      }
      function DA(n, r) {
        return n && Vs(n, ln(r, 3));
      }
      function IA(n) {
        return n == null ? [] : sf(n, Ar(n));
      }
      function AA(n) {
        return n == null ? [] : sf(n, Zr(n));
      }
      function wl(n, r, a) {
        var f = n == null ? i : Si(n, r);
        return f === i ? a : f;
      }
      function RA(n, r) {
        return n != null && ug(n, r, $1);
      }
      function yl(n, r) {
        return n != null && ug(n, r, V1);
      }
      var CA = Qh(function(n, r, a) {
        r != null && typeof r.toString != "function" && (r = Zo.call(r)), n[r] = a;
      }, xl(Jr)), wA = Qh(function(n, r, a) {
        r != null && typeof r.toString != "function" && (r = Zo.call(r)), Wn.call(n, r) ? n[r].push(a) : n[r] = [a];
      }, ln), yA = Rn(Ru);
      function Ar(n) {
        return Vr(n) ? gh(n) : js(n);
      }
      function Zr(n) {
        return Vr(n) ? gh(n, !0) : aN(n);
      }
      function mA(n, r) {
        var a = {};
        return r = ln(r, 3), He(n, function(f, l, g) {
          nt(a, r(f, l, g), f);
        }), a;
      }
      function xA(n, r) {
        var a = {};
        return r = ln(r, 3), He(n, function(f, l, g) {
          nt(a, l, r(f, l, g));
        }), a;
      }
      var PA = Ta(function(n, r, a) {
        lf(n, r, a);
      }), kg = Ta(function(n, r, a, f) {
        lf(n, r, a, f);
      }), OA = et(function(n, r) {
        var a = {};
        if (n == null)
          return a;
        var f = !1;
        r = er(r, function(g) {
          return g = Pt(g, n), f || (f = g.length > 1), g;
        }), Be(n, _l(n), a), f && (a = ge(a, S | I | T, CN));
        for (var l = r.length; l--; )
          al(a, r[l]);
        return a;
      });
      function LA(n, r) {
        return Gg(n, Cf(ln(r)));
      }
      var bA = et(function(n, r) {
        return n == null ? {} : oN(n, r);
      });
      function Gg(n, r) {
        if (n == null)
          return {};
        var a = er(_l(n), function(f) {
          return [f];
        });
        return r = ln(r), Lh(n, a, function(f, l) {
          return r(f, l[0]);
        });
      }
      function MA(n, r, a) {
        r = Pt(r, n);
        var f = -1, l = r.length;
        for (l || (l = 1, n = i); ++f < l; ) {
          var g = n == null ? i : n[ke(r[f])];
          g === i && (f = l, g = a), n = it(g) ? g.call(n) : g;
        }
        return n;
      }
      function YA(n, r, a) {
        return n == null ? n : wu(n, r, a);
      }
      function UA(n, r, a, f) {
        return f = typeof f == "function" ? f : i, n == null ? n : wu(n, r, a, f);
      }
      var Wg = rg(Ar), zg = rg(Zr);
      function FA(n, r, a) {
        var f = Nn(n), l = f || Lt(n) || Da(n);
        if (r = ln(r, 4), a == null) {
          var g = n && n.constructor;
          l ? a = f ? new g() : [] : ur(n) ? a = it(g) ? Ea(jo(n)) : {} : a = {};
        }
        return (l ? _e : He)(n, function(N, A, w) {
          return r(a, N, A, w);
        }), a;
      }
      function HA(n, r) {
        return n == null ? !0 : al(n, r);
      }
      function BA(n, r, a) {
        return n == null ? n : Fh(n, r, fl(a));
      }
      function kA(n, r, a, f) {
        return f = typeof f == "function" ? f : i, n == null ? n : Fh(n, r, fl(a), f);
      }
      function Ia(n) {
        return n == null ? [] : Bs(n, Ar(n));
      }
      function GA(n) {
        return n == null ? [] : Bs(n, Zr(n));
      }
      function WA(n, r, a) {
        return a === i && (a = r, r = i), a !== i && (a = Te(a), a = a === a ? a : 0), r !== i && (r = Te(r), r = r === r ? r : 0), Ti(Te(n), r, a);
      }
      function zA(n, r, a) {
        return r = at(r), a === i ? (a = r, r = 0) : a = at(a), n = Te(n), Z1(n, r, a);
      }
      function qA(n, r, a) {
        if (a && typeof a != "boolean" && Hr(n, r, a) && (r = a = i), a === i && (typeof r == "boolean" ? (a = r, r = i) : typeof n == "boolean" && (a = n, n = i)), n === i && r === i ? (n = 0, r = 1) : (n = at(n), r === i ? (r = n, n = 0) : r = at(r)), n > r) {
          var f = n;
          n = r, r = f;
        }
        if (a || n % 1 || r % 1) {
          var l = dh();
          return Mr(n + l * (r - n + IS("1e-" + ((l + "").length - 1))), r);
        }
        return el(n, r);
      }
      var KA = Sa(function(n, r, a) {
        return r = r.toLowerCase(), n + (a ? qg(r) : r);
      });
      function qg(n) {
        return ml(Bn(n).toLowerCase());
      }
      function Kg(n) {
        return n = Bn(n), n && n.replace($T, YS).replace(_S, "");
      }
      function XA(n, r, a) {
        n = Bn(n), r = ie(r);
        var f = n.length;
        a = a === i ? f : Ti(Dn(a), 0, f);
        var l = a;
        return a -= r.length, a >= 0 && n.slice(a, l) == r;
      }
      function $A(n) {
        return n = Bn(n), n && yT.test(n) ? n.replace(Id, US) : n;
      }
      function VA(n) {
        return n = Bn(n), n && bT.test(n) ? n.replace(As, "\\$&") : n;
      }
      var ZA = Sa(function(n, r, a) {
        return n + (a ? "-" : "") + r.toLowerCase();
      }), JA = Sa(function(n, r, a) {
        return n + (a ? " " : "") + r.toLowerCase();
      }), QA = Vh("toLowerCase");
      function jA(n, r, a) {
        n = Bn(n), r = Dn(r);
        var f = r ? _a(n) : 0;
        if (!r || f >= r)
          return n;
        var l = (r - f) / 2;
        return pf(tf(l), a) + n + pf(ef(l), a);
      }
      function nR(n, r, a) {
        n = Bn(n), r = Dn(r);
        var f = r ? _a(n) : 0;
        return r && f < r ? n + pf(r - f, a) : n;
      }
      function rR(n, r, a) {
        n = Bn(n), r = Dn(r);
        var f = r ? _a(n) : 0;
        return r && f < r ? pf(r - f, a) + n : n;
      }
      function eR(n, r, a) {
        return a || r == null ? r = 0 : r && (r = +r), c1(Bn(n).replace(Rs, ""), r || 0);
      }
      function tR(n, r, a) {
        return (a ? Hr(n, r, a) : r === i) ? r = 1 : r = Dn(r), tl(Bn(n), r);
      }
      function iR() {
        var n = arguments, r = Bn(n[0]);
        return n.length < 3 ? r : r.replace(n[1], n[2]);
      }
      var aR = Sa(function(n, r, a) {
        return n + (a ? "_" : "") + r.toLowerCase();
      });
      function uR(n, r, a) {
        return a && typeof a != "number" && Hr(n, r, a) && (r = a = i), a = a === i ? Z : a >>> 0, a ? (n = Bn(n), n && (typeof r == "string" || r != null && !Cl(r)) && (r = ie(r), !r && va(n)) ? Ot(Re(n), 0, a) : n.split(r, a)) : [];
      }
      var oR = Sa(function(n, r, a) {
        return n + (a ? " " : "") + ml(r);
      });
      function fR(n, r, a) {
        return n = Bn(n), a = a == null ? 0 : Ti(Dn(a), 0, n.length), r = ie(r), n.slice(a, a + r.length) == r;
      }
      function cR(n, r, a) {
        var f = _.templateSettings;
        a && Hr(n, r, a) && (r = i), n = Bn(n), r = mf({}, r, f, eg);
        var l = mf({}, r.imports, f.imports, eg), g = Ar(l), N = Bs(l, g), A, w, B = 0, G = r.interpolate || ko, z = "__p += '", nn = Gs(
          (r.escape || ko).source + "|" + G.source + "|" + (G === Ad ? GT : ko).source + "|" + (r.evaluate || ko).source + "|$",
          "g"
        ), fn = "//# sourceURL=" + (Wn.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ES + "]") + `
`;
        n.replace(nn, function(_n, yn, Ln, ue, Br, oe) {
          return Ln || (Ln = ue), z += n.slice(B, oe).replace(VT, FS), yn && (A = !0, z += `' +
__e(` + yn + `) +
'`), Br && (w = !0, z += `';
` + Br + `;
__p += '`), Ln && (z += `' +
((__t = (` + Ln + `)) == null ? '' : __t) +
'`), B = oe + _n.length, _n;
        }), z += `';
`;
        var vn = Wn.call(r, "variable") && r.variable;
        if (!vn)
          z = `with (obj) {
` + z + `
}
`;
        else if (BT.test(vn))
          throw new Tn(v);
        z = (w ? z.replace(AT, "") : z).replace(RT, "$1").replace(CT, "$1;"), z = "function(" + (vn || "obj") + `) {
` + (vn ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (A ? ", __e = _.escape" : "") + (w ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + z + `return __p
}`;
        var In = $g(function() {
          return Un(g, fn + "return " + z).apply(i, N);
        });
        if (In.source = z, Rl(In))
          throw In;
        return In;
      }
      function sR(n) {
        return Bn(n).toLowerCase();
      }
      function lR(n) {
        return Bn(n).toUpperCase();
      }
      function vR(n, r, a) {
        if (n = Bn(n), n && (a || r === i))
          return th(n);
        if (!n || !(r = ie(r)))
          return n;
        var f = Re(n), l = Re(r), g = ih(f, l), N = ah(f, l) + 1;
        return Ot(f, g, N).join("");
      }
      function _R(n, r, a) {
        if (n = Bn(n), n && (a || r === i))
          return n.slice(0, oh(n) + 1);
        if (!n || !(r = ie(r)))
          return n;
        var f = Re(n), l = ah(f, Re(r)) + 1;
        return Ot(f, 0, l).join("");
      }
      function dR(n, r, a) {
        if (n = Bn(n), n && (a || r === i))
          return n.replace(Rs, "");
        if (!n || !(r = ie(r)))
          return n;
        var f = Re(n), l = ih(f, Re(r));
        return Ot(f, l).join("");
      }
      function hR(n, r) {
        var a = or, f = on;
        if (ur(r)) {
          var l = "separator" in r ? r.separator : l;
          a = "length" in r ? Dn(r.length) : a, f = "omission" in r ? ie(r.omission) : f;
        }
        n = Bn(n);
        var g = n.length;
        if (va(n)) {
          var N = Re(n);
          g = N.length;
        }
        if (a >= g)
          return n;
        var A = a - _a(f);
        if (A < 1)
          return f;
        var w = N ? Ot(N, 0, A).join("") : n.slice(0, A);
        if (l === i)
          return w + f;
        if (N && (A += w.length - A), Cl(l)) {
          if (n.slice(A).search(l)) {
            var B, G = w;
            for (l.global || (l = Gs(l.source, Bn(Rd.exec(l)) + "g")), l.lastIndex = 0; B = l.exec(G); )
              var z = B.index;
            w = w.slice(0, z === i ? A : z);
          }
        } else if (n.indexOf(ie(l), A) != A) {
          var nn = w.lastIndexOf(l);
          nn > -1 && (w = w.slice(0, nn));
        }
        return w + f;
      }
      function gR(n) {
        return n = Bn(n), n && wT.test(n) ? n.replace(Dd, qS) : n;
      }
      var pR = Sa(function(n, r, a) {
        return n + (a ? " " : "") + r.toUpperCase();
      }), ml = Vh("toUpperCase");
      function Xg(n, r, a) {
        return n = Bn(n), r = a ? i : r, r === i ? BS(n) ? $S(n) : PS(n) : n.match(r) || [];
      }
      var $g = Rn(function(n, r) {
        try {
          return ee(n, i, r);
        } catch (a) {
          return Rl(a) ? a : new Tn(a);
        }
      }), ER = et(function(n, r) {
        return _e(r, function(a) {
          a = ke(a), nt(n, a, Il(n[a], n));
        }), n;
      });
      function TR(n) {
        var r = n == null ? 0 : n.length, a = ln();
        return n = r ? er(n, function(f) {
          if (typeof f[1] != "function")
            throw new de(s);
          return [a(f[0]), f[1]];
        }) : [], Rn(function(f) {
          for (var l = -1; ++l < r; ) {
            var g = n[l];
            if (ee(g[0], this, f))
              return ee(g[1], this, f);
          }
        });
      }
      function SR(n) {
        return q1(ge(n, S));
      }
      function xl(n) {
        return function() {
          return n;
        };
      }
      function NR(n, r) {
        return n == null || n !== n ? r : n;
      }
      var DR = Jh(), IR = Jh(!0);
      function Jr(n) {
        return n;
      }
      function Pl(n) {
        return wh(typeof n == "function" ? n : ge(n, S));
      }
      function AR(n) {
        return mh(ge(n, S));
      }
      function RR(n, r) {
        return xh(n, ge(r, S));
      }
      var CR = Rn(function(n, r) {
        return function(a) {
          return Ru(a, n, r);
        };
      }), wR = Rn(function(n, r) {
        return function(a) {
          return Ru(n, a, r);
        };
      });
      function Ol(n, r, a) {
        var f = Ar(r), l = sf(r, f);
        a == null && !(ur(r) && (l.length || !f.length)) && (a = r, r = n, n = this, l = sf(r, Ar(r)));
        var g = !(ur(a) && "chain" in a) || !!a.chain, N = it(n);
        return _e(l, function(A) {
          var w = r[A];
          n[A] = w, N && (n.prototype[A] = function() {
            var B = this.__chain__;
            if (g || B) {
              var G = n(this.__wrapped__), z = G.__actions__ = $r(this.__actions__);
              return z.push({ func: w, args: arguments, thisArg: n }), G.__chain__ = B, G;
            }
            return w.apply(n, Ct([this.value()], arguments));
          });
        }), n;
      }
      function yR() {
        return wr._ === this && (wr._ = n1), this;
      }
      function Ll() {
      }
      function mR(n) {
        return n = Dn(n), Rn(function(r) {
          return Ph(r, n);
        });
      }
      var xR = sl(er), PR = sl(Qd), OR = sl(Ms);
      function Vg(n) {
        return pl(n) ? Ys(ke(n)) : fN(n);
      }
      function LR(n) {
        return function(r) {
          return n == null ? i : Si(n, r);
        };
      }
      var bR = jh(), MR = jh(!0);
      function bl() {
        return [];
      }
      function Ml() {
        return !1;
      }
      function YR() {
        return {};
      }
      function UR() {
        return "";
      }
      function FR() {
        return !0;
      }
      function HR(n, r) {
        if (n = Dn(n), n < 1 || n > rr)
          return [];
        var a = Z, f = Mr(n, Z);
        r = ln(r), n -= Z;
        for (var l = Hs(f, r); ++a < n; )
          r(a);
        return l;
      }
      function BR(n) {
        return Nn(n) ? er(n, ke) : ae(n) ? [n] : $r(hg(Bn(n)));
      }
      function kR(n) {
        var r = ++QS;
        return Bn(n) + r;
      }
      var GR = gf(function(n, r) {
        return n + r;
      }, 0), WR = ll("ceil"), zR = gf(function(n, r) {
        return n / r;
      }, 1), qR = ll("floor");
      function KR(n) {
        return n && n.length ? cf(n, Jr, Zs) : i;
      }
      function XR(n, r) {
        return n && n.length ? cf(n, ln(r, 2), Zs) : i;
      }
      function $R(n) {
        return rh(n, Jr);
      }
      function VR(n, r) {
        return rh(n, ln(r, 2));
      }
      function ZR(n) {
        return n && n.length ? cf(n, Jr, nl) : i;
      }
      function JR(n, r) {
        return n && n.length ? cf(n, ln(r, 2), nl) : i;
      }
      var QR = gf(function(n, r) {
        return n * r;
      }, 1), jR = ll("round"), nC = gf(function(n, r) {
        return n - r;
      }, 0);
      function rC(n) {
        return n && n.length ? Fs(n, Jr) : 0;
      }
      function eC(n, r) {
        return n && n.length ? Fs(n, ln(r, 2)) : 0;
      }
      return _.after = AI, _.ary = Cg, _.assign = lA, _.assignIn = Bg, _.assignInWith = mf, _.assignWith = vA, _.at = _A, _.before = wg, _.bind = Il, _.bindAll = ER, _.bindKey = yg, _.castArray = YI, _.chain = Ig, _.chunk = qN, _.compact = KN, _.concat = XN, _.cond = TR, _.conforms = SR, _.constant = xl, _.countBy = rI, _.create = dA, _.curry = mg, _.curryRight = xg, _.debounce = Pg, _.defaults = hA, _.defaultsDeep = gA, _.defer = RI, _.delay = CI, _.difference = $N, _.differenceBy = VN, _.differenceWith = ZN, _.drop = JN, _.dropRight = QN, _.dropRightWhile = jN, _.dropWhile = nD, _.fill = rD, _.filter = tI, _.flatMap = uI, _.flatMapDeep = oI, _.flatMapDepth = fI, _.flatten = Tg, _.flattenDeep = eD, _.flattenDepth = tD, _.flip = wI, _.flow = DR, _.flowRight = IR, _.fromPairs = iD, _.functions = IA, _.functionsIn = AA, _.groupBy = cI, _.initial = uD, _.intersection = oD, _.intersectionBy = fD, _.intersectionWith = cD, _.invert = CA, _.invertBy = wA, _.invokeMap = lI, _.iteratee = Pl, _.keyBy = vI, _.keys = Ar, _.keysIn = Zr, _.map = If, _.mapKeys = mA, _.mapValues = xA, _.matches = AR, _.matchesProperty = RR, _.memoize = Rf, _.merge = PA, _.mergeWith = kg, _.method = CR, _.methodOf = wR, _.mixin = Ol, _.negate = Cf, _.nthArg = mR, _.omit = OA, _.omitBy = LA, _.once = yI, _.orderBy = _I, _.over = xR, _.overArgs = mI, _.overEvery = PR, _.overSome = OR, _.partial = Al, _.partialRight = Og, _.partition = dI, _.pick = bA, _.pickBy = Gg, _.property = Vg, _.propertyOf = LR, _.pull = _D, _.pullAll = Ng, _.pullAllBy = dD, _.pullAllWith = hD, _.pullAt = gD, _.range = bR, _.rangeRight = MR, _.rearg = xI, _.reject = pI, _.remove = pD, _.rest = PI, _.reverse = Nl, _.sampleSize = TI, _.set = YA, _.setWith = UA, _.shuffle = SI, _.slice = ED, _.sortBy = II, _.sortedUniq = RD, _.sortedUniqBy = CD, _.split = uR, _.spread = OI, _.tail = wD, _.take = yD, _.takeRight = mD, _.takeRightWhile = xD, _.takeWhile = PD, _.tap = KD, _.throttle = LI, _.thru = Df, _.toArray = Ug, _.toPairs = Wg, _.toPairsIn = zg, _.toPath = BR, _.toPlainObject = Hg, _.transform = FA, _.unary = bI, _.union = OD, _.unionBy = LD, _.unionWith = bD, _.uniq = MD, _.uniqBy = YD, _.uniqWith = UD, _.unset = HA, _.unzip = Dl, _.unzipWith = Dg, _.update = BA, _.updateWith = kA, _.values = Ia, _.valuesIn = GA, _.without = FD, _.words = Xg, _.wrap = MI, _.xor = HD, _.xorBy = BD, _.xorWith = kD, _.zip = GD, _.zipObject = WD, _.zipObjectDeep = zD, _.zipWith = qD, _.entries = Wg, _.entriesIn = zg, _.extend = Bg, _.extendWith = mf, Ol(_, _), _.add = GR, _.attempt = $g, _.camelCase = KA, _.capitalize = qg, _.ceil = WR, _.clamp = WA, _.clone = UI, _.cloneDeep = HI, _.cloneDeepWith = BI, _.cloneWith = FI, _.conformsTo = kI, _.deburr = Kg, _.defaultTo = NR, _.divide = zR, _.endsWith = XA, _.eq = we, _.escape = $A, _.escapeRegExp = VA, _.every = eI, _.find = iI, _.findIndex = pg, _.findKey = pA, _.findLast = aI, _.findLastIndex = Eg, _.findLastKey = EA, _.floor = qR, _.forEach = Ag, _.forEachRight = Rg, _.forIn = TA, _.forInRight = SA, _.forOwn = NA, _.forOwnRight = DA, _.get = wl, _.gt = GI, _.gte = WI, _.has = RA, _.hasIn = yl, _.head = Sg, _.identity = Jr, _.includes = sI, _.indexOf = aD, _.inRange = zA, _.invoke = yA, _.isArguments = Ii, _.isArray = Nn, _.isArrayBuffer = zI, _.isArrayLike = Vr, _.isArrayLikeObject = sr, _.isBoolean = qI, _.isBuffer = Lt, _.isDate = KI, _.isElement = XI, _.isEmpty = $I, _.isEqual = VI, _.isEqualWith = ZI, _.isError = Rl, _.isFinite = JI, _.isFunction = it, _.isInteger = Lg, _.isLength = wf, _.isMap = bg, _.isMatch = QI, _.isMatchWith = jI, _.isNaN = nA, _.isNative = rA, _.isNil = tA, _.isNull = eA, _.isNumber = Mg, _.isObject = ur, _.isObjectLike = fr, _.isPlainObject = Pu, _.isRegExp = Cl, _.isSafeInteger = iA, _.isSet = Yg, _.isString = yf, _.isSymbol = ae, _.isTypedArray = Da, _.isUndefined = aA, _.isWeakMap = uA, _.isWeakSet = oA, _.join = sD, _.kebabCase = ZA, _.last = Ee, _.lastIndexOf = lD, _.lowerCase = JA, _.lowerFirst = QA, _.lt = fA, _.lte = cA, _.max = KR, _.maxBy = XR, _.mean = $R, _.meanBy = VR, _.min = ZR, _.minBy = JR, _.stubArray = bl, _.stubFalse = Ml, _.stubObject = YR, _.stubString = UR, _.stubTrue = FR, _.multiply = QR, _.nth = vD, _.noConflict = yR, _.noop = Ll, _.now = Af, _.pad = jA, _.padEnd = nR, _.padStart = rR, _.parseInt = eR, _.random = qA, _.reduce = hI, _.reduceRight = gI, _.repeat = tR, _.replace = iR, _.result = MA, _.round = jR, _.runInContext = C, _.sample = EI, _.size = NI, _.snakeCase = aR, _.some = DI, _.sortedIndex = TD, _.sortedIndexBy = SD, _.sortedIndexOf = ND, _.sortedLastIndex = DD, _.sortedLastIndexBy = ID, _.sortedLastIndexOf = AD, _.startCase = oR, _.startsWith = fR, _.subtract = nC, _.sum = rC, _.sumBy = eC, _.template = cR, _.times = HR, _.toFinite = at, _.toInteger = Dn, _.toLength = Fg, _.toLower = sR, _.toNumber = Te, _.toSafeInteger = sA, _.toString = Bn, _.toUpper = lR, _.trim = vR, _.trimEnd = _R, _.trimStart = dR, _.truncate = hR, _.unescape = gR, _.uniqueId = kR, _.upperCase = pR, _.upperFirst = ml, _.each = Ag, _.eachRight = Rg, _.first = Sg, Ol(_, function() {
        var n = {};
        return He(_, function(r, a) {
          Wn.call(_.prototype, a) || (n[a] = r);
        }), n;
      }(), { chain: !1 }), _.VERSION = u, _e(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n) {
        _[n].placeholder = _;
      }), _e(["drop", "take"], function(n, r) {
        mn.prototype[n] = function(a) {
          a = a === i ? 1 : pr(Dn(a), 0);
          var f = this.__filtered__ && !r ? new mn(this) : this.clone();
          return f.__filtered__ ? f.__takeCount__ = Mr(a, f.__takeCount__) : f.__views__.push({
            size: Mr(a, Z),
            type: n + (f.__dir__ < 0 ? "Right" : "")
          }), f;
        }, mn.prototype[n + "Right"] = function(a) {
          return this.reverse()[n](a).reverse();
        };
      }), _e(["filter", "map", "takeWhile"], function(n, r) {
        var a = r + 1, f = a == Or || a == Xr;
        mn.prototype[n] = function(l) {
          var g = this.clone();
          return g.__iteratees__.push({
            iteratee: ln(l, 3),
            type: a
          }), g.__filtered__ = g.__filtered__ || f, g;
        };
      }), _e(["head", "last"], function(n, r) {
        var a = "take" + (r ? "Right" : "");
        mn.prototype[n] = function() {
          return this[a](1).value()[0];
        };
      }), _e(["initial", "tail"], function(n, r) {
        var a = "drop" + (r ? "" : "Right");
        mn.prototype[n] = function() {
          return this.__filtered__ ? new mn(this) : this[a](1);
        };
      }), mn.prototype.compact = function() {
        return this.filter(Jr);
      }, mn.prototype.find = function(n) {
        return this.filter(n).head();
      }, mn.prototype.findLast = function(n) {
        return this.reverse().find(n);
      }, mn.prototype.invokeMap = Rn(function(n, r) {
        return typeof n == "function" ? new mn(this) : this.map(function(a) {
          return Ru(a, n, r);
        });
      }), mn.prototype.reject = function(n) {
        return this.filter(Cf(ln(n)));
      }, mn.prototype.slice = function(n, r) {
        n = Dn(n);
        var a = this;
        return a.__filtered__ && (n > 0 || r < 0) ? new mn(a) : (n < 0 ? a = a.takeRight(-n) : n && (a = a.drop(n)), r !== i && (r = Dn(r), a = r < 0 ? a.dropRight(-r) : a.take(r - n)), a);
      }, mn.prototype.takeRightWhile = function(n) {
        return this.reverse().takeWhile(n).reverse();
      }, mn.prototype.toArray = function() {
        return this.take(Z);
      }, He(mn.prototype, function(n, r) {
        var a = /^(?:filter|find|map|reject)|While$/.test(r), f = /^(?:head|last)$/.test(r), l = _[f ? "take" + (r == "last" ? "Right" : "") : r], g = f || /^find/.test(r);
        l && (_.prototype[r] = function() {
          var N = this.__wrapped__, A = f ? [1] : arguments, w = N instanceof mn, B = A[0], G = w || Nn(N), z = function(yn) {
            var Ln = l.apply(_, Ct([yn], A));
            return f && nn ? Ln[0] : Ln;
          };
          G && a && typeof B == "function" && B.length != 1 && (w = G = !1);
          var nn = this.__chain__, fn = !!this.__actions__.length, vn = g && !nn, In = w && !fn;
          if (!g && G) {
            N = In ? N : new mn(this);
            var _n = n.apply(N, A);
            return _n.__actions__.push({ func: Df, args: [z], thisArg: i }), new he(_n, nn);
          }
          return vn && In ? n.apply(this, A) : (_n = this.thru(z), vn ? f ? _n.value()[0] : _n.value() : _n);
        });
      }), _e(["pop", "push", "shift", "sort", "splice", "unshift"], function(n) {
        var r = Xo[n], a = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", f = /^(?:pop|shift)$/.test(n);
        _.prototype[n] = function() {
          var l = arguments;
          if (f && !this.__chain__) {
            var g = this.value();
            return r.apply(Nn(g) ? g : [], l);
          }
          return this[a](function(N) {
            return r.apply(Nn(N) ? N : [], l);
          });
        };
      }), He(mn.prototype, function(n, r) {
        var a = _[r];
        if (a) {
          var f = a.name + "";
          Wn.call(pa, f) || (pa[f] = []), pa[f].push({ name: r, func: a });
        }
      }), pa[hf(i, b).name] = [{
        name: "wrapper",
        func: i
      }], mn.prototype.clone = g1, mn.prototype.reverse = p1, mn.prototype.value = E1, _.prototype.at = XD, _.prototype.chain = $D, _.prototype.commit = VD, _.prototype.next = ZD, _.prototype.plant = QD, _.prototype.reverse = jD, _.prototype.toJSON = _.prototype.valueOf = _.prototype.value = nI, _.prototype.first = _.prototype.head, Eu && (_.prototype[Eu] = JD), _;
    }, da = VS();
    hi ? ((hi.exports = da)._ = da, Ps._ = da) : wr._ = da;
  }).call($u);
})(ss, ss.exports);
var Sr = ss.exports;
function Fp(e, t) {
  return Sr.isString(e[0]) ? e[0] : Sr.isError(e[0]) ? e[0].message || "Unknown Error" : t || "Unknown Error";
}
function vx(e, t) {
  return Sr.isError(e[0]) ? e[0] : e.length > 1 && Sr.isError(e[1]) ? e[1] : new Error(t);
}
function Hp(e) {
  return !Sr.isString(e[0]) && !Sr.isError(e[0]) ? lu(e[0]) ?? {} : e.length > 1 && !Sr.isError(e[1]) ? lu(e[1]) ?? {} : {};
}
function _x(e, t, i) {
  const u = {}, o = t;
  return o.isAxiosError && Object.assign(u, {
    code: o.code,
    request: lu(
      Sr.pickBy(
        o.config,
        (c, s) => ["axios-retry", "headers", "method", "params", "url"].includes(s)
      )
    ),
    response: lu(
      Sr.pickBy(o.response, (c, s) => {
        var v;
        return ["headers", "status", "statusText"].includes(s) ? !0 : s === "data" && ["text/plain", "text/html", "application/json"].includes(
          Sr.toLower(
            Sr.find((v = o.response) == null ? void 0 : v.headers, (d, p) => Sr.toLower(p) === "content-type")
          ) || ""
        );
      })
    )
  }), {
    consoleMessage: e,
    ...u,
    ...i
  };
}
function lu(e) {
  if (e != null)
    return Sr.isString(e) || Sr.isBoolean(e) || Sr.isNumber(e) ? e : Sr.isArray(e) ? Sr.map(e, lu) : Sr.mapValues(Sr.toPlainObject(e), lu);
}
function px(e) {
  const { enabled: t, clientConfig: i } = e;
  return tC(() => {
    t === !0 && dx(i);
  }, [t]), null;
}
function dx(e) {
  const t = new lx({
    config: {
      connectionString: e.connectionString,
      enableAjaxErrorStatusText: !0
    }
  });
  t.loadAppInsights(), t.trackPageView(), t.addTelemetryInitializer(() => !0), hx(t);
}
function hx(e) {
  const t = window.console, i = Object.assign({}, t);
  i.error = (...u) => {
    if (t.error(...u), u.length === 0)
      return;
    const o = Fp(u, "Unknown Error"), c = vx(u, o), s = Hp(u), v = {
      exception: c,
      severityLevel: ep.Error
    };
    e.trackException(v, _x(o, c, s));
  }, i.warn = (...u) => {
    t.warn(...u);
    const o = Fp(u, "Unknown Warning"), c = Hp(u);
    e.trackTrace(
      { message: `Warning occurred: ${o}`, severityLevel: ep.Warning },
      c
    );
  }, window.console = i;
}
export {
  px as AppInsightsConnector
};
//# sourceMappingURL=index.mjs.map
